var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve2, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var step = (x2) => x2.done ? resolve2(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function makeMap$2(str, expectsLowerCase) {
  const map = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
}
const NOOP$1 = () => {
};
const extend$2 = Object.assign;
const hasOwnProperty$2 = Object.prototype.hasOwnProperty;
const hasOwn$2 = (val, key) => hasOwnProperty$2.call(val, key);
const isArray$3 = Array.isArray;
const isMap$1 = (val) => toTypeString$3(val) === "[object Map]";
const isFunction$3 = (val) => typeof val === "function";
const isString$3 = (val) => typeof val === "string";
const isSymbol = (val) => typeof val === "symbol";
const isObject$3 = (val) => val !== null && typeof val === "object";
const objectToString$3 = Object.prototype.toString;
const toTypeString$3 = (value) => objectToString$3.call(value);
const toRawType = (value) => {
  return toTypeString$3(value).slice(8, -1);
};
const isIntegerKey = (key) => isString$3(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const hasChanged$1 = (value, oldValue) => !Object.is(value, oldValue);
const def$1 = (obj, key, value) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    value
  });
};
let activeEffectScope;
class EffectScope {
  constructor(detached = false) {
    this.active = true;
    this.effects = [];
    this.cleanups = [];
    if (!detached && activeEffectScope) {
      this.parent = activeEffectScope;
      this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
  }
  run(fn) {
    if (this.active) {
      try {
        activeEffectScope = this;
        return fn();
      } finally {
        activeEffectScope = this.parent;
      }
    }
  }
  on() {
    activeEffectScope = this;
  }
  off() {
    activeEffectScope = this.parent;
  }
  stop(fromParent) {
    if (this.active) {
      let i, l;
      for (i = 0, l = this.effects.length; i < l; i++) {
        this.effects[i].stop();
      }
      for (i = 0, l = this.cleanups.length; i < l; i++) {
        this.cleanups[i]();
      }
      if (this.scopes) {
        for (i = 0, l = this.scopes.length; i < l; i++) {
          this.scopes[i].stop(true);
        }
      }
      if (this.parent && !fromParent) {
        const last = this.parent.scopes.pop();
        if (last && last !== this) {
          this.parent.scopes[this.index] = last;
          last.index = this.index;
        }
      }
      this.active = false;
    }
  }
}
function effectScope(detached) {
  return new EffectScope(detached);
}
function recordEffectScope(effect, scope = activeEffectScope) {
  if (scope && scope.active) {
    scope.effects.push(effect);
  }
}
const createDep = (effects) => {
  const dep = new Set(effects);
  dep.w = 0;
  dep.n = 0;
  return dep;
};
const wasTracked = (dep) => (dep.w & trackOpBit) > 0;
const newTracked = (dep) => (dep.n & trackOpBit) > 0;
const initDepMarkers = ({ deps }) => {
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].w |= trackOpBit;
    }
  }
};
const finalizeDepMarkers = (effect) => {
  const { deps } = effect;
  if (deps.length) {
    let ptr = 0;
    for (let i = 0; i < deps.length; i++) {
      const dep = deps[i];
      if (wasTracked(dep) && !newTracked(dep)) {
        dep.delete(effect);
      } else {
        deps[ptr++] = dep;
      }
      dep.w &= ~trackOpBit;
      dep.n &= ~trackOpBit;
    }
    deps.length = ptr;
  }
};
const targetMap = /* @__PURE__ */ new WeakMap();
let effectTrackDepth = 0;
let trackOpBit = 1;
const maxMarkerBits = 30;
let activeEffect;
const ITERATE_KEY = Symbol("");
const MAP_KEY_ITERATE_KEY = Symbol("");
class ReactiveEffect {
  constructor(fn, scheduler = null, scope) {
    this.fn = fn;
    this.scheduler = scheduler;
    this.active = true;
    this.deps = [];
    this.parent = void 0;
    recordEffectScope(this, scope);
  }
  run() {
    if (!this.active) {
      return this.fn();
    }
    let parent = activeEffect;
    let lastShouldTrack = shouldTrack;
    while (parent) {
      if (parent === this) {
        return;
      }
      parent = parent.parent;
    }
    try {
      this.parent = activeEffect;
      activeEffect = this;
      shouldTrack = true;
      trackOpBit = 1 << ++effectTrackDepth;
      if (effectTrackDepth <= maxMarkerBits) {
        initDepMarkers(this);
      } else {
        cleanupEffect(this);
      }
      return this.fn();
    } finally {
      if (effectTrackDepth <= maxMarkerBits) {
        finalizeDepMarkers(this);
      }
      trackOpBit = 1 << --effectTrackDepth;
      activeEffect = this.parent;
      shouldTrack = lastShouldTrack;
      this.parent = void 0;
    }
  }
  stop() {
    if (this.active) {
      cleanupEffect(this);
      if (this.onStop) {
        this.onStop();
      }
      this.active = false;
    }
  }
}
function cleanupEffect(effect) {
  const { deps } = effect;
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].delete(effect);
    }
    deps.length = 0;
  }
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function track(target, type, key) {
  if (shouldTrack && activeEffect) {
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = createDep());
    }
    trackEffects(dep);
  }
}
function trackEffects(dep, debuggerEventExtraInfo) {
  let shouldTrack2 = false;
  if (effectTrackDepth <= maxMarkerBits) {
    if (!newTracked(dep)) {
      dep.n |= trackOpBit;
      shouldTrack2 = !wasTracked(dep);
    }
  } else {
    shouldTrack2 = !dep.has(activeEffect);
  }
  if (shouldTrack2) {
    dep.add(activeEffect);
    activeEffect.deps.push(dep);
  }
}
function trigger$1(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    return;
  }
  let deps = [];
  if (type === "clear") {
    deps = [...depsMap.values()];
  } else if (key === "length" && isArray$3(target)) {
    depsMap.forEach((dep, key2) => {
      if (key2 === "length" || key2 >= newValue) {
        deps.push(dep);
      }
    });
  } else {
    if (key !== void 0) {
      deps.push(depsMap.get(key));
    }
    switch (type) {
      case "add":
        if (!isArray$3(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
          if (isMap$1(target)) {
            deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        } else if (isIntegerKey(key)) {
          deps.push(depsMap.get("length"));
        }
        break;
      case "delete":
        if (!isArray$3(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
          if (isMap$1(target)) {
            deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        }
        break;
      case "set":
        if (isMap$1(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
        }
        break;
    }
  }
  if (deps.length === 1) {
    if (deps[0]) {
      {
        triggerEffects(deps[0]);
      }
    }
  } else {
    const effects = [];
    for (const dep of deps) {
      if (dep) {
        effects.push(...dep);
      }
    }
    {
      triggerEffects(createDep(effects));
    }
  }
}
function triggerEffects(dep, debuggerEventExtraInfo) {
  for (const effect of isArray$3(dep) ? dep : [...dep]) {
    if (effect !== activeEffect || effect.allowRecurse) {
      if (effect.scheduler) {
        effect.scheduler();
      } else {
        effect.run();
      }
    }
  }
}
const isNonTrackableKeys = /* @__PURE__ */ makeMap$2(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol));
const get = /* @__PURE__ */ createGetter();
const shallowGet = /* @__PURE__ */ createGetter(false, true);
const readonlyGet = /* @__PURE__ */ createGetter(true);
const arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
  const instrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    instrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i = 0, l = this.length; i < l; i++) {
        track(arr, "get", i + "");
      }
      const res = arr[key](...args);
      if (res === -1 || res === false) {
        return arr[key](...args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    instrumentations[key] = function(...args) {
      pauseTracking();
      const res = toRaw(this)[key].apply(this, args);
      resetTracking();
      return res;
    };
  });
  return instrumentations;
}
function createGetter(isReadonly2 = false, shallow = false) {
  return function get2(target, key, receiver) {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_isShallow") {
      return shallow;
    } else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
      return target;
    }
    const targetIsArray = isArray$3(target);
    if (!isReadonly2 && targetIsArray && hasOwn$2(arrayInstrumentations, key)) {
      return Reflect.get(arrayInstrumentations, key, receiver);
    }
    const res = Reflect.get(target, key, receiver);
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly2) {
      track(target, "get", key);
    }
    if (shallow) {
      return res;
    }
    if (isRef(res)) {
      const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
      return shouldUnwrap ? res.value : res;
    }
    if (isObject$3(res)) {
      return isReadonly2 ? readonly(res) : reactive(res);
    }
    return res;
  };
}
const set = /* @__PURE__ */ createSetter();
const shallowSet = /* @__PURE__ */ createSetter(true);
function createSetter(shallow = false) {
  return function set2(target, key, value, receiver) {
    let oldValue = target[key];
    if (isReadonly(oldValue) && isRef(oldValue) && !isRef(value)) {
      return false;
    }
    if (!shallow && !isReadonly(value)) {
      if (!isShallow(value)) {
        value = toRaw(value);
        oldValue = toRaw(oldValue);
      }
      if (!isArray$3(target) && isRef(oldValue) && !isRef(value)) {
        oldValue.value = value;
        return true;
      }
    }
    const hadKey = isArray$3(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn$2(target, key);
    const result = Reflect.set(target, key, value, receiver);
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger$1(target, "add", key, value);
      } else if (hasChanged$1(value, oldValue)) {
        trigger$1(target, "set", key, value);
      }
    }
    return result;
  };
}
function deleteProperty(target, key) {
  const hadKey = hasOwn$2(target, key);
  target[key];
  const result = Reflect.deleteProperty(target, key);
  if (result && hadKey) {
    trigger$1(target, "delete", key, void 0);
  }
  return result;
}
function has(target, key) {
  const result = Reflect.has(target, key);
  if (!isSymbol(key) || !builtInSymbols.has(key)) {
    track(target, "has", key);
  }
  return result;
}
function ownKeys(target) {
  track(target, "iterate", isArray$3(target) ? "length" : ITERATE_KEY);
  return Reflect.ownKeys(target);
}
const mutableHandlers = {
  get,
  set,
  deleteProperty,
  has,
  ownKeys
};
const readonlyHandlers = {
  get: readonlyGet,
  set(target, key) {
    return true;
  },
  deleteProperty(target, key) {
    return true;
  }
};
const shallowReactiveHandlers = /* @__PURE__ */ extend$2({}, mutableHandlers, {
  get: shallowGet,
  set: shallowSet
});
const toShallow = (value) => value;
const getProto = (v2) => Reflect.getPrototypeOf(v2);
function get$1(target, key, isReadonly2 = false, isShallow2 = false) {
  target = target["__v_raw"];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly2 && track(rawTarget, "get", key);
  }
  !isReadonly2 && track(rawTarget, "get", rawKey);
  const { has: has2 } = getProto(rawTarget);
  const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
  if (has2.call(rawTarget, key)) {
    return wrap(target.get(key));
  } else if (has2.call(rawTarget, rawKey)) {
    return wrap(target.get(rawKey));
  } else if (target !== rawTarget) {
    target.get(key);
  }
}
function has$1(key, isReadonly2 = false) {
  const target = this["__v_raw"];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly2 && track(rawTarget, "has", key);
  }
  !isReadonly2 && track(rawTarget, "has", rawKey);
  return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly2 = false) {
  target = target["__v_raw"];
  !isReadonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
  return Reflect.get(target, "size", target);
}
function add(value) {
  value = toRaw(value);
  const target = toRaw(this);
  const proto = getProto(target);
  const hadKey = proto.has.call(target, value);
  if (!hadKey) {
    target.add(value);
    trigger$1(target, "add", value, value);
  }
  return this;
}
function set$1(key, value) {
  value = toRaw(value);
  const target = toRaw(this);
  const { has: has2, get: get2 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  }
  const oldValue = get2.call(target, key);
  target.set(key, value);
  if (!hadKey) {
    trigger$1(target, "add", key, value);
  } else if (hasChanged$1(value, oldValue)) {
    trigger$1(target, "set", key, value);
  }
  return this;
}
function deleteEntry(key) {
  const target = toRaw(this);
  const { has: has2, get: get2 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  }
  get2 ? get2.call(target, key) : void 0;
  const result = target.delete(key);
  if (hadKey) {
    trigger$1(target, "delete", key, void 0);
  }
  return result;
}
function clear() {
  const target = toRaw(this);
  const hadItems = target.size !== 0;
  const result = target.clear();
  if (hadItems) {
    trigger$1(target, "clear", void 0, void 0);
  }
  return result;
}
function createForEach(isReadonly2, isShallow2) {
  return function forEach(callback, thisArg) {
    const observed = this;
    const target = observed["__v_raw"];
    const rawTarget = toRaw(target);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(rawTarget, "iterate", ITERATE_KEY);
    return target.forEach((value, key) => {
      return callback.call(thisArg, wrap(value), wrap(key), observed);
    });
  };
}
function createIterableMethod(method, isReadonly2, isShallow2) {
  return function(...args) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap$1(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
    return {
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    return type === "delete" ? false : this;
  };
}
function createInstrumentations() {
  const mutableInstrumentations2 = {
    get(key) {
      return get$1(this, key);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  const shallowInstrumentations2 = {
    get(key) {
      return get$1(this, key, false, true);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  const readonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, false)
  };
  const shallowReadonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, true)
  };
  const iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations2[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
    shallowInstrumentations2[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
  });
  return [
    mutableInstrumentations2,
    readonlyInstrumentations2,
    shallowInstrumentations2,
    shallowReadonlyInstrumentations2
  ];
}
const [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly2, shallow) {
  const instrumentations = shallow ? isReadonly2 ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly2 ? readonlyInstrumentations : mutableInstrumentations;
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(hasOwn$2(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
  };
}
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive(target) {
  if (isReadonly(target)) {
    return target;
  }
  return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
  return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
  return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject$3(target)) {
    return target;
  }
  if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
  proxyMap.set(target, proxy);
  return proxy;
}
function isReactive(value) {
  if (isReadonly(value)) {
    return isReactive(value["__v_raw"]);
  }
  return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
  return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
  return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
  return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
  const raw = observed && observed["__v_raw"];
  return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
  def$1(value, "__v_skip", true);
  return value;
}
const toReactive = (value) => isObject$3(value) ? reactive(value) : value;
const toReadonly = (value) => isObject$3(value) ? readonly(value) : value;
function trackRefValue(ref2) {
  if (shouldTrack && activeEffect) {
    ref2 = toRaw(ref2);
    {
      trackEffects(ref2.dep || (ref2.dep = createDep()));
    }
  }
}
function triggerRefValue(ref2, newVal) {
  ref2 = toRaw(ref2);
  if (ref2.dep) {
    {
      triggerEffects(ref2.dep);
    }
  }
}
function isRef(r2) {
  return !!(r2 && r2.__v_isRef === true);
}
function ref(value) {
  return createRef(value, false);
}
function shallowRef(value) {
  return createRef(value, true);
}
function createRef(rawValue, shallow) {
  if (isRef(rawValue)) {
    return rawValue;
  }
  return new RefImpl(rawValue, shallow);
}
class RefImpl {
  constructor(value, __v_isShallow) {
    this.__v_isShallow = __v_isShallow;
    this.dep = void 0;
    this.__v_isRef = true;
    this._rawValue = __v_isShallow ? value : toRaw(value);
    this._value = __v_isShallow ? value : toReactive(value);
  }
  get value() {
    trackRefValue(this);
    return this._value;
  }
  set value(newVal) {
    newVal = this.__v_isShallow ? newVal : toRaw(newVal);
    if (hasChanged$1(newVal, this._rawValue)) {
      this._rawValue = newVal;
      this._value = this.__v_isShallow ? newVal : toReactive(newVal);
      triggerRefValue(this);
    }
  }
}
function unref(ref2) {
  return isRef(ref2) ? ref2.value : ref2;
}
const shallowUnwrapHandlers = {
  get: (target, key, receiver) => unref(Reflect.get(target, key, receiver)),
  set: (target, key, value, receiver) => {
    const oldValue = target[key];
    if (isRef(oldValue) && !isRef(value)) {
      oldValue.value = value;
      return true;
    } else {
      return Reflect.set(target, key, value, receiver);
    }
  }
};
function proxyRefs(objectWithRefs) {
  return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class ComputedRefImpl {
  constructor(getter, _setter, isReadonly2, isSSR) {
    this._setter = _setter;
    this.dep = void 0;
    this.__v_isRef = true;
    this._dirty = true;
    this.effect = new ReactiveEffect(getter, () => {
      if (!this._dirty) {
        this._dirty = true;
        triggerRefValue(this);
      }
    });
    this.effect.computed = this;
    this.effect.active = this._cacheable = !isSSR;
    this["__v_isReadonly"] = isReadonly2;
  }
  get value() {
    const self2 = toRaw(this);
    trackRefValue(self2);
    if (self2._dirty || !self2._cacheable) {
      self2._dirty = false;
      self2._value = self2.effect.run();
    }
    return self2._value;
  }
  set value(newValue) {
    this._setter(newValue);
  }
}
function computed$1(getterOrOptions, debugOptions, isSSR = false) {
  let getter;
  let setter;
  const onlyGetter = isFunction$3(getterOrOptions);
  if (onlyGetter) {
    getter = getterOrOptions;
    setter = NOOP$1;
  } else {
    getter = getterOrOptions.get;
    setter = getterOrOptions.set;
  }
  const cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
  return cRef;
}
Promise.resolve();
function makeMap$1(str, expectsLowerCase) {
  const map = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
}
function normalizeStyle(value) {
  if (isArray$2(value)) {
    const res = {};
    for (let i = 0; i < value.length; i++) {
      const item = value[i];
      const normalized = isString$2(item) ? parseStringStyle(item) : normalizeStyle(item);
      if (normalized) {
        for (const key in normalized) {
          res[key] = normalized[key];
        }
      }
    }
    return res;
  } else if (isString$2(value)) {
    return value;
  } else if (isObject$2(value)) {
    return value;
  }
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:(.+)/;
function parseStringStyle(cssText) {
  const ret = {};
  cssText.split(listDelimiterRE).forEach((item) => {
    if (item) {
      const tmp = item.split(propertyDelimiterRE);
      tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return ret;
}
function normalizeClass(value) {
  let res = "";
  if (isString$2(value)) {
    res = value;
  } else if (isArray$2(value)) {
    for (let i = 0; i < value.length; i++) {
      const normalized = normalizeClass(value[i]);
      if (normalized) {
        res += normalized + " ";
      }
    }
  } else if (isObject$2(value)) {
    for (const name2 in value) {
      if (value[name2]) {
        res += name2 + " ";
      }
    }
  }
  return res.trim();
}
function normalizeProps(props) {
  if (!props)
    return null;
  let { class: klass, style } = props;
  if (klass && !isString$2(klass)) {
    props.class = normalizeClass(klass);
  }
  if (style) {
    props.style = normalizeStyle(style);
  }
  return props;
}
const toDisplayString$1 = (val) => {
  return isString$2(val) ? val : val == null ? "" : isArray$2(val) || isObject$2(val) && (val.toString === objectToString$2 || !isFunction$2(val.toString)) ? JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val) => {
  if (val && val.__v_isRef) {
    return replacer(_key, val.value);
  } else if (isMap(val)) {
    return {
      [`Map(${val.size})`]: [...val.entries()].reduce((entries, [key, val2]) => {
        entries[`${key} =>`] = val2;
        return entries;
      }, {})
    };
  } else if (isSet$1(val)) {
    return {
      [`Set(${val.size})`]: [...val.values()]
    };
  } else if (isObject$2(val) && !isArray$2(val) && !isPlainObject$1(val)) {
    return String(val);
  }
  return val;
};
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = () => {
};
const NO = () => false;
const onRE$1 = /^on[^a-z]/;
const isOn$1 = (key) => onRE$1.test(key);
const isModelListener$1 = (key) => key.startsWith("onUpdate:");
const extend$1 = Object.assign;
const remove = (arr, el) => {
  const i = arr.indexOf(el);
  if (i > -1) {
    arr.splice(i, 1);
  }
};
const hasOwnProperty$1 = Object.prototype.hasOwnProperty;
const hasOwn$1 = (val, key) => hasOwnProperty$1.call(val, key);
const isArray$2 = Array.isArray;
const isMap = (val) => toTypeString$2(val) === "[object Map]";
const isSet$1 = (val) => toTypeString$2(val) === "[object Set]";
const isFunction$2 = (val) => typeof val === "function";
const isString$2 = (val) => typeof val === "string";
const isObject$2 = (val) => val !== null && typeof val === "object";
const isPromise = (val) => {
  return isObject$2(val) && isFunction$2(val.then) && isFunction$2(val.catch);
};
const objectToString$2 = Object.prototype.toString;
const toTypeString$2 = (value) => objectToString$2.call(value);
const isPlainObject$1 = (val) => toTypeString$2(val) === "[object Object]";
const isReservedProp = /* @__PURE__ */ makeMap$1(
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
);
const cacheStringFunction$1 = (fn) => {
  const cache2 = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache2[str];
    return hit || (cache2[str] = fn(str));
  };
};
const camelizeRE$1 = /-(\w)/g;
const camelize$1 = cacheStringFunction$1((str) => {
  return str.replace(camelizeRE$1, (_2, c) => c ? c.toUpperCase() : "");
});
const hyphenateRE$1 = /\B([A-Z])/g;
const hyphenate$1 = cacheStringFunction$1((str) => str.replace(hyphenateRE$1, "-$1").toLowerCase());
const capitalize$2 = cacheStringFunction$1((str) => str.charAt(0).toUpperCase() + str.slice(1));
const toHandlerKey = cacheStringFunction$1((str) => str ? `on${capitalize$2(str)}` : ``);
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
const invokeArrayFns$1 = (fns, arg) => {
  for (let i = 0; i < fns.length; i++) {
    fns[i](arg);
  }
};
const def = (obj, key, value) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    value
  });
};
const toNumber$1 = (val) => {
  const n2 = parseFloat(val);
  return isNaN(n2) ? val : n2;
};
let _globalThis$1;
const getGlobalThis$1 = () => {
  return _globalThis$1 || (_globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function callWithErrorHandling(fn, instance, type, args) {
  let res;
  try {
    res = args ? fn(...args) : fn();
  } catch (err) {
    handleError(err, instance, type);
  }
  return res;
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
  if (isFunction$2(fn)) {
    const res = callWithErrorHandling(fn, instance, type, args);
    if (res && isPromise(res)) {
      res.catch((err) => {
        handleError(err, instance, type);
      });
    }
    return res;
  }
  const values = [];
  for (let i = 0; i < fn.length; i++) {
    values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
  }
  return values;
}
function handleError(err, instance, type, throwInDev = true) {
  const contextVNode = instance ? instance.vnode : null;
  if (instance) {
    let cur = instance.parent;
    const exposedInstance = instance.proxy;
    const errorInfo = type;
    while (cur) {
      const errorCapturedHooks = cur.ec;
      if (errorCapturedHooks) {
        for (let i = 0; i < errorCapturedHooks.length; i++) {
          if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
            return;
          }
        }
      }
      cur = cur.parent;
    }
    const appErrorHandler = instance.appContext.config.errorHandler;
    if (appErrorHandler) {
      callWithErrorHandling(appErrorHandler, null, 10, [err, exposedInstance, errorInfo]);
      return;
    }
  }
  logError(err, type, contextVNode, throwInDev);
}
function logError(err, type, contextVNode, throwInDev = true) {
  {
    console.error(err);
  }
}
let isFlushing = false;
let isFlushPending = false;
const queue = [];
let flushIndex = 0;
const pendingPreFlushCbs = [];
let activePreFlushCbs = null;
let preFlushIndex = 0;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = Promise.resolve();
let currentFlushPromise = null;
let currentPreFlushParentJob = null;
function nextTick(fn) {
  const p2 = currentFlushPromise || resolvedPromise;
  return fn ? p2.then(this ? fn.bind(this) : fn) : p2;
}
function findInsertionIndex(id) {
  let start = flushIndex + 1;
  let end = queue.length;
  while (start < end) {
    const middle = start + end >>> 1;
    const middleJobId = getId(queue[middle]);
    middleJobId < id ? start = middle + 1 : end = middle;
  }
  return start;
}
function queueJob(job) {
  if ((!queue.length || !queue.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) && job !== currentPreFlushParentJob) {
    if (job.id == null) {
      queue.push(job);
    } else {
      queue.splice(findInsertionIndex(job.id), 0, job);
    }
    queueFlush();
  }
}
function queueFlush() {
  if (!isFlushing && !isFlushPending) {
    isFlushPending = true;
    currentFlushPromise = resolvedPromise.then(flushJobs);
  }
}
function invalidateJob(job) {
  const i = queue.indexOf(job);
  if (i > flushIndex) {
    queue.splice(i, 1);
  }
}
function queueCb(cb, activeQueue, pendingQueue, index) {
  if (!isArray$2(cb)) {
    if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index + 1 : index)) {
      pendingQueue.push(cb);
    }
  } else {
    pendingQueue.push(...cb);
  }
  queueFlush();
}
function queuePreFlushCb(cb) {
  queueCb(cb, activePreFlushCbs, pendingPreFlushCbs, preFlushIndex);
}
function queuePostFlushCb(cb) {
  queueCb(cb, activePostFlushCbs, pendingPostFlushCbs, postFlushIndex);
}
function flushPreFlushCbs(seen, parentJob = null) {
  if (pendingPreFlushCbs.length) {
    currentPreFlushParentJob = parentJob;
    activePreFlushCbs = [...new Set(pendingPreFlushCbs)];
    pendingPreFlushCbs.length = 0;
    for (preFlushIndex = 0; preFlushIndex < activePreFlushCbs.length; preFlushIndex++) {
      activePreFlushCbs[preFlushIndex]();
    }
    activePreFlushCbs = null;
    preFlushIndex = 0;
    currentPreFlushParentJob = null;
    flushPreFlushCbs(seen, parentJob);
  }
}
function flushPostFlushCbs(seen) {
  if (pendingPostFlushCbs.length) {
    const deduped = [...new Set(pendingPostFlushCbs)];
    pendingPostFlushCbs.length = 0;
    if (activePostFlushCbs) {
      activePostFlushCbs.push(...deduped);
      return;
    }
    activePostFlushCbs = deduped;
    activePostFlushCbs.sort((a2, b2) => getId(a2) - getId(b2));
    for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
      activePostFlushCbs[postFlushIndex]();
    }
    activePostFlushCbs = null;
    postFlushIndex = 0;
  }
}
const getId = (job) => job.id == null ? Infinity : job.id;
function flushJobs(seen) {
  isFlushPending = false;
  isFlushing = true;
  flushPreFlushCbs(seen);
  queue.sort((a2, b2) => getId(a2) - getId(b2));
  const check = NOOP;
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job && job.active !== false) {
        if (false)
          ;
        callWithErrorHandling(job, null, 14);
      }
    }
  } finally {
    flushIndex = 0;
    queue.length = 0;
    flushPostFlushCbs();
    isFlushing = false;
    currentFlushPromise = null;
    if (queue.length || pendingPreFlushCbs.length || pendingPostFlushCbs.length) {
      flushJobs(seen);
    }
  }
}
function emit$1(instance, event, ...rawArgs) {
  const props = instance.vnode.props || EMPTY_OBJ;
  let args = rawArgs;
  const isModelListener2 = event.startsWith("update:");
  const modelArg = isModelListener2 && event.slice(7);
  if (modelArg && modelArg in props) {
    const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
    const { number: number2, trim } = props[modifiersKey] || EMPTY_OBJ;
    if (trim) {
      args = rawArgs.map((a2) => a2.trim());
    } else if (number2) {
      args = rawArgs.map(toNumber$1);
    }
  }
  let handlerName;
  let handler = props[handlerName = toHandlerKey(event)] || props[handlerName = toHandlerKey(camelize$1(event))];
  if (!handler && isModelListener2) {
    handler = props[handlerName = toHandlerKey(hyphenate$1(event))];
  }
  if (handler) {
    callWithAsyncErrorHandling(handler, instance, 6, args);
  }
  const onceHandler = props[handlerName + `Once`];
  if (onceHandler) {
    if (!instance.emitted) {
      instance.emitted = {};
    } else if (instance.emitted[handlerName]) {
      return;
    }
    instance.emitted[handlerName] = true;
    callWithAsyncErrorHandling(onceHandler, instance, 6, args);
  }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
  const cache2 = appContext.emitsCache;
  const cached = cache2.get(comp);
  if (cached !== void 0) {
    return cached;
  }
  const raw = comp.emits;
  let normalized = {};
  let hasExtends = false;
  if (!isFunction$2(comp)) {
    const extendEmits = (raw2) => {
      const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
      if (normalizedFromExtend) {
        hasExtends = true;
        extend$1(normalized, normalizedFromExtend);
      }
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendEmits);
    }
    if (comp.extends) {
      extendEmits(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendEmits);
    }
  }
  if (!raw && !hasExtends) {
    cache2.set(comp, null);
    return null;
  }
  if (isArray$2(raw)) {
    raw.forEach((key) => normalized[key] = null);
  } else {
    extend$1(normalized, raw);
  }
  cache2.set(comp, normalized);
  return normalized;
}
function isEmitListener(options, key) {
  if (!options || !isOn$1(key)) {
    return false;
  }
  key = key.slice(2).replace(/Once$/, "");
  return hasOwn$1(options, key[0].toLowerCase() + key.slice(1)) || hasOwn$1(options, hyphenate$1(key)) || hasOwn$1(options, key);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
  const prev = currentRenderingInstance;
  currentRenderingInstance = instance;
  currentScopeId = instance && instance.type.__scopeId || null;
  return prev;
}
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
  if (!ctx)
    return fn;
  if (fn._n) {
    return fn;
  }
  const renderFnWithContext = (...args) => {
    if (renderFnWithContext._d) {
      setBlockTracking(-1);
    }
    const prevInstance = setCurrentRenderingInstance(ctx);
    const res = fn(...args);
    setCurrentRenderingInstance(prevInstance);
    if (renderFnWithContext._d) {
      setBlockTracking(1);
    }
    return res;
  };
  renderFnWithContext._n = true;
  renderFnWithContext._c = true;
  renderFnWithContext._d = true;
  return renderFnWithContext;
}
function markAttrsAccessed() {
}
function renderComponentRoot(instance) {
  const { type: Component, vnode, proxy, withProxy, props, propsOptions: [propsOptions], slots, attrs, emit, render: render2, renderCache, data, setupState, ctx, inheritAttrs } = instance;
  let result;
  let fallthroughAttrs;
  const prev = setCurrentRenderingInstance(instance);
  try {
    if (vnode.shapeFlag & 4) {
      const proxyToUse = withProxy || proxy;
      result = normalizeVNode(render2.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
      fallthroughAttrs = attrs;
    } else {
      const render3 = Component;
      if (false)
        ;
      result = normalizeVNode(render3.length > 1 ? render3(props, false ? {
        get attrs() {
          markAttrsAccessed();
          return attrs;
        },
        slots,
        emit
      } : { attrs, slots, emit }) : render3(props, null));
      fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
    }
  } catch (err) {
    blockStack.length = 0;
    handleError(err, instance, 1);
    result = createVNode(Comment);
  }
  let root = result;
  if (fallthroughAttrs && inheritAttrs !== false) {
    const keys = Object.keys(fallthroughAttrs);
    const { shapeFlag } = root;
    if (keys.length) {
      if (shapeFlag & (1 | 6)) {
        if (propsOptions && keys.some(isModelListener$1)) {
          fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
        }
        root = cloneVNode(root, fallthroughAttrs);
      }
    }
  }
  if (vnode.dirs) {
    root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
  }
  if (vnode.transition) {
    root.transition = vnode.transition;
  }
  {
    result = root;
  }
  setCurrentRenderingInstance(prev);
  return result;
}
const getFunctionalFallthrough = (attrs) => {
  let res;
  for (const key in attrs) {
    if (key === "class" || key === "style" || isOn$1(key)) {
      (res || (res = {}))[key] = attrs[key];
    }
  }
  return res;
};
const filterModelListeners = (attrs, props) => {
  const res = {};
  for (const key in attrs) {
    if (!isModelListener$1(key) || !(key.slice(9) in props)) {
      res[key] = attrs[key];
    }
  }
  return res;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
  const { props: prevProps, children: prevChildren, component } = prevVNode;
  const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
  const emits = component.emitsOptions;
  if (nextVNode.dirs || nextVNode.transition) {
    return true;
  }
  if (optimized && patchFlag >= 0) {
    if (patchFlag & 1024) {
      return true;
    }
    if (patchFlag & 16) {
      if (!prevProps) {
        return !!nextProps;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    } else if (patchFlag & 8) {
      const dynamicProps = nextVNode.dynamicProps;
      for (let i = 0; i < dynamicProps.length; i++) {
        const key = dynamicProps[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
          return true;
        }
      }
    }
  } else {
    if (prevChildren || nextChildren) {
      if (!nextChildren || !nextChildren.$stable) {
        return true;
      }
    }
    if (prevProps === nextProps) {
      return false;
    }
    if (!prevProps) {
      return !!nextProps;
    }
    if (!nextProps) {
      return true;
    }
    return hasPropsChanged(prevProps, nextProps, emits);
  }
  return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
  const nextKeys = Object.keys(nextProps);
  if (nextKeys.length !== Object.keys(prevProps).length) {
    return true;
  }
  for (let i = 0; i < nextKeys.length; i++) {
    const key = nextKeys[i];
    if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
      return true;
    }
  }
  return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
  while (parent && parent.subTree === vnode) {
    (vnode = parent.vnode).el = el;
    parent = parent.parent;
  }
}
const isSuspense = (type) => type.__isSuspense;
function queueEffectWithSuspense(fn, suspense) {
  if (suspense && suspense.pendingBranch) {
    if (isArray$2(fn)) {
      suspense.effects.push(...fn);
    } else {
      suspense.effects.push(fn);
    }
  } else {
    queuePostFlushCb(fn);
  }
}
function provide(key, value) {
  if (!currentInstance)
    ;
  else {
    let provides = currentInstance.provides;
    const parentProvides = currentInstance.parent && currentInstance.parent.provides;
    if (parentProvides === provides) {
      provides = currentInstance.provides = Object.create(parentProvides);
    }
    provides[key] = value;
  }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
  const instance = currentInstance || currentRenderingInstance;
  if (instance) {
    const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
    if (provides && key in provides) {
      return provides[key];
    } else if (arguments.length > 1) {
      return treatDefaultAsFactory && isFunction$2(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    } else
      ;
  }
}
function watchEffect(effect, options) {
  return doWatch(effect, null, options);
}
const INITIAL_WATCHER_VALUE = {};
function watch(source, cb, options) {
  return doWatch(source, cb, options);
}
function doWatch(source, cb, { immediate, deep, flush, onTrack, onTrigger } = EMPTY_OBJ) {
  const instance = currentInstance;
  let getter;
  let forceTrigger = false;
  let isMultiSource = false;
  if (isRef(source)) {
    getter = () => source.value;
    forceTrigger = isShallow(source);
  } else if (isReactive(source)) {
    getter = () => source;
    deep = true;
  } else if (isArray$2(source)) {
    isMultiSource = true;
    forceTrigger = source.some(isReactive);
    getter = () => source.map((s) => {
      if (isRef(s)) {
        return s.value;
      } else if (isReactive(s)) {
        return traverse(s);
      } else if (isFunction$2(s)) {
        return callWithErrorHandling(s, instance, 2);
      } else
        ;
    });
  } else if (isFunction$2(source)) {
    if (cb) {
      getter = () => callWithErrorHandling(source, instance, 2);
    } else {
      getter = () => {
        if (instance && instance.isUnmounted) {
          return;
        }
        if (cleanup) {
          cleanup();
        }
        return callWithAsyncErrorHandling(source, instance, 3, [onCleanup]);
      };
    }
  } else {
    getter = NOOP;
  }
  if (cb && deep) {
    const baseGetter = getter;
    getter = () => traverse(baseGetter());
  }
  let cleanup;
  let onCleanup = (fn) => {
    cleanup = effect.onStop = () => {
      callWithErrorHandling(fn, instance, 4);
    };
  };
  if (isInSSRComponentSetup) {
    onCleanup = NOOP;
    if (!cb) {
      getter();
    } else if (immediate) {
      callWithAsyncErrorHandling(cb, instance, 3, [
        getter(),
        isMultiSource ? [] : void 0,
        onCleanup
      ]);
    }
    return NOOP;
  }
  let oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
  const job = () => {
    if (!effect.active) {
      return;
    }
    if (cb) {
      const newValue = effect.run();
      if (deep || forceTrigger || (isMultiSource ? newValue.some((v2, i) => hasChanged(v2, oldValue[i])) : hasChanged(newValue, oldValue)) || false) {
        if (cleanup) {
          cleanup();
        }
        callWithAsyncErrorHandling(cb, instance, 3, [
          newValue,
          oldValue === INITIAL_WATCHER_VALUE ? void 0 : oldValue,
          onCleanup
        ]);
        oldValue = newValue;
      }
    } else {
      effect.run();
    }
  };
  job.allowRecurse = !!cb;
  let scheduler;
  if (flush === "sync") {
    scheduler = job;
  } else if (flush === "post") {
    scheduler = () => queuePostRenderEffect(job, instance && instance.suspense);
  } else {
    scheduler = () => {
      if (!instance || instance.isMounted) {
        queuePreFlushCb(job);
      } else {
        job();
      }
    };
  }
  const effect = new ReactiveEffect(getter, scheduler);
  if (cb) {
    if (immediate) {
      job();
    } else {
      oldValue = effect.run();
    }
  } else if (flush === "post") {
    queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
  } else {
    effect.run();
  }
  return () => {
    effect.stop();
    if (instance && instance.scope) {
      remove(instance.scope.effects, effect);
    }
  };
}
function instanceWatch(source, value, options) {
  const publicThis = this.proxy;
  const getter = isString$2(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
  let cb;
  if (isFunction$2(value)) {
    cb = value;
  } else {
    cb = value.handler;
    options = value;
  }
  const cur = currentInstance;
  setCurrentInstance(this);
  const res = doWatch(getter, cb.bind(publicThis), options);
  if (cur) {
    setCurrentInstance(cur);
  } else {
    unsetCurrentInstance();
  }
  return res;
}
function createPathGetter(ctx, path) {
  const segments = path.split(".");
  return () => {
    let cur = ctx;
    for (let i = 0; i < segments.length && cur; i++) {
      cur = cur[segments[i]];
    }
    return cur;
  };
}
function traverse(value, seen) {
  if (!isObject$2(value) || value["__v_skip"]) {
    return value;
  }
  seen = seen || /* @__PURE__ */ new Set();
  if (seen.has(value)) {
    return value;
  }
  seen.add(value);
  if (isRef(value)) {
    traverse(value.value, seen);
  } else if (isArray$2(value)) {
    for (let i = 0; i < value.length; i++) {
      traverse(value[i], seen);
    }
  } else if (isSet$1(value) || isMap(value)) {
    value.forEach((v2) => {
      traverse(v2, seen);
    });
  } else if (isPlainObject$1(value)) {
    for (const key in value) {
      traverse(value[key], seen);
    }
  }
  return value;
}
function useTransitionState() {
  const state = {
    isMounted: false,
    isLeaving: false,
    isUnmounting: false,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  onMounted(() => {
    state.isMounted = true;
  });
  onBeforeUnmount(() => {
    state.isUnmounting = true;
  });
  return state;
}
const TransitionHookValidator = [Function, Array];
const BaseTransitionImpl = {
  name: `BaseTransition`,
  props: {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
  },
  setup(props, { slots }) {
    const instance = getCurrentInstance();
    const state = useTransitionState();
    let prevTransitionKey;
    return () => {
      const children = slots.default && getTransitionRawChildren(slots.default(), true);
      if (!children || !children.length) {
        return;
      }
      const rawProps = toRaw(props);
      const { mode } = rawProps;
      const child = children[0];
      if (state.isLeaving) {
        return emptyPlaceholder(child);
      }
      const innerChild = getKeepAliveChild(child);
      if (!innerChild) {
        return emptyPlaceholder(child);
      }
      const enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance);
      setTransitionHooks(innerChild, enterHooks);
      const oldChild = instance.subTree;
      const oldInnerChild = oldChild && getKeepAliveChild(oldChild);
      let transitionKeyChanged = false;
      const { getTransitionKey } = innerChild.type;
      if (getTransitionKey) {
        const key = getTransitionKey();
        if (prevTransitionKey === void 0) {
          prevTransitionKey = key;
        } else if (key !== prevTransitionKey) {
          prevTransitionKey = key;
          transitionKeyChanged = true;
        }
      }
      if (oldInnerChild && oldInnerChild.type !== Comment && (!isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
        const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
        setTransitionHooks(oldInnerChild, leavingHooks);
        if (mode === "out-in") {
          state.isLeaving = true;
          leavingHooks.afterLeave = () => {
            state.isLeaving = false;
            instance.update();
          };
          return emptyPlaceholder(child);
        } else if (mode === "in-out" && innerChild.type !== Comment) {
          leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
            const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
            leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
            el._leaveCb = () => {
              earlyRemove();
              el._leaveCb = void 0;
              delete enterHooks.delayedLeave;
            };
            enterHooks.delayedLeave = delayedLeave;
          };
        }
      }
      return child;
    };
  }
};
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
  const { leavingVNodes } = state;
  let leavingVNodesCache = leavingVNodes.get(vnode.type);
  if (!leavingVNodesCache) {
    leavingVNodesCache = /* @__PURE__ */ Object.create(null);
    leavingVNodes.set(vnode.type, leavingVNodesCache);
  }
  return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance) {
  const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
  const key = String(vnode.key);
  const leavingVNodesCache = getLeavingNodesForType(state, vnode);
  const callHook2 = (hook, args) => {
    hook && callWithAsyncErrorHandling(hook, instance, 9, args);
  };
  const hooks = {
    mode,
    persisted,
    beforeEnter(el) {
      let hook = onBeforeEnter;
      if (!state.isMounted) {
        if (appear) {
          hook = onBeforeAppear || onBeforeEnter;
        } else {
          return;
        }
      }
      if (el._leaveCb) {
        el._leaveCb(true);
      }
      const leavingVNode = leavingVNodesCache[key];
      if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) {
        leavingVNode.el._leaveCb();
      }
      callHook2(hook, [el]);
    },
    enter(el) {
      let hook = onEnter;
      let afterHook = onAfterEnter;
      let cancelHook = onEnterCancelled;
      if (!state.isMounted) {
        if (appear) {
          hook = onAppear || onEnter;
          afterHook = onAfterAppear || onAfterEnter;
          cancelHook = onAppearCancelled || onEnterCancelled;
        } else {
          return;
        }
      }
      let called = false;
      const done = el._enterCb = (cancelled) => {
        if (called)
          return;
        called = true;
        if (cancelled) {
          callHook2(cancelHook, [el]);
        } else {
          callHook2(afterHook, [el]);
        }
        if (hooks.delayedLeave) {
          hooks.delayedLeave();
        }
        el._enterCb = void 0;
      };
      if (hook) {
        hook(el, done);
        if (hook.length <= 1) {
          done();
        }
      } else {
        done();
      }
    },
    leave(el, remove2) {
      const key2 = String(vnode.key);
      if (el._enterCb) {
        el._enterCb(true);
      }
      if (state.isUnmounting) {
        return remove2();
      }
      callHook2(onBeforeLeave, [el]);
      let called = false;
      const done = el._leaveCb = (cancelled) => {
        if (called)
          return;
        called = true;
        remove2();
        if (cancelled) {
          callHook2(onLeaveCancelled, [el]);
        } else {
          callHook2(onAfterLeave, [el]);
        }
        el._leaveCb = void 0;
        if (leavingVNodesCache[key2] === vnode) {
          delete leavingVNodesCache[key2];
        }
      };
      leavingVNodesCache[key2] = vnode;
      if (onLeave) {
        onLeave(el, done);
        if (onLeave.length <= 1) {
          done();
        }
      } else {
        done();
      }
    },
    clone(vnode2) {
      return resolveTransitionHooks(vnode2, props, state, instance);
    }
  };
  return hooks;
}
function emptyPlaceholder(vnode) {
  if (isKeepAlive(vnode)) {
    vnode = cloneVNode(vnode);
    vnode.children = null;
    return vnode;
  }
}
function getKeepAliveChild(vnode) {
  return isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function setTransitionHooks(vnode, hooks) {
  if (vnode.shapeFlag & 6 && vnode.component) {
    setTransitionHooks(vnode.component.subTree, hooks);
  } else if (vnode.shapeFlag & 128) {
    vnode.ssContent.transition = hooks.clone(vnode.ssContent);
    vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
  } else {
    vnode.transition = hooks;
  }
}
function getTransitionRawChildren(children, keepComment = false) {
  let ret = [];
  let keyedFragmentCount = 0;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (child.type === Fragment) {
      if (child.patchFlag & 128)
        keyedFragmentCount++;
      ret = ret.concat(getTransitionRawChildren(child.children, keepComment));
    } else if (keepComment || child.type !== Comment) {
      ret.push(child);
    }
  }
  if (keyedFragmentCount > 1) {
    for (let i = 0; i < ret.length; i++) {
      ret[i].patchFlag = -2;
    }
  }
  return ret;
}
function defineComponent(options) {
  return isFunction$2(options) ? { setup: options, name: options.name } : options;
}
const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
function onActivated(hook, target) {
  registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
  registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
  const wrappedHook = hook.__wdc || (hook.__wdc = () => {
    let current = target;
    while (current) {
      if (current.isDeactivated) {
        return;
      }
      current = current.parent;
    }
    return hook();
  });
  injectHook(type, wrappedHook, target);
  if (target) {
    let current = target.parent;
    while (current && current.parent) {
      if (isKeepAlive(current.parent.vnode)) {
        injectToKeepAliveRoot(wrappedHook, type, target, current);
      }
      current = current.parent;
    }
  }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
  const injected = injectHook(type, hook, keepAliveRoot, true);
  onUnmounted(() => {
    remove(keepAliveRoot[type], injected);
  }, target);
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
  if (target) {
    const hooks = target[type] || (target[type] = []);
    const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
      if (target.isUnmounted) {
        return;
      }
      pauseTracking();
      setCurrentInstance(target);
      const res = callWithAsyncErrorHandling(hook, target, type, args);
      unsetCurrentInstance();
      resetTracking();
      return res;
    });
    if (prepend) {
      hooks.unshift(wrappedHook);
    } else {
      hooks.push(wrappedHook);
    }
    return wrappedHook;
  }
}
const createHook = (lifecycle) => (hook, target = currentInstance) => (!isInSSRComponentSetup || lifecycle === "sp") && injectHook(lifecycle, hook, target);
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
  injectHook("ec", hook, target);
}
let shouldCacheAccess = true;
function applyOptions(instance) {
  const options = resolveMergedOptions(instance);
  const publicThis = instance.proxy;
  const ctx = instance.ctx;
  shouldCacheAccess = false;
  if (options.beforeCreate) {
    callHook$1(options.beforeCreate, instance, "bc");
  }
  const {
    data: dataOptions,
    computed: computedOptions,
    methods,
    watch: watchOptions,
    provide: provideOptions,
    inject: injectOptions,
    created,
    beforeMount,
    mounted,
    beforeUpdate,
    updated,
    activated,
    deactivated,
    beforeDestroy,
    beforeUnmount,
    destroyed,
    unmounted,
    render: render2,
    renderTracked,
    renderTriggered,
    errorCaptured,
    serverPrefetch,
    expose,
    inheritAttrs,
    components,
    directives,
    filters
  } = options;
  const checkDuplicateProperties = null;
  if (injectOptions) {
    resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
  }
  if (methods) {
    for (const key in methods) {
      const methodHandler = methods[key];
      if (isFunction$2(methodHandler)) {
        {
          ctx[key] = methodHandler.bind(publicThis);
        }
      }
    }
  }
  if (dataOptions) {
    const data = dataOptions.call(publicThis, publicThis);
    if (!isObject$2(data))
      ;
    else {
      instance.data = reactive(data);
    }
  }
  shouldCacheAccess = true;
  if (computedOptions) {
    for (const key in computedOptions) {
      const opt = computedOptions[key];
      const get2 = isFunction$2(opt) ? opt.bind(publicThis, publicThis) : isFunction$2(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
      const set2 = !isFunction$2(opt) && isFunction$2(opt.set) ? opt.set.bind(publicThis) : NOOP;
      const c = computed({
        get: get2,
        set: set2
      });
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => c.value,
        set: (v2) => c.value = v2
      });
    }
  }
  if (watchOptions) {
    for (const key in watchOptions) {
      createWatcher(watchOptions[key], ctx, publicThis, key);
    }
  }
  if (provideOptions) {
    const provides = isFunction$2(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
    Reflect.ownKeys(provides).forEach((key) => {
      provide(key, provides[key]);
    });
  }
  if (created) {
    callHook$1(created, instance, "c");
  }
  function registerLifecycleHook(register, hook) {
    if (isArray$2(hook)) {
      hook.forEach((_hook) => register(_hook.bind(publicThis)));
    } else if (hook) {
      register(hook.bind(publicThis));
    }
  }
  registerLifecycleHook(onBeforeMount, beforeMount);
  registerLifecycleHook(onMounted, mounted);
  registerLifecycleHook(onBeforeUpdate, beforeUpdate);
  registerLifecycleHook(onUpdated, updated);
  registerLifecycleHook(onActivated, activated);
  registerLifecycleHook(onDeactivated, deactivated);
  registerLifecycleHook(onErrorCaptured, errorCaptured);
  registerLifecycleHook(onRenderTracked, renderTracked);
  registerLifecycleHook(onRenderTriggered, renderTriggered);
  registerLifecycleHook(onBeforeUnmount, beforeUnmount);
  registerLifecycleHook(onUnmounted, unmounted);
  registerLifecycleHook(onServerPrefetch, serverPrefetch);
  if (isArray$2(expose)) {
    if (expose.length) {
      const exposed = instance.exposed || (instance.exposed = {});
      expose.forEach((key) => {
        Object.defineProperty(exposed, key, {
          get: () => publicThis[key],
          set: (val) => publicThis[key] = val
        });
      });
    } else if (!instance.exposed) {
      instance.exposed = {};
    }
  }
  if (render2 && instance.render === NOOP) {
    instance.render = render2;
  }
  if (inheritAttrs != null) {
    instance.inheritAttrs = inheritAttrs;
  }
  if (components)
    instance.components = components;
  if (directives)
    instance.directives = directives;
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP, unwrapRef = false) {
  if (isArray$2(injectOptions)) {
    injectOptions = normalizeInject(injectOptions);
  }
  for (const key in injectOptions) {
    const opt = injectOptions[key];
    let injected;
    if (isObject$2(opt)) {
      if ("default" in opt) {
        injected = inject(opt.from || key, opt.default, true);
      } else {
        injected = inject(opt.from || key);
      }
    } else {
      injected = inject(opt);
    }
    if (isRef(injected)) {
      if (unwrapRef) {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => injected.value,
          set: (v2) => injected.value = v2
        });
      } else {
        ctx[key] = injected;
      }
    } else {
      ctx[key] = injected;
    }
  }
}
function callHook$1(hook, instance, type) {
  callWithAsyncErrorHandling(isArray$2(hook) ? hook.map((h2) => h2.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
  const getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
  if (isString$2(raw)) {
    const handler = ctx[raw];
    if (isFunction$2(handler)) {
      watch(getter, handler);
    }
  } else if (isFunction$2(raw)) {
    watch(getter, raw.bind(publicThis));
  } else if (isObject$2(raw)) {
    if (isArray$2(raw)) {
      raw.forEach((r2) => createWatcher(r2, ctx, publicThis, key));
    } else {
      const handler = isFunction$2(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
      if (isFunction$2(handler)) {
        watch(getter, handler, raw);
      }
    }
  } else
    ;
}
function resolveMergedOptions(instance) {
  const base = instance.type;
  const { mixins, extends: extendsOptions } = base;
  const { mixins: globalMixins, optionsCache: cache2, config: { optionMergeStrategies } } = instance.appContext;
  const cached = cache2.get(base);
  let resolved;
  if (cached) {
    resolved = cached;
  } else if (!globalMixins.length && !mixins && !extendsOptions) {
    {
      resolved = base;
    }
  } else {
    resolved = {};
    if (globalMixins.length) {
      globalMixins.forEach((m2) => mergeOptions(resolved, m2, optionMergeStrategies, true));
    }
    mergeOptions(resolved, base, optionMergeStrategies);
  }
  cache2.set(base, resolved);
  return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
  const { mixins, extends: extendsOptions } = from;
  if (extendsOptions) {
    mergeOptions(to, extendsOptions, strats, true);
  }
  if (mixins) {
    mixins.forEach((m2) => mergeOptions(to, m2, strats, true));
  }
  for (const key in from) {
    if (asMixin && key === "expose")
      ;
    else {
      const strat = internalOptionMergeStrats[key] || strats && strats[key];
      to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
  }
  return to;
}
const internalOptionMergeStrats = {
  data: mergeDataFn,
  props: mergeObjectOptions,
  emits: mergeObjectOptions,
  methods: mergeObjectOptions,
  computed: mergeObjectOptions,
  beforeCreate: mergeAsArray,
  created: mergeAsArray,
  beforeMount: mergeAsArray,
  mounted: mergeAsArray,
  beforeUpdate: mergeAsArray,
  updated: mergeAsArray,
  beforeDestroy: mergeAsArray,
  beforeUnmount: mergeAsArray,
  destroyed: mergeAsArray,
  unmounted: mergeAsArray,
  activated: mergeAsArray,
  deactivated: mergeAsArray,
  errorCaptured: mergeAsArray,
  serverPrefetch: mergeAsArray,
  components: mergeObjectOptions,
  directives: mergeObjectOptions,
  watch: mergeWatchOptions,
  provide: mergeDataFn,
  inject: mergeInject
};
function mergeDataFn(to, from) {
  if (!from) {
    return to;
  }
  if (!to) {
    return from;
  }
  return function mergedDataFn() {
    return extend$1(isFunction$2(to) ? to.call(this, this) : to, isFunction$2(from) ? from.call(this, this) : from);
  };
}
function mergeInject(to, from) {
  return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
  if (isArray$2(raw)) {
    const res = {};
    for (let i = 0; i < raw.length; i++) {
      res[raw[i]] = raw[i];
    }
    return res;
  }
  return raw;
}
function mergeAsArray(to, from) {
  return to ? [...new Set([].concat(to, from))] : from;
}
function mergeObjectOptions(to, from) {
  return to ? extend$1(extend$1(/* @__PURE__ */ Object.create(null), to), from) : from;
}
function mergeWatchOptions(to, from) {
  if (!to)
    return from;
  if (!from)
    return to;
  const merged = extend$1(/* @__PURE__ */ Object.create(null), to);
  for (const key in from) {
    merged[key] = mergeAsArray(to[key], from[key]);
  }
  return merged;
}
function initProps(instance, rawProps, isStateful, isSSR = false) {
  const props = {};
  const attrs = {};
  def(attrs, InternalObjectKey, 1);
  instance.propsDefaults = /* @__PURE__ */ Object.create(null);
  setFullProps(instance, rawProps, props, attrs);
  for (const key in instance.propsOptions[0]) {
    if (!(key in props)) {
      props[key] = void 0;
    }
  }
  if (isStateful) {
    instance.props = isSSR ? props : shallowReactive(props);
  } else {
    if (!instance.type.props) {
      instance.props = attrs;
    } else {
      instance.props = props;
    }
  }
  instance.attrs = attrs;
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
  const { props, attrs, vnode: { patchFlag } } = instance;
  const rawCurrentProps = toRaw(props);
  const [options] = instance.propsOptions;
  let hasAttrsChanged = false;
  if ((optimized || patchFlag > 0) && !(patchFlag & 16)) {
    if (patchFlag & 8) {
      const propsToUpdate = instance.vnode.dynamicProps;
      for (let i = 0; i < propsToUpdate.length; i++) {
        let key = propsToUpdate[i];
        const value = rawProps[key];
        if (options) {
          if (hasOwn$1(attrs, key)) {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          } else {
            const camelizedKey = camelize$1(key);
            props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
          }
        } else {
          if (value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
  } else {
    if (setFullProps(instance, rawProps, props, attrs)) {
      hasAttrsChanged = true;
    }
    let kebabKey;
    for (const key in rawCurrentProps) {
      if (!rawProps || !hasOwn$1(rawProps, key) && ((kebabKey = hyphenate$1(key)) === key || !hasOwn$1(rawProps, kebabKey))) {
        if (options) {
          if (rawPrevProps && (rawPrevProps[key] !== void 0 || rawPrevProps[kebabKey] !== void 0)) {
            props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
          }
        } else {
          delete props[key];
        }
      }
    }
    if (attrs !== rawCurrentProps) {
      for (const key in attrs) {
        if (!rawProps || !hasOwn$1(rawProps, key) && true) {
          delete attrs[key];
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (hasAttrsChanged) {
    trigger$1(instance, "set", "$attrs");
  }
}
function setFullProps(instance, rawProps, props, attrs) {
  const [options, needCastKeys] = instance.propsOptions;
  let hasAttrsChanged = false;
  let rawCastValues;
  if (rawProps) {
    for (let key in rawProps) {
      if (isReservedProp(key)) {
        continue;
      }
      const value = rawProps[key];
      let camelKey;
      if (options && hasOwn$1(options, camelKey = camelize$1(key))) {
        if (!needCastKeys || !needCastKeys.includes(camelKey)) {
          props[camelKey] = value;
        } else {
          (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        }
      } else if (!isEmitListener(instance.emitsOptions, key)) {
        if (!(key in attrs) || value !== attrs[key]) {
          attrs[key] = value;
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (needCastKeys) {
    const rawCurrentProps = toRaw(props);
    const castValues = rawCastValues || EMPTY_OBJ;
    for (let i = 0; i < needCastKeys.length; i++) {
      const key = needCastKeys[i];
      props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !hasOwn$1(castValues, key));
    }
  }
  return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
  const opt = options[key];
  if (opt != null) {
    const hasDefault = hasOwn$1(opt, "default");
    if (hasDefault && value === void 0) {
      const defaultValue = opt.default;
      if (opt.type !== Function && isFunction$2(defaultValue)) {
        const { propsDefaults } = instance;
        if (key in propsDefaults) {
          value = propsDefaults[key];
        } else {
          setCurrentInstance(instance);
          value = propsDefaults[key] = defaultValue.call(null, props);
          unsetCurrentInstance();
        }
      } else {
        value = defaultValue;
      }
    }
    if (opt[0]) {
      if (isAbsent && !hasDefault) {
        value = false;
      } else if (opt[1] && (value === "" || value === hyphenate$1(key))) {
        value = true;
      }
    }
  }
  return value;
}
function normalizePropsOptions(comp, appContext, asMixin = false) {
  const cache2 = appContext.propsCache;
  const cached = cache2.get(comp);
  if (cached) {
    return cached;
  }
  const raw = comp.props;
  const normalized = {};
  const needCastKeys = [];
  let hasExtends = false;
  if (!isFunction$2(comp)) {
    const extendProps = (raw2) => {
      hasExtends = true;
      const [props, keys] = normalizePropsOptions(raw2, appContext, true);
      extend$1(normalized, props);
      if (keys)
        needCastKeys.push(...keys);
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendProps);
    }
    if (comp.extends) {
      extendProps(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendProps);
    }
  }
  if (!raw && !hasExtends) {
    cache2.set(comp, EMPTY_ARR);
    return EMPTY_ARR;
  }
  if (isArray$2(raw)) {
    for (let i = 0; i < raw.length; i++) {
      const normalizedKey = camelize$1(raw[i]);
      if (validatePropName(normalizedKey)) {
        normalized[normalizedKey] = EMPTY_OBJ;
      }
    }
  } else if (raw) {
    for (const key in raw) {
      const normalizedKey = camelize$1(key);
      if (validatePropName(normalizedKey)) {
        const opt = raw[key];
        const prop = normalized[normalizedKey] = isArray$2(opt) || isFunction$2(opt) ? { type: opt } : opt;
        if (prop) {
          const booleanIndex = getTypeIndex(Boolean, prop.type);
          const stringIndex = getTypeIndex(String, prop.type);
          prop[0] = booleanIndex > -1;
          prop[1] = stringIndex < 0 || booleanIndex < stringIndex;
          if (booleanIndex > -1 || hasOwn$1(prop, "default")) {
            needCastKeys.push(normalizedKey);
          }
        }
      }
    }
  }
  const res = [normalized, needCastKeys];
  cache2.set(comp, res);
  return res;
}
function validatePropName(key) {
  if (key[0] !== "$") {
    return true;
  }
  return false;
}
function getType(ctor) {
  const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ctor === null ? "null" : "";
}
function isSameType(a2, b2) {
  return getType(a2) === getType(b2);
}
function getTypeIndex(type, expectedTypes) {
  if (isArray$2(expectedTypes)) {
    return expectedTypes.findIndex((t2) => isSameType(t2, type));
  } else if (isFunction$2(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1;
  }
  return -1;
}
const isInternalKey = (key) => key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value) => isArray$2(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
const normalizeSlot = (key, rawSlot, ctx) => {
  const normalized = withCtx((...args) => {
    return normalizeSlotValue(rawSlot(...args));
  }, ctx);
  normalized._c = false;
  return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance) => {
  const ctx = rawSlots._ctx;
  for (const key in rawSlots) {
    if (isInternalKey(key))
      continue;
    const value = rawSlots[key];
    if (isFunction$2(value)) {
      slots[key] = normalizeSlot(key, value, ctx);
    } else if (value != null) {
      const normalized = normalizeSlotValue(value);
      slots[key] = () => normalized;
    }
  }
};
const normalizeVNodeSlots = (instance, children) => {
  const normalized = normalizeSlotValue(children);
  instance.slots.default = () => normalized;
};
const initSlots = (instance, children) => {
  if (instance.vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      instance.slots = toRaw(children);
      def(children, "_", type);
    } else {
      normalizeObjectSlots(children, instance.slots = {});
    }
  } else {
    instance.slots = {};
    if (children) {
      normalizeVNodeSlots(instance, children);
    }
  }
  def(instance.slots, InternalObjectKey, 1);
};
const updateSlots = (instance, children, optimized) => {
  const { vnode, slots } = instance;
  let needDeletionCheck = true;
  let deletionComparisonTarget = EMPTY_OBJ;
  if (vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      if (optimized && type === 1) {
        needDeletionCheck = false;
      } else {
        extend$1(slots, children);
        if (!optimized && type === 1) {
          delete slots._;
        }
      }
    } else {
      needDeletionCheck = !children.$stable;
      normalizeObjectSlots(children, slots);
    }
    deletionComparisonTarget = children;
  } else if (children) {
    normalizeVNodeSlots(instance, children);
    deletionComparisonTarget = { default: 1 };
  }
  if (needDeletionCheck) {
    for (const key in slots) {
      if (!isInternalKey(key) && !(key in deletionComparisonTarget)) {
        delete slots[key];
      }
    }
  }
};
function withDirectives(vnode, directives) {
  const internalInstance = currentRenderingInstance;
  if (internalInstance === null) {
    return vnode;
  }
  const instance = internalInstance.proxy;
  const bindings = vnode.dirs || (vnode.dirs = []);
  for (let i = 0; i < directives.length; i++) {
    let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i];
    if (isFunction$2(dir)) {
      dir = {
        mounted: dir,
        updated: dir
      };
    }
    if (dir.deep) {
      traverse(value);
    }
    bindings.push({
      dir,
      instance,
      value,
      oldValue: void 0,
      arg,
      modifiers
    });
  }
  return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name2) {
  const bindings = vnode.dirs;
  const oldBindings = prevVNode && prevVNode.dirs;
  for (let i = 0; i < bindings.length; i++) {
    const binding = bindings[i];
    if (oldBindings) {
      binding.oldValue = oldBindings[i].value;
    }
    let hook = binding.dir[name2];
    if (hook) {
      pauseTracking();
      callWithAsyncErrorHandling(hook, instance, 8, [
        vnode.el,
        binding,
        vnode,
        prevVNode
      ]);
      resetTracking();
    }
  }
}
function createAppContext() {
  return {
    app: null,
    config: {
      isNativeTag: NO,
      performance: false,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let uid = 0;
function createAppAPI(render2, hydrate) {
  return function createApp(rootComponent, rootProps = null) {
    if (rootProps != null && !isObject$2(rootProps)) {
      rootProps = null;
    }
    const context = createAppContext();
    const installedPlugins = /* @__PURE__ */ new Set();
    let isMounted = false;
    const app = context.app = {
      _uid: uid++,
      _component: rootComponent,
      _props: rootProps,
      _container: null,
      _context: context,
      _instance: null,
      version,
      get config() {
        return context.config;
      },
      set config(v2) {
      },
      use(plugin, ...options) {
        if (installedPlugins.has(plugin))
          ;
        else if (plugin && isFunction$2(plugin.install)) {
          installedPlugins.add(plugin);
          plugin.install(app, ...options);
        } else if (isFunction$2(plugin)) {
          installedPlugins.add(plugin);
          plugin(app, ...options);
        } else
          ;
        return app;
      },
      mixin(mixin) {
        {
          if (!context.mixins.includes(mixin)) {
            context.mixins.push(mixin);
          }
        }
        return app;
      },
      component(name2, component) {
        if (!component) {
          return context.components[name2];
        }
        context.components[name2] = component;
        return app;
      },
      directive(name2, directive) {
        if (!directive) {
          return context.directives[name2];
        }
        context.directives[name2] = directive;
        return app;
      },
      mount(rootContainer, isHydrate, isSVG) {
        if (!isMounted) {
          const vnode = createVNode(rootComponent, rootProps);
          vnode.appContext = context;
          if (isHydrate && hydrate) {
            hydrate(vnode, rootContainer);
          } else {
            render2(vnode, rootContainer, isSVG);
          }
          isMounted = true;
          app._container = rootContainer;
          rootContainer.__vue_app__ = app;
          return getExposeProxy(vnode.component) || vnode.component.proxy;
        }
      },
      unmount() {
        if (isMounted) {
          render2(null, app._container);
          delete app._container.__vue_app__;
        }
      },
      provide(key, value) {
        context.provides[key] = value;
        return app;
      }
    };
    return app;
  };
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
  if (isArray$2(rawRef)) {
    rawRef.forEach((r2, i) => setRef(r2, oldRawRef && (isArray$2(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
    return;
  }
  if (isAsyncWrapper(vnode) && !isUnmount) {
    return;
  }
  const refValue = vnode.shapeFlag & 4 ? getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
  const value = isUnmount ? null : refValue;
  const { i: owner, r: ref2 } = rawRef;
  const oldRef = oldRawRef && oldRawRef.r;
  const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
  const setupState = owner.setupState;
  if (oldRef != null && oldRef !== ref2) {
    if (isString$2(oldRef)) {
      refs[oldRef] = null;
      if (hasOwn$1(setupState, oldRef)) {
        setupState[oldRef] = null;
      }
    } else if (isRef(oldRef)) {
      oldRef.value = null;
    }
  }
  if (isFunction$2(ref2)) {
    callWithErrorHandling(ref2, owner, 12, [value, refs]);
  } else {
    const _isString = isString$2(ref2);
    const _isRef = isRef(ref2);
    if (_isString || _isRef) {
      const doSet = () => {
        if (rawRef.f) {
          const existing = _isString ? refs[ref2] : ref2.value;
          if (isUnmount) {
            isArray$2(existing) && remove(existing, refValue);
          } else {
            if (!isArray$2(existing)) {
              if (_isString) {
                refs[ref2] = [refValue];
              } else {
                ref2.value = [refValue];
                if (rawRef.k)
                  refs[rawRef.k] = ref2.value;
              }
            } else if (!existing.includes(refValue)) {
              existing.push(refValue);
            }
          }
        } else if (_isString) {
          refs[ref2] = value;
          if (hasOwn$1(setupState, ref2)) {
            setupState[ref2] = value;
          }
        } else if (isRef(ref2)) {
          ref2.value = value;
          if (rawRef.k)
            refs[rawRef.k] = value;
        } else
          ;
      };
      if (value) {
        doSet.id = -1;
        queuePostRenderEffect(doSet, parentSuspense);
      } else {
        doSet();
      }
    }
  }
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
  return baseCreateRenderer(options);
}
function baseCreateRenderer(options, createHydrationFns) {
  const target = getGlobalThis$1();
  target.__VUE__ = true;
  const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = NOOP, cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
  const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren) => {
    if (n1 === n2) {
      return;
    }
    if (n1 && !isSameVNodeType(n1, n2)) {
      anchor = getNextHostNode(n1);
      unmount(n1, parentComponent, parentSuspense, true);
      n1 = null;
    }
    if (n2.patchFlag === -2) {
      optimized = false;
      n2.dynamicChildren = null;
    }
    const { type, ref: ref2, shapeFlag } = n2;
    switch (type) {
      case Text:
        processText(n1, n2, container, anchor);
        break;
      case Comment:
        processCommentNode(n1, n2, container, anchor);
        break;
      case Static:
        if (n1 == null) {
          mountStaticNode(n2, container, anchor, isSVG);
        }
        break;
      case Fragment:
        processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        break;
      default:
        if (shapeFlag & 1) {
          processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (shapeFlag & 6) {
          processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (shapeFlag & 64) {
          type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        } else if (shapeFlag & 128) {
          type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        } else
          ;
    }
    if (ref2 != null && parentComponent) {
      setRef(ref2, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    }
  };
  const processText = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
    } else {
      const el = n2.el = n1.el;
      if (n2.children !== n1.children) {
        hostSetText(el, n2.children);
      }
    }
  };
  const processCommentNode = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
    } else {
      n2.el = n1.el;
    }
  };
  const mountStaticNode = (n2, container, anchor, isSVG) => {
    [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
  };
  const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostInsert(el, container, nextSibling);
      el = next;
    }
    hostInsert(anchor, container, nextSibling);
  };
  const removeStaticNode = ({ el, anchor }) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostRemove(el);
      el = next;
    }
    hostRemove(anchor);
  };
  const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    isSVG = isSVG || n2.type === "svg";
    if (n1 == null) {
      mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    } else {
      patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
  };
  const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    let el;
    let vnodeHook;
    const { type, props, shapeFlag, transition, patchFlag, dirs } = vnode;
    if (vnode.el && hostCloneNode !== void 0 && patchFlag === -1) {
      el = vnode.el = hostCloneNode(vnode.el);
    } else {
      el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
      if (shapeFlag & 8) {
        hostSetElementText(el, vnode.children);
      } else if (shapeFlag & 16) {
        mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "created");
      }
      if (props) {
        for (const key in props) {
          if (key !== "value" && !isReservedProp(key)) {
            hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
          }
        }
        if ("value" in props) {
          hostPatchProp(el, "value", null, props.value);
        }
        if (vnodeHook = props.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
      }
      setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
    }
    if (dirs) {
      invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
    }
    const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
    if (needCallTransitionHooks) {
      transition.beforeEnter(el);
    }
    hostInsert(el, container, anchor);
    if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        needCallTransitionHooks && transition.enter(el);
        dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
      }, parentSuspense);
    }
  };
  const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
    if (scopeId) {
      hostSetScopeId(el, scopeId);
    }
    if (slotScopeIds) {
      for (let i = 0; i < slotScopeIds.length; i++) {
        hostSetScopeId(el, slotScopeIds[i]);
      }
    }
    if (parentComponent) {
      let subTree = parentComponent.subTree;
      if (vnode === subTree) {
        const parentVNode = parentComponent.vnode;
        setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
      }
    }
  };
  const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0) => {
    for (let i = start; i < children.length; i++) {
      const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
      patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
  };
  const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    const el = n2.el = n1.el;
    let { patchFlag, dynamicChildren, dirs } = n2;
    patchFlag |= n1.patchFlag & 16;
    const oldProps = n1.props || EMPTY_OBJ;
    const newProps = n2.props || EMPTY_OBJ;
    let vnodeHook;
    parentComponent && toggleRecurse(parentComponent, false);
    if (vnodeHook = newProps.onVnodeBeforeUpdate) {
      invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
    }
    if (dirs) {
      invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
    }
    parentComponent && toggleRecurse(parentComponent, true);
    const areChildrenSVG = isSVG && n2.type !== "foreignObject";
    if (dynamicChildren) {
      patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
    } else if (!optimized) {
      patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
    }
    if (patchFlag > 0) {
      if (patchFlag & 16) {
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
      } else {
        if (patchFlag & 2) {
          if (oldProps.class !== newProps.class) {
            hostPatchProp(el, "class", null, newProps.class, isSVG);
          }
        }
        if (patchFlag & 4) {
          hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
        }
        if (patchFlag & 8) {
          const propsToUpdate = n2.dynamicProps;
          for (let i = 0; i < propsToUpdate.length; i++) {
            const key = propsToUpdate[i];
            const prev = oldProps[key];
            const next = newProps[key];
            if (next !== prev || key === "value") {
              hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
            }
          }
        }
      }
      if (patchFlag & 1) {
        if (n1.children !== n2.children) {
          hostSetElementText(el, n2.children);
        }
      }
    } else if (!optimized && dynamicChildren == null) {
      patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
    }
    if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
      }, parentSuspense);
    }
  };
  const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds) => {
    for (let i = 0; i < newChildren.length; i++) {
      const oldVNode = oldChildren[i];
      const newVNode = newChildren[i];
      const container = oldVNode.el && (oldVNode.type === Fragment || !isSameVNodeType(oldVNode, newVNode) || oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : fallbackContainer;
      patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
    }
  };
  const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) => {
    if (oldProps !== newProps) {
      for (const key in newProps) {
        if (isReservedProp(key))
          continue;
        const next = newProps[key];
        const prev = oldProps[key];
        if (next !== prev && key !== "value") {
          hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
        }
      }
      if (oldProps !== EMPTY_OBJ) {
        for (const key in oldProps) {
          if (!isReservedProp(key) && !(key in newProps)) {
            hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
          }
        }
      }
      if ("value" in newProps) {
        hostPatchProp(el, "value", oldProps.value, newProps.value);
      }
    }
  };
  const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
    const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
    let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
    if (fragmentSlotScopeIds) {
      slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
    }
    if (n1 == null) {
      hostInsert(fragmentStartAnchor, container, anchor);
      hostInsert(fragmentEndAnchor, container, anchor);
      mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    } else {
      if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && n1.dynamicChildren) {
        patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
        if (n2.key != null || parentComponent && n2 === parentComponent.subTree) {
          traverseStaticChildren(n1, n2, true);
        }
      } else {
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      }
    }
  };
  const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    n2.slotScopeIds = slotScopeIds;
    if (n1 == null) {
      if (n2.shapeFlag & 512) {
        parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
      } else {
        mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
      }
    } else {
      updateComponent(n1, n2, optimized);
    }
  };
  const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
    const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
    if (isKeepAlive(initialVNode)) {
      instance.ctx.renderer = internals;
    }
    {
      setupComponent(instance);
    }
    if (instance.asyncDep) {
      parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
      if (!initialVNode.el) {
        const placeholder = instance.subTree = createVNode(Comment);
        processCommentNode(null, placeholder, container, anchor);
      }
      return;
    }
    setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
  };
  const updateComponent = (n1, n2, optimized) => {
    const instance = n2.component = n1.component;
    if (shouldUpdateComponent(n1, n2, optimized)) {
      if (instance.asyncDep && !instance.asyncResolved) {
        updateComponentPreRender(instance, n2, optimized);
        return;
      } else {
        instance.next = n2;
        invalidateJob(instance.update);
        instance.update();
      }
    } else {
      n2.component = n1.component;
      n2.el = n1.el;
      instance.vnode = n2;
    }
  };
  const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized) => {
    const componentUpdateFn = () => {
      if (!instance.isMounted) {
        let vnodeHook;
        const { el, props } = initialVNode;
        const { bm, m: m2, parent } = instance;
        const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
        toggleRecurse(instance, false);
        if (bm) {
          invokeArrayFns$1(bm);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
          invokeVNodeHook(vnodeHook, parent, initialVNode);
        }
        toggleRecurse(instance, true);
        if (el && hydrateNode) {
          const hydrateSubTree = () => {
            instance.subTree = renderComponentRoot(instance);
            hydrateNode(el, instance.subTree, instance, parentSuspense, null);
          };
          if (isAsyncWrapperVNode) {
            initialVNode.type.__asyncLoader().then(
              () => !instance.isUnmounted && hydrateSubTree()
            );
          } else {
            hydrateSubTree();
          }
        } else {
          const subTree = instance.subTree = renderComponentRoot(instance);
          patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
          initialVNode.el = subTree.el;
        }
        if (m2) {
          queuePostRenderEffect(m2, parentSuspense);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
          const scopedInitialVNode = initialVNode;
          queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
        }
        if (initialVNode.shapeFlag & 256) {
          instance.a && queuePostRenderEffect(instance.a, parentSuspense);
        }
        instance.isMounted = true;
        initialVNode = container = anchor = null;
      } else {
        let { next, bu, u: u2, parent, vnode } = instance;
        let originNext = next;
        let vnodeHook;
        toggleRecurse(instance, false);
        if (next) {
          next.el = vnode.el;
          updateComponentPreRender(instance, next, optimized);
        } else {
          next = vnode;
        }
        if (bu) {
          invokeArrayFns$1(bu);
        }
        if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
          invokeVNodeHook(vnodeHook, parent, next, vnode);
        }
        toggleRecurse(instance, true);
        const nextTree = renderComponentRoot(instance);
        const prevTree = instance.subTree;
        instance.subTree = nextTree;
        patch(
          prevTree,
          nextTree,
          hostParentNode(prevTree.el),
          getNextHostNode(prevTree),
          instance,
          parentSuspense,
          isSVG
        );
        next.el = nextTree.el;
        if (originNext === null) {
          updateHOCHostEl(instance, nextTree.el);
        }
        if (u2) {
          queuePostRenderEffect(u2, parentSuspense);
        }
        if (vnodeHook = next.props && next.props.onVnodeUpdated) {
          queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
        }
      }
    };
    const effect = instance.effect = new ReactiveEffect(
      componentUpdateFn,
      () => queueJob(instance.update),
      instance.scope
    );
    const update = instance.update = effect.run.bind(effect);
    update.id = instance.uid;
    toggleRecurse(instance, true);
    update();
  };
  const updateComponentPreRender = (instance, nextVNode, optimized) => {
    nextVNode.component = instance;
    const prevProps = instance.vnode.props;
    instance.vnode = nextVNode;
    instance.next = null;
    updateProps(instance, nextVNode.props, prevProps, optimized);
    updateSlots(instance, nextVNode.children, optimized);
    pauseTracking();
    flushPreFlushCbs(void 0, instance.update);
    resetTracking();
  };
  const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false) => {
    const c1 = n1 && n1.children;
    const prevShapeFlag = n1 ? n1.shapeFlag : 0;
    const c2 = n2.children;
    const { patchFlag, shapeFlag } = n2;
    if (patchFlag > 0) {
      if (patchFlag & 128) {
        patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        return;
      } else if (patchFlag & 256) {
        patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        return;
      }
    }
    if (shapeFlag & 8) {
      if (prevShapeFlag & 16) {
        unmountChildren(c1, parentComponent, parentSuspense);
      }
      if (c2 !== c1) {
        hostSetElementText(container, c2);
      }
    } else {
      if (prevShapeFlag & 16) {
        if (shapeFlag & 16) {
          patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else {
          unmountChildren(c1, parentComponent, parentSuspense, true);
        }
      } else {
        if (prevShapeFlag & 8) {
          hostSetElementText(container, "");
        }
        if (shapeFlag & 16) {
          mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
      }
    }
  };
  const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    c1 = c1 || EMPTY_ARR;
    c2 = c2 || EMPTY_ARR;
    const oldLength = c1.length;
    const newLength = c2.length;
    const commonLength = Math.min(oldLength, newLength);
    let i;
    for (i = 0; i < commonLength; i++) {
      const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
    if (oldLength > newLength) {
      unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
    } else {
      mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    }
  };
  const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    let i = 0;
    const l2 = c2.length;
    let e1 = c1.length - 1;
    let e2 = l2 - 1;
    while (i <= e1 && i <= e2) {
      const n1 = c1[i];
      const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      if (isSameVNodeType(n1, n2)) {
        patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        break;
      }
      i++;
    }
    while (i <= e1 && i <= e2) {
      const n1 = c1[e1];
      const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
      if (isSameVNodeType(n1, n2)) {
        patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        break;
      }
      e1--;
      e2--;
    }
    if (i > e1) {
      if (i <= e2) {
        const nextPos = e2 + 1;
        const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
        while (i <= e2) {
          patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          i++;
        }
      }
    } else if (i > e2) {
      while (i <= e1) {
        unmount(c1[i], parentComponent, parentSuspense, true);
        i++;
      }
    } else {
      const s1 = i;
      const s2 = i;
      const keyToNewIndexMap = /* @__PURE__ */ new Map();
      for (i = s2; i <= e2; i++) {
        const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        if (nextChild.key != null) {
          keyToNewIndexMap.set(nextChild.key, i);
        }
      }
      let j2;
      let patched = 0;
      const toBePatched = e2 - s2 + 1;
      let moved = false;
      let maxNewIndexSoFar = 0;
      const newIndexToOldIndexMap = new Array(toBePatched);
      for (i = 0; i < toBePatched; i++)
        newIndexToOldIndexMap[i] = 0;
      for (i = s1; i <= e1; i++) {
        const prevChild = c1[i];
        if (patched >= toBePatched) {
          unmount(prevChild, parentComponent, parentSuspense, true);
          continue;
        }
        let newIndex;
        if (prevChild.key != null) {
          newIndex = keyToNewIndexMap.get(prevChild.key);
        } else {
          for (j2 = s2; j2 <= e2; j2++) {
            if (newIndexToOldIndexMap[j2 - s2] === 0 && isSameVNodeType(prevChild, c2[j2])) {
              newIndex = j2;
              break;
            }
          }
        }
        if (newIndex === void 0) {
          unmount(prevChild, parentComponent, parentSuspense, true);
        } else {
          newIndexToOldIndexMap[newIndex - s2] = i + 1;
          if (newIndex >= maxNewIndexSoFar) {
            maxNewIndexSoFar = newIndex;
          } else {
            moved = true;
          }
          patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          patched++;
        }
      }
      const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
      j2 = increasingNewIndexSequence.length - 1;
      for (i = toBePatched - 1; i >= 0; i--) {
        const nextIndex = s2 + i;
        const nextChild = c2[nextIndex];
        const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
        if (newIndexToOldIndexMap[i] === 0) {
          patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (moved) {
          if (j2 < 0 || i !== increasingNewIndexSequence[j2]) {
            move(nextChild, container, anchor, 2);
          } else {
            j2--;
          }
        }
      }
    }
  };
  const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
    const { el, type, transition, children, shapeFlag } = vnode;
    if (shapeFlag & 6) {
      move(vnode.component.subTree, container, anchor, moveType);
      return;
    }
    if (shapeFlag & 128) {
      vnode.suspense.move(container, anchor, moveType);
      return;
    }
    if (shapeFlag & 64) {
      type.move(vnode, container, anchor, internals);
      return;
    }
    if (type === Fragment) {
      hostInsert(el, container, anchor);
      for (let i = 0; i < children.length; i++) {
        move(children[i], container, anchor, moveType);
      }
      hostInsert(vnode.anchor, container, anchor);
      return;
    }
    if (type === Static) {
      moveStaticNode(vnode, container, anchor);
      return;
    }
    const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
    if (needTransition) {
      if (moveType === 0) {
        transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        queuePostRenderEffect(() => transition.enter(el), parentSuspense);
      } else {
        const { leave, delayLeave, afterLeave } = transition;
        const remove3 = () => hostInsert(el, container, anchor);
        const performLeave = () => {
          leave(el, () => {
            remove3();
            afterLeave && afterLeave();
          });
        };
        if (delayLeave) {
          delayLeave(el, remove3, performLeave);
        } else {
          performLeave();
        }
      }
    } else {
      hostInsert(el, container, anchor);
    }
  };
  const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
    const { type, props, ref: ref2, children, dynamicChildren, shapeFlag, patchFlag, dirs } = vnode;
    if (ref2 != null) {
      setRef(ref2, null, parentSuspense, vnode, true);
    }
    if (shapeFlag & 256) {
      parentComponent.ctx.deactivate(vnode);
      return;
    }
    const shouldInvokeDirs = shapeFlag & 1 && dirs;
    const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
    let vnodeHook;
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
      invokeVNodeHook(vnodeHook, parentComponent, vnode);
    }
    if (shapeFlag & 6) {
      unmountComponent(vnode.component, parentSuspense, doRemove);
    } else {
      if (shapeFlag & 128) {
        vnode.suspense.unmount(parentSuspense, doRemove);
        return;
      }
      if (shouldInvokeDirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
      }
      if (shapeFlag & 64) {
        vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
      } else if (dynamicChildren && (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
        unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
      } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
        unmountChildren(children, parentComponent, parentSuspense);
      }
      if (doRemove) {
        remove2(vnode);
      }
    }
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
      }, parentSuspense);
    }
  };
  const remove2 = (vnode) => {
    const { type, el, anchor, transition } = vnode;
    if (type === Fragment) {
      removeFragment(el, anchor);
      return;
    }
    if (type === Static) {
      removeStaticNode(vnode);
      return;
    }
    const performRemove = () => {
      hostRemove(el);
      if (transition && !transition.persisted && transition.afterLeave) {
        transition.afterLeave();
      }
    };
    if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
      const { leave, delayLeave } = transition;
      const performLeave = () => leave(el, performRemove);
      if (delayLeave) {
        delayLeave(vnode.el, performRemove, performLeave);
      } else {
        performLeave();
      }
    } else {
      performRemove();
    }
  };
  const removeFragment = (cur, end) => {
    let next;
    while (cur !== end) {
      next = hostNextSibling(cur);
      hostRemove(cur);
      cur = next;
    }
    hostRemove(end);
  };
  const unmountComponent = (instance, parentSuspense, doRemove) => {
    const { bum, scope, update, subTree, um } = instance;
    if (bum) {
      invokeArrayFns$1(bum);
    }
    scope.stop();
    if (update) {
      update.active = false;
      unmount(subTree, instance, parentSuspense, doRemove);
    }
    if (um) {
      queuePostRenderEffect(um, parentSuspense);
    }
    queuePostRenderEffect(() => {
      instance.isUnmounted = true;
    }, parentSuspense);
    if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
      parentSuspense.deps--;
      if (parentSuspense.deps === 0) {
        parentSuspense.resolve();
      }
    }
  };
  const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
    for (let i = start; i < children.length; i++) {
      unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    }
  };
  const getNextHostNode = (vnode) => {
    if (vnode.shapeFlag & 6) {
      return getNextHostNode(vnode.component.subTree);
    }
    if (vnode.shapeFlag & 128) {
      return vnode.suspense.next();
    }
    return hostNextSibling(vnode.anchor || vnode.el);
  };
  const render2 = (vnode, container, isSVG) => {
    if (vnode == null) {
      if (container._vnode) {
        unmount(container._vnode, null, null, true);
      }
    } else {
      patch(container._vnode || null, vnode, container, null, null, null, isSVG);
    }
    flushPostFlushCbs();
    container._vnode = vnode;
  };
  const internals = {
    p: patch,
    um: unmount,
    m: move,
    r: remove2,
    mt: mountComponent,
    mc: mountChildren,
    pc: patchChildren,
    pbc: patchBlockChildren,
    n: getNextHostNode,
    o: options
  };
  let hydrate;
  let hydrateNode;
  if (createHydrationFns) {
    [hydrate, hydrateNode] = createHydrationFns(internals);
  }
  return {
    render: render2,
    hydrate,
    createApp: createAppAPI(render2, hydrate)
  };
}
function toggleRecurse({ effect, update }, allowed) {
  effect.allowRecurse = update.allowRecurse = allowed;
}
function traverseStaticChildren(n1, n2, shallow = false) {
  const ch1 = n1.children;
  const ch2 = n2.children;
  if (isArray$2(ch1) && isArray$2(ch2)) {
    for (let i = 0; i < ch1.length; i++) {
      const c1 = ch1[i];
      let c2 = ch2[i];
      if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
        if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
          c2 = ch2[i] = cloneIfMounted(ch2[i]);
          c2.el = c1.el;
        }
        if (!shallow)
          traverseStaticChildren(c1, c2);
      }
    }
  }
}
function getSequence(arr) {
  const p2 = arr.slice();
  const result = [0];
  let i, j2, u2, v2, c;
  const len = arr.length;
  for (i = 0; i < len; i++) {
    const arrI = arr[i];
    if (arrI !== 0) {
      j2 = result[result.length - 1];
      if (arr[j2] < arrI) {
        p2[i] = j2;
        result.push(i);
        continue;
      }
      u2 = 0;
      v2 = result.length - 1;
      while (u2 < v2) {
        c = u2 + v2 >> 1;
        if (arr[result[c]] < arrI) {
          u2 = c + 1;
        } else {
          v2 = c;
        }
      }
      if (arrI < arr[result[u2]]) {
        if (u2 > 0) {
          p2[i] = result[u2 - 1];
        }
        result[u2] = i;
      }
    }
  }
  u2 = result.length;
  v2 = result[u2 - 1];
  while (u2-- > 0) {
    result[u2] = v2;
    v2 = p2[v2];
  }
  return result;
}
const isTeleport = (type) => type.__isTeleport;
const isTeleportDisabled = (props) => props && (props.disabled || props.disabled === "");
const isTargetSVG = (target) => typeof SVGElement !== "undefined" && target instanceof SVGElement;
const resolveTarget = (props, select) => {
  const targetSelector = props && props.to;
  if (isString$2(targetSelector)) {
    if (!select) {
      return null;
    } else {
      const target = select(targetSelector);
      return target;
    }
  } else {
    return targetSelector;
  }
};
const TeleportImpl = {
  __isTeleport: true,
  process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
    const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
    const disabled = isTeleportDisabled(n2.props);
    let { shapeFlag, children, dynamicChildren } = n2;
    if (n1 == null) {
      const placeholder = n2.el = createText("");
      const mainAnchor = n2.anchor = createText("");
      insert(placeholder, container, anchor);
      insert(mainAnchor, container, anchor);
      const target = n2.target = resolveTarget(n2.props, querySelector);
      const targetAnchor = n2.targetAnchor = createText("");
      if (target) {
        insert(targetAnchor, target);
        isSVG = isSVG || isTargetSVG(target);
      }
      const mount = (container2, anchor2) => {
        if (shapeFlag & 16) {
          mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
      };
      if (disabled) {
        mount(container, mainAnchor);
      } else if (target) {
        mount(target, targetAnchor);
      }
    } else {
      n2.el = n1.el;
      const mainAnchor = n2.anchor = n1.anchor;
      const target = n2.target = n1.target;
      const targetAnchor = n2.targetAnchor = n1.targetAnchor;
      const wasDisabled = isTeleportDisabled(n1.props);
      const currentContainer = wasDisabled ? container : target;
      const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
      isSVG = isSVG || isTargetSVG(target);
      if (dynamicChildren) {
        patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
        traverseStaticChildren(n1, n2, true);
      } else if (!optimized) {
        patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
      }
      if (disabled) {
        if (!wasDisabled) {
          moveTeleport(n2, container, mainAnchor, internals, 1);
        }
      } else {
        if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
          const nextTarget = n2.target = resolveTarget(n2.props, querySelector);
          if (nextTarget) {
            moveTeleport(n2, nextTarget, null, internals, 0);
          }
        } else if (wasDisabled) {
          moveTeleport(n2, target, targetAnchor, internals, 1);
        }
      }
    }
  },
  remove(vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
    const { shapeFlag, children, anchor, targetAnchor, target, props } = vnode;
    if (target) {
      hostRemove(targetAnchor);
    }
    if (doRemove || !isTeleportDisabled(props)) {
      hostRemove(anchor);
      if (shapeFlag & 16) {
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
        }
      }
    }
  },
  move: moveTeleport,
  hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
  if (moveType === 0) {
    insert(vnode.targetAnchor, container, parentAnchor);
  }
  const { el, anchor, shapeFlag, children, props } = vnode;
  const isReorder = moveType === 2;
  if (isReorder) {
    insert(el, container, parentAnchor);
  }
  if (!isReorder || isTeleportDisabled(props)) {
    if (shapeFlag & 16) {
      for (let i = 0; i < children.length; i++) {
        move(children[i], container, parentAnchor, 2);
      }
    }
  }
  if (isReorder) {
    insert(anchor, container, parentAnchor);
  }
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector } }, hydrateChildren) {
  const target = vnode.target = resolveTarget(vnode.props, querySelector);
  if (target) {
    const targetNode = target._lpa || target.firstChild;
    if (vnode.shapeFlag & 16) {
      if (isTeleportDisabled(vnode.props)) {
        vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
        vnode.targetAnchor = targetNode;
      } else {
        vnode.anchor = nextSibling(node);
        vnode.targetAnchor = hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
      }
      target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
    }
  }
  return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
const COMPONENTS = "components";
const DIRECTIVES = "directives";
function resolveComponent(name2, maybeSelfReference) {
  return resolveAsset(COMPONENTS, name2, true, maybeSelfReference) || name2;
}
const NULL_DYNAMIC_COMPONENT = Symbol();
function resolveDynamicComponent(component) {
  if (isString$2(component)) {
    return resolveAsset(COMPONENTS, component, false) || component;
  } else {
    return component || NULL_DYNAMIC_COMPONENT;
  }
}
function resolveDirective(name2) {
  return resolveAsset(DIRECTIVES, name2);
}
function resolveAsset(type, name2, warnMissing = true, maybeSelfReference = false) {
  const instance = currentRenderingInstance || currentInstance;
  if (instance) {
    const Component = instance.type;
    if (type === COMPONENTS) {
      const selfName = getComponentName(Component);
      if (selfName && (selfName === name2 || selfName === camelize$1(name2) || selfName === capitalize$2(camelize$1(name2)))) {
        return Component;
      }
    }
    const res = resolve(instance[type] || Component[type], name2) || resolve(instance.appContext[type], name2);
    if (!res && maybeSelfReference) {
      return Component;
    }
    return res;
  }
}
function resolve(registry, name2) {
  return registry && (registry[name2] || registry[camelize$1(name2)] || registry[capitalize$2(camelize$1(name2))]);
}
const Fragment = Symbol(void 0);
const Text = Symbol(void 0);
const Comment = Symbol(void 0);
const Static = Symbol(void 0);
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
  blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
  blockStack.pop();
  currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value) {
  isBlockTreeEnabled += value;
}
function setupBlock(vnode) {
  vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
  closeBlock();
  if (isBlockTreeEnabled > 0 && currentBlock) {
    currentBlock.push(vnode);
  }
  return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
  return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
  return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode$1(value) {
  return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
  return n1.type === n2.type && n1.key === n2.key;
}
const InternalObjectKey = `__vInternal`;
const normalizeKey = ({ key }) => key != null ? key : null;
const normalizeRef = ({ ref: ref2, ref_key, ref_for }) => {
  return ref2 != null ? isString$2(ref2) || isRef(ref2) || isFunction$2(ref2) ? { i: currentRenderingInstance, r: ref2, k: ref_key, f: !!ref_for } : ref2 : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
  const vnode = {
    __v_isVNode: true,
    __v_skip: true,
    type,
    props,
    key: props && normalizeKey(props),
    ref: props && normalizeRef(props),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag,
    patchFlag,
    dynamicProps,
    dynamicChildren: null,
    appContext: null
  };
  if (needFullChildrenNormalization) {
    normalizeChildren(vnode, children);
    if (shapeFlag & 128) {
      type.normalize(vnode);
    }
  } else if (children) {
    vnode.shapeFlag |= isString$2(children) ? 8 : 16;
  }
  if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock && (vnode.patchFlag > 0 || shapeFlag & 6) && vnode.patchFlag !== 32) {
    currentBlock.push(vnode);
  }
  return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
  if (!type || type === NULL_DYNAMIC_COMPONENT) {
    type = Comment;
  }
  if (isVNode$1(type)) {
    const cloned = cloneVNode(type, props, true);
    if (children) {
      normalizeChildren(cloned, children);
    }
    return cloned;
  }
  if (isClassComponent(type)) {
    type = type.__vccOpts;
  }
  if (props) {
    props = guardReactiveProps(props);
    let { class: klass, style } = props;
    if (klass && !isString$2(klass)) {
      props.class = normalizeClass(klass);
    }
    if (isObject$2(style)) {
      if (isProxy(style) && !isArray$2(style)) {
        style = extend$1({}, style);
      }
      props.style = normalizeStyle(style);
    }
  }
  const shapeFlag = isString$2(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject$2(type) ? 4 : isFunction$2(type) ? 2 : 0;
  return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
  if (!props)
    return null;
  return isProxy(props) || InternalObjectKey in props ? extend$1({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false) {
  const { props, ref: ref2, patchFlag, children } = vnode;
  const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
  const cloned = {
    __v_isVNode: true,
    __v_skip: true,
    type: vnode.type,
    props: mergedProps,
    key: mergedProps && normalizeKey(mergedProps),
    ref: extraProps && extraProps.ref ? mergeRef && ref2 ? isArray$2(ref2) ? ref2.concat(normalizeRef(extraProps)) : [ref2, normalizeRef(extraProps)] : normalizeRef(extraProps) : ref2,
    scopeId: vnode.scopeId,
    slotScopeIds: vnode.slotScopeIds,
    children,
    target: vnode.target,
    targetAnchor: vnode.targetAnchor,
    staticCount: vnode.staticCount,
    shapeFlag: vnode.shapeFlag,
    patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
    dynamicProps: vnode.dynamicProps,
    dynamicChildren: vnode.dynamicChildren,
    appContext: vnode.appContext,
    dirs: vnode.dirs,
    transition: vnode.transition,
    component: vnode.component,
    suspense: vnode.suspense,
    ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
    ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
    el: vnode.el,
    anchor: vnode.anchor
  };
  return cloned;
}
function createTextVNode(text = " ", flag = 0) {
  return createVNode(Text, null, text, flag);
}
function createCommentVNode(text = "", asBlock = false) {
  return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
  if (child == null || typeof child === "boolean") {
    return createVNode(Comment);
  } else if (isArray$2(child)) {
    return createVNode(
      Fragment,
      null,
      child.slice()
    );
  } else if (typeof child === "object") {
    return cloneIfMounted(child);
  } else {
    return createVNode(Text, null, String(child));
  }
}
function cloneIfMounted(child) {
  return child.el === null || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
  let type = 0;
  const { shapeFlag } = vnode;
  if (children == null) {
    children = null;
  } else if (isArray$2(children)) {
    type = 16;
  } else if (typeof children === "object") {
    if (shapeFlag & (1 | 64)) {
      const slot = children.default;
      if (slot) {
        slot._c && (slot._d = false);
        normalizeChildren(vnode, slot());
        slot._c && (slot._d = true);
      }
      return;
    } else {
      type = 32;
      const slotFlag = children._;
      if (!slotFlag && !(InternalObjectKey in children)) {
        children._ctx = currentRenderingInstance;
      } else if (slotFlag === 3 && currentRenderingInstance) {
        if (currentRenderingInstance.slots._ === 1) {
          children._ = 1;
        } else {
          children._ = 2;
          vnode.patchFlag |= 1024;
        }
      }
    }
  } else if (isFunction$2(children)) {
    children = { default: children, _ctx: currentRenderingInstance };
    type = 32;
  } else {
    children = String(children);
    if (shapeFlag & 64) {
      type = 16;
      children = [createTextVNode(children)];
    } else {
      type = 8;
    }
  }
  vnode.children = children;
  vnode.shapeFlag |= type;
}
function mergeProps(...args) {
  const ret = {};
  for (let i = 0; i < args.length; i++) {
    const toMerge = args[i];
    for (const key in toMerge) {
      if (key === "class") {
        if (ret.class !== toMerge.class) {
          ret.class = normalizeClass([ret.class, toMerge.class]);
        }
      } else if (key === "style") {
        ret.style = normalizeStyle([ret.style, toMerge.style]);
      } else if (isOn$1(key)) {
        const existing = ret[key];
        const incoming = toMerge[key];
        if (incoming && existing !== incoming && !(isArray$2(existing) && existing.includes(incoming))) {
          ret[key] = existing ? [].concat(existing, incoming) : incoming;
        }
      } else if (key !== "") {
        ret[key] = toMerge[key];
      }
    }
  }
  return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
  callWithAsyncErrorHandling(hook, instance, 7, [
    vnode,
    prevVNode
  ]);
}
function renderList(source, renderItem, cache2, index) {
  let ret;
  const cached = cache2 && cache2[index];
  if (isArray$2(source) || isString$2(source)) {
    ret = new Array(source.length);
    for (let i = 0, l = source.length; i < l; i++) {
      ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    }
  } else if (typeof source === "number") {
    ret = new Array(source);
    for (let i = 0; i < source; i++) {
      ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    }
  } else if (isObject$2(source)) {
    if (source[Symbol.iterator]) {
      ret = Array.from(source, (item, i) => renderItem(item, i, void 0, cached && cached[i]));
    } else {
      const keys = Object.keys(source);
      ret = new Array(keys.length);
      for (let i = 0, l = keys.length; i < l; i++) {
        const key = keys[i];
        ret[i] = renderItem(source[key], key, i, cached && cached[i]);
      }
    }
  } else {
    ret = [];
  }
  if (cache2) {
    cache2[index] = ret;
  }
  return ret;
}
function createSlots(slots, dynamicSlots) {
  for (let i = 0; i < dynamicSlots.length; i++) {
    const slot = dynamicSlots[i];
    if (isArray$2(slot)) {
      for (let j2 = 0; j2 < slot.length; j2++) {
        slots[slot[j2].name] = slot[j2].fn;
      }
    } else if (slot) {
      slots[slot.name] = slot.fn;
    }
  }
  return slots;
}
function renderSlot(slots, name2, props = {}, fallback, noSlotted) {
  if (currentRenderingInstance.isCE) {
    return createVNode("slot", name2 === "default" ? null : { name: name2 }, fallback && fallback());
  }
  let slot = slots[name2];
  if (slot && slot._c) {
    slot._d = false;
  }
  openBlock();
  const validSlotContent = slot && ensureValidVNode(slot(props));
  const rendered = createBlock(Fragment, { key: props.key || `_${name2}` }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
  if (!noSlotted && rendered.scopeId) {
    rendered.slotScopeIds = [rendered.scopeId + "-s"];
  }
  if (slot && slot._c) {
    slot._d = true;
  }
  return rendered;
}
function ensureValidVNode(vnodes) {
  return vnodes.some((child) => {
    if (!isVNode$1(child))
      return true;
    if (child.type === Comment)
      return false;
    if (child.type === Fragment && !ensureValidVNode(child.children))
      return false;
    return true;
  }) ? vnodes : null;
}
function toHandlers(obj) {
  const ret = {};
  for (const key in obj) {
    ret[toHandlerKey(key)] = obj[key];
  }
  return ret;
}
const getPublicInstance = (i) => {
  if (!i)
    return null;
  if (isStatefulComponent(i))
    return getExposeProxy(i) || i.proxy;
  return getPublicInstance(i.parent);
};
const publicPropertiesMap = extend$1(/* @__PURE__ */ Object.create(null), {
  $: (i) => i,
  $el: (i) => i.vnode.el,
  $data: (i) => i.data,
  $props: (i) => i.props,
  $attrs: (i) => i.attrs,
  $slots: (i) => i.slots,
  $refs: (i) => i.refs,
  $parent: (i) => getPublicInstance(i.parent),
  $root: (i) => getPublicInstance(i.root),
  $emit: (i) => i.emit,
  $options: (i) => resolveMergedOptions(i),
  $forceUpdate: (i) => () => queueJob(i.update),
  $nextTick: (i) => nextTick.bind(i.proxy),
  $watch: (i) => instanceWatch.bind(i)
});
const PublicInstanceProxyHandlers = {
  get({ _: instance }, key) {
    const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
    let normalizedProps;
    if (key[0] !== "$") {
      const n2 = accessCache[key];
      if (n2 !== void 0) {
        switch (n2) {
          case 1:
            return setupState[key];
          case 2:
            return data[key];
          case 4:
            return ctx[key];
          case 3:
            return props[key];
        }
      } else if (setupState !== EMPTY_OBJ && hasOwn$1(setupState, key)) {
        accessCache[key] = 1;
        return setupState[key];
      } else if (data !== EMPTY_OBJ && hasOwn$1(data, key)) {
        accessCache[key] = 2;
        return data[key];
      } else if ((normalizedProps = instance.propsOptions[0]) && hasOwn$1(normalizedProps, key)) {
        accessCache[key] = 3;
        return props[key];
      } else if (ctx !== EMPTY_OBJ && hasOwn$1(ctx, key)) {
        accessCache[key] = 4;
        return ctx[key];
      } else if (shouldCacheAccess) {
        accessCache[key] = 0;
      }
    }
    const publicGetter = publicPropertiesMap[key];
    let cssModule, globalProperties;
    if (publicGetter) {
      if (key === "$attrs") {
        track(instance, "get", key);
      }
      return publicGetter(instance);
    } else if ((cssModule = type.__cssModules) && (cssModule = cssModule[key])) {
      return cssModule;
    } else if (ctx !== EMPTY_OBJ && hasOwn$1(ctx, key)) {
      accessCache[key] = 4;
      return ctx[key];
    } else if (globalProperties = appContext.config.globalProperties, hasOwn$1(globalProperties, key)) {
      {
        return globalProperties[key];
      }
    } else
      ;
  },
  set({ _: instance }, key, value) {
    const { data, setupState, ctx } = instance;
    if (setupState !== EMPTY_OBJ && hasOwn$1(setupState, key)) {
      setupState[key] = value;
      return true;
    } else if (data !== EMPTY_OBJ && hasOwn$1(data, key)) {
      data[key] = value;
      return true;
    } else if (hasOwn$1(instance.props, key)) {
      return false;
    }
    if (key[0] === "$" && key.slice(1) in instance) {
      return false;
    } else {
      {
        ctx[key] = value;
      }
    }
    return true;
  },
  has({ _: { data, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
    let normalizedProps;
    return !!accessCache[key] || data !== EMPTY_OBJ && hasOwn$1(data, key) || setupState !== EMPTY_OBJ && hasOwn$1(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn$1(normalizedProps, key) || hasOwn$1(ctx, key) || hasOwn$1(publicPropertiesMap, key) || hasOwn$1(appContext.config.globalProperties, key);
  },
  defineProperty(target, key, descriptor) {
    if (descriptor.get != null) {
      this.set(target, key, descriptor.get(), null);
    } else if (descriptor.value != null) {
      this.set(target, key, descriptor.value, null);
    }
    return Reflect.defineProperty(target, key, descriptor);
  }
};
const emptyAppContext = createAppContext();
let uid$1 = 0;
function createComponentInstance(vnode, parent, suspense) {
  const type = vnode.type;
  const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
  const instance = {
    uid: uid$1++,
    vnode,
    type,
    parent,
    appContext,
    root: null,
    next: null,
    subTree: null,
    effect: null,
    update: null,
    scope: new EffectScope(true),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: parent ? parent.provides : Object.create(appContext.provides),
    accessCache: null,
    renderCache: [],
    components: null,
    directives: null,
    propsOptions: normalizePropsOptions(type, appContext),
    emitsOptions: normalizeEmitsOptions(type, appContext),
    emit: null,
    emitted: null,
    propsDefaults: EMPTY_OBJ,
    inheritAttrs: type.inheritAttrs,
    ctx: EMPTY_OBJ,
    data: EMPTY_OBJ,
    props: EMPTY_OBJ,
    attrs: EMPTY_OBJ,
    slots: EMPTY_OBJ,
    refs: EMPTY_OBJ,
    setupState: EMPTY_OBJ,
    setupContext: null,
    suspense,
    suspenseId: suspense ? suspense.pendingId : 0,
    asyncDep: null,
    asyncResolved: false,
    isMounted: false,
    isUnmounted: false,
    isDeactivated: false,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  {
    instance.ctx = { _: instance };
  }
  instance.root = parent ? parent.root : instance;
  instance.emit = emit$1.bind(null, instance);
  if (vnode.ce) {
    vnode.ce(instance);
  }
  return instance;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
const setCurrentInstance = (instance) => {
  currentInstance = instance;
  instance.scope.on();
};
const unsetCurrentInstance = () => {
  currentInstance && currentInstance.scope.off();
  currentInstance = null;
};
function isStatefulComponent(instance) {
  return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false) {
  isInSSRComponentSetup = isSSR;
  const { props, children } = instance.vnode;
  const isStateful = isStatefulComponent(instance);
  initProps(instance, props, isStateful, isSSR);
  initSlots(instance, children);
  const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
  isInSSRComponentSetup = false;
  return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
  const Component = instance.type;
  instance.accessCache = /* @__PURE__ */ Object.create(null);
  instance.proxy = markRaw(new Proxy(instance.ctx, PublicInstanceProxyHandlers));
  const { setup } = Component;
  if (setup) {
    const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
    setCurrentInstance(instance);
    pauseTracking();
    const setupResult = callWithErrorHandling(setup, instance, 0, [instance.props, setupContext]);
    resetTracking();
    unsetCurrentInstance();
    if (isPromise(setupResult)) {
      setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
      if (isSSR) {
        return setupResult.then((resolvedResult) => {
          handleSetupResult(instance, resolvedResult, isSSR);
        }).catch((e2) => {
          handleError(e2, instance, 0);
        });
      } else {
        instance.asyncDep = setupResult;
      }
    } else {
      handleSetupResult(instance, setupResult, isSSR);
    }
  } else {
    finishComponentSetup(instance, isSSR);
  }
}
function handleSetupResult(instance, setupResult, isSSR) {
  if (isFunction$2(setupResult)) {
    if (instance.type.__ssrInlineRender) {
      instance.ssrRender = setupResult;
    } else {
      instance.render = setupResult;
    }
  } else if (isObject$2(setupResult)) {
    instance.setupState = proxyRefs(setupResult);
  } else
    ;
  finishComponentSetup(instance, isSSR);
}
let compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
  const Component = instance.type;
  if (!instance.render) {
    if (!isSSR && compile && !Component.render) {
      const template = Component.template;
      if (template) {
        const { isCustomElement, compilerOptions } = instance.appContext.config;
        const { delimiters, compilerOptions: componentCompilerOptions } = Component;
        const finalCompilerOptions = extend$1(extend$1({
          isCustomElement,
          delimiters
        }, compilerOptions), componentCompilerOptions);
        Component.render = compile(template, finalCompilerOptions);
      }
    }
    instance.render = Component.render || NOOP;
  }
  {
    setCurrentInstance(instance);
    pauseTracking();
    applyOptions(instance);
    resetTracking();
    unsetCurrentInstance();
  }
}
function createAttrsProxy(instance) {
  return new Proxy(instance.attrs, {
    get(target, key) {
      track(instance, "get", "$attrs");
      return target[key];
    }
  });
}
function createSetupContext(instance) {
  const expose = (exposed) => {
    instance.exposed = exposed || {};
  };
  let attrs;
  {
    return {
      get attrs() {
        return attrs || (attrs = createAttrsProxy(instance));
      },
      slots: instance.slots,
      emit: instance.emit,
      expose
    };
  }
}
function getExposeProxy(instance) {
  if (instance.exposed) {
    return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
      get(target, key) {
        if (key in target) {
          return target[key];
        } else if (key in publicPropertiesMap) {
          return publicPropertiesMap[key](instance);
        }
      }
    }));
  }
}
function getComponentName(Component) {
  return isFunction$2(Component) ? Component.displayName || Component.name : Component.name;
}
function isClassComponent(value) {
  return isFunction$2(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions) => {
  return computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
};
function h(type, propsOrChildren, children) {
  const l = arguments.length;
  if (l === 2) {
    if (isObject$2(propsOrChildren) && !isArray$2(propsOrChildren)) {
      if (isVNode$1(propsOrChildren)) {
        return createVNode(type, null, [propsOrChildren]);
      }
      return createVNode(type, propsOrChildren);
    } else {
      return createVNode(type, null, propsOrChildren);
    }
  } else {
    if (l > 3) {
      children = Array.prototype.slice.call(arguments, 2);
    } else if (l === 3 && isVNode$1(children)) {
      children = [children];
    }
    return createVNode(type, propsOrChildren, children);
  }
}
const version = "3.2.31";
function makeMap(str, expectsLowerCase) {
  const map = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
}
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
function includeBooleanAttr(value) {
  return !!value || value === "";
}
function looseCompareArrays(a2, b2) {
  if (a2.length !== b2.length)
    return false;
  let equal = true;
  for (let i = 0; equal && i < a2.length; i++) {
    equal = looseEqual(a2[i], b2[i]);
  }
  return equal;
}
function looseEqual(a2, b2) {
  if (a2 === b2)
    return true;
  let aValidType = isDate$1(a2);
  let bValidType = isDate$1(b2);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? a2.getTime() === b2.getTime() : false;
  }
  aValidType = isArray$1(a2);
  bValidType = isArray$1(b2);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? looseCompareArrays(a2, b2) : false;
  }
  aValidType = isObject$1(a2);
  bValidType = isObject$1(b2);
  if (aValidType || bValidType) {
    if (!aValidType || !bValidType) {
      return false;
    }
    const aKeysCount = Object.keys(a2).length;
    const bKeysCount = Object.keys(b2).length;
    if (aKeysCount !== bKeysCount) {
      return false;
    }
    for (const key in a2) {
      const aHasKey = a2.hasOwnProperty(key);
      const bHasKey = b2.hasOwnProperty(key);
      if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a2[key], b2[key])) {
        return false;
      }
    }
  }
  return String(a2) === String(b2);
}
function looseIndexOf(arr, val) {
  return arr.findIndex((item) => looseEqual(item, val));
}
const onRE = /^on[^a-z]/;
const isOn = (key) => onRE.test(key);
const isModelListener = (key) => key.startsWith("onUpdate:");
const extend = Object.assign;
const isArray$1 = Array.isArray;
const isSet = (val) => toTypeString$1(val) === "[object Set]";
const isDate$1 = (val) => val instanceof Date;
const isFunction$1 = (val) => typeof val === "function";
const isString$1 = (val) => typeof val === "string";
const isObject$1 = (val) => val !== null && typeof val === "object";
const objectToString$1 = Object.prototype.toString;
const toTypeString$1 = (value) => objectToString$1.call(value);
const cacheStringFunction = (fn) => {
  const cache2 = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache2[str];
    return hit || (cache2[str] = fn(str));
  };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction((str) => {
  return str.replace(camelizeRE, (_2, c) => c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize$1 = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
const invokeArrayFns = (fns, arg) => {
  for (let i = 0; i < fns.length; i++) {
    fns[i](arg);
  }
};
const toNumber = (val) => {
  const n2 = parseFloat(val);
  return isNaN(n2) ? val : n2;
};
const svgNS = "http://www.w3.org/2000/svg";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && doc.createElement("template");
const nodeOps = {
  insert: (child, parent, anchor) => {
    parent.insertBefore(child, anchor || null);
  },
  remove: (child) => {
    const parent = child.parentNode;
    if (parent) {
      parent.removeChild(child);
    }
  },
  createElement: (tag, isSVG, is, props) => {
    const el = isSVG ? doc.createElementNS(svgNS, tag) : doc.createElement(tag, is ? { is } : void 0);
    if (tag === "select" && props && props.multiple != null) {
      el.setAttribute("multiple", props.multiple);
    }
    return el;
  },
  createText: (text) => doc.createTextNode(text),
  createComment: (text) => doc.createComment(text),
  setText: (node, text) => {
    node.nodeValue = text;
  },
  setElementText: (el, text) => {
    el.textContent = text;
  },
  parentNode: (node) => node.parentNode,
  nextSibling: (node) => node.nextSibling,
  querySelector: (selector) => doc.querySelector(selector),
  setScopeId(el, id) {
    el.setAttribute(id, "");
  },
  cloneNode(el) {
    const cloned = el.cloneNode(true);
    if (`_value` in el) {
      cloned._value = el._value;
    }
    return cloned;
  },
  insertStaticContent(content, parent, anchor, isSVG, start, end) {
    const before = anchor ? anchor.previousSibling : parent.lastChild;
    if (start && (start === end || start.nextSibling)) {
      while (true) {
        parent.insertBefore(start.cloneNode(true), anchor);
        if (start === end || !(start = start.nextSibling))
          break;
      }
    } else {
      templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
      const template = templateContainer.content;
      if (isSVG) {
        const wrapper = template.firstChild;
        while (wrapper.firstChild) {
          template.appendChild(wrapper.firstChild);
        }
        template.removeChild(wrapper);
      }
      parent.insertBefore(template, anchor);
    }
    return [
      before ? before.nextSibling : parent.firstChild,
      anchor ? anchor.previousSibling : parent.lastChild
    ];
  }
};
function patchClass(el, value, isSVG) {
  const transitionClasses = el._vtc;
  if (transitionClasses) {
    value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
  }
  if (value == null) {
    el.removeAttribute("class");
  } else if (isSVG) {
    el.setAttribute("class", value);
  } else {
    el.className = value;
  }
}
function patchStyle(el, prev, next) {
  const style = el.style;
  const isCssString = isString$1(next);
  if (next && !isCssString) {
    for (const key in next) {
      setStyle(style, key, next[key]);
    }
    if (prev && !isString$1(prev)) {
      for (const key in prev) {
        if (next[key] == null) {
          setStyle(style, key, "");
        }
      }
    }
  } else {
    const currentDisplay = style.display;
    if (isCssString) {
      if (prev !== next) {
        style.cssText = next;
      }
    } else if (prev) {
      el.removeAttribute("style");
    }
    if ("_vod" in el) {
      style.display = currentDisplay;
    }
  }
}
const importantRE = /\s*!important$/;
function setStyle(style, name2, val) {
  if (isArray$1(val)) {
    val.forEach((v2) => setStyle(style, name2, v2));
  } else {
    if (name2.startsWith("--")) {
      style.setProperty(name2, val);
    } else {
      const prefixed = autoPrefix(style, name2);
      if (importantRE.test(val)) {
        style.setProperty(hyphenate(prefixed), val.replace(importantRE, ""), "important");
      } else {
        style[prefixed] = val;
      }
    }
  }
}
const prefixes = ["Webkit", "Moz", "ms"];
const prefixCache = {};
function autoPrefix(style, rawName) {
  const cached = prefixCache[rawName];
  if (cached) {
    return cached;
  }
  let name2 = camelize$1(rawName);
  if (name2 !== "filter" && name2 in style) {
    return prefixCache[rawName] = name2;
  }
  name2 = capitalize$1(name2);
  for (let i = 0; i < prefixes.length; i++) {
    const prefixed = prefixes[i] + name2;
    if (prefixed in style) {
      return prefixCache[rawName] = prefixed;
    }
  }
  return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance) {
  if (isSVG && key.startsWith("xlink:")) {
    if (value == null) {
      el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    const isBoolean2 = isSpecialBooleanAttr(key);
    if (value == null || isBoolean2 && !includeBooleanAttr(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, isBoolean2 ? "" : value);
    }
  }
}
function patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
  if (key === "innerHTML" || key === "textContent") {
    if (prevChildren) {
      unmountChildren(prevChildren, parentComponent, parentSuspense);
    }
    el[key] = value == null ? "" : value;
    return;
  }
  if (key === "value" && el.tagName !== "PROGRESS" && !el.tagName.includes("-")) {
    el._value = value;
    const newValue = value == null ? "" : value;
    if (el.value !== newValue || el.tagName === "OPTION") {
      el.value = newValue;
    }
    if (value == null) {
      el.removeAttribute(key);
    }
    return;
  }
  if (value === "" || value == null) {
    const type = typeof el[key];
    if (type === "boolean") {
      el[key] = includeBooleanAttr(value);
      return;
    } else if (value == null && type === "string") {
      el[key] = "";
      el.removeAttribute(key);
      return;
    } else if (type === "number") {
      try {
        el[key] = 0;
      } catch (_a) {
      }
      el.removeAttribute(key);
      return;
    }
  }
  try {
    el[key] = value;
  } catch (e2) {
  }
}
let _getNow = Date.now;
let skipTimestampCheck = false;
if (typeof window !== "undefined") {
  if (_getNow() > document.createEvent("Event").timeStamp) {
    _getNow = () => performance.now();
  }
  const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
  skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
}
let cachedNow = 0;
const p$1 = Promise.resolve();
const reset = () => {
  cachedNow = 0;
};
const getNow = () => cachedNow || (p$1.then(reset), cachedNow = _getNow());
function addEventListener(el, event, handler, options) {
  el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
  el.removeEventListener(event, handler, options);
}
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
  const invokers = el._vei || (el._vei = {});
  const existingInvoker = invokers[rawName];
  if (nextValue && existingInvoker) {
    existingInvoker.value = nextValue;
  } else {
    const [name2, options] = parseName(rawName);
    if (nextValue) {
      const invoker = invokers[rawName] = createInvoker(nextValue, instance);
      addEventListener(el, name2, invoker, options);
    } else if (existingInvoker) {
      removeEventListener(el, name2, existingInvoker, options);
      invokers[rawName] = void 0;
    }
  }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name2) {
  let options;
  if (optionsModifierRE.test(name2)) {
    options = {};
    let m2;
    while (m2 = name2.match(optionsModifierRE)) {
      name2 = name2.slice(0, name2.length - m2[0].length);
      options[m2[0].toLowerCase()] = true;
    }
  }
  return [hyphenate(name2.slice(2)), options];
}
function createInvoker(initialValue, instance) {
  const invoker = (e2) => {
    const timeStamp = e2.timeStamp || _getNow();
    if (skipTimestampCheck || timeStamp >= invoker.attached - 1) {
      callWithAsyncErrorHandling(patchStopImmediatePropagation(e2, invoker.value), instance, 5, [e2]);
    }
  };
  invoker.value = initialValue;
  invoker.attached = getNow();
  return invoker;
}
function patchStopImmediatePropagation(e2, value) {
  if (isArray$1(value)) {
    const originalStop = e2.stopImmediatePropagation;
    e2.stopImmediatePropagation = () => {
      originalStop.call(e2);
      e2._stopped = true;
    };
    return value.map((fn) => (e3) => !e3._stopped && fn && fn(e3));
  } else {
    return value;
  }
}
const nativeOnRE = /^on[a-z]/;
const patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren) => {
  if (key === "class") {
    patchClass(el, nextValue, isSVG);
  } else if (key === "style") {
    patchStyle(el, prevValue, nextValue);
  } else if (isOn(key)) {
    if (!isModelListener(key)) {
      patchEvent(el, key, prevValue, nextValue, parentComponent);
    }
  } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
    patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
  } else {
    if (key === "true-value") {
      el._trueValue = nextValue;
    } else if (key === "false-value") {
      el._falseValue = nextValue;
    }
    patchAttr(el, key, nextValue, isSVG);
  }
};
function shouldSetAsProp(el, key, value, isSVG) {
  if (isSVG) {
    if (key === "innerHTML" || key === "textContent") {
      return true;
    }
    if (key in el && nativeOnRE.test(key) && isFunction$1(value)) {
      return true;
    }
    return false;
  }
  if (key === "spellcheck" || key === "draggable") {
    return false;
  }
  if (key === "form") {
    return false;
  }
  if (key === "list" && el.tagName === "INPUT") {
    return false;
  }
  if (key === "type" && el.tagName === "TEXTAREA") {
    return false;
  }
  if (nativeOnRE.test(key) && isString$1(value)) {
    return false;
  }
  return key in el;
}
function defineCustomElement(options, hydate) {
  const Comp = defineComponent(options);
  class VueCustomElement extends VueElement {
    constructor(initialProps) {
      super(Comp, initialProps, hydate);
    }
  }
  VueCustomElement.def = Comp;
  return VueCustomElement;
}
const BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class VueElement extends BaseClass {
  constructor(_def, _props = {}, hydrate) {
    super();
    this._def = _def;
    this._props = _props;
    this._instance = null;
    this._connected = false;
    this._resolved = false;
    this._numberProps = null;
    if (this.shadowRoot && hydrate) {
      hydrate(this._createVNode(), this.shadowRoot);
    } else {
      this.attachShadow({ mode: "open" });
    }
  }
  connectedCallback() {
    this._connected = true;
    if (!this._instance) {
      this._resolveDef();
    }
  }
  disconnectedCallback() {
    this._connected = false;
    nextTick(() => {
      if (!this._connected) {
        render(null, this.shadowRoot);
        this._instance = null;
      }
    });
  }
  _resolveDef() {
    if (this._resolved) {
      return;
    }
    this._resolved = true;
    for (let i = 0; i < this.attributes.length; i++) {
      this._setAttr(this.attributes[i].name);
    }
    new MutationObserver((mutations) => {
      for (const m2 of mutations) {
        this._setAttr(m2.attributeName);
      }
    }).observe(this, { attributes: true });
    const resolve2 = (def2) => {
      const { props, styles } = def2;
      const hasOptions = !isArray$1(props);
      const rawKeys = props ? hasOptions ? Object.keys(props) : props : [];
      let numberProps;
      if (hasOptions) {
        for (const key in this._props) {
          const opt = props[key];
          if (opt === Number || opt && opt.type === Number) {
            this._props[key] = toNumber(this._props[key]);
            (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[key] = true;
          }
        }
      }
      this._numberProps = numberProps;
      for (const key of Object.keys(this)) {
        if (key[0] !== "_") {
          this._setProp(key, this[key], true, false);
        }
      }
      for (const key of rawKeys.map(camelize)) {
        Object.defineProperty(this, key, {
          get() {
            return this._getProp(key);
          },
          set(val) {
            this._setProp(key, val);
          }
        });
      }
      this._applyStyles(styles);
      this._update();
    };
    const asyncDef = this._def.__asyncLoader;
    if (asyncDef) {
      asyncDef().then(resolve2);
    } else {
      resolve2(this._def);
    }
  }
  _setAttr(key) {
    let value = this.getAttribute(key);
    if (this._numberProps && this._numberProps[key]) {
      value = toNumber(value);
    }
    this._setProp(camelize(key), value, false);
  }
  _getProp(key) {
    return this._props[key];
  }
  _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
    if (val !== this._props[key]) {
      this._props[key] = val;
      if (shouldUpdate && this._instance) {
        this._update();
      }
      if (shouldReflect) {
        if (val === true) {
          this.setAttribute(hyphenate(key), "");
        } else if (typeof val === "string" || typeof val === "number") {
          this.setAttribute(hyphenate(key), val + "");
        } else if (!val) {
          this.removeAttribute(hyphenate(key));
        }
      }
    }
  }
  _update() {
    render(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const vnode = createVNode(this._def, extend({}, this._props));
    if (!this._instance) {
      vnode.ce = (instance) => {
        this._instance = instance;
        instance.isCE = true;
        instance.emit = (event, ...args) => {
          this.dispatchEvent(new CustomEvent(event, {
            detail: args
          }));
        };
        let parent = this;
        while (parent = parent && (parent.parentNode || parent.host)) {
          if (parent instanceof VueElement) {
            instance.parent = parent._instance;
            break;
          }
        }
      };
    }
    return vnode;
  }
  _applyStyles(styles) {
    if (styles) {
      styles.forEach((css) => {
        const s = document.createElement("style");
        s.textContent = css;
        this.shadowRoot.appendChild(s);
      });
    }
  }
}
const TRANSITION = "transition";
const ANIMATION = "animation";
const Transition = (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots);
Transition.displayName = "Transition";
const DOMTransitionPropsValidators = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: true
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
};
Transition.props = /* @__PURE__ */ extend({}, BaseTransition.props, DOMTransitionPropsValidators);
const callHook = (hook, args = []) => {
  if (isArray$1(hook)) {
    hook.forEach((h2) => h2(...args));
  } else if (hook) {
    hook(...args);
  }
};
const hasExplicitCallback = (hook) => {
  return hook ? isArray$1(hook) ? hook.some((h2) => h2.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
  const baseProps = {};
  for (const key in rawProps) {
    if (!(key in DOMTransitionPropsValidators)) {
      baseProps[key] = rawProps[key];
    }
  }
  if (rawProps.css === false) {
    return baseProps;
  }
  const { name: name2 = "v", type, duration, enterFromClass = `${name2}-enter-from`, enterActiveClass = `${name2}-enter-active`, enterToClass = `${name2}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name2}-leave-from`, leaveActiveClass = `${name2}-leave-active`, leaveToClass = `${name2}-leave-to` } = rawProps;
  const durations = normalizeDuration(duration);
  const enterDuration = durations && durations[0];
  const leaveDuration = durations && durations[1];
  const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
  const finishEnter = (el, isAppear, done) => {
    removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
    removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
    done && done();
  };
  const finishLeave = (el, done) => {
    removeTransitionClass(el, leaveToClass);
    removeTransitionClass(el, leaveActiveClass);
    done && done();
  };
  const makeEnterHook = (isAppear) => {
    return (el, done) => {
      const hook = isAppear ? onAppear : onEnter;
      const resolve2 = () => finishEnter(el, isAppear, done);
      callHook(hook, [el, resolve2]);
      nextFrame(() => {
        removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
        addTransitionClass(el, isAppear ? appearToClass : enterToClass);
        if (!hasExplicitCallback(hook)) {
          whenTransitionEnds(el, type, enterDuration, resolve2);
        }
      });
    };
  };
  return extend(baseProps, {
    onBeforeEnter(el) {
      callHook(onBeforeEnter, [el]);
      addTransitionClass(el, enterFromClass);
      addTransitionClass(el, enterActiveClass);
    },
    onBeforeAppear(el) {
      callHook(onBeforeAppear, [el]);
      addTransitionClass(el, appearFromClass);
      addTransitionClass(el, appearActiveClass);
    },
    onEnter: makeEnterHook(false),
    onAppear: makeEnterHook(true),
    onLeave(el, done) {
      const resolve2 = () => finishLeave(el, done);
      addTransitionClass(el, leaveFromClass);
      forceReflow();
      addTransitionClass(el, leaveActiveClass);
      nextFrame(() => {
        removeTransitionClass(el, leaveFromClass);
        addTransitionClass(el, leaveToClass);
        if (!hasExplicitCallback(onLeave)) {
          whenTransitionEnds(el, type, leaveDuration, resolve2);
        }
      });
      callHook(onLeave, [el, resolve2]);
    },
    onEnterCancelled(el) {
      finishEnter(el, false);
      callHook(onEnterCancelled, [el]);
    },
    onAppearCancelled(el) {
      finishEnter(el, true);
      callHook(onAppearCancelled, [el]);
    },
    onLeaveCancelled(el) {
      finishLeave(el);
      callHook(onLeaveCancelled, [el]);
    }
  });
}
function normalizeDuration(duration) {
  if (duration == null) {
    return null;
  } else if (isObject$1(duration)) {
    return [NumberOf(duration.enter), NumberOf(duration.leave)];
  } else {
    const n2 = NumberOf(duration);
    return [n2, n2];
  }
}
function NumberOf(val) {
  const res = toNumber(val);
  return res;
}
function addTransitionClass(el, cls) {
  cls.split(/\s+/).forEach((c) => c && el.classList.add(c));
  (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
  cls.split(/\s+/).forEach((c) => c && el.classList.remove(c));
  const { _vtc } = el;
  if (_vtc) {
    _vtc.delete(cls);
    if (!_vtc.size) {
      el._vtc = void 0;
    }
  }
}
function nextFrame(cb) {
  requestAnimationFrame(() => {
    requestAnimationFrame(cb);
  });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve2) {
  const id = el._endId = ++endId;
  const resolveIfNotStale = () => {
    if (id === el._endId) {
      resolve2();
    }
  };
  if (explicitTimeout) {
    return setTimeout(resolveIfNotStale, explicitTimeout);
  }
  const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
  if (!type) {
    return resolve2();
  }
  const endEvent = type + "end";
  let ended = 0;
  const end = () => {
    el.removeEventListener(endEvent, onEnd);
    resolveIfNotStale();
  };
  const onEnd = (e2) => {
    if (e2.target === el && ++ended >= propCount) {
      end();
    }
  };
  setTimeout(() => {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
  const styles = window.getComputedStyle(el);
  const getStyleProperties = (key) => (styles[key] || "").split(", ");
  const transitionDelays = getStyleProperties(TRANSITION + "Delay");
  const transitionDurations = getStyleProperties(TRANSITION + "Duration");
  const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  const animationDelays = getStyleProperties(ANIMATION + "Delay");
  const animationDurations = getStyleProperties(ANIMATION + "Duration");
  const animationTimeout = getTimeout(animationDelays, animationDurations);
  let type = null;
  let timeout = 0;
  let propCount = 0;
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
    propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
  }
  const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(styles[TRANSITION + "Property"]);
  return {
    type,
    timeout,
    propCount,
    hasTransform
  };
}
function getTimeout(delays, durations) {
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }
  return Math.max(...durations.map((d, i) => toMs(d) + toMs(delays[i])));
}
function toMs(s) {
  return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
  return document.body.offsetHeight;
}
const getModelAssigner = (vnode) => {
  const fn = vnode.props["onUpdate:modelValue"];
  return isArray$1(fn) ? (value) => invokeArrayFns(fn, value) : fn;
};
function onCompositionStart(e2) {
  e2.target.composing = true;
}
function onCompositionEnd(e2) {
  const target = e2.target;
  if (target.composing) {
    target.composing = false;
    trigger(target, "input");
  }
}
function trigger(el, type) {
  const e2 = document.createEvent("HTMLEvents");
  e2.initEvent(type, true, true);
  el.dispatchEvent(e2);
}
const vModelText = {
  created(el, { modifiers: { lazy, trim, number: number2 } }, vnode) {
    el._assign = getModelAssigner(vnode);
    const castToNumber = number2 || vnode.props && vnode.props.type === "number";
    addEventListener(el, lazy ? "change" : "input", (e2) => {
      if (e2.target.composing)
        return;
      let domValue = el.value;
      if (trim) {
        domValue = domValue.trim();
      } else if (castToNumber) {
        domValue = toNumber(domValue);
      }
      el._assign(domValue);
    });
    if (trim) {
      addEventListener(el, "change", () => {
        el.value = el.value.trim();
      });
    }
    if (!lazy) {
      addEventListener(el, "compositionstart", onCompositionStart);
      addEventListener(el, "compositionend", onCompositionEnd);
      addEventListener(el, "change", onCompositionEnd);
    }
  },
  mounted(el, { value }) {
    el.value = value == null ? "" : value;
  },
  beforeUpdate(el, { value, modifiers: { lazy, trim, number: number2 } }, vnode) {
    el._assign = getModelAssigner(vnode);
    if (el.composing)
      return;
    if (document.activeElement === el) {
      if (lazy) {
        return;
      }
      if (trim && el.value.trim() === value) {
        return;
      }
      if ((number2 || el.type === "number") && toNumber(el.value) === value) {
        return;
      }
    }
    const newValue = value == null ? "" : value;
    if (el.value !== newValue) {
      el.value = newValue;
    }
  }
};
const vModelCheckbox = {
  deep: true,
  created(el, _2, vnode) {
    el._assign = getModelAssigner(vnode);
    addEventListener(el, "change", () => {
      const modelValue = el._modelValue;
      const elementValue = getValue(el);
      const checked = el.checked;
      const assign2 = el._assign;
      if (isArray$1(modelValue)) {
        const index = looseIndexOf(modelValue, elementValue);
        const found = index !== -1;
        if (checked && !found) {
          assign2(modelValue.concat(elementValue));
        } else if (!checked && found) {
          const filtered = [...modelValue];
          filtered.splice(index, 1);
          assign2(filtered);
        }
      } else if (isSet(modelValue)) {
        const cloned = new Set(modelValue);
        if (checked) {
          cloned.add(elementValue);
        } else {
          cloned.delete(elementValue);
        }
        assign2(cloned);
      } else {
        assign2(getCheckboxValue(el, checked));
      }
    });
  },
  mounted: setChecked,
  beforeUpdate(el, binding, vnode) {
    el._assign = getModelAssigner(vnode);
    setChecked(el, binding, vnode);
  }
};
function setChecked(el, { value, oldValue }, vnode) {
  el._modelValue = value;
  if (isArray$1(value)) {
    el.checked = looseIndexOf(value, vnode.props.value) > -1;
  } else if (isSet(value)) {
    el.checked = value.has(vnode.props.value);
  } else if (value !== oldValue) {
    el.checked = looseEqual(value, getCheckboxValue(el, true));
  }
}
function getValue(el) {
  return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked) {
  const key = checked ? "_trueValue" : "_falseValue";
  return key in el ? el[key] : checked;
}
const systemModifiers = ["ctrl", "shift", "alt", "meta"];
const modifierGuards = {
  stop: (e2) => e2.stopPropagation(),
  prevent: (e2) => e2.preventDefault(),
  self: (e2) => e2.target !== e2.currentTarget,
  ctrl: (e2) => !e2.ctrlKey,
  shift: (e2) => !e2.shiftKey,
  alt: (e2) => !e2.altKey,
  meta: (e2) => !e2.metaKey,
  left: (e2) => "button" in e2 && e2.button !== 0,
  middle: (e2) => "button" in e2 && e2.button !== 1,
  right: (e2) => "button" in e2 && e2.button !== 2,
  exact: (e2, modifiers) => systemModifiers.some((m2) => e2[`${m2}Key`] && !modifiers.includes(m2))
};
const withModifiers = (fn, modifiers) => {
  return (event, ...args) => {
    for (let i = 0; i < modifiers.length; i++) {
      const guard = modifierGuards[modifiers[i]];
      if (guard && guard(event, modifiers))
        return;
    }
    return fn(event, ...args);
  };
};
const keyNames = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
};
const withKeys = (fn, modifiers) => {
  return (event) => {
    if (!("key" in event)) {
      return;
    }
    const eventKey = hyphenate(event.key);
    if (modifiers.some((k2) => k2 === eventKey || keyNames[k2] === eventKey)) {
      return fn(event);
    }
  };
};
const vShow = {
  beforeMount(el, { value }, { transition }) {
    el._vod = el.style.display === "none" ? "" : el.style.display;
    if (transition && value) {
      transition.beforeEnter(el);
    } else {
      setDisplay(el, value);
    }
  },
  mounted(el, { value }, { transition }) {
    if (transition && value) {
      transition.enter(el);
    }
  },
  updated(el, { value, oldValue }, { transition }) {
    if (!value === !oldValue)
      return;
    if (transition) {
      if (value) {
        transition.beforeEnter(el);
        setDisplay(el, true);
        transition.enter(el);
      } else {
        transition.leave(el, () => {
          setDisplay(el, false);
        });
      }
    } else {
      setDisplay(el, value);
    }
  },
  beforeUnmount(el, { value }) {
    setDisplay(el, value);
  }
};
function setDisplay(el, value) {
  el.style.display = value ? el._vod : "none";
}
const rendererOptions = extend({ patchProp }, nodeOps);
let renderer;
function ensureRenderer() {
  return renderer || (renderer = createRenderer(rendererOptions));
}
const render = (...args) => {
  ensureRenderer().render(...args);
};
function useWebFonts() {
  onMounted(() => {
    const link1 = document.createElement("link");
    link1.rel = "preconnect";
    link1.href = "https://fonts.googleapis.com";
    const link2 = document.createElement("link");
    link2.rel = "preconnect";
    link2.href = "https://fonts.gstatic.com";
    link2.crossOrigin = "true";
    const link3 = document.createElement("link");
    link3.rel = "stylesheet";
    link3.href = "https://fonts.googleapis.com/css?family=DM Sans:400,600,700";
    document.head.appendChild(link1);
    document.head.appendChild(link2);
    document.head.appendChild(link3);
  });
}
function isStringNullish(value) {
  return value === void 0 || value === null || value === "" || value === " ";
}
const appId = ref("");
const appIdUnassigned = computed(() => isStringNullish(appId.value));
function updateAppId(newAppId) {
  appId.value = newAppId;
}
function useAppId() {
  return {
    appId: readonly(appId),
    appIdUnassigned,
    updateAppId
  };
}
const defaultCountryCode = ref("us");
function updateDefaultCountryCode(newCode) {
  if (newCode) {
    defaultCountryCode.value = newCode;
  }
}
function useDefaultCountryCode() {
  return {
    defaultCountryCode,
    updateDefaultCountryCode
  };
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var uaParser = { exports: {} };
(function(module, exports) {
  (function(window2, undefined$1) {
    var LIBVERSION = "1.0.32", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION2 = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook";
    var extend2 = function(regexes2, extensions) {
      var mergedRegexes = {};
      for (var i in regexes2) {
        if (extensions[i] && extensions[i].length % 2 === 0) {
          mergedRegexes[i] = extensions[i].concat(regexes2[i]);
        } else {
          mergedRegexes[i] = regexes2[i];
        }
      }
      return mergedRegexes;
    }, enumerize = function(arr) {
      var enums = {};
      for (var i = 0; i < arr.length; i++) {
        enums[arr[i].toUpperCase()] = arr[i];
      }
      return enums;
    }, has2 = function(str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
      return str.toLowerCase();
    }, majorize = function(version2) {
      return typeof version2 === STR_TYPE ? version2.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
    }, trim = function(str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };
    var rgxMapper = function(ua, arrays) {
      var i = 0, j2, k2, p2, q2, matches, match;
      while (i < arrays.length && !matches) {
        var regex = arrays[i], props = arrays[i + 1];
        j2 = k2 = 0;
        while (j2 < regex.length && !matches) {
          matches = regex[j2++].exec(ua);
          if (!!matches) {
            for (p2 = 0; p2 < props.length; p2++) {
              match = matches[++k2];
              q2 = props[p2];
              if (typeof q2 === OBJ_TYPE && q2.length > 0) {
                if (q2.length === 2) {
                  if (typeof q2[1] == FUNC_TYPE) {
                    this[q2[0]] = q2[1].call(this, match);
                  } else {
                    this[q2[0]] = q2[1];
                  }
                } else if (q2.length === 3) {
                  if (typeof q2[1] === FUNC_TYPE && !(q2[1].exec && q2[1].test)) {
                    this[q2[0]] = match ? q2[1].call(this, match, q2[2]) : undefined$1;
                  } else {
                    this[q2[0]] = match ? match.replace(q2[1], q2[2]) : undefined$1;
                  }
                } else if (q2.length === 4) {
                  this[q2[0]] = match ? q2[3].call(this, match.replace(q2[1], q2[2])) : undefined$1;
                }
              } else {
                this[q2] = match ? match : undefined$1;
              }
            }
          }
        }
        i += 2;
      }
    }, strMapper = function(str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j2 = 0; j2 < map[i].length; j2++) {
            if (has2(map[i][j2], str)) {
              return i === UNKNOWN ? undefined$1 : i;
            }
          }
        } else if (has2(map[i], str)) {
          return i === UNKNOWN ? undefined$1 : i;
        }
      }
      return str;
    };
    var oldSafariMap = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, windowsVersionMap = {
      "ME": "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      "2000": "NT 5.0",
      "XP": ["NT 5.1", "NT 5.2"],
      "Vista": "NT 6.0",
      "7": "NT 6.1",
      "8": "NT 6.2",
      "8.1": "NT 6.3",
      "10": ["NT 6.4", "NT 10.0"],
      "RT": "ARM"
    };
    var regexes = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Edge"]],
        [
          /(opera mini)\/([-\w\.]+)/i,
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /opios[\/ ]+([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA]],
        [
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          /(?:ms|\()(ie) ([\w\.]+)/i,
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          /(weibo)__([\d\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
        ],
        [VERSION2, [NAME, "UC" + BROWSER]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          /\bqbcore\/([\w\.]+).+microm/i
        ],
        [VERSION2, [NAME, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
        ],
        [VERSION2, [NAME, "IE"]],
        [
          /yabrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION2],
        [
          /\bfocus\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, OPERA + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "MIUI " + BROWSER]],
        [
          /fxios\/([-\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
        ],
        [[NAME, "360 " + BROWSER]],
        [
          /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 " + BROWSER], VERSION2],
        [
          /(comodo_dragon)\/([\w\.]+)/i
        ],
        [[NAME, /_/g, " "], VERSION2],
        [
          /(electron)\/([\w\.]+) safari/i,
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          /(lbbrowser)/i,
          /\[(linkedin)app\]/i
        ],
        [NAME],
        [
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
        ],
        [[NAME, FACEBOOK], VERSION2],
        [
          /safari (line)\/([\w\.]+)/i,
          /\b(line)\/([\w\.]+)\/iab/i,
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
        ],
        [VERSION2, [NAME, "GSA"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
        ],
        [VERSION2, [NAME, CHROME + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
        ],
        [[NAME, CHROME + " WebView"], VERSION2],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
        ],
        [VERSION2, [NAME, "Android " + BROWSER]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
        ],
        [VERSION2, [NAME, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
        ],
        [VERSION2, NAME],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
        ],
        [NAME, [VERSION2, strMapper, oldSafariMap]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /(navigator|netscape\d?)\/([-\w\.]+)/i
        ],
        [[NAME, "Netscape"], VERSION2],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
        ],
        [VERSION2, [NAME, FIREFOX + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          /(firefox)\/([\w\.]+)/i,
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          /(links) \(([\w\.]+)/i
        ],
        [NAME, VERSION2]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
        ],
        [[ARCHITECTURE, "amd64"]],
        [
          /(ia32(?=;))/i
        ],
        [[ARCHITECTURE, lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
        ],
        [[ARCHITECTURE, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
        ],
        [[ARCHITECTURE, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
        ],
        [[ARCHITECTURE, "armhf"]],
        [
          /windows (ce|mobile); ppc;/i
        ],
        [[ARCHITECTURE, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
        ],
        [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
        [
          /(sun4\w)[;\)]/i
        ],
        [[ARCHITECTURE, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        ],
        [[ARCHITECTURE, lowerize]]
      ],
      device: [
        [
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
        [
          /\((ip(?:hone|od)[\w ]*);/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
        [
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
        [
          /\b(poco[\w ]+)(?: bui|\))/i,
          /\b; (\w+) build\/hm\1/i,
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
        [
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
        [
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
        [
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
        [
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
        [
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, TABLET]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
        [
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
        [
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]],
        [
          /(pixel c)\b/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
        [
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
        [
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
        [
          /(alexa)webm/i,
          /(kf[a-z]{2}wi)( bui|\))/i,
          /(kf[a-z]+)( bui|\)).+silk\//i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
        ],
        [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
        [
          /(playbook);[-\w\),; ]+(rim)/i
        ],
        [MODEL, VENDOR, [TYPE, TABLET]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
        ],
        [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
        [
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
        [
          /(nexus 9)/i
        ],
        [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i
        ],
        [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
        [
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
        [
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
        [
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          /(hp) ([\w ]+\w)/i,
          /(asus)-?(\w+)/i,
          /(microsoft); (lumia[\w ]+)/i,
          /(lenovo)[-_ ]?([-\w]+)/i,
          /(jolla)/i,
          /(oppo) ?([\w ]+) bui/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(archos) (gamepad2?)/i,
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /(nook)[\w ]+build\/(\w+)/i,
          /(dell) (strea[kpr\d ]*[\dko])/i,
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          /(trinity)[- ]*(t\d{3}) bui/i,
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(surface duo)/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
        [
          /(u304aa)/i
        ],
        [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
        [
          /\bsie-(\w*)/i
        ],
        [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
        [
          /\b(rct\w+) b/i
        ],
        [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
        [
          /\b(venue[\d ]{2,7}) b/i
        ],
        [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
        [
          /\b(q(?:mv|ta)\w+) b/i
        ],
        [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
        ],
        [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
        [
          /\b(k88) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
        [
          /\b(nx\d{3}j) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
        [
          /\b(gen\d{3}) b.+49h/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
        [
          /\b(zur\d{3}) b/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
        [
          /\b((zeki)?tb.*\b) b/i
        ],
        [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
        ],
        [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
        [
          /\b(ns-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
        ],
        [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
        ],
        [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
        [
          /\b(ph-1) /i
        ],
        [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
        ],
        [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
        [
          /\b(trio[-\w\. ]+) b/i
        ],
        [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
        [
          /\btu_(1491) b/i
        ],
        [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
        [
          /(shield[\w ]+) b/i
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
        [
          /(sprint) (\w+)/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kin\.[onetw]{3})/i
        ],
        [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
        [
          /(ouya)/i,
          /(nintendo) ([wids3utch]+)/i
        ],
        [VENDOR, MODEL, [TYPE, CONSOLE]],
        [
          /droid.+; (shield) bui/i
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
        [
          /(playstation [345portablevi]+)/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
        [
          /smart-tv.+(samsung)/i
        ],
        [VENDOR, [TYPE, SMARTTV]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
        ],
        [[VENDOR, LG], [TYPE, SMARTTV]],
        [
          /(apple) ?tv/i
        ],
        [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
        [
          /crkey/i
        ],
        [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
        [
          /droid.+aft(\w)( bui|\))/i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
        [
          /(bravia[\w ]+)( bui|\))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
        [
          /(mitv-\w{5}) bui/i
        ],
        [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
        ],
        [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [[TYPE, SMARTTV]],
        [
          /((pebble))app/i
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /droid.+; (glass) \d/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
        [
          /(quest( 2)?)/i
        ],
        [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
        [
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
        ],
        [VENDOR, [TYPE, EMBEDDED]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
        ],
        [MODEL, [TYPE, MOBILE]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
        ],
        [MODEL, [TYPE, TABLET]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
        ],
        [[TYPE, TABLET]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
        ],
        [[TYPE, MOBILE]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
        ],
        [MODEL, [VENDOR, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, EDGE + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
        ],
        [VERSION2, [NAME, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          /ekioh(flow)\/([\w\.]+)/i,
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          /(icab)[\/ ]([23]\.[\d\.]+)/i
        ],
        [NAME, VERSION2],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
        ],
        [VERSION2, NAME]
      ],
      os: [
        [
          /microsoft (windows) (vista|xp)/i
        ],
        [NAME, VERSION2],
        [
          /(windows) nt 6\.2; (arm)/i,
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [NAME, [VERSION2, strMapper, windowsVersionMap]],
        [
          /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[NAME, "Windows"], [VERSION2, strMapper, windowsVersionMap]],
        [
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[VERSION2, /_/g, "."], [NAME, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
        ],
        [[NAME, "Mac OS"], [VERSION2, /_/g, "."]],
        [
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
        ],
        [VERSION2, NAME],
        [
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          /\((series40);/i
        ],
        [NAME, VERSION2],
        [
          /\(bb(10);/i
        ],
        [VERSION2, [NAME, BLACKBERRY]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
        ],
        [VERSION2, [NAME, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, FIREFOX + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME, "webOS"]],
        [
          /crkey\/([\d\.]+)/i
        ],
        [VERSION2, [NAME, CHROME + "cast"]],
        [
          /(cros) [\w]+ ([\w\.]+\w)/i
        ],
        [[NAME, "Chromium OS"], VERSION2],
        [
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          /(xbox); +xbox ([^\);]+)/i,
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          /(mint)[\/\(\) ]?(\w*)/i,
          /(mageia|vectorlinux)[; ]/i,
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          /(hurd|linux) ?([\w\.]*)/i,
          /(gnu) ?([\w\.]*)/i,
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          /(haiku) (\w+)/i
        ],
        [NAME, VERSION2],
        [
          /(sunos) ?([\w\.\d]*)/i
        ],
        [[NAME, "Solaris"], VERSION2],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
          /(unix) ?([\w\.]*)/i
        ],
        [NAME, VERSION2]
      ]
    };
    var UAParser2 = function(ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser2)) {
        return new UAParser2(ua, extensions).getResult();
      }
      var _ua = ua || (typeof window2 !== UNDEF_TYPE && window2.navigator && window2.navigator.userAgent ? window2.navigator.userAgent : EMPTY);
      var _rgxmap = extensions ? extend2(regexes, extensions) : regexes;
      this.getBrowser = function() {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION2] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser.major = majorize(_browser.version);
        return _browser;
      };
      this.getCPU = function() {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function() {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        return _device;
      };
      this.getEngine = function() {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION2] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function() {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION2] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        return _os;
      };
      this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function() {
        return _ua;
      };
      this.setUA = function(ua2) {
        _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim(ua2, UA_MAX_LENGTH) : ua2;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser2.VERSION = LIBVERSION;
    UAParser2.BROWSER = enumerize([NAME, VERSION2, MAJOR]);
    UAParser2.CPU = enumerize([ARCHITECTURE]);
    UAParser2.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser2.ENGINE = UAParser2.OS = enumerize([NAME, VERSION2]);
    {
      if (module.exports) {
        exports = module.exports = UAParser2;
      }
      exports.UAParser = UAParser2;
    }
    var $2 = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
    if ($2 && !$2.ua) {
      var parser = new UAParser2();
      $2.ua = parser.getResult();
      $2.ua.get = function() {
        return parser.getUA();
      };
      $2.ua.set = function(ua) {
        parser.setUA(ua);
        var result = parser.getResult();
        for (var prop in result) {
          $2.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var UAParser = uaParser.exports;
function e(e2) {
  this.message = e2;
}
e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";
var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r2) {
  var t2 = String(r2).replace(/=+$/, "");
  if (t2.length % 4 == 1)
    throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n2, o2, a2 = 0, i = 0, c = ""; o2 = t2.charAt(i++); ~o2 && (n2 = a2 % 4 ? 64 * n2 + o2 : o2, a2++ % 4) ? c += String.fromCharCode(255 & n2 >> (-2 * a2 & 6)) : 0)
    o2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o2);
  return c;
};
function t(e2) {
  var t2 = e2.replace(/-/g, "+").replace(/_/g, "/");
  switch (t2.length % 4) {
    case 0:
      break;
    case 2:
      t2 += "==";
      break;
    case 3:
      t2 += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(e3) {
      return decodeURIComponent(r(e3).replace(/(.)/g, function(e4, r2) {
        var t3 = r2.charCodeAt(0).toString(16).toUpperCase();
        return t3.length < 2 && (t3 = "0" + t3), "%" + t3;
      }));
    }(t2);
  } catch (e3) {
    return r(t2);
  }
}
function n(e2) {
  this.message = e2;
}
function o$1(e2, r2) {
  if ("string" != typeof e2)
    throw new n("Invalid token specified");
  var o2 = true === (r2 = r2 || {}).header ? 0 : 1;
  try {
    return JSON.parse(t(e2.split(".")[o2]));
  } catch (e3) {
    throw new n("Invalid token specified: " + e3.message);
  }
}
n.prototype = new Error(), n.prototype.name = "InvalidTokenError";
var g = class {
  encodeBytes(e2) {
    let n2 = btoa(String.fromCharCode(...new Uint8Array(e2))).replace(/\+/g, "-").replace(/\//g, "_");
    return H(n2);
  }
  decodeBytes(e2) {
    let t2 = e2.replace(/-/g, "+").replace(/_/g, "/"), n2 = H(t2);
    return Uint8Array.from(atob(n2), (d) => d.charCodeAt(0));
  }
}, H = (r2) => {
  let e2 = r2.indexOf("=");
  return r2.slice(0, e2 === -1 ? r2.length : e2);
};
var o = class extends Error {
  constructor(t2, n2) {
    super();
    this.name = "PassageError", this.statusCode = n2.status, this.statusText = n2.statusText, this.message = this._parsePsgErrorResponse(t2);
  }
  _parsePsgErrorResponse(t2) {
    try {
      return t2 = JSON.parse(t2), t2.error ? t2.error : "";
    } catch (e2) {
      return t2;
    }
  }
}, _ = ((i) => (i[i.MultipleChoice = 300] = "MultipleChoice", i[i.MovedPermanantly = 301] = "MovedPermanantly", i[i.Found = 302] = "Found", i[i.SeeOther = 303] = "SeeOther", i[i.NotModified = 304] = "NotModified", i[i.TemporaryRedirect = 307] = "TemporaryRedirect", i[i.PermanentRedirect = 308] = "PermanentRedirect", i[i.BadRequest = 400] = "BadRequest", i[i.Unauthorized = 401] = "Unauthorized", i[i.PaymentRequired = 402] = "PaymentRequired", i[i.Forbidden = 403] = "Forbidden", i[i.NotFound = 404] = "NotFound", i[i.MethodNotAllowed = 405] = "MethodNotAllowed", i[i.NotAcceptable = 406] = "NotAcceptable", i[i.ProxyAuthenticationRequired = 407] = "ProxyAuthenticationRequired", i[i.RequestTimeout = 408] = "RequestTimeout", i[i.Conflict = 409] = "Conflict", i[i.Gone = 410] = "Gone", i[i.LengthRequired = 411] = "LengthRequired", i[i.PreconditionFailed = 412] = "PreconditionFailed", i[i.PayloadTooLarge = 413] = "PayloadTooLarge", i[i.URITooLong = 414] = "URITooLong", i[i.UnsupportedMediaType = 415] = "UnsupportedMediaType", i[i.RangeNotSatisfiable = 416] = "RangeNotSatisfiable", i[i.ExpectationFailed = 417] = "ExpectationFailed", i[i.MisdirectedRequest = 421] = "MisdirectedRequest", i[i.UnprocessableEntity = 422] = "UnprocessableEntity", i[i.Locked = 423] = "Locked", i[i.FailedDependency = 424] = "FailedDependency", i[i.TooEarly = 425] = "TooEarly", i[i.UpgradeRequired = 426] = "UpgradeRequired", i[i.PreconditionRequired = 428] = "PreconditionRequired", i[i.TooManyRequests = 429] = "TooManyRequests", i[i.RequestHeaderFieldsTooLarge = 431] = "RequestHeaderFieldsTooLarge", i[i.UnavailableForLegalReasons = 451] = "UnavailableForLegalReasons", i[i.InternalServerError = 500] = "InternalServerError", i[i.NotImplemented = 501] = "NotImplemented", i[i.BadGateway = 502] = "BadGateway", i[i.ServiceUnavailable = 503] = "ServiceUnavailable", i[i.GatewayTimeout = 504] = "GatewayTimeout", i[i.HTTPVersionNotSupported = 505] = "HTTPVersionNotSupported", i[i.VariantAlsoNegotiates = 506] = "VariantAlsoNegotiates", i[i.InsufficientStorage = 507] = "InsufficientStorage", i[i.LoopDetected = 508] = "LoopDetected", i[i.NotExtended = 510] = "NotExtended", i[i.NetworkAuthenticationRequired = 511] = "NetworkAuthenticationRequired", i[i.PSGCredObjectDoesNotExist = 700] = "PSGCredObjectDoesNotExist", i[i.PSGParsePublicKeyForNewDeviceFailed = 701] = "PSGParsePublicKeyForNewDeviceFailed", i[i.PSGParsePublicKeyForLoginFailed = 702] = "PSGParsePublicKeyForLoginFailed", i[i.PSGCouldNotGetUserCredential = 703] = "PSGCouldNotGetUserCredential", i[i.PSGLoginRequired = 704] = "PSGLoginRequired", i))(_ || {});
var x = new g(), B = typeof window > "u", N = (r2) => `Failed to access localStorage. ${r2} must be run client-side.`, p = class {
  _isLocalHost() {
    return Boolean(window.location.hostname === "localhost" || window.location.hostname === "[::1]" || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
  }
  _isHttps() {
    return location.protocol === "https:";
  }
  setAuthToken(e2) {
    localStorage.setItem("psg_auth_token", e2);
    let t2 = !this._isHttps() && this._isLocalHost();
    document.cookie = `psg_auth_token = ${e2}; path=/ ${t2 ? "" : ";secure"}`;
  }
  deleteAuthToken() {
    localStorage.removeItem("psg_auth_token"), document.cookie = "psg_auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  }
  psgCredIDExists(e2) {
    return __async(this, null, function* () {
      let t2 = e2.user.id, n2 = e2.handshake.challenge.publicKey.allowCredentials, s = localStorage.getItem("psg_cred_obj");
      if (!s)
        throw new o("Could not get psg_cred_obj", { status: 700, statusText: "PSG Cred Object Does Not Exist" });
      let d = JSON.parse(s)[t2];
      return n2.find((S) => {
        if (x.encodeBytes(x.decodeBytes(S.id)) === x.encodeBytes(x.decodeBytes(d)))
          return true;
      });
    });
  }
  setPsgCredID(e2, t2) {
    if (!t2)
      throw new o("Could not get user's credential", { status: 703, statusText: "PSG Could Not Get User Credential" });
    let n2 = localStorage.getItem("psg_cred_obj");
    if (n2) {
      let s = JSON.parse(n2);
      s[e2] = t2 == null ? void 0 : t2.id, localStorage.setItem("psg_cred_obj", JSON.stringify(s));
    } else
      localStorage.setItem("psg_cred_obj", JSON.stringify({ [e2]: t2 == null ? void 0 : t2.id }));
  }
  setRefreshToken(e2) {
    if (e2) {
      if (B) {
        console.warn(N("setRefreshToken"));
        return;
      }
      localStorage.setItem("psg_refresh_token", e2);
    }
  }
  getRefreshToken() {
    return B ? (console.warn(N("getRefreshToken")), null) : localStorage.getItem("psg_refresh_token");
  }
  deleteRefreshToken() {
    if (B) {
      console.warn(N("deleteRefreshToken"));
      return;
    }
    localStorage.removeItem("psg_refresh_token");
  }
};
var w = class {
  constructor() {
    this.userAgent = new UAParser();
  }
  getBrowserInfo() {
    return __async(this, null, function* () {
      return { createPassKeySupported: yield this._canBrowserCreatePassKey(), getPassKeySupported: yield this._canBrowserGetPasskey(), conditionalUISupported: yield this._isConditionalMediationAvailable() };
    });
  }
  _canBrowserCreatePassKey() {
    return __async(this, null, function* () {
      return !!(this._isiOSPasskeySupported() || this._isMacPasskeySupported());
    });
  }
  _canBrowserGetPasskey() {
    return this._canBrowserCreatePassKey();
  }
  _isConditionalMediationAvailable() {
    return __async(this, null, function* () {
      return false;
    });
  }
  _isiOSPasskeySupported() {
    return this.userAgent.getOS().name == "iOS" && parseFloat(this.userAgent.getOS().version || "") >= 16;
  }
  _isMacPasskeySupported() {
    return this.userAgent.getBrowser().name == "Safari" && parseFloat(this.userAgent.getBrowser().version || "") >= 16 && this.userAgent.getOS().name == "Mac OS";
  }
  _isChrome107() {
    return this.userAgent.getBrowser().name == "Chrome" && parseFloat(this.userAgent.getBrowser().version || "") >= 107;
  }
};
function u(r2) {
  return __async(this, null, function* () {
    return r2.ok ? r2.json() : yield r2.text().then((e2) => {
      throw new o(e2, r2);
    });
  });
}
var j = new p(), M = (r2) => typeof r2 == "object" && r2 !== null && typeof r2.auth_result < "u";
function y(r2) {
  if (!M(r2))
    return console.warn("Not a valid auth response"), r2;
  let e2 = r2.auth_result.refresh_token;
  return e2 && j.setRefreshToken(e2), r2;
}
function O() {
  let r2 = navigator.userAgent.toLowerCase().indexOf("firefox") > -1, e2 = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./), t2 = e2 ? parseInt(e2[1]) : 0;
  return navigator.platform.indexOf("Win") !== -1 && r2 && t2 === 98;
}
function L(r2) {
  let e2 = new Uint8Array(68);
  e2.set(r2.slice(0, 68));
  let t2 = new Uint8Array(r2.byteLength - 68);
  t2.set(r2.slice(68, r2.byteLength));
  let n2 = new Uint8Array(15), s = new Uint8Array(e2.byteLength + n2.byteLength + t2.byteLength);
  s.set(e2, 0), s.set(n2, e2.byteLength), s.set(t2, e2.byteLength + n2.byteLength);
  let d = s[30] + 15;
  return s.set([d], 30), s;
}
var F = { URL: "https://auth.passage.id", version: "@passageidentity/passage-js 2.6.3" };
var k = F;
function a(r2) {
  let e2 = new Headers(r2), t2 = k.version;
  return e2.append("Passage-Version", t2), e2;
}
var R = new g(), $ = new p(), W = new w(), A = class {
  constructor(e2, t2) {
    this.apiUrl = e2 + "/register/", this.identifier = t2;
  }
  withWebAuthn() {
    return __async(this, null, function* () {
      let { createPassKeySupported: e2 } = yield W.getBrowserInfo(), t2 = yield fetch(this.apiUrl + "webauthn/start", { headers: a(), body: JSON.stringify({ identifier: this.identifier }), method: "POST" }).then(u), n2 = yield navigator.credentials.create({ publicKey: this._parsePublicKey(t2.handshake.challenge.publicKey) }).catch((S) => {
        throw new o("error parsing public key for webAuthn", { status: 702, statusText: "PSG Parse Public Key For Login Failed" });
      }).then((S) => S), s = new Uint8Array(n2 == null ? void 0 : n2.response.attestationObject);
      O() && (s = L(s));
      let d = t2.user.id, l = yield fetch(this.apiUrl + "webauthn/finish", { headers: a(), method: "POST", body: JSON.stringify({ user_id: d, handshake_id: t2.handshake.id, handshake_response: { rawId: R.encodeBytes(n2 == null ? void 0 : n2.rawId), id: n2 == null ? void 0 : n2.id, type: n2 == null ? void 0 : n2.type, response: { attestationObject: R.encodeBytes(s), clientDataJSON: R.encodeBytes(n2 == null ? void 0 : n2.response.clientDataJSON) } }, cred_type: e2 ? "passkey" : "platform" }) }).then(u).then(y);
      return $.setPsgCredID(d, n2), l.auth_result;
    });
  }
  _parsePublicKey(e2) {
    return e2.challenge = R.decodeBytes(e2.challenge.toString()), e2.user.id = R.decodeBytes(e2.user.id.toString()), e2;
  }
};
var T = new g(), v = class {
  constructor(e2, t2) {
    this.apiUrl = e2 + "/login/", this.identifier = t2 != null ? t2 : "";
  }
  withWebAuthn() {
    return __async(this, null, function* () {
      let e2 = JSON.stringify({ identifier: this.identifier }), t2 = this.identifier ? e2 : void 0, n2 = yield fetch(this.apiUrl + "webauthn/start", { headers: a(), method: "POST", body: t2 }).then(u), s = yield navigator.credentials.get({ publicKey: this._parsePublicKey(n2.handshake.challenge.publicKey) }).catch((l) => {
        throw new o("error parsing public key for webAuthn", { status: 702, statusText: "PSG Parse Public Key For Login Failed" });
      }).then((l) => l);
      return s ? (yield fetch(this.apiUrl + "webauthn/finish", { headers: a(), method: "POST", body: JSON.stringify({ user_id: this.identifier ? n2.user.id : void 0, handshake_id: n2.handshake.id, handshake_response: { id: s.id, rawId: T.encodeBytes(s.rawId), type: s.type, response: { clientDataJSON: T.encodeBytes(s.response.clientDataJSON), authenticatorData: T.encodeBytes(s.response.authenticatorData), signature: T.encodeBytes(s.response.signature), userHandle: T.encodeBytes(s.response.userHandle) } } }) }).then(u).then(y)).auth_result : { auth_token: "", redirect_url: "" };
    });
  }
  _parsePublicKey(e2) {
    if (e2.challenge = Uint8Array.from(atob(e2.challenge.toString()), (t2) => t2.charCodeAt(0)), e2.allowCredentials) {
      for (let t2 = 0; t2 < e2.allowCredentials.length; t2++) {
        let n2 = e2.allowCredentials[t2];
        n2.id = T.decodeBytes(n2.id.toString());
      }
      return e2;
    }
    return e2;
  }
};
var P = class {
  constructor(e2) {
    this.apiUrl = e2;
  }
  appInfo() {
    return __async(this, null, function* () {
      return (yield fetch(this.apiUrl, { headers: a(), method: "GET" }).then(u)).app;
    });
  }
  identifierExists(e2) {
    return __async(this, null, function* () {
      return (yield fetch(this.apiUrl + "/users?identifier=" + encodeURIComponent(e2), { headers: a(), method: "GET" }).then(u)).user;
    });
  }
};
var f = new g(), J = new p(), m = class {
  constructor(e2) {
    this.apiUrl = e2;
  }
  newRegister(e2, t2) {
    return __async(this, null, function* () {
      return (yield fetch(this.apiUrl + "/register/magic-link", { headers: a(), method: "POST", body: JSON.stringify({ identifier: e2, magic_link_path: window.location.pathname, language: t2 }) }).then(u)).magic_link;
    });
  }
  newLogin(e2, t2) {
    return __async(this, null, function* () {
      return (yield fetch(this.apiUrl + "/login/magic-link", { headers: a(), method: "POST", body: JSON.stringify({ identifier: e2, magic_link_path: window.location.pathname, language: t2 }) }).then(u)).magic_link;
    });
  }
  getStatus(e2) {
    return __async(this, null, function* () {
      return (yield fetch(this.apiUrl + "/magic-link/status", { headers: a(), method: "POST", body: JSON.stringify({ id: e2 }) }).then(u).then(y)).auth_result;
    });
  }
  activate(e2) {
    return __async(this, null, function* () {
      return (yield fetch(this.apiUrl + "/magic-link/activate", { headers: a(), method: "PATCH", body: JSON.stringify({ magic_link: e2 }) }).then(u).then(y)).auth_result;
    });
  }
  activateWebAuthnLogin(e2) {
    return __async(this, null, function* () {
      let t2 = yield fetch(this.apiUrl + "/magic-link/webauthn/login/start", { headers: a(), body: JSON.stringify({ magic_link: e2 }), method: "POST" }).then(u);
      if (!(yield J.psgCredIDExists(t2)))
        throw new o("psg_cred_obj does not exist in the allow list", { status: 700, statusText: "Not Found" });
      let s = yield navigator.credentials.get({ publicKey: this._parsePublicKeyLogin(t2.handshake.challenge.publicKey) }).catch((l) => {
        throw new o("could not parse publickey for login", { status: 702, statusText: "PSG Parse Public Key For Login Failed" });
      });
      return s ? (yield fetch(this.apiUrl + "/magic-link/webauthn/login/finish", { headers: a(), method: "POST", body: JSON.stringify({ magic_link: e2, user_id: t2.user.id, handshake_id: t2.handshake.id, handshake_response: { id: s.id, rawId: f.encodeBytes(s.rawId), type: s.type, response: { clientDataJSON: f.encodeBytes(s.response.clientDataJSON), authenticatorData: f.encodeBytes(s.response.authenticatorData), signature: f.encodeBytes(s.response.signature), userHandle: f.encodeBytes(s.response.userHandle) } } }) }).then(u).then(y)).auth_result : { auth_token: "", redirect_url: "" };
    });
  }
  activateWebAuthnNewDevice(e2) {
    return __async(this, null, function* () {
      let t2 = yield fetch(this.apiUrl + "/magic-link/webauthn/new/start", { headers: a(), body: JSON.stringify({ magic_link: e2 }), method: "POST" }).then(u), n2 = yield navigator.credentials.create({ publicKey: this._parsePublicKeyNewDevice(t2.handshake.challenge.publicKey) }).catch((S) => {
        throw new o("could not parse public key for new device", { status: 701, statusText: "PSG Parse Public Key For New Device Failed" });
      }), s = new Uint8Array(n2 == null ? void 0 : n2.response.attestationObject);
      O() && (s = L(s));
      let d = yield fetch(this.apiUrl + "/magic-link/webauthn/new/finish", { headers: a(), method: "POST", body: JSON.stringify({ magic_link: e2, user_id: t2.user.id, handshake_id: t2.handshake.id, handshake_response: { rawId: f.encodeBytes(n2.rawId), id: n2.id, type: n2.type, response: { attestationObject: f.encodeBytes(s), clientDataJSON: f.encodeBytes(n2.response.clientDataJSON) } }, device_name: navigator.userAgent }) }).then(u).then(y), l = t2.user.id;
      return J.setPsgCredID(l, n2), d.auth_result;
    });
  }
  _parsePublicKeyLogin(e2) {
    if (e2.challenge = Uint8Array.from(atob(e2.challenge.toString()), (t2) => t2.charCodeAt(0)), e2.allowCredentials) {
      for (let t2 = 0; t2 < e2.allowCredentials.length; t2++) {
        let n2 = e2.allowCredentials[t2];
        n2.id = f.decodeBytes(n2.id.toString());
      }
      return e2;
    }
    return e2;
  }
  _parsePublicKeyNewDevice(e2) {
    return e2.challenge = f.decodeBytes(e2.challenge.toString()), e2.user.id = f.decodeBytes(e2.user.id.toString()), e2;
  }
};
var U = new g(), b = new p(), z = new w(), I = class {
  constructor(e2) {
    this.userID = "", this._iss = "", this.authToken = e2, this._useLocalStorage = typeof e2 > "u", this.authGuard(), this._apiVersion = "v1";
    try {
      new URL(this._iss), this._appEndpoint = `${this._iss}`;
    } catch (e3) {
      this._appEndpoint = `${k.URL}/${this._apiVersion}/apps/${this._iss}`;
    }
    this._currentUserEndpoint = `${this._appEndpoint}/currentuser`;
  }
  _getAuthToken() {
    if (!this._useLocalStorage && this.authToken !== void 0 && this.authToken !== "")
      return this.authToken;
    if (typeof window > "u")
      return console.warn("PassageUser is failed to access localStorage. This function must be run client-side or be provided an authToken JWT."), "";
    let e2 = localStorage.getItem("psg_auth_token");
    return e2 || "";
  }
  _validJWTPayload(e2) {
    let n2 = Math.floor(Date.now() / 1e3);
    return !(e2.exp && n2 > e2.exp);
  }
  _validJWTHeader(e2) {
    let t2 = { alg: "RS256", typ: "JWT" };
    return !(e2.alg !== t2.alg || e2.typ !== t2.typ);
  }
  authGuard() {
    let e2 = this._getAuthToken();
    try {
      let t2 = o$1(e2, { header: true }), n2 = o$1(e2);
      return !!(n2 !== void 0 && t2 !== void 0 && (this.userID = n2.sub, this._iss = n2.iss, this._validJWTPayload(n2) && this._validJWTHeader(t2)));
    } catch (e3) {
      return false;
    }
  }
  userInfo() {
    return __async(this, null, function* () {
      return this.authGuard() ? (yield fetch(this._currentUserEndpoint, { method: "GET", headers: a({ Authorization: `Bearer ${this._getAuthToken()}` }) }).then((t2) => __async(this, null, function* () {
        return t2.status !== 200 ? void 0 : yield t2.json();
      })).catch((t2) => {
        throw new o("Failed to fetch current user.", { status: 404, statusText: "Not Found" });
      })).user : void 0;
    });
  }
  changeEmail(e2, t2) {
    return __async(this, null, function* () {
      if (!this.authGuard())
        throw new o("Current user is not authorized.", { status: 401, statusText: "Unauthorized" });
      return (yield fetch(`${this._currentUserEndpoint}/email`, { method: "PATCH", headers: a({ Authorization: `Bearer ${this._getAuthToken()}`, "Content-Type": "application/json" }), body: JSON.stringify({ new_email: e2, language: t2 }) }).then(u)).magic_link;
    });
  }
  changePhone(e2, t2) {
    return __async(this, null, function* () {
      if (!this.authGuard())
        throw new o("Current user is not authorized.", { status: 401, statusText: "Unauthorized" });
      return (yield fetch(`${this._currentUserEndpoint}/phone`, { method: "PATCH", headers: a({ Authorization: `Bearer ${this._getAuthToken()}`, "Content-Type": "application/json" }), body: JSON.stringify({ new_phone: e2, language: t2 }) }).then(u)).magic_link;
    });
  }
  editDevice(e2, t2) {
    return __async(this, null, function* () {
      if (!this.authGuard())
        throw new o("Current user is not authorized.", { status: 409, statusText: "Conflict" });
      if (e2 === "" || e2 === void 0)
        throw new o("A deviceID is required for an edit device request.", { status: 400, statusText: "Bad Request" });
      if (Object.keys(t2).length === 0)
        throw new o("Edit device request must not have an empty request body.", { status: 400, statusText: "Bad Request" });
      return (yield fetch(`${this._currentUserEndpoint}/devices/${e2}`, { method: "PATCH", headers: a({ Authorization: `Bearer ${this._getAuthToken()}`, "Content-Type": "application/json" }), body: JSON.stringify(__spreadValues({}, t2)) }).then(u)).device;
    });
  }
  listDevices() {
    return __async(this, null, function* () {
      if (!this.authGuard())
        throw new o("Current user is not authorized.", { status: 401, statusText: "Unauthorized" });
      return (yield fetch(`${this._currentUserEndpoint}/devices/`, { method: "GET", headers: a({ Authorization: `Bearer ${this._getAuthToken()}`, "Content-Type": "application/json" }) }).then(u)).devices;
    });
  }
  addDevice() {
    return __async(this, null, function* () {
      if (!this.authGuard())
        throw new o("Current user is not authorized.", { status: 401, statusText: "Unauthorized" });
      let { createPassKeySupported: e2 } = yield z.getBrowserInfo(), t2 = yield fetch(this._currentUserEndpoint + "/devices/start", { headers: a({ Authorization: `Bearer ${this._getAuthToken()}` }), method: "POST" }).then(u), n2 = yield navigator.credentials.create({ publicKey: this._parsePublicKey(t2.handshake.challenge.publicKey) }).catch((l) => {
        throw new o("failed to parse public key", { status: 701, statusText: "PSG Parse Public Key For New Device Failed" });
      }).then((l) => l), s = t2.user.id, d = yield fetch(this._currentUserEndpoint + "/devices/finish", { headers: a({ Authorization: `Bearer ${this._getAuthToken()}` }), method: "POST", body: JSON.stringify({ user_id: s, handshake_id: t2.handshake.id, handshake_response: { rawId: U.encodeBytes(n2 == null ? void 0 : n2.rawId), id: n2 == null ? void 0 : n2.id, type: n2 == null ? void 0 : n2.type, response: { attestationObject: U.encodeBytes(n2 == null ? void 0 : n2.response.attestationObject), clientDataJSON: U.encodeBytes(n2 == null ? void 0 : n2.response.clientDataJSON) } }, cred_type: e2 ? "passkey" : "platform" }) }).then(u);
      return b.setPsgCredID(s, n2), d.device;
    });
  }
  deleteDevice(e2) {
    return __async(this, null, function* () {
      if (!this.authGuard())
        throw new o("Current user is not authorized.", { status: 401, statusText: "Unauthorized" });
      if (!e2)
        throw new o("A deviceID is required to delete a device.", { status: 404, statusText: "Not Found" });
      let t2 = false;
      return t2 = yield fetch(`${this._currentUserEndpoint}/devices/${e2}`, { method: "DELETE", headers: a({ Authorization: `Bearer ${this._getAuthToken()}`, "Content-Type": "application/json" }) }).then((n2) => __async(this, null, function* () {
        return n2.ok ? true : yield n2.text().then((s) => {
          throw new o(s, n2);
        });
      })), t2;
    });
  }
  _parsePublicKey(e2) {
    return e2.challenge = U.decodeBytes(e2.challenge.toString()), e2.user.id = U.decodeBytes(e2.user.id.toString()), e2;
  }
  getMetadata() {
    return __async(this, null, function* () {
      return this.authGuard() ? (yield fetch(`${this._currentUserEndpoint}/user-metadata`, { method: "GET", headers: a({ Authorization: `Bearer ${this._getAuthToken()}` }) }).then(u)).user_metadata : void 0;
    });
  }
  updateMetadata(e2) {
    return __async(this, null, function* () {
      if (!this.authGuard())
        throw new o("Current user is not authorized.", { status: 401, statusText: "Unauthorized" });
      return (yield fetch(`${this._currentUserEndpoint}/user-metadata`, { method: "PATCH", headers: a({ Authorization: `Bearer ${this._getAuthToken()}`, "Content-Type": "application/json" }), body: JSON.stringify({ user_metadata: e2 }) }).then(u)).user;
    });
  }
  signOut() {
    return __async(this, null, function* () {
      b.deleteAuthToken();
      let e2 = b.getRefreshToken();
      return e2 ? fetch(`${this._appEndpoint}/tokens/?` + new URLSearchParams({ refresh_token: e2 }), { method: "DELETE" }).then(({ status: t2 }) => t2 === 200).finally(() => {
        b.deleteRefreshToken();
      }) : true;
    });
  }
  getAuthToken() {
    return __async(this, null, function* () {
      let e2 = this._getAuthToken(), t2 = o$1(e2);
      return t2 !== void 0 && this._validJWTPayload(t2) ? Promise.resolve(e2) : this.refresh();
    });
  }
  refresh() {
    return __async(this, null, function* () {
      let e2 = new o("Login required", { status: 704, statusText: "Login required" }), t2 = b.getRefreshToken();
      return t2 ? fetch(`${this._appEndpoint}/tokens/`, { headers: a(), method: "POST", body: JSON.stringify({ refresh_token: t2 }) }).then(u).then((n2) => {
        b.setRefreshToken(n2.auth_result.refresh_token);
        let s = n2.auth_result.auth_token;
        return this._useLocalStorage ? b.setAuthToken(s) : this.authToken = s, s;
      }).catch(() => {
        throw e2;
      }) : Promise.reject(e2);
    });
  }
};
var G = (r2, e2) => __async(void 0, null, function* () {
  let t2, n2 = new Promise((s) => {
    t2 = setTimeout(s, e2);
  });
  return Promise.race([r2, n2]).then((s) => (clearTimeout(t2), s));
});
var q = class {
  constructor(e2) {
    this.appID = e2, this.baseUrl = k.URL, this.apiVersion = "v1", this.fullUrl = `${this.baseUrl}/${this.apiVersion}/apps/${this.appID}`;
  }
  credIDExists(e2) {
    let t2 = localStorage.getItem("psg_cred_obj");
    return t2 ? !!JSON.parse(t2)[e2] : false;
  }
  setAuthToken(e2) {
    new p().setAuthToken(e2);
  }
  signOut() {
    console.warn("Passage.signOut is deprecated and will be removed in a future version. Use User.signOut instead."), new p().deleteAuthToken();
  }
  register(e2) {
    return __async(this, null, function* () {
      return yield new A(this.fullUrl, e2).withWebAuthn();
    });
  }
  login(e2) {
    return __async(this, null, function* () {
      return yield new v(this.fullUrl, e2).withWebAuthn();
    });
  }
  appInfo() {
    return __async(this, null, function* () {
      return yield new P(this.fullUrl).appInfo();
    });
  }
  browserInfo() {
    return __async(this, null, function* () {
      return yield new w().getBrowserInfo();
    });
  }
  checkWebauthnConfig(e2) {
    let t2 = true;
    return e2.auth_origin.replace(/\/$/, "") != window.location.origin.replace(/\/$/, "") && (console.error('The auth_origin configured for webauthn in your app settings does not match the "origin" of your current URL.  Please reconfigure this in the admin console. (Your current "origin" is `' + window.location.origin + "`) Passage will continue to work with other authentication methods."), t2 = false), t2;
  }
  isWebauthnSupported(e2) {
    return __async(this, null, function* () {
      let t2 = false;
      return window.PublicKeyCredential && (e2 ? t2 = true : yield G(window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then((n2) => {
        t2 = n2;
      }).catch(() => console.log("Something went wrong.")), 150)), t2;
    });
  }
  identifierExists(e2) {
    return __async(this, null, function* () {
      return yield new P(this.fullUrl).identifierExists(e2);
    });
  }
  newRegisterMagicLink(e2, t2) {
    return __async(this, null, function* () {
      return yield new m(this.fullUrl).newRegister(e2, t2);
    });
  }
  newLoginMagicLink(e2, t2) {
    return __async(this, null, function* () {
      return yield new m(this.fullUrl).newLogin(e2, t2);
    });
  }
  magicLinkActivate(e2) {
    return __async(this, null, function* () {
      return yield new m(this.fullUrl).activate(e2);
    });
  }
  magicLinkActivateWebAuthnLogin(e2) {
    return __async(this, null, function* () {
      return yield new m(this.fullUrl).activateWebAuthnLogin(e2);
    });
  }
  magicLinkActivateWebAuthnNewDevice(e2) {
    return __async(this, null, function* () {
      return yield new m(this.fullUrl).activateWebAuthnNewDevice(e2);
    });
  }
  getMagicLinkStatus(e2) {
    return __async(this, null, function* () {
      return yield new m(this.fullUrl).getStatus(e2);
    });
  }
  getCurrentUser(e2) {
    return new I(e2);
  }
  createUser(e2) {
    return __async(this, null, function* () {
      return (yield fetch(`${this.fullUrl}/users`, { headers: a(), body: JSON.stringify(__spreadValues({}, e2)), method: "POST" }).then(u)).user;
    });
  }
};
var C = ((n2) => (n2.email = "email", n2.phone = "phone", n2.both = "both", n2))(C || {}), V = ((s) => (s.Phone = "phone", s.Email = "email", s.Both = "both", s.Either = "either", s))(V || {}), Y = ((l) => (l.STRING = "string", l.BOOLEAN = "boolean", l.INTEGER = "integer", l.DATE = "date", l.PHONE = "phone", l.EMAIL = "email", l))(Y || {});
var Q = ((n2) => (n2.ACTIVE = "active", n2.INACTIVE = "inactive", n2.PENDING = "pending", n2))(Q || {}), X = ((t2) => (t2.Platform = "platform", t2.Passkey = "passkey", t2))(X || {});
/*!
  * shared v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const inBrowser = typeof window !== "undefined";
const hasSymbol = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
const makeSymbol = (name2) => hasSymbol ? Symbol(name2) : name2;
const generateFormatCacheKey = (locale, key, source) => friendlyJSONstringify({ l: locale, k: key, s: source });
const friendlyJSONstringify = (json) => JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
const isNumber = (val) => typeof val === "number" && isFinite(val);
const isDate = (val) => toTypeString(val) === "[object Date]";
const isRegExp = (val) => toTypeString(val) === "[object RegExp]";
const isEmptyObject = (val) => isPlainObject(val) && Object.keys(val).length === 0;
function warn(msg, err) {
  if (typeof console !== "undefined") {
    console.warn(`[intlify] ` + msg);
    if (err) {
      console.warn(err.stack);
    }
  }
}
const assign = Object.assign;
let _globalThis;
const getGlobalThis = () => {
  return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function escapeHtml(rawText) {
  return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
const isArray = Array.isArray;
const isFunction = (val) => typeof val === "function";
const isString = (val) => typeof val === "string";
const isBoolean = (val) => typeof val === "boolean";
const isObject = (val) => val !== null && typeof val === "object";
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const isPlainObject = (val) => toTypeString(val) === "[object Object]";
const toDisplayString = (val) => {
  return val == null ? "" : isArray(val) || isPlainObject(val) && val.toString === objectToString ? JSON.stringify(val, null, 2) : String(val);
};
/*!
* message-compiler v9.2.2
* (c) 2022 kazuya kawaguchi
* Released under the MIT License.
*/
const CompileErrorCodes = {
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  __EXTEND_POINT__: 15
};
function createCompileError(code2, loc, options = {}) {
  const { domain, messages, args } = options;
  const msg = code2;
  const error = new SyntaxError(String(msg));
  error.code = code2;
  if (loc) {
    error.location = loc;
  }
  error.domain = domain;
  return error;
}
function defaultOnError(error) {
  throw error;
}
function createPosition(line, column, offset) {
  return { line, column, offset };
}
function createLocation(start, end, source) {
  const loc = { start, end };
  if (source != null) {
    loc.source = source;
  }
  return loc;
}
const CHAR_SP = " ";
const CHAR_CR = "\r";
const CHAR_LF = "\n";
const CHAR_LS = String.fromCharCode(8232);
const CHAR_PS = String.fromCharCode(8233);
function createScanner(str) {
  const _buf = str;
  let _index = 0;
  let _line = 1;
  let _column = 1;
  let _peekOffset = 0;
  const isCRLF = (index2) => _buf[index2] === CHAR_CR && _buf[index2 + 1] === CHAR_LF;
  const isLF = (index2) => _buf[index2] === CHAR_LF;
  const isPS = (index2) => _buf[index2] === CHAR_PS;
  const isLS = (index2) => _buf[index2] === CHAR_LS;
  const isLineEnd = (index2) => isCRLF(index2) || isLF(index2) || isPS(index2) || isLS(index2);
  const index = () => _index;
  const line = () => _line;
  const column = () => _column;
  const peekOffset = () => _peekOffset;
  const charAt = (offset) => isCRLF(offset) || isPS(offset) || isLS(offset) ? CHAR_LF : _buf[offset];
  const currentChar = () => charAt(_index);
  const currentPeek = () => charAt(_index + _peekOffset);
  function next() {
    _peekOffset = 0;
    if (isLineEnd(_index)) {
      _line++;
      _column = 0;
    }
    if (isCRLF(_index)) {
      _index++;
    }
    _index++;
    _column++;
    return _buf[_index];
  }
  function peek() {
    if (isCRLF(_index + _peekOffset)) {
      _peekOffset++;
    }
    _peekOffset++;
    return _buf[_index + _peekOffset];
  }
  function reset2() {
    _index = 0;
    _line = 1;
    _column = 1;
    _peekOffset = 0;
  }
  function resetPeek(offset = 0) {
    _peekOffset = offset;
  }
  function skipToPeek() {
    const target = _index + _peekOffset;
    while (target !== _index) {
      next();
    }
    _peekOffset = 0;
  }
  return {
    index,
    line,
    column,
    peekOffset,
    charAt,
    currentChar,
    currentPeek,
    next,
    peek,
    reset: reset2,
    resetPeek,
    skipToPeek
  };
}
const EOF = void 0;
const LITERAL_DELIMITER = "'";
const ERROR_DOMAIN$1 = "tokenizer";
function createTokenizer(source, options = {}) {
  const location2 = options.location !== false;
  const _scnr = createScanner(source);
  const currentOffset = () => _scnr.index();
  const currentPosition = () => createPosition(_scnr.line(), _scnr.column(), _scnr.index());
  const _initLoc = currentPosition();
  const _initOffset = currentOffset();
  const _context = {
    currentType: 14,
    offset: _initOffset,
    startLoc: _initLoc,
    endLoc: _initLoc,
    lastType: 14,
    lastOffset: _initOffset,
    lastStartLoc: _initLoc,
    lastEndLoc: _initLoc,
    braceNest: 0,
    inLinked: false,
    text: ""
  };
  const context = () => _context;
  const { onError } = options;
  function emitError(code2, pos, offset, ...args) {
    const ctx = context();
    pos.column += offset;
    pos.offset += offset;
    if (onError) {
      const loc = createLocation(ctx.startLoc, pos);
      const err = createCompileError(code2, loc, {
        domain: ERROR_DOMAIN$1,
        args
      });
      onError(err);
    }
  }
  function getToken(context2, type, value) {
    context2.endLoc = currentPosition();
    context2.currentType = type;
    const token = { type };
    if (location2) {
      token.loc = createLocation(context2.startLoc, context2.endLoc);
    }
    if (value != null) {
      token.value = value;
    }
    return token;
  }
  const getEndToken = (context2) => getToken(context2, 14);
  function eat(scnr, ch) {
    if (scnr.currentChar() === ch) {
      scnr.next();
      return ch;
    } else {
      emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
      return "";
    }
  }
  function peekSpaces(scnr) {
    let buf = "";
    while (scnr.currentPeek() === CHAR_SP || scnr.currentPeek() === CHAR_LF) {
      buf += scnr.currentPeek();
      scnr.peek();
    }
    return buf;
  }
  function skipSpaces(scnr) {
    const buf = peekSpaces(scnr);
    scnr.skipToPeek();
    return buf;
  }
  function isIdentifierStart(ch) {
    if (ch === EOF) {
      return false;
    }
    const cc = ch.charCodeAt(0);
    return cc >= 97 && cc <= 122 || cc >= 65 && cc <= 90 || cc === 95;
  }
  function isNumberStart(ch) {
    if (ch === EOF) {
      return false;
    }
    const cc = ch.charCodeAt(0);
    return cc >= 48 && cc <= 57;
  }
  function isNamedIdentifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2) {
      return false;
    }
    peekSpaces(scnr);
    const ret = isIdentifierStart(scnr.currentPeek());
    scnr.resetPeek();
    return ret;
  }
  function isListIdentifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2) {
      return false;
    }
    peekSpaces(scnr);
    const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
    const ret = isNumberStart(ch);
    scnr.resetPeek();
    return ret;
  }
  function isLiteralStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2) {
      return false;
    }
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === LITERAL_DELIMITER;
    scnr.resetPeek();
    return ret;
  }
  function isLinkedDotStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 8) {
      return false;
    }
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === ".";
    scnr.resetPeek();
    return ret;
  }
  function isLinkedModifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 9) {
      return false;
    }
    peekSpaces(scnr);
    const ret = isIdentifierStart(scnr.currentPeek());
    scnr.resetPeek();
    return ret;
  }
  function isLinkedDelimiterStart(scnr, context2) {
    const { currentType } = context2;
    if (!(currentType === 8 || currentType === 12)) {
      return false;
    }
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === ":";
    scnr.resetPeek();
    return ret;
  }
  function isLinkedReferStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 10) {
      return false;
    }
    const fn = () => {
      const ch = scnr.currentPeek();
      if (ch === "{") {
        return isIdentifierStart(scnr.peek());
      } else if (ch === "@" || ch === "%" || ch === "|" || ch === ":" || ch === "." || ch === CHAR_SP || !ch) {
        return false;
      } else if (ch === CHAR_LF) {
        scnr.peek();
        return fn();
      } else {
        return isIdentifierStart(ch);
      }
    };
    const ret = fn();
    scnr.resetPeek();
    return ret;
  }
  function isPluralStart(scnr) {
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === "|";
    scnr.resetPeek();
    return ret;
  }
  function detectModuloStart(scnr) {
    const spaces = peekSpaces(scnr);
    const ret = scnr.currentPeek() === "%" && scnr.peek() === "{";
    scnr.resetPeek();
    return {
      isModulo: ret,
      hasSpace: spaces.length > 0
    };
  }
  function isTextStart(scnr, reset2 = true) {
    const fn = (hasSpace = false, prev = "", detectModulo = false) => {
      const ch = scnr.currentPeek();
      if (ch === "{") {
        return prev === "%" ? false : hasSpace;
      } else if (ch === "@" || !ch) {
        return prev === "%" ? true : hasSpace;
      } else if (ch === "%") {
        scnr.peek();
        return fn(hasSpace, "%", true);
      } else if (ch === "|") {
        return prev === "%" || detectModulo ? true : !(prev === CHAR_SP || prev === CHAR_LF);
      } else if (ch === CHAR_SP) {
        scnr.peek();
        return fn(true, CHAR_SP, detectModulo);
      } else if (ch === CHAR_LF) {
        scnr.peek();
        return fn(true, CHAR_LF, detectModulo);
      } else {
        return true;
      }
    };
    const ret = fn();
    reset2 && scnr.resetPeek();
    return ret;
  }
  function takeChar(scnr, fn) {
    const ch = scnr.currentChar();
    if (ch === EOF) {
      return EOF;
    }
    if (fn(ch)) {
      scnr.next();
      return ch;
    }
    return null;
  }
  function takeIdentifierChar(scnr) {
    const closure = (ch) => {
      const cc = ch.charCodeAt(0);
      return cc >= 97 && cc <= 122 || cc >= 65 && cc <= 90 || cc >= 48 && cc <= 57 || cc === 95 || cc === 36;
    };
    return takeChar(scnr, closure);
  }
  function takeDigit(scnr) {
    const closure = (ch) => {
      const cc = ch.charCodeAt(0);
      return cc >= 48 && cc <= 57;
    };
    return takeChar(scnr, closure);
  }
  function takeHexDigit(scnr) {
    const closure = (ch) => {
      const cc = ch.charCodeAt(0);
      return cc >= 48 && cc <= 57 || cc >= 65 && cc <= 70 || cc >= 97 && cc <= 102;
    };
    return takeChar(scnr, closure);
  }
  function getDigits(scnr) {
    let ch = "";
    let num = "";
    while (ch = takeDigit(scnr)) {
      num += ch;
    }
    return num;
  }
  function readModulo(scnr) {
    skipSpaces(scnr);
    const ch = scnr.currentChar();
    if (ch !== "%") {
      emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
    }
    scnr.next();
    return "%";
  }
  function readText(scnr) {
    let buf = "";
    while (true) {
      const ch = scnr.currentChar();
      if (ch === "{" || ch === "}" || ch === "@" || ch === "|" || !ch) {
        break;
      } else if (ch === "%") {
        if (isTextStart(scnr)) {
          buf += ch;
          scnr.next();
        } else {
          break;
        }
      } else if (ch === CHAR_SP || ch === CHAR_LF) {
        if (isTextStart(scnr)) {
          buf += ch;
          scnr.next();
        } else if (isPluralStart(scnr)) {
          break;
        } else {
          buf += ch;
          scnr.next();
        }
      } else {
        buf += ch;
        scnr.next();
      }
    }
    return buf;
  }
  function readNamedIdentifier(scnr) {
    skipSpaces(scnr);
    let ch = "";
    let name2 = "";
    while (ch = takeIdentifierChar(scnr)) {
      name2 += ch;
    }
    if (scnr.currentChar() === EOF) {
      emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
    }
    return name2;
  }
  function readListIdentifier(scnr) {
    skipSpaces(scnr);
    let value = "";
    if (scnr.currentChar() === "-") {
      scnr.next();
      value += `-${getDigits(scnr)}`;
    } else {
      value += getDigits(scnr);
    }
    if (scnr.currentChar() === EOF) {
      emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
    }
    return value;
  }
  function readLiteral(scnr) {
    skipSpaces(scnr);
    eat(scnr, `'`);
    let ch = "";
    let literal = "";
    const fn = (x2) => x2 !== LITERAL_DELIMITER && x2 !== CHAR_LF;
    while (ch = takeChar(scnr, fn)) {
      if (ch === "\\") {
        literal += readEscapeSequence(scnr);
      } else {
        literal += ch;
      }
    }
    const current = scnr.currentChar();
    if (current === CHAR_LF || current === EOF) {
      emitError(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
      if (current === CHAR_LF) {
        scnr.next();
        eat(scnr, `'`);
      }
      return literal;
    }
    eat(scnr, `'`);
    return literal;
  }
  function readEscapeSequence(scnr) {
    const ch = scnr.currentChar();
    switch (ch) {
      case "\\":
      case `'`:
        scnr.next();
        return `\\${ch}`;
      case "u":
        return readUnicodeEscapeSequence(scnr, ch, 4);
      case "U":
        return readUnicodeEscapeSequence(scnr, ch, 6);
      default:
        emitError(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
        return "";
    }
  }
  function readUnicodeEscapeSequence(scnr, unicode, digits) {
    eat(scnr, unicode);
    let sequence = "";
    for (let i = 0; i < digits; i++) {
      const ch = takeHexDigit(scnr);
      if (!ch) {
        emitError(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
        break;
      }
      sequence += ch;
    }
    return `\\${unicode}${sequence}`;
  }
  function readInvalidIdentifier(scnr) {
    skipSpaces(scnr);
    let ch = "";
    let identifiers = "";
    const closure = (ch2) => ch2 !== "{" && ch2 !== "}" && ch2 !== CHAR_SP && ch2 !== CHAR_LF;
    while (ch = takeChar(scnr, closure)) {
      identifiers += ch;
    }
    return identifiers;
  }
  function readLinkedModifier(scnr) {
    let ch = "";
    let name2 = "";
    while (ch = takeIdentifierChar(scnr)) {
      name2 += ch;
    }
    return name2;
  }
  function readLinkedRefer(scnr) {
    const fn = (detect = false, buf) => {
      const ch = scnr.currentChar();
      if (ch === "{" || ch === "%" || ch === "@" || ch === "|" || !ch) {
        return buf;
      } else if (ch === CHAR_SP) {
        return buf;
      } else if (ch === CHAR_LF) {
        buf += ch;
        scnr.next();
        return fn(detect, buf);
      } else {
        buf += ch;
        scnr.next();
        return fn(true, buf);
      }
    };
    return fn(false, "");
  }
  function readPlural(scnr) {
    skipSpaces(scnr);
    const plural = eat(scnr, "|");
    skipSpaces(scnr);
    return plural;
  }
  function readTokenInPlaceholder(scnr, context2) {
    let token = null;
    const ch = scnr.currentChar();
    switch (ch) {
      case "{":
        if (context2.braceNest >= 1) {
          emitError(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
        }
        scnr.next();
        token = getToken(context2, 2, "{");
        skipSpaces(scnr);
        context2.braceNest++;
        return token;
      case "}":
        if (context2.braceNest > 0 && context2.currentType === 2) {
          emitError(CompileErrorCodes.EMPTY_PLACEHOLDER, currentPosition(), 0);
        }
        scnr.next();
        token = getToken(context2, 3, "}");
        context2.braceNest--;
        context2.braceNest > 0 && skipSpaces(scnr);
        if (context2.inLinked && context2.braceNest === 0) {
          context2.inLinked = false;
        }
        return token;
      case "@":
        if (context2.braceNest > 0) {
          emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        token = readTokenInLinked(scnr, context2) || getEndToken(context2);
        context2.braceNest = 0;
        return token;
      default:
        let validNamedIdentifier = true;
        let validListIdentifier = true;
        let validLiteral = true;
        if (isPluralStart(scnr)) {
          if (context2.braceNest > 0) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
          }
          token = getToken(context2, 1, readPlural(scnr));
          context2.braceNest = 0;
          context2.inLinked = false;
          return token;
        }
        if (context2.braceNest > 0 && (context2.currentType === 5 || context2.currentType === 6 || context2.currentType === 7)) {
          emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
          context2.braceNest = 0;
          return readToken(scnr, context2);
        }
        if (validNamedIdentifier = isNamedIdentifierStart(scnr, context2)) {
          token = getToken(context2, 5, readNamedIdentifier(scnr));
          skipSpaces(scnr);
          return token;
        }
        if (validListIdentifier = isListIdentifierStart(scnr, context2)) {
          token = getToken(context2, 6, readListIdentifier(scnr));
          skipSpaces(scnr);
          return token;
        }
        if (validLiteral = isLiteralStart(scnr, context2)) {
          token = getToken(context2, 7, readLiteral(scnr));
          skipSpaces(scnr);
          return token;
        }
        if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
          token = getToken(context2, 13, readInvalidIdentifier(scnr));
          emitError(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
          skipSpaces(scnr);
          return token;
        }
        break;
    }
    return token;
  }
  function readTokenInLinked(scnr, context2) {
    const { currentType } = context2;
    let token = null;
    const ch = scnr.currentChar();
    if ((currentType === 8 || currentType === 9 || currentType === 12 || currentType === 10) && (ch === CHAR_LF || ch === CHAR_SP)) {
      emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
    }
    switch (ch) {
      case "@":
        scnr.next();
        token = getToken(context2, 8, "@");
        context2.inLinked = true;
        return token;
      case ".":
        skipSpaces(scnr);
        scnr.next();
        return getToken(context2, 9, ".");
      case ":":
        skipSpaces(scnr);
        scnr.next();
        return getToken(context2, 10, ":");
      default:
        if (isPluralStart(scnr)) {
          token = getToken(context2, 1, readPlural(scnr));
          context2.braceNest = 0;
          context2.inLinked = false;
          return token;
        }
        if (isLinkedDotStart(scnr, context2) || isLinkedDelimiterStart(scnr, context2)) {
          skipSpaces(scnr);
          return readTokenInLinked(scnr, context2);
        }
        if (isLinkedModifierStart(scnr, context2)) {
          skipSpaces(scnr);
          return getToken(context2, 12, readLinkedModifier(scnr));
        }
        if (isLinkedReferStart(scnr, context2)) {
          skipSpaces(scnr);
          if (ch === "{") {
            return readTokenInPlaceholder(scnr, context2) || token;
          } else {
            return getToken(context2, 11, readLinkedRefer(scnr));
          }
        }
        if (currentType === 8) {
          emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
        }
        context2.braceNest = 0;
        context2.inLinked = false;
        return readToken(scnr, context2);
    }
  }
  function readToken(scnr, context2) {
    let token = { type: 14 };
    if (context2.braceNest > 0) {
      return readTokenInPlaceholder(scnr, context2) || getEndToken(context2);
    }
    if (context2.inLinked) {
      return readTokenInLinked(scnr, context2) || getEndToken(context2);
    }
    const ch = scnr.currentChar();
    switch (ch) {
      case "{":
        return readTokenInPlaceholder(scnr, context2) || getEndToken(context2);
      case "}":
        emitError(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
        scnr.next();
        return getToken(context2, 3, "}");
      case "@":
        return readTokenInLinked(scnr, context2) || getEndToken(context2);
      default:
        if (isPluralStart(scnr)) {
          token = getToken(context2, 1, readPlural(scnr));
          context2.braceNest = 0;
          context2.inLinked = false;
          return token;
        }
        const { isModulo, hasSpace } = detectModuloStart(scnr);
        if (isModulo) {
          return hasSpace ? getToken(context2, 0, readText(scnr)) : getToken(context2, 4, readModulo(scnr));
        }
        if (isTextStart(scnr)) {
          return getToken(context2, 0, readText(scnr));
        }
        break;
    }
    return token;
  }
  function nextToken() {
    const { currentType, offset, startLoc, endLoc } = _context;
    _context.lastType = currentType;
    _context.lastOffset = offset;
    _context.lastStartLoc = startLoc;
    _context.lastEndLoc = endLoc;
    _context.offset = currentOffset();
    _context.startLoc = currentPosition();
    if (_scnr.currentChar() === EOF) {
      return getToken(_context, 14);
    }
    return readToken(_scnr, _context);
  }
  return {
    nextToken,
    currentOffset,
    currentPosition,
    context
  };
}
const ERROR_DOMAIN = "parser";
const KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(match, codePoint4, codePoint6) {
  switch (match) {
    case `\\\\`:
      return `\\`;
    case `\\'`:
      return `'`;
    default: {
      const codePoint = parseInt(codePoint4 || codePoint6, 16);
      if (codePoint <= 55295 || codePoint >= 57344) {
        return String.fromCodePoint(codePoint);
      }
      return "\uFFFD";
    }
  }
}
function createParser(options = {}) {
  const location2 = options.location !== false;
  const { onError } = options;
  function emitError(tokenzer, code2, start, offset, ...args) {
    const end = tokenzer.currentPosition();
    end.offset += offset;
    end.column += offset;
    if (onError) {
      const loc = createLocation(start, end);
      const err = createCompileError(code2, loc, {
        domain: ERROR_DOMAIN,
        args
      });
      onError(err);
    }
  }
  function startNode(type, offset, loc) {
    const node = {
      type,
      start: offset,
      end: offset
    };
    if (location2) {
      node.loc = { start: loc, end: loc };
    }
    return node;
  }
  function endNode(node, offset, pos, type) {
    node.end = offset;
    if (type) {
      node.type = type;
    }
    if (location2 && node.loc) {
      node.loc.end = pos;
    }
  }
  function parseText(tokenizer, value) {
    const context = tokenizer.context();
    const node = startNode(3, context.offset, context.startLoc);
    node.value = value;
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseList(tokenizer, index) {
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(5, offset, loc);
    node.index = parseInt(index, 10);
    tokenizer.nextToken();
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseNamed(tokenizer, key) {
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(4, offset, loc);
    node.key = key;
    tokenizer.nextToken();
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseLiteral(tokenizer, value) {
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(9, offset, loc);
    node.value = value.replace(KNOWN_ESCAPES, fromEscapeSequence);
    tokenizer.nextToken();
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseLinkedModifier(tokenizer) {
    const token = tokenizer.nextToken();
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(8, offset, loc);
    if (token.type !== 12) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
      node.value = "";
      endNode(node, offset, loc);
      return {
        nextConsumeToken: token,
        node
      };
    }
    if (token.value == null) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
    }
    node.value = token.value || "";
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return {
      node
    };
  }
  function parseLinkedKey(tokenizer, value) {
    const context = tokenizer.context();
    const node = startNode(7, context.offset, context.startLoc);
    node.value = value;
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseLinked(tokenizer) {
    const context = tokenizer.context();
    const linkedNode = startNode(6, context.offset, context.startLoc);
    let token = tokenizer.nextToken();
    if (token.type === 9) {
      const parsed = parseLinkedModifier(tokenizer);
      linkedNode.modifier = parsed.node;
      token = parsed.nextConsumeToken || tokenizer.nextToken();
    }
    if (token.type !== 10) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
    }
    token = tokenizer.nextToken();
    if (token.type === 2) {
      token = tokenizer.nextToken();
    }
    switch (token.type) {
      case 11:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
        break;
      case 5:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseNamed(tokenizer, token.value || "");
        break;
      case 6:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseList(tokenizer, token.value || "");
        break;
      case 7:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseLiteral(tokenizer, token.value || "");
        break;
      default:
        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
        const nextContext = tokenizer.context();
        const emptyLinkedKeyNode = startNode(7, nextContext.offset, nextContext.startLoc);
        emptyLinkedKeyNode.value = "";
        endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
        linkedNode.key = emptyLinkedKeyNode;
        endNode(linkedNode, nextContext.offset, nextContext.startLoc);
        return {
          nextConsumeToken: token,
          node: linkedNode
        };
    }
    endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
    return {
      node: linkedNode
    };
  }
  function parseMessage(tokenizer) {
    const context = tokenizer.context();
    const startOffset = context.currentType === 1 ? tokenizer.currentOffset() : context.offset;
    const startLoc = context.currentType === 1 ? context.endLoc : context.startLoc;
    const node = startNode(2, startOffset, startLoc);
    node.items = [];
    let nextToken = null;
    do {
      const token = nextToken || tokenizer.nextToken();
      nextToken = null;
      switch (token.type) {
        case 0:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseText(tokenizer, token.value || ""));
          break;
        case 6:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseList(tokenizer, token.value || ""));
          break;
        case 5:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseNamed(tokenizer, token.value || ""));
          break;
        case 7:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseLiteral(tokenizer, token.value || ""));
          break;
        case 8:
          const parsed = parseLinked(tokenizer);
          node.items.push(parsed.node);
          nextToken = parsed.nextConsumeToken || null;
          break;
      }
    } while (context.currentType !== 14 && context.currentType !== 1);
    const endOffset = context.currentType === 1 ? context.lastOffset : tokenizer.currentOffset();
    const endLoc = context.currentType === 1 ? context.lastEndLoc : tokenizer.currentPosition();
    endNode(node, endOffset, endLoc);
    return node;
  }
  function parsePlural(tokenizer, offset, loc, msgNode) {
    const context = tokenizer.context();
    let hasEmptyMessage = msgNode.items.length === 0;
    const node = startNode(1, offset, loc);
    node.cases = [];
    node.cases.push(msgNode);
    do {
      const msg = parseMessage(tokenizer);
      if (!hasEmptyMessage) {
        hasEmptyMessage = msg.items.length === 0;
      }
      node.cases.push(msg);
    } while (context.currentType !== 14);
    if (hasEmptyMessage) {
      emitError(tokenizer, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
    }
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseResource(tokenizer) {
    const context = tokenizer.context();
    const { offset, startLoc } = context;
    const msgNode = parseMessage(tokenizer);
    if (context.currentType === 14) {
      return msgNode;
    } else {
      return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
  }
  function parse2(source) {
    const tokenizer = createTokenizer(source, assign({}, options));
    const context = tokenizer.context();
    const node = startNode(0, context.offset, context.startLoc);
    if (location2 && node.loc) {
      node.loc.source = source;
    }
    node.body = parseResource(tokenizer);
    if (context.currentType !== 14) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
    }
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  return { parse: parse2 };
}
function getTokenCaption(token) {
  if (token.type === 14) {
    return "EOF";
  }
  const name2 = (token.value || "").replace(/\r?\n/gu, "\\n");
  return name2.length > 10 ? name2.slice(0, 9) + "\u2026" : name2;
}
function createTransformer(ast, options = {}) {
  const _context = {
    ast,
    helpers: /* @__PURE__ */ new Set()
  };
  const context = () => _context;
  const helper = (name2) => {
    _context.helpers.add(name2);
    return name2;
  };
  return { context, helper };
}
function traverseNodes(nodes, transformer) {
  for (let i = 0; i < nodes.length; i++) {
    traverseNode(nodes[i], transformer);
  }
}
function traverseNode(node, transformer) {
  switch (node.type) {
    case 1:
      traverseNodes(node.cases, transformer);
      transformer.helper("plural");
      break;
    case 2:
      traverseNodes(node.items, transformer);
      break;
    case 6:
      const linked = node;
      traverseNode(linked.key, transformer);
      transformer.helper("linked");
      transformer.helper("type");
      break;
    case 5:
      transformer.helper("interpolate");
      transformer.helper("list");
      break;
    case 4:
      transformer.helper("interpolate");
      transformer.helper("named");
      break;
  }
}
function transform(ast, options = {}) {
  const transformer = createTransformer(ast);
  transformer.helper("normalize");
  ast.body && traverseNode(ast.body, transformer);
  const context = transformer.context();
  ast.helpers = Array.from(context.helpers);
}
function createCodeGenerator(ast, options) {
  const { sourceMap, filename, breakLineCode, needIndent: _needIndent } = options;
  const _context = {
    source: ast.loc.source,
    filename,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode,
    needIndent: _needIndent,
    indentLevel: 0
  };
  const context = () => _context;
  function push(code2, node) {
    _context.code += code2;
  }
  function _newline(n2, withBreakLine = true) {
    const _breakLineCode = withBreakLine ? breakLineCode : "";
    push(_needIndent ? _breakLineCode + `  `.repeat(n2) : _breakLineCode);
  }
  function indent(withNewLine = true) {
    const level = ++_context.indentLevel;
    withNewLine && _newline(level);
  }
  function deindent(withNewLine = true) {
    const level = --_context.indentLevel;
    withNewLine && _newline(level);
  }
  function newline() {
    _newline(_context.indentLevel);
  }
  const helper = (key) => `_${key}`;
  const needIndent = () => _context.needIndent;
  return {
    context,
    push,
    indent,
    deindent,
    newline,
    helper,
    needIndent
  };
}
function generateLinkedNode(generator, node) {
  const { helper } = generator;
  generator.push(`${helper("linked")}(`);
  generateNode(generator, node.key);
  if (node.modifier) {
    generator.push(`, `);
    generateNode(generator, node.modifier);
    generator.push(`, _type`);
  } else {
    generator.push(`, undefined, _type`);
  }
  generator.push(`)`);
}
function generateMessageNode(generator, node) {
  const { helper, needIndent } = generator;
  generator.push(`${helper("normalize")}([`);
  generator.indent(needIndent());
  const length = node.items.length;
  for (let i = 0; i < length; i++) {
    generateNode(generator, node.items[i]);
    if (i === length - 1) {
      break;
    }
    generator.push(", ");
  }
  generator.deindent(needIndent());
  generator.push("])");
}
function generatePluralNode(generator, node) {
  const { helper, needIndent } = generator;
  if (node.cases.length > 1) {
    generator.push(`${helper("plural")}([`);
    generator.indent(needIndent());
    const length = node.cases.length;
    for (let i = 0; i < length; i++) {
      generateNode(generator, node.cases[i]);
      if (i === length - 1) {
        break;
      }
      generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push(`])`);
  }
}
function generateResource(generator, node) {
  if (node.body) {
    generateNode(generator, node.body);
  } else {
    generator.push("null");
  }
}
function generateNode(generator, node) {
  const { helper } = generator;
  switch (node.type) {
    case 0:
      generateResource(generator, node);
      break;
    case 1:
      generatePluralNode(generator, node);
      break;
    case 2:
      generateMessageNode(generator, node);
      break;
    case 6:
      generateLinkedNode(generator, node);
      break;
    case 8:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 7:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 5:
      generator.push(`${helper("interpolate")}(${helper("list")}(${node.index}))`, node);
      break;
    case 4:
      generator.push(`${helper("interpolate")}(${helper("named")}(${JSON.stringify(node.key)}))`, node);
      break;
    case 9:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 3:
      generator.push(JSON.stringify(node.value), node);
      break;
  }
}
const generate = (ast, options = {}) => {
  const mode = isString(options.mode) ? options.mode : "normal";
  const filename = isString(options.filename) ? options.filename : "message.intl";
  const sourceMap = !!options.sourceMap;
  const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
  const needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
  const helpers = ast.helpers || [];
  const generator = createCodeGenerator(ast, {
    mode,
    filename,
    sourceMap,
    breakLineCode,
    needIndent
  });
  generator.push(mode === "normal" ? `function __msg__ (ctx) {` : `(ctx) => {`);
  generator.indent(needIndent);
  if (helpers.length > 0) {
    generator.push(`const { ${helpers.map((s) => `${s}: _${s}`).join(", ")} } = ctx`);
    generator.newline();
  }
  generator.push(`return `);
  generateNode(generator, ast);
  generator.deindent(needIndent);
  generator.push(`}`);
  const { code: code2, map } = generator.context();
  return {
    ast,
    code: code2,
    map: map ? map.toJSON() : void 0
  };
};
function baseCompile(source, options = {}) {
  const assignedOptions = assign({}, options);
  const parser = createParser(assignedOptions);
  const ast = parser.parse(source);
  transform(ast, assignedOptions);
  return generate(ast, assignedOptions);
}
/*!
 * devtools-if v9.2.2
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */
const IntlifyDevToolsHooks = {
  I18nInit: "i18n:init",
  FunctionTranslate: "function:translate"
};
/*!
* core-base v9.2.2
* (c) 2022 kazuya kawaguchi
* Released under the MIT License.
*/
const pathStateMachine = [];
pathStateMachine[0] = {
  ["w"]: [0],
  ["i"]: [3, 0],
  ["["]: [4],
  ["o"]: [7]
};
pathStateMachine[1] = {
  ["w"]: [1],
  ["."]: [2],
  ["["]: [4],
  ["o"]: [7]
};
pathStateMachine[2] = {
  ["w"]: [2],
  ["i"]: [3, 0],
  ["0"]: [3, 0]
};
pathStateMachine[3] = {
  ["i"]: [3, 0],
  ["0"]: [3, 0],
  ["w"]: [1, 1],
  ["."]: [2, 1],
  ["["]: [4, 1],
  ["o"]: [7, 1]
};
pathStateMachine[4] = {
  ["'"]: [5, 0],
  ['"']: [6, 0],
  ["["]: [
    4,
    2
  ],
  ["]"]: [1, 3],
  ["o"]: 8,
  ["l"]: [4, 0]
};
pathStateMachine[5] = {
  ["'"]: [4, 0],
  ["o"]: 8,
  ["l"]: [5, 0]
};
pathStateMachine[6] = {
  ['"']: [4, 0],
  ["o"]: 8,
  ["l"]: [6, 0]
};
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
  return literalValueRE.test(exp);
}
function stripQuotes(str) {
  const a2 = str.charCodeAt(0);
  const b2 = str.charCodeAt(str.length - 1);
  return a2 === b2 && (a2 === 34 || a2 === 39) ? str.slice(1, -1) : str;
}
function getPathCharType(ch) {
  if (ch === void 0 || ch === null) {
    return "o";
  }
  const code2 = ch.charCodeAt(0);
  switch (code2) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return ch;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function formatSubPath(path) {
  const trimmed = path.trim();
  if (path.charAt(0) === "0" && isNaN(parseInt(path))) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : "*" + trimmed;
}
function parse(path) {
  const keys = [];
  let index = -1;
  let mode = 0;
  let subPathDepth = 0;
  let c;
  let key;
  let newChar;
  let type;
  let transition;
  let action;
  let typeMap;
  const actions = [];
  actions[0] = () => {
    if (key === void 0) {
      key = newChar;
    } else {
      key += newChar;
    }
  };
  actions[1] = () => {
    if (key !== void 0) {
      keys.push(key);
      key = void 0;
    }
  };
  actions[2] = () => {
    actions[0]();
    subPathDepth++;
  };
  actions[3] = () => {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = 4;
      actions[0]();
    } else {
      subPathDepth = 0;
      if (key === void 0) {
        return false;
      }
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[1]();
      }
    }
  };
  function maybeUnescapeQuote() {
    const nextChar = path[index + 1];
    if (mode === 5 && nextChar === "'" || mode === 6 && nextChar === '"') {
      index++;
      newChar = "\\" + nextChar;
      actions[0]();
      return true;
    }
  }
  while (mode !== null) {
    index++;
    c = path[index];
    if (c === "\\" && maybeUnescapeQuote()) {
      continue;
    }
    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap["l"] || 8;
    if (transition === 8) {
      return;
    }
    mode = transition[0];
    if (transition[1] !== void 0) {
      action = actions[transition[1]];
      if (action) {
        newChar = c;
        if (action() === false) {
          return;
        }
      }
    }
    if (mode === 7) {
      return keys;
    }
  }
}
const cache$1 = /* @__PURE__ */ new Map();
function resolveWithKeyValue(obj, path) {
  return isObject(obj) ? obj[path] : null;
}
function resolveValue(obj, path) {
  if (!isObject(obj)) {
    return null;
  }
  let hit = cache$1.get(path);
  if (!hit) {
    hit = parse(path);
    if (hit) {
      cache$1.set(path, hit);
    }
  }
  if (!hit) {
    return null;
  }
  const len = hit.length;
  let last = obj;
  let i = 0;
  while (i < len) {
    const val = last[hit[i]];
    if (val === void 0) {
      return null;
    }
    last = val;
    i++;
  }
  return last;
}
const DEFAULT_MODIFIER = (str) => str;
const DEFAULT_MESSAGE = (ctx) => "";
const DEFAULT_MESSAGE_DATA_TYPE = "text";
const DEFAULT_NORMALIZE = (values) => values.length === 0 ? "" : values.join("");
const DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(choice, choicesLength) {
  choice = Math.abs(choice);
  if (choicesLength === 2) {
    return choice ? choice > 1 ? 1 : 0 : 1;
  }
  return choice ? Math.min(choice, 2) : 0;
}
function getPluralIndex(options) {
  const index = isNumber(options.pluralIndex) ? options.pluralIndex : -1;
  return options.named && (isNumber(options.named.count) || isNumber(options.named.n)) ? isNumber(options.named.count) ? options.named.count : isNumber(options.named.n) ? options.named.n : index : index;
}
function normalizeNamed(pluralIndex, props) {
  if (!props.count) {
    props.count = pluralIndex;
  }
  if (!props.n) {
    props.n = pluralIndex;
  }
}
function createMessageContext(options = {}) {
  const locale = options.locale;
  const pluralIndex = getPluralIndex(options);
  const pluralRule = isObject(options.pluralRules) && isString(locale) && isFunction(options.pluralRules[locale]) ? options.pluralRules[locale] : pluralDefault;
  const orgPluralRule = isObject(options.pluralRules) && isString(locale) && isFunction(options.pluralRules[locale]) ? pluralDefault : void 0;
  const plural = (messages) => {
    return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
  };
  const _list = options.list || [];
  const list = (index) => _list[index];
  const _named = options.named || {};
  isNumber(options.pluralIndex) && normalizeNamed(pluralIndex, _named);
  const named = (key) => _named[key];
  function message2(key) {
    const msg = isFunction(options.messages) ? options.messages(key) : isObject(options.messages) ? options.messages[key] : false;
    return !msg ? options.parent ? options.parent.message(key) : DEFAULT_MESSAGE : msg;
  }
  const _modifier = (name2) => options.modifiers ? options.modifiers[name2] : DEFAULT_MODIFIER;
  const normalize = isPlainObject(options.processor) && isFunction(options.processor.normalize) ? options.processor.normalize : DEFAULT_NORMALIZE;
  const interpolate = isPlainObject(options.processor) && isFunction(options.processor.interpolate) ? options.processor.interpolate : DEFAULT_INTERPOLATE;
  const type = isPlainObject(options.processor) && isString(options.processor.type) ? options.processor.type : DEFAULT_MESSAGE_DATA_TYPE;
  const linked = (key, ...args) => {
    const [arg1, arg2] = args;
    let type2 = "text";
    let modifier = "";
    if (args.length === 1) {
      if (isObject(arg1)) {
        modifier = arg1.modifier || modifier;
        type2 = arg1.type || type2;
      } else if (isString(arg1)) {
        modifier = arg1 || modifier;
      }
    } else if (args.length === 2) {
      if (isString(arg1)) {
        modifier = arg1 || modifier;
      }
      if (isString(arg2)) {
        type2 = arg2 || type2;
      }
    }
    let msg = message2(key)(ctx);
    if (type2 === "vnode" && isArray(msg) && modifier) {
      msg = msg[0];
    }
    return modifier ? _modifier(modifier)(msg, type2) : msg;
  };
  const ctx = {
    ["list"]: list,
    ["named"]: named,
    ["plural"]: plural,
    ["linked"]: linked,
    ["message"]: message2,
    ["type"]: type,
    ["interpolate"]: interpolate,
    ["normalize"]: normalize
  };
  return ctx;
}
let devtools = null;
function setDevToolsHook(hook) {
  devtools = hook;
}
function initI18nDevTools(i18n2, version2, meta) {
  devtools && devtools.emit(IntlifyDevToolsHooks.I18nInit, {
    timestamp: Date.now(),
    i18n: i18n2,
    version: version2,
    meta
  });
}
const translateDevTools = /* @__PURE__ */ createDevToolsHook(IntlifyDevToolsHooks.FunctionTranslate);
function createDevToolsHook(hook) {
  return (payloads) => devtools && devtools.emit(hook, payloads);
}
const CoreWarnCodes = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  __EXTEND_POINT__: 7
};
function fallbackWithSimple(ctx, fallback, start) {
  return [.../* @__PURE__ */ new Set([
    start,
    ...isArray(fallback) ? fallback : isObject(fallback) ? Object.keys(fallback) : isString(fallback) ? [fallback] : [start]
  ])];
}
function fallbackWithLocaleChain(ctx, fallback, start) {
  const startLocale = isString(start) ? start : DEFAULT_LOCALE;
  const context = ctx;
  if (!context.__localeChainCache) {
    context.__localeChainCache = /* @__PURE__ */ new Map();
  }
  let chain = context.__localeChainCache.get(startLocale);
  if (!chain) {
    chain = [];
    let block = [start];
    while (isArray(block)) {
      block = appendBlockToChain(chain, block, fallback);
    }
    const defaults = isArray(fallback) || !isPlainObject(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
    block = isString(defaults) ? [defaults] : defaults;
    if (isArray(block)) {
      appendBlockToChain(chain, block, false);
    }
    context.__localeChainCache.set(startLocale, chain);
  }
  return chain;
}
function appendBlockToChain(chain, block, blocks) {
  let follow = true;
  for (let i = 0; i < block.length && isBoolean(follow); i++) {
    const locale = block[i];
    if (isString(locale)) {
      follow = appendLocaleToChain(chain, block[i], blocks);
    }
  }
  return follow;
}
function appendLocaleToChain(chain, locale, blocks) {
  let follow;
  const tokens = locale.split("-");
  do {
    const target = tokens.join("-");
    follow = appendItemToChain(chain, target, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && follow === true);
  return follow;
}
function appendItemToChain(chain, target, blocks) {
  let follow = false;
  if (!chain.includes(target)) {
    follow = true;
    if (target) {
      follow = target[target.length - 1] !== "!";
      const locale = target.replace(/!/g, "");
      chain.push(locale);
      if ((isArray(blocks) || isPlainObject(blocks)) && blocks[locale]) {
        follow = blocks[locale];
      }
    }
  }
  return follow;
}
const VERSION$1 = "9.2.2";
const NOT_REOSLVED = -1;
const DEFAULT_LOCALE = "en-US";
const MISSING_RESOLVE_VALUE = "";
const capitalize = (str) => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function getDefaultLinkedModifiers() {
  return {
    upper: (val, type) => {
      return type === "text" && isString(val) ? val.toUpperCase() : type === "vnode" && isObject(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
    },
    lower: (val, type) => {
      return type === "text" && isString(val) ? val.toLowerCase() : type === "vnode" && isObject(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
    },
    capitalize: (val, type) => {
      return type === "text" && isString(val) ? capitalize(val) : type === "vnode" && isObject(val) && "__v_isVNode" in val ? capitalize(val.children) : val;
    }
  };
}
let _compiler;
function registerMessageCompiler(compiler) {
  _compiler = compiler;
}
let _resolver;
function registerMessageResolver(resolver) {
  _resolver = resolver;
}
let _fallbacker;
function registerLocaleFallbacker(fallbacker) {
  _fallbacker = fallbacker;
}
let _additionalMeta = null;
const setAdditionalMeta = (meta) => {
  _additionalMeta = meta;
};
const getAdditionalMeta = () => _additionalMeta;
let _fallbackContext = null;
const setFallbackContext = (context) => {
  _fallbackContext = context;
};
const getFallbackContext = () => _fallbackContext;
let _cid = 0;
function createCoreContext(options = {}) {
  const version2 = isString(options.version) ? options.version : VERSION$1;
  const locale = isString(options.locale) ? options.locale : DEFAULT_LOCALE;
  const fallbackLocale = isArray(options.fallbackLocale) || isPlainObject(options.fallbackLocale) || isString(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
  const messages = isPlainObject(options.messages) ? options.messages : { [locale]: {} };
  const datetimeFormats = isPlainObject(options.datetimeFormats) ? options.datetimeFormats : { [locale]: {} };
  const numberFormats = isPlainObject(options.numberFormats) ? options.numberFormats : { [locale]: {} };
  const modifiers = assign({}, options.modifiers || {}, getDefaultLinkedModifiers());
  const pluralRules = options.pluralRules || {};
  const missing = isFunction(options.missing) ? options.missing : null;
  const missingWarn = isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : true;
  const fallbackWarn = isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : true;
  const fallbackFormat = !!options.fallbackFormat;
  const unresolving = !!options.unresolving;
  const postTranslation = isFunction(options.postTranslation) ? options.postTranslation : null;
  const processor = isPlainObject(options.processor) ? options.processor : null;
  const warnHtmlMessage = isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
  const escapeParameter = !!options.escapeParameter;
  const messageCompiler = isFunction(options.messageCompiler) ? options.messageCompiler : _compiler;
  const messageResolver = isFunction(options.messageResolver) ? options.messageResolver : _resolver || resolveWithKeyValue;
  const localeFallbacker = isFunction(options.localeFallbacker) ? options.localeFallbacker : _fallbacker || fallbackWithSimple;
  const fallbackContext = isObject(options.fallbackContext) ? options.fallbackContext : void 0;
  const onWarn = isFunction(options.onWarn) ? options.onWarn : warn;
  const internalOptions = options;
  const __datetimeFormatters = isObject(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : /* @__PURE__ */ new Map();
  const __numberFormatters = isObject(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : /* @__PURE__ */ new Map();
  const __meta = isObject(internalOptions.__meta) ? internalOptions.__meta : {};
  _cid++;
  const context = {
    version: version2,
    cid: _cid,
    locale,
    fallbackLocale,
    messages,
    modifiers,
    pluralRules,
    missing,
    missingWarn,
    fallbackWarn,
    fallbackFormat,
    unresolving,
    postTranslation,
    processor,
    warnHtmlMessage,
    escapeParameter,
    messageCompiler,
    messageResolver,
    localeFallbacker,
    fallbackContext,
    onWarn,
    __meta
  };
  {
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
  }
  if (__INTLIFY_PROD_DEVTOOLS__) {
    initI18nDevTools(context, version2, __meta);
  }
  return context;
}
function handleMissing(context, key, locale, missingWarn, type) {
  const { missing, onWarn } = context;
  if (missing !== null) {
    const ret = missing(context, locale, key, type);
    return isString(ret) ? ret : key;
  } else {
    return key;
  }
}
function updateFallbackLocale(ctx, locale, fallback) {
  const context = ctx;
  context.__localeChainCache = /* @__PURE__ */ new Map();
  ctx.localeFallbacker(ctx, fallback, locale);
}
const defaultOnCacheKey = (source) => source;
let compileCache = /* @__PURE__ */ Object.create(null);
function compileToFunction(source, options = {}) {
  {
    const onCacheKey = options.onCacheKey || defaultOnCacheKey;
    const key = onCacheKey(source);
    const cached = compileCache[key];
    if (cached) {
      return cached;
    }
    let occurred = false;
    const onError = options.onError || defaultOnError;
    options.onError = (err) => {
      occurred = true;
      onError(err);
    };
    const { code: code2 } = baseCompile(source, options);
    const msg = new Function(`return ${code2}`)();
    return !occurred ? compileCache[key] = msg : msg;
  }
}
let code$1 = CompileErrorCodes.__EXTEND_POINT__;
const inc$1 = () => ++code$1;
const CoreErrorCodes = {
  INVALID_ARGUMENT: code$1,
  INVALID_DATE_ARGUMENT: inc$1(),
  INVALID_ISO_DATE_ARGUMENT: inc$1(),
  __EXTEND_POINT__: inc$1()
};
function createCoreError(code2) {
  return createCompileError(code2, null, void 0);
}
const NOOP_MESSAGE_FUNCTION = () => "";
const isMessageFunction = (val) => isFunction(val);
function translate(context, ...args) {
  const { fallbackFormat, postTranslation, unresolving, messageCompiler, fallbackLocale, messages } = context;
  const [key, options] = parseTranslateArgs(...args);
  const missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn;
  const fallbackWarn = isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
  const escapeParameter = isBoolean(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
  const resolvedMessage = !!options.resolvedMessage;
  const defaultMsgOrKey = isString(options.default) || isBoolean(options.default) ? !isBoolean(options.default) ? options.default : !messageCompiler ? () => key : key : fallbackFormat ? !messageCompiler ? () => key : key : "";
  const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
  const locale = isString(options.locale) ? options.locale : context.locale;
  escapeParameter && escapeParams(options);
  let [formatScope, targetLocale, message2] = !resolvedMessage ? resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
    key,
    locale,
    messages[locale] || {}
  ];
  let format = formatScope;
  let cacheBaseKey = key;
  if (!resolvedMessage && !(isString(format) || isMessageFunction(format))) {
    if (enableDefaultMsg) {
      format = defaultMsgOrKey;
      cacheBaseKey = format;
    }
  }
  if (!resolvedMessage && (!(isString(format) || isMessageFunction(format)) || !isString(targetLocale))) {
    return unresolving ? NOT_REOSLVED : key;
  }
  let occurred = false;
  const errorDetector = () => {
    occurred = true;
  };
  const msg = !isMessageFunction(format) ? compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) : format;
  if (occurred) {
    return format;
  }
  const ctxOptions = getMessageContextOptions(context, targetLocale, message2, options);
  const msgContext = createMessageContext(ctxOptions);
  const messaged = evaluateMessage(context, msg, msgContext);
  const ret = postTranslation ? postTranslation(messaged, key) : messaged;
  if (__INTLIFY_PROD_DEVTOOLS__) {
    const payloads = {
      timestamp: Date.now(),
      key: isString(key) ? key : isMessageFunction(format) ? format.key : "",
      locale: targetLocale || (isMessageFunction(format) ? format.locale : ""),
      format: isString(format) ? format : isMessageFunction(format) ? format.source : "",
      message: ret
    };
    payloads.meta = assign({}, context.__meta, getAdditionalMeta() || {});
    translateDevTools(payloads);
  }
  return ret;
}
function escapeParams(options) {
  if (isArray(options.list)) {
    options.list = options.list.map((item) => isString(item) ? escapeHtml(item) : item);
  } else if (isObject(options.named)) {
    Object.keys(options.named).forEach((key) => {
      if (isString(options.named[key])) {
        options.named[key] = escapeHtml(options.named[key]);
      }
    });
  }
}
function resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
  const { messages, onWarn, messageResolver: resolveValue2, localeFallbacker } = context;
  const locales = localeFallbacker(context, fallbackLocale, locale);
  let message2 = {};
  let targetLocale;
  let format = null;
  const type = "translate";
  for (let i = 0; i < locales.length; i++) {
    targetLocale = locales[i];
    message2 = messages[targetLocale] || {};
    if ((format = resolveValue2(message2, key)) === null) {
      format = message2[key];
    }
    if (isString(format) || isFunction(format))
      break;
    const missingRet = handleMissing(
      context,
      key,
      targetLocale,
      missingWarn,
      type
    );
    if (missingRet !== key) {
      format = missingRet;
    }
  }
  return [format, targetLocale, message2];
}
function compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) {
  const { messageCompiler, warnHtmlMessage } = context;
  if (isMessageFunction(format)) {
    const msg2 = format;
    msg2.locale = msg2.locale || targetLocale;
    msg2.key = msg2.key || key;
    return msg2;
  }
  if (messageCompiler == null) {
    const msg2 = () => format;
    msg2.locale = targetLocale;
    msg2.key = key;
    return msg2;
  }
  const msg = messageCompiler(format, getCompileOptions(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, errorDetector));
  msg.locale = targetLocale;
  msg.key = key;
  msg.source = format;
  return msg;
}
function evaluateMessage(context, msg, msgCtx) {
  const messaged = msg(msgCtx);
  return messaged;
}
function parseTranslateArgs(...args) {
  const [arg1, arg2, arg3] = args;
  const options = {};
  if (!isString(arg1) && !isNumber(arg1) && !isMessageFunction(arg1)) {
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  }
  const key = isNumber(arg1) ? String(arg1) : isMessageFunction(arg1) ? arg1 : arg1;
  if (isNumber(arg2)) {
    options.plural = arg2;
  } else if (isString(arg2)) {
    options.default = arg2;
  } else if (isPlainObject(arg2) && !isEmptyObject(arg2)) {
    options.named = arg2;
  } else if (isArray(arg2)) {
    options.list = arg2;
  }
  if (isNumber(arg3)) {
    options.plural = arg3;
  } else if (isString(arg3)) {
    options.default = arg3;
  } else if (isPlainObject(arg3)) {
    assign(options, arg3);
  }
  return [key, options];
}
function getCompileOptions(context, locale, key, source, warnHtmlMessage, errorDetector) {
  return {
    warnHtmlMessage,
    onError: (err) => {
      errorDetector && errorDetector(err);
      {
        throw err;
      }
    },
    onCacheKey: (source2) => generateFormatCacheKey(locale, key, source2)
  };
}
function getMessageContextOptions(context, locale, message2, options) {
  const { modifiers, pluralRules, messageResolver: resolveValue2, fallbackLocale, fallbackWarn, missingWarn, fallbackContext } = context;
  const resolveMessage = (key) => {
    let val = resolveValue2(message2, key);
    if (val == null && fallbackContext) {
      const [, , message3] = resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
      val = resolveValue2(message3, key);
    }
    if (isString(val)) {
      let occurred = false;
      const errorDetector = () => {
        occurred = true;
      };
      const msg = compileMessageFormat(context, key, locale, val, key, errorDetector);
      return !occurred ? msg : NOOP_MESSAGE_FUNCTION;
    } else if (isMessageFunction(val)) {
      return val;
    } else {
      return NOOP_MESSAGE_FUNCTION;
    }
  };
  const ctxOptions = {
    locale,
    modifiers,
    pluralRules,
    messages: resolveMessage
  };
  if (context.processor) {
    ctxOptions.processor = context.processor;
  }
  if (options.list) {
    ctxOptions.list = options.list;
  }
  if (options.named) {
    ctxOptions.named = options.named;
  }
  if (isNumber(options.plural)) {
    ctxOptions.pluralIndex = options.plural;
  }
  return ctxOptions;
}
function datetime(context, ...args) {
  const { datetimeFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
  const { __datetimeFormatters } = context;
  const [key, value, options, overrides] = parseDateTimeArgs(...args);
  const missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn;
  isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
  const part = !!options.part;
  const locale = isString(options.locale) ? options.locale : context.locale;
  const locales = localeFallbacker(
    context,
    fallbackLocale,
    locale
  );
  if (!isString(key) || key === "") {
    return new Intl.DateTimeFormat(locale, overrides).format(value);
  }
  let datetimeFormat = {};
  let targetLocale;
  let format = null;
  const type = "datetime format";
  for (let i = 0; i < locales.length; i++) {
    targetLocale = locales[i];
    datetimeFormat = datetimeFormats[targetLocale] || {};
    format = datetimeFormat[key];
    if (isPlainObject(format))
      break;
    handleMissing(context, key, targetLocale, missingWarn, type);
  }
  if (!isPlainObject(format) || !isString(targetLocale)) {
    return unresolving ? NOT_REOSLVED : key;
  }
  let id = `${targetLocale}__${key}`;
  if (!isEmptyObject(overrides)) {
    id = `${id}__${JSON.stringify(overrides)}`;
  }
  let formatter = __datetimeFormatters.get(id);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(targetLocale, assign({}, format, overrides));
    __datetimeFormatters.set(id, formatter);
  }
  return !part ? formatter.format(value) : formatter.formatToParts(value);
}
const DATETIME_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function parseDateTimeArgs(...args) {
  const [arg1, arg2, arg3, arg4] = args;
  const options = {};
  let overrides = {};
  let value;
  if (isString(arg1)) {
    const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!matches) {
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    }
    const dateTime = matches[3] ? matches[3].trim().startsWith("T") ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
    value = new Date(dateTime);
    try {
      value.toISOString();
    } catch (e2) {
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (isDate(arg1)) {
    if (isNaN(arg1.getTime())) {
      throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
    }
    value = arg1;
  } else if (isNumber(arg1)) {
    value = arg1;
  } else {
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  }
  if (isString(arg2)) {
    options.key = arg2;
  } else if (isPlainObject(arg2)) {
    Object.keys(arg2).forEach((key) => {
      if (DATETIME_FORMAT_OPTIONS_KEYS.includes(key)) {
        overrides[key] = arg2[key];
      } else {
        options[key] = arg2[key];
      }
    });
  }
  if (isString(arg3)) {
    options.locale = arg3;
  } else if (isPlainObject(arg3)) {
    overrides = arg3;
  }
  if (isPlainObject(arg4)) {
    overrides = arg4;
  }
  return [options.key || "", value, options, overrides];
}
function clearDateTimeFormat(ctx, locale, format) {
  const context = ctx;
  for (const key in format) {
    const id = `${locale}__${key}`;
    if (!context.__datetimeFormatters.has(id)) {
      continue;
    }
    context.__datetimeFormatters.delete(id);
  }
}
function number(context, ...args) {
  const { numberFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
  const { __numberFormatters } = context;
  const [key, value, options, overrides] = parseNumberArgs(...args);
  const missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn;
  isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
  const part = !!options.part;
  const locale = isString(options.locale) ? options.locale : context.locale;
  const locales = localeFallbacker(
    context,
    fallbackLocale,
    locale
  );
  if (!isString(key) || key === "") {
    return new Intl.NumberFormat(locale, overrides).format(value);
  }
  let numberFormat = {};
  let targetLocale;
  let format = null;
  const type = "number format";
  for (let i = 0; i < locales.length; i++) {
    targetLocale = locales[i];
    numberFormat = numberFormats[targetLocale] || {};
    format = numberFormat[key];
    if (isPlainObject(format))
      break;
    handleMissing(context, key, targetLocale, missingWarn, type);
  }
  if (!isPlainObject(format) || !isString(targetLocale)) {
    return unresolving ? NOT_REOSLVED : key;
  }
  let id = `${targetLocale}__${key}`;
  if (!isEmptyObject(overrides)) {
    id = `${id}__${JSON.stringify(overrides)}`;
  }
  let formatter = __numberFormatters.get(id);
  if (!formatter) {
    formatter = new Intl.NumberFormat(targetLocale, assign({}, format, overrides));
    __numberFormatters.set(id, formatter);
  }
  return !part ? formatter.format(value) : formatter.formatToParts(value);
}
const NUMBER_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function parseNumberArgs(...args) {
  const [arg1, arg2, arg3, arg4] = args;
  const options = {};
  let overrides = {};
  if (!isNumber(arg1)) {
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  }
  const value = arg1;
  if (isString(arg2)) {
    options.key = arg2;
  } else if (isPlainObject(arg2)) {
    Object.keys(arg2).forEach((key) => {
      if (NUMBER_FORMAT_OPTIONS_KEYS.includes(key)) {
        overrides[key] = arg2[key];
      } else {
        options[key] = arg2[key];
      }
    });
  }
  if (isString(arg3)) {
    options.locale = arg3;
  } else if (isPlainObject(arg3)) {
    overrides = arg3;
  }
  if (isPlainObject(arg4)) {
    overrides = arg4;
  }
  return [options.key || "", value, options, overrides];
}
function clearNumberFormat(ctx, locale, format) {
  const context = ctx;
  for (const key in format) {
    const id = `${locale}__${key}`;
    if (!context.__numberFormatters.has(id)) {
      continue;
    }
    context.__numberFormatters.delete(id);
  }
}
{
  if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") {
    getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
  }
}
/*!
 * vue-i18n v9.2.2
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */
const VERSION = "9.2.2";
function initFeatureFlags() {
  if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") {
    getGlobalThis().__VUE_I18N_FULL_INSTALL__ = true;
  }
  if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") {
    getGlobalThis().__VUE_I18N_LEGACY_API__ = true;
  }
  if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") {
    getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
  }
}
CoreWarnCodes.__EXTEND_POINT__;
let code = CompileErrorCodes.__EXTEND_POINT__;
const inc = () => ++code;
const I18nErrorCodes = {
  UNEXPECTED_RETURN_TYPE: code,
  INVALID_ARGUMENT: inc(),
  MUST_BE_CALL_SETUP_TOP: inc(),
  NOT_INSLALLED: inc(),
  NOT_AVAILABLE_IN_LEGACY_MODE: inc(),
  REQUIRED_VALUE: inc(),
  INVALID_VALUE: inc(),
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: inc(),
  NOT_INSLALLED_WITH_PROVIDE: inc(),
  UNEXPECTED_ERROR: inc(),
  NOT_COMPATIBLE_LEGACY_VUE_I18N: inc(),
  BRIDGE_SUPPORT_VUE_2_ONLY: inc(),
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: inc(),
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: inc(),
  __EXTEND_POINT__: inc()
};
function createI18nError(code2, ...args) {
  return createCompileError(code2, null, void 0);
}
const TransrateVNodeSymbol = /* @__PURE__ */ makeSymbol("__transrateVNode");
const DatetimePartsSymbol = /* @__PURE__ */ makeSymbol("__datetimeParts");
const NumberPartsSymbol = /* @__PURE__ */ makeSymbol("__numberParts");
const SetPluralRulesSymbol = makeSymbol("__setPluralRules");
makeSymbol("__intlifyMeta");
const InejctWithOption = /* @__PURE__ */ makeSymbol("__injectWithOption");
function handleFlatJson(obj) {
  if (!isObject(obj)) {
    return obj;
  }
  for (const key in obj) {
    if (!hasOwn(obj, key)) {
      continue;
    }
    if (!key.includes(".")) {
      if (isObject(obj[key])) {
        handleFlatJson(obj[key]);
      }
    } else {
      const subKeys = key.split(".");
      const lastIndex = subKeys.length - 1;
      let currentObj = obj;
      for (let i = 0; i < lastIndex; i++) {
        if (!(subKeys[i] in currentObj)) {
          currentObj[subKeys[i]] = {};
        }
        currentObj = currentObj[subKeys[i]];
      }
      currentObj[subKeys[lastIndex]] = obj[key];
      delete obj[key];
      if (isObject(currentObj[subKeys[lastIndex]])) {
        handleFlatJson(currentObj[subKeys[lastIndex]]);
      }
    }
  }
  return obj;
}
function getLocaleMessages(locale, options) {
  const { messages, __i18n, messageResolver, flatJson } = options;
  const ret = isPlainObject(messages) ? messages : isArray(__i18n) ? {} : { [locale]: {} };
  if (isArray(__i18n)) {
    __i18n.forEach((custom) => {
      if ("locale" in custom && "resource" in custom) {
        const { locale: locale2, resource } = custom;
        if (locale2) {
          ret[locale2] = ret[locale2] || {};
          deepCopy(resource, ret[locale2]);
        } else {
          deepCopy(resource, ret);
        }
      } else {
        isString(custom) && deepCopy(JSON.parse(custom), ret);
      }
    });
  }
  if (messageResolver == null && flatJson) {
    for (const key in ret) {
      if (hasOwn(ret, key)) {
        handleFlatJson(ret[key]);
      }
    }
  }
  return ret;
}
const isNotObjectOrIsArray = (val) => !isObject(val) || isArray(val);
function deepCopy(src, des) {
  if (isNotObjectOrIsArray(src) || isNotObjectOrIsArray(des)) {
    throw createI18nError(I18nErrorCodes.INVALID_VALUE);
  }
  for (const key in src) {
    if (hasOwn(src, key)) {
      if (isNotObjectOrIsArray(src[key]) || isNotObjectOrIsArray(des[key])) {
        des[key] = src[key];
      } else {
        deepCopy(src[key], des[key]);
      }
    }
  }
}
function getComponentOptions(instance) {
  return instance.type;
}
function adjustI18nResources(global2, options, componentOptions) {
  let messages = isObject(options.messages) ? options.messages : {};
  if ("__i18nGlobal" in componentOptions) {
    messages = getLocaleMessages(global2.locale.value, {
      messages,
      __i18n: componentOptions.__i18nGlobal
    });
  }
  const locales = Object.keys(messages);
  if (locales.length) {
    locales.forEach((locale) => {
      global2.mergeLocaleMessage(locale, messages[locale]);
    });
  }
  {
    if (isObject(options.datetimeFormats)) {
      const locales2 = Object.keys(options.datetimeFormats);
      if (locales2.length) {
        locales2.forEach((locale) => {
          global2.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
      }
    }
    if (isObject(options.numberFormats)) {
      const locales2 = Object.keys(options.numberFormats);
      if (locales2.length) {
        locales2.forEach((locale) => {
          global2.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
      }
    }
  }
}
function createTextNode(key) {
  return createVNode(Text, null, key, 0);
}
const DEVTOOLS_META = "__INTLIFY_META__";
let composerID = 0;
function defineCoreMissingHandler(missing) {
  return (ctx, locale, key, type) => {
    return missing(locale, key, getCurrentInstance() || void 0, type);
  };
}
const getMetaInfo = () => {
  const instance = getCurrentInstance();
  let meta = null;
  return instance && (meta = getComponentOptions(instance)[DEVTOOLS_META]) ? { [DEVTOOLS_META]: meta } : null;
};
function createComposer(options = {}, VueI18nLegacy) {
  const { __root } = options;
  const _isGlobal = __root === void 0;
  let _inheritLocale = isBoolean(options.inheritLocale) ? options.inheritLocale : true;
  const _locale = ref(
    __root && _inheritLocale ? __root.locale.value : isString(options.locale) ? options.locale : DEFAULT_LOCALE
  );
  const _fallbackLocale = ref(
    __root && _inheritLocale ? __root.fallbackLocale.value : isString(options.fallbackLocale) || isArray(options.fallbackLocale) || isPlainObject(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value
  );
  const _messages = ref(getLocaleMessages(_locale.value, options));
  const _datetimeFormats = ref(isPlainObject(options.datetimeFormats) ? options.datetimeFormats : { [_locale.value]: {} });
  const _numberFormats = ref(isPlainObject(options.numberFormats) ? options.numberFormats : { [_locale.value]: {} });
  let _missingWarn = __root ? __root.missingWarn : isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : true;
  let _fallbackWarn = __root ? __root.fallbackWarn : isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : true;
  let _fallbackRoot = __root ? __root.fallbackRoot : isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
  let _fallbackFormat = !!options.fallbackFormat;
  let _missing = isFunction(options.missing) ? options.missing : null;
  let _runtimeMissing = isFunction(options.missing) ? defineCoreMissingHandler(options.missing) : null;
  let _postTranslation = isFunction(options.postTranslation) ? options.postTranslation : null;
  let _warnHtmlMessage = __root ? __root.warnHtmlMessage : isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
  let _escapeParameter = !!options.escapeParameter;
  const _modifiers = __root ? __root.modifiers : isPlainObject(options.modifiers) ? options.modifiers : {};
  let _pluralRules = options.pluralRules || __root && __root.pluralRules;
  let _context;
  const getCoreContext = () => {
    _isGlobal && setFallbackContext(null);
    const ctxOptions = {
      version: VERSION,
      locale: _locale.value,
      fallbackLocale: _fallbackLocale.value,
      messages: _messages.value,
      modifiers: _modifiers,
      pluralRules: _pluralRules,
      missing: _runtimeMissing === null ? void 0 : _runtimeMissing,
      missingWarn: _missingWarn,
      fallbackWarn: _fallbackWarn,
      fallbackFormat: _fallbackFormat,
      unresolving: true,
      postTranslation: _postTranslation === null ? void 0 : _postTranslation,
      warnHtmlMessage: _warnHtmlMessage,
      escapeParameter: _escapeParameter,
      messageResolver: options.messageResolver,
      __meta: { framework: "vue" }
    };
    {
      ctxOptions.datetimeFormats = _datetimeFormats.value;
      ctxOptions.numberFormats = _numberFormats.value;
      ctxOptions.__datetimeFormatters = isPlainObject(_context) ? _context.__datetimeFormatters : void 0;
      ctxOptions.__numberFormatters = isPlainObject(_context) ? _context.__numberFormatters : void 0;
    }
    const ctx = createCoreContext(ctxOptions);
    _isGlobal && setFallbackContext(ctx);
    return ctx;
  };
  _context = getCoreContext();
  updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
  function trackReactivityValues() {
    return [
      _locale.value,
      _fallbackLocale.value,
      _messages.value,
      _datetimeFormats.value,
      _numberFormats.value
    ];
  }
  const locale = computed({
    get: () => _locale.value,
    set: (val) => {
      _locale.value = val;
      _context.locale = _locale.value;
    }
  });
  const fallbackLocale = computed({
    get: () => _fallbackLocale.value,
    set: (val) => {
      _fallbackLocale.value = val;
      _context.fallbackLocale = _fallbackLocale.value;
      updateFallbackLocale(_context, _locale.value, val);
    }
  });
  const messages = computed(() => _messages.value);
  const datetimeFormats = /* @__PURE__ */ computed(() => _datetimeFormats.value);
  const numberFormats = /* @__PURE__ */ computed(() => _numberFormats.value);
  function getPostTranslationHandler() {
    return isFunction(_postTranslation) ? _postTranslation : null;
  }
  function setPostTranslationHandler(handler) {
    _postTranslation = handler;
    _context.postTranslation = handler;
  }
  function getMissingHandler() {
    return _missing;
  }
  function setMissingHandler(handler) {
    if (handler !== null) {
      _runtimeMissing = defineCoreMissingHandler(handler);
    }
    _missing = handler;
    _context.missing = _runtimeMissing;
  }
  const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) => {
    trackReactivityValues();
    let ret;
    if (__INTLIFY_PROD_DEVTOOLS__) {
      try {
        setAdditionalMeta(getMetaInfo());
        if (!_isGlobal) {
          _context.fallbackContext = __root ? getFallbackContext() : void 0;
        }
        ret = fn(_context);
      } finally {
        setAdditionalMeta(null);
        if (!_isGlobal) {
          _context.fallbackContext = void 0;
        }
      }
    } else {
      ret = fn(_context);
    }
    if (isNumber(ret) && ret === NOT_REOSLVED) {
      const [key, arg2] = argumentParser();
      return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
    } else if (successCondition(ret)) {
      return ret;
    } else {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    }
  };
  function t2(...args) {
    return wrapWithDeps((context) => Reflect.apply(translate, null, [context, ...args]), () => parseTranslateArgs(...args), "translate", (root) => Reflect.apply(root.t, root, [...args]), (key) => key, (val) => isString(val));
  }
  function rt(...args) {
    const [arg1, arg2, arg3] = args;
    if (arg3 && !isObject(arg3)) {
      throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
    }
    return t2(...[arg1, arg2, assign({ resolvedMessage: true }, arg3 || {})]);
  }
  function d(...args) {
    return wrapWithDeps((context) => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), "datetime format", (root) => Reflect.apply(root.d, root, [...args]), () => MISSING_RESOLVE_VALUE, (val) => isString(val));
  }
  function n2(...args) {
    return wrapWithDeps((context) => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), "number format", (root) => Reflect.apply(root.n, root, [...args]), () => MISSING_RESOLVE_VALUE, (val) => isString(val));
  }
  function normalize(values) {
    return values.map((val) => isString(val) || isNumber(val) || isBoolean(val) ? createTextNode(String(val)) : val);
  }
  const interpolate = (val) => val;
  const processor = {
    normalize,
    interpolate,
    type: "vnode"
  };
  function transrateVNode(...args) {
    return wrapWithDeps(
      (context) => {
        let ret;
        const _context2 = context;
        try {
          _context2.processor = processor;
          ret = Reflect.apply(translate, null, [_context2, ...args]);
        } finally {
          _context2.processor = null;
        }
        return ret;
      },
      () => parseTranslateArgs(...args),
      "translate",
      (root) => root[TransrateVNodeSymbol](...args),
      (key) => [createTextNode(key)],
      (val) => isArray(val)
    );
  }
  function numberParts(...args) {
    return wrapWithDeps(
      (context) => Reflect.apply(number, null, [context, ...args]),
      () => parseNumberArgs(...args),
      "number format",
      (root) => root[NumberPartsSymbol](...args),
      () => [],
      (val) => isString(val) || isArray(val)
    );
  }
  function datetimeParts(...args) {
    return wrapWithDeps(
      (context) => Reflect.apply(datetime, null, [context, ...args]),
      () => parseDateTimeArgs(...args),
      "datetime format",
      (root) => root[DatetimePartsSymbol](...args),
      () => [],
      (val) => isString(val) || isArray(val)
    );
  }
  function setPluralRules(rules) {
    _pluralRules = rules;
    _context.pluralRules = _pluralRules;
  }
  function te(key, locale2) {
    const targetLocale = isString(locale2) ? locale2 : _locale.value;
    const message2 = getLocaleMessage(targetLocale);
    return _context.messageResolver(message2, key) !== null;
  }
  function resolveMessages(key) {
    let messages2 = null;
    const locales = fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
    for (let i = 0; i < locales.length; i++) {
      const targetLocaleMessages = _messages.value[locales[i]] || {};
      const messageValue = _context.messageResolver(targetLocaleMessages, key);
      if (messageValue != null) {
        messages2 = messageValue;
        break;
      }
    }
    return messages2;
  }
  function tm(key) {
    const messages2 = resolveMessages(key);
    return messages2 != null ? messages2 : __root ? __root.tm(key) || {} : {};
  }
  function getLocaleMessage(locale2) {
    return _messages.value[locale2] || {};
  }
  function setLocaleMessage(locale2, message2) {
    _messages.value[locale2] = message2;
    _context.messages = _messages.value;
  }
  function mergeLocaleMessage(locale2, message2) {
    _messages.value[locale2] = _messages.value[locale2] || {};
    deepCopy(message2, _messages.value[locale2]);
    _context.messages = _messages.value;
  }
  function getDateTimeFormat(locale2) {
    return _datetimeFormats.value[locale2] || {};
  }
  function setDateTimeFormat(locale2, format) {
    _datetimeFormats.value[locale2] = format;
    _context.datetimeFormats = _datetimeFormats.value;
    clearDateTimeFormat(_context, locale2, format);
  }
  function mergeDateTimeFormat(locale2, format) {
    _datetimeFormats.value[locale2] = assign(_datetimeFormats.value[locale2] || {}, format);
    _context.datetimeFormats = _datetimeFormats.value;
    clearDateTimeFormat(_context, locale2, format);
  }
  function getNumberFormat(locale2) {
    return _numberFormats.value[locale2] || {};
  }
  function setNumberFormat(locale2, format) {
    _numberFormats.value[locale2] = format;
    _context.numberFormats = _numberFormats.value;
    clearNumberFormat(_context, locale2, format);
  }
  function mergeNumberFormat(locale2, format) {
    _numberFormats.value[locale2] = assign(_numberFormats.value[locale2] || {}, format);
    _context.numberFormats = _numberFormats.value;
    clearNumberFormat(_context, locale2, format);
  }
  composerID++;
  if (__root && inBrowser) {
    watch(__root.locale, (val) => {
      if (_inheritLocale) {
        _locale.value = val;
        _context.locale = val;
        updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
      }
    });
    watch(__root.fallbackLocale, (val) => {
      if (_inheritLocale) {
        _fallbackLocale.value = val;
        _context.fallbackLocale = val;
        updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
      }
    });
  }
  const composer = {
    id: composerID,
    locale,
    fallbackLocale,
    get inheritLocale() {
      return _inheritLocale;
    },
    set inheritLocale(val) {
      _inheritLocale = val;
      if (val && __root) {
        _locale.value = __root.locale.value;
        _fallbackLocale.value = __root.fallbackLocale.value;
        updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
      }
    },
    get availableLocales() {
      return Object.keys(_messages.value).sort();
    },
    messages,
    get modifiers() {
      return _modifiers;
    },
    get pluralRules() {
      return _pluralRules || {};
    },
    get isGlobal() {
      return _isGlobal;
    },
    get missingWarn() {
      return _missingWarn;
    },
    set missingWarn(val) {
      _missingWarn = val;
      _context.missingWarn = _missingWarn;
    },
    get fallbackWarn() {
      return _fallbackWarn;
    },
    set fallbackWarn(val) {
      _fallbackWarn = val;
      _context.fallbackWarn = _fallbackWarn;
    },
    get fallbackRoot() {
      return _fallbackRoot;
    },
    set fallbackRoot(val) {
      _fallbackRoot = val;
    },
    get fallbackFormat() {
      return _fallbackFormat;
    },
    set fallbackFormat(val) {
      _fallbackFormat = val;
      _context.fallbackFormat = _fallbackFormat;
    },
    get warnHtmlMessage() {
      return _warnHtmlMessage;
    },
    set warnHtmlMessage(val) {
      _warnHtmlMessage = val;
      _context.warnHtmlMessage = val;
    },
    get escapeParameter() {
      return _escapeParameter;
    },
    set escapeParameter(val) {
      _escapeParameter = val;
      _context.escapeParameter = val;
    },
    t: t2,
    getLocaleMessage,
    setLocaleMessage,
    mergeLocaleMessage,
    getPostTranslationHandler,
    setPostTranslationHandler,
    getMissingHandler,
    setMissingHandler,
    [SetPluralRulesSymbol]: setPluralRules
  };
  {
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n2;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[InejctWithOption] = options.__injectWithOption;
    composer[TransrateVNodeSymbol] = transrateVNode;
    composer[DatetimePartsSymbol] = datetimeParts;
    composer[NumberPartsSymbol] = numberParts;
  }
  return composer;
}
function convertComposerOptions(options) {
  const locale = isString(options.locale) ? options.locale : DEFAULT_LOCALE;
  const fallbackLocale = isString(options.fallbackLocale) || isArray(options.fallbackLocale) || isPlainObject(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
  const missing = isFunction(options.missing) ? options.missing : void 0;
  const missingWarn = isBoolean(options.silentTranslationWarn) || isRegExp(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
  const fallbackWarn = isBoolean(options.silentFallbackWarn) || isRegExp(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
  const fallbackRoot = isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
  const fallbackFormat = !!options.formatFallbackMessages;
  const modifiers = isPlainObject(options.modifiers) ? options.modifiers : {};
  const pluralizationRules = options.pluralizationRules;
  const postTranslation = isFunction(options.postTranslation) ? options.postTranslation : void 0;
  const warnHtmlMessage = isString(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
  const escapeParameter = !!options.escapeParameterHtml;
  const inheritLocale = isBoolean(options.sync) ? options.sync : true;
  let messages = options.messages;
  if (isPlainObject(options.sharedMessages)) {
    const sharedMessages = options.sharedMessages;
    const locales = Object.keys(sharedMessages);
    messages = locales.reduce((messages2, locale2) => {
      const message2 = messages2[locale2] || (messages2[locale2] = {});
      assign(message2, sharedMessages[locale2]);
      return messages2;
    }, messages || {});
  }
  const { __i18n, __root, __injectWithOption } = options;
  const datetimeFormats = options.datetimeFormats;
  const numberFormats = options.numberFormats;
  const flatJson = options.flatJson;
  return {
    locale,
    fallbackLocale,
    messages,
    flatJson,
    datetimeFormats,
    numberFormats,
    missing,
    missingWarn,
    fallbackWarn,
    fallbackRoot,
    fallbackFormat,
    modifiers,
    pluralRules: pluralizationRules,
    postTranslation,
    warnHtmlMessage,
    escapeParameter,
    messageResolver: options.messageResolver,
    inheritLocale,
    __i18n,
    __root,
    __injectWithOption
  };
}
function createVueI18n(options = {}, VueI18nLegacy) {
  {
    const composer = createComposer(convertComposerOptions(options));
    const vueI18n = {
      id: composer.id,
      get locale() {
        return composer.locale.value;
      },
      set locale(val) {
        composer.locale.value = val;
      },
      get fallbackLocale() {
        return composer.fallbackLocale.value;
      },
      set fallbackLocale(val) {
        composer.fallbackLocale.value = val;
      },
      get messages() {
        return composer.messages.value;
      },
      get datetimeFormats() {
        return composer.datetimeFormats.value;
      },
      get numberFormats() {
        return composer.numberFormats.value;
      },
      get availableLocales() {
        return composer.availableLocales;
      },
      get formatter() {
        return {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(val) {
      },
      get missing() {
        return composer.getMissingHandler();
      },
      set missing(handler) {
        composer.setMissingHandler(handler);
      },
      get silentTranslationWarn() {
        return isBoolean(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
      },
      set silentTranslationWarn(val) {
        composer.missingWarn = isBoolean(val) ? !val : val;
      },
      get silentFallbackWarn() {
        return isBoolean(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
      },
      set silentFallbackWarn(val) {
        composer.fallbackWarn = isBoolean(val) ? !val : val;
      },
      get modifiers() {
        return composer.modifiers;
      },
      get formatFallbackMessages() {
        return composer.fallbackFormat;
      },
      set formatFallbackMessages(val) {
        composer.fallbackFormat = val;
      },
      get postTranslation() {
        return composer.getPostTranslationHandler();
      },
      set postTranslation(handler) {
        composer.setPostTranslationHandler(handler);
      },
      get sync() {
        return composer.inheritLocale;
      },
      set sync(val) {
        composer.inheritLocale = val;
      },
      get warnHtmlInMessage() {
        return composer.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(val) {
        composer.warnHtmlMessage = val !== "off";
      },
      get escapeParameterHtml() {
        return composer.escapeParameter;
      },
      set escapeParameterHtml(val) {
        composer.escapeParameter = val;
      },
      get preserveDirectiveContent() {
        return true;
      },
      set preserveDirectiveContent(val) {
      },
      get pluralizationRules() {
        return composer.pluralRules || {};
      },
      __composer: composer,
      t(...args) {
        const [arg1, arg2, arg3] = args;
        const options2 = {};
        let list = null;
        let named = null;
        if (!isString(arg1)) {
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        const key = arg1;
        if (isString(arg2)) {
          options2.locale = arg2;
        } else if (isArray(arg2)) {
          list = arg2;
        } else if (isPlainObject(arg2)) {
          named = arg2;
        }
        if (isArray(arg3)) {
          list = arg3;
        } else if (isPlainObject(arg3)) {
          named = arg3;
        }
        return Reflect.apply(composer.t, composer, [
          key,
          list || named || {},
          options2
        ]);
      },
      rt(...args) {
        return Reflect.apply(composer.rt, composer, [...args]);
      },
      tc(...args) {
        const [arg1, arg2, arg3] = args;
        const options2 = { plural: 1 };
        let list = null;
        let named = null;
        if (!isString(arg1)) {
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        const key = arg1;
        if (isString(arg2)) {
          options2.locale = arg2;
        } else if (isNumber(arg2)) {
          options2.plural = arg2;
        } else if (isArray(arg2)) {
          list = arg2;
        } else if (isPlainObject(arg2)) {
          named = arg2;
        }
        if (isString(arg3)) {
          options2.locale = arg3;
        } else if (isArray(arg3)) {
          list = arg3;
        } else if (isPlainObject(arg3)) {
          named = arg3;
        }
        return Reflect.apply(composer.t, composer, [
          key,
          list || named || {},
          options2
        ]);
      },
      te(key, locale) {
        return composer.te(key, locale);
      },
      tm(key) {
        return composer.tm(key);
      },
      getLocaleMessage(locale) {
        return composer.getLocaleMessage(locale);
      },
      setLocaleMessage(locale, message2) {
        composer.setLocaleMessage(locale, message2);
      },
      mergeLocaleMessage(locale, message2) {
        composer.mergeLocaleMessage(locale, message2);
      },
      d(...args) {
        return Reflect.apply(composer.d, composer, [...args]);
      },
      getDateTimeFormat(locale) {
        return composer.getDateTimeFormat(locale);
      },
      setDateTimeFormat(locale, format) {
        composer.setDateTimeFormat(locale, format);
      },
      mergeDateTimeFormat(locale, format) {
        composer.mergeDateTimeFormat(locale, format);
      },
      n(...args) {
        return Reflect.apply(composer.n, composer, [...args]);
      },
      getNumberFormat(locale) {
        return composer.getNumberFormat(locale);
      },
      setNumberFormat(locale, format) {
        composer.setNumberFormat(locale, format);
      },
      mergeNumberFormat(locale, format) {
        composer.mergeNumberFormat(locale, format);
      },
      getChoiceIndex(choice, choicesLength) {
        return -1;
      },
      __onComponentInstanceCreated(target) {
        const { componentInstanceCreatedListener } = options;
        if (componentInstanceCreatedListener) {
          componentInstanceCreatedListener(target, vueI18n);
        }
      }
    };
    return vueI18n;
  }
}
const baseFormatProps = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    validator: (val) => val === "parent" || val === "global",
    default: "parent"
  },
  i18n: {
    type: Object
  }
};
function getInterpolateArg({ slots }, keys) {
  if (keys.length === 1 && keys[0] === "default") {
    const ret = slots.default ? slots.default() : [];
    return ret.reduce((slot, current) => {
      return slot = [
        ...slot,
        ...isArray(current.children) ? current.children : [current]
      ];
    }, []);
  } else {
    return keys.reduce((arg, key) => {
      const slot = slots[key];
      if (slot) {
        arg[key] = slot();
      }
      return arg;
    }, {});
  }
}
function getFragmentableTag(tag) {
  return Fragment;
}
const Translation = {
  name: "i18n-t",
  props: assign({
    keypath: {
      type: String,
      required: true
    },
    plural: {
      type: [Number, String],
      validator: (val) => isNumber(val) || !isNaN(val)
    }
  }, baseFormatProps),
  setup(props, context) {
    const { slots, attrs } = context;
    const i18n2 = props.i18n || useI18n({
      useScope: props.scope,
      __useComponent: true
    });
    return () => {
      const keys = Object.keys(slots).filter((key) => key !== "_");
      const options = {};
      if (props.locale) {
        options.locale = props.locale;
      }
      if (props.plural !== void 0) {
        options.plural = isString(props.plural) ? +props.plural : props.plural;
      }
      const arg = getInterpolateArg(context, keys);
      const children = i18n2[TransrateVNodeSymbol](props.keypath, arg, options);
      const assignedAttrs = assign({}, attrs);
      const tag = isString(props.tag) || isObject(props.tag) ? props.tag : getFragmentableTag();
      return h(tag, assignedAttrs, children);
    };
  }
};
function isVNode(target) {
  return isArray(target) && !isString(target[0]);
}
function renderFormatter(props, context, slotKeys, partFormatter) {
  const { slots, attrs } = context;
  return () => {
    const options = { part: true };
    let overrides = {};
    if (props.locale) {
      options.locale = props.locale;
    }
    if (isString(props.format)) {
      options.key = props.format;
    } else if (isObject(props.format)) {
      if (isString(props.format.key)) {
        options.key = props.format.key;
      }
      overrides = Object.keys(props.format).reduce((options2, prop) => {
        return slotKeys.includes(prop) ? assign({}, options2, { [prop]: props.format[prop] }) : options2;
      }, {});
    }
    const parts = partFormatter(...[props.value, options, overrides]);
    let children = [options.key];
    if (isArray(parts)) {
      children = parts.map((part, index) => {
        const slot = slots[part.type];
        const node = slot ? slot({ [part.type]: part.value, index, parts }) : [part.value];
        if (isVNode(node)) {
          node[0].key = `${part.type}-${index}`;
        }
        return node;
      });
    } else if (isString(parts)) {
      children = [parts];
    }
    const assignedAttrs = assign({}, attrs);
    const tag = isString(props.tag) || isObject(props.tag) ? props.tag : getFragmentableTag();
    return h(tag, assignedAttrs, children);
  };
}
const NumberFormat = {
  name: "i18n-n",
  props: assign({
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  setup(props, context) {
    const i18n2 = props.i18n || useI18n({ useScope: "parent", __useComponent: true });
    return renderFormatter(props, context, NUMBER_FORMAT_OPTIONS_KEYS, (...args) => i18n2[NumberPartsSymbol](...args));
  }
};
const DatetimeFormat = {
  name: "i18n-d",
  props: assign({
    value: {
      type: [Number, Date],
      required: true
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  setup(props, context) {
    const i18n2 = props.i18n || useI18n({ useScope: "parent", __useComponent: true });
    return renderFormatter(props, context, DATETIME_FORMAT_OPTIONS_KEYS, (...args) => i18n2[DatetimePartsSymbol](...args));
  }
};
function getComposer$2(i18n2, instance) {
  const i18nInternal = i18n2;
  if (i18n2.mode === "composition") {
    return i18nInternal.__getInstance(instance) || i18n2.global;
  } else {
    const vueI18n = i18nInternal.__getInstance(instance);
    return vueI18n != null ? vueI18n.__composer : i18n2.global.__composer;
  }
}
function vTDirective(i18n2) {
  const _process = (binding) => {
    const { instance, modifiers, value } = binding;
    if (!instance || !instance.$) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    const composer = getComposer$2(i18n2, instance.$);
    const parsedValue = parseValue(value);
    return [
      Reflect.apply(composer.t, composer, [...makeParams(parsedValue)]),
      composer
    ];
  };
  const register = (el, binding) => {
    const [textContent, composer] = _process(binding);
    if (inBrowser && i18n2.global === composer) {
      el.__i18nWatcher = watch(composer.locale, () => {
        binding.instance && binding.instance.$forceUpdate();
      });
    }
    el.__composer = composer;
    el.textContent = textContent;
  };
  const unregister = (el) => {
    if (inBrowser && el.__i18nWatcher) {
      el.__i18nWatcher();
      el.__i18nWatcher = void 0;
      delete el.__i18nWatcher;
    }
    if (el.__composer) {
      el.__composer = void 0;
      delete el.__composer;
    }
  };
  const update = (el, { value }) => {
    if (el.__composer) {
      const composer = el.__composer;
      const parsedValue = parseValue(value);
      el.textContent = Reflect.apply(composer.t, composer, [
        ...makeParams(parsedValue)
      ]);
    }
  };
  const getSSRProps = (binding) => {
    const [textContent] = _process(binding);
    return { textContent };
  };
  return {
    created: register,
    unmounted: unregister,
    beforeUpdate: update,
    getSSRProps
  };
}
function parseValue(value) {
  if (isString(value)) {
    return { path: value };
  } else if (isPlainObject(value)) {
    if (!("path" in value)) {
      throw createI18nError(I18nErrorCodes.REQUIRED_VALUE, "path");
    }
    return value;
  } else {
    throw createI18nError(I18nErrorCodes.INVALID_VALUE);
  }
}
function makeParams(value) {
  const { path, locale, args, choice, plural } = value;
  const options = {};
  const named = args || {};
  if (isString(locale)) {
    options.locale = locale;
  }
  if (isNumber(choice)) {
    options.plural = choice;
  }
  if (isNumber(plural)) {
    options.plural = plural;
  }
  return [path, named, options];
}
function apply(app, i18n2, ...options) {
  const pluginOptions = isPlainObject(options[0]) ? options[0] : {};
  const useI18nComponentName = !!pluginOptions.useI18nComponentName;
  const globalInstall = isBoolean(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
  if (globalInstall) {
    app.component(!useI18nComponentName ? Translation.name : "i18n", Translation);
    app.component(NumberFormat.name, NumberFormat);
    app.component(DatetimeFormat.name, DatetimeFormat);
  }
  {
    app.directive("t", vTDirective(i18n2));
  }
}
function defineMixin(vuei18n, composer, i18n2) {
  return {
    beforeCreate() {
      const instance = getCurrentInstance();
      if (!instance) {
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      }
      const options = this.$options;
      if (options.i18n) {
        const optionsI18n = options.i18n;
        if (options.__i18n) {
          optionsI18n.__i18n = options.__i18n;
        }
        optionsI18n.__root = composer;
        if (this === this.$root) {
          this.$i18n = mergeToRoot(vuei18n, optionsI18n);
        } else {
          optionsI18n.__injectWithOption = true;
          this.$i18n = createVueI18n(optionsI18n);
        }
      } else if (options.__i18n) {
        if (this === this.$root) {
          this.$i18n = mergeToRoot(vuei18n, options);
        } else {
          this.$i18n = createVueI18n({
            __i18n: options.__i18n,
            __injectWithOption: true,
            __root: composer
          });
        }
      } else {
        this.$i18n = vuei18n;
      }
      if (options.__i18nGlobal) {
        adjustI18nResources(composer, options, options);
      }
      vuei18n.__onComponentInstanceCreated(this.$i18n);
      i18n2.__setInstance(instance, this.$i18n);
      this.$t = (...args) => this.$i18n.t(...args);
      this.$rt = (...args) => this.$i18n.rt(...args);
      this.$tc = (...args) => this.$i18n.tc(...args);
      this.$te = (key, locale) => this.$i18n.te(key, locale);
      this.$d = (...args) => this.$i18n.d(...args);
      this.$n = (...args) => this.$i18n.n(...args);
      this.$tm = (key) => this.$i18n.tm(key);
    },
    mounted() {
    },
    unmounted() {
      const instance = getCurrentInstance();
      if (!instance) {
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      }
      delete this.$t;
      delete this.$rt;
      delete this.$tc;
      delete this.$te;
      delete this.$d;
      delete this.$n;
      delete this.$tm;
      i18n2.__deleteInstance(instance);
      delete this.$i18n;
    }
  };
}
function mergeToRoot(root, options) {
  root.locale = options.locale || root.locale;
  root.fallbackLocale = options.fallbackLocale || root.fallbackLocale;
  root.missing = options.missing || root.missing;
  root.silentTranslationWarn = options.silentTranslationWarn || root.silentFallbackWarn;
  root.silentFallbackWarn = options.silentFallbackWarn || root.silentFallbackWarn;
  root.formatFallbackMessages = options.formatFallbackMessages || root.formatFallbackMessages;
  root.postTranslation = options.postTranslation || root.postTranslation;
  root.warnHtmlInMessage = options.warnHtmlInMessage || root.warnHtmlInMessage;
  root.escapeParameterHtml = options.escapeParameterHtml || root.escapeParameterHtml;
  root.sync = options.sync || root.sync;
  root.__composer[SetPluralRulesSymbol](options.pluralizationRules || root.pluralizationRules);
  const messages = getLocaleMessages(root.locale, {
    messages: options.messages,
    __i18n: options.__i18n
  });
  Object.keys(messages).forEach((locale) => root.mergeLocaleMessage(locale, messages[locale]));
  if (options.datetimeFormats) {
    Object.keys(options.datetimeFormats).forEach((locale) => root.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
  }
  if (options.numberFormats) {
    Object.keys(options.numberFormats).forEach((locale) => root.mergeNumberFormat(locale, options.numberFormats[locale]));
  }
  return root;
}
const I18nInjectionKey = /* @__PURE__ */ makeSymbol("global-vue-i18n");
function createI18n(options = {}, VueI18nLegacy) {
  const __legacyMode = __VUE_I18N_LEGACY_API__ && isBoolean(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
  const __globalInjection = isBoolean(options.globalInjection) ? options.globalInjection : true;
  const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
  const __instances = /* @__PURE__ */ new Map();
  const [globalScope, __global] = createGlobal(options, __legacyMode);
  const symbol = makeSymbol("");
  function __getInstance(component) {
    return __instances.get(component) || null;
  }
  function __setInstance(component, instance) {
    __instances.set(component, instance);
  }
  function __deleteInstance(component) {
    __instances.delete(component);
  }
  {
    let _a;
    const i18n2 = {
      get mode() {
        return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
      },
      get allowComposition() {
        return __allowComposition;
      },
      install(app, ...options2) {
        return __async(this, null, function* () {
          app.__VUE_I18N_SYMBOL__ = symbol;
          app.provide(app.__VUE_I18N_SYMBOL__, i18n2);
          if (!__legacyMode && __globalInjection) {
            injectGlobalFields(app, i18n2.global);
          }
          if (__VUE_I18N_FULL_INSTALL__) {
            apply(app, i18n2, ...options2);
          }
          if (__VUE_I18N_LEGACY_API__ && __legacyMode) {
            app.mixin(defineMixin(__global, __global.__composer, i18n2));
          }
          const unmountApp = app.unmount;
          app.unmount = () => {
            i18n2.dispose();
            unmountApp();
          };
        });
      },
      get global() {
        return __global;
      },
      dispose() {
        globalScope.stop();
      },
      __instances,
      __getInstance,
      __setInstance,
      __deleteInstance
    };
    return i18n2;
  }
}
function useI18n(options = {}) {
  const instance = getCurrentInstance();
  if (instance == null) {
    throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
  }
  if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) {
    throw createI18nError(I18nErrorCodes.NOT_INSLALLED);
  }
  const i18n2 = getI18nInstance(instance);
  const global2 = getGlobalComposer(i18n2);
  const componentOptions = getComponentOptions(instance);
  const scope = getScope(options, componentOptions);
  if (__VUE_I18N_LEGACY_API__) {
    if (i18n2.mode === "legacy" && !options.__useComponent) {
      if (!i18n2.allowComposition) {
        throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
      }
      return useI18nForLegacy(instance, scope, global2, options);
    }
  }
  if (scope === "global") {
    adjustI18nResources(global2, options, componentOptions);
    return global2;
  }
  if (scope === "parent") {
    let composer2 = getComposer(i18n2, instance, options.__useComponent);
    if (composer2 == null) {
      composer2 = global2;
    }
    return composer2;
  }
  const i18nInternal = i18n2;
  let composer = i18nInternal.__getInstance(instance);
  if (composer == null) {
    const composerOptions = assign({}, options);
    if ("__i18n" in componentOptions) {
      composerOptions.__i18n = componentOptions.__i18n;
    }
    if (global2) {
      composerOptions.__root = global2;
    }
    composer = createComposer(composerOptions);
    setupLifeCycle(i18nInternal, instance);
    i18nInternal.__setInstance(instance, composer);
  }
  return composer;
}
function createGlobal(options, legacyMode, VueI18nLegacy) {
  const scope = effectScope();
  {
    const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(() => createVueI18n(options)) : scope.run(() => createComposer(options));
    if (obj == null) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    return [scope, obj];
  }
}
function getI18nInstance(instance) {
  {
    const i18n2 = inject(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : I18nInjectionKey);
    if (!i18n2) {
      throw createI18nError(!instance.isCE ? I18nErrorCodes.UNEXPECTED_ERROR : I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE);
    }
    return i18n2;
  }
}
function getScope(options, componentOptions) {
  return isEmptyObject(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function getGlobalComposer(i18n2) {
  return i18n2.mode === "composition" ? i18n2.global : i18n2.global.__composer;
}
function getComposer(i18n2, target, useComponent = false) {
  let composer = null;
  const root = target.root;
  let current = target.parent;
  while (current != null) {
    const i18nInternal = i18n2;
    if (i18n2.mode === "composition") {
      composer = i18nInternal.__getInstance(current);
    } else {
      if (__VUE_I18N_LEGACY_API__) {
        const vueI18n = i18nInternal.__getInstance(current);
        if (vueI18n != null) {
          composer = vueI18n.__composer;
          if (useComponent && composer && !composer[InejctWithOption]) {
            composer = null;
          }
        }
      }
    }
    if (composer != null) {
      break;
    }
    if (root === current) {
      break;
    }
    current = current.parent;
  }
  return composer;
}
function setupLifeCycle(i18n2, target, composer) {
  {
    onMounted(() => {
    }, target);
    onUnmounted(() => {
      i18n2.__deleteInstance(target);
    }, target);
  }
}
function useI18nForLegacy(instance, scope, root, options = {}) {
  const isLocale = scope === "local";
  const _composer = shallowRef(null);
  if (isLocale && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) {
    throw createI18nError(I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  }
  const _inheritLocale = isBoolean(options.inheritLocale) ? options.inheritLocale : true;
  const _locale = ref(
    isLocale && _inheritLocale ? root.locale.value : isString(options.locale) ? options.locale : DEFAULT_LOCALE
  );
  const _fallbackLocale = ref(
    isLocale && _inheritLocale ? root.fallbackLocale.value : isString(options.fallbackLocale) || isArray(options.fallbackLocale) || isPlainObject(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value
  );
  const _messages = ref(getLocaleMessages(_locale.value, options));
  const _datetimeFormats = ref(isPlainObject(options.datetimeFormats) ? options.datetimeFormats : { [_locale.value]: {} });
  const _numberFormats = ref(isPlainObject(options.numberFormats) ? options.numberFormats : { [_locale.value]: {} });
  const _missingWarn = isLocale ? root.missingWarn : isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : true;
  const _fallbackWarn = isLocale ? root.fallbackWarn : isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : true;
  const _fallbackRoot = isLocale ? root.fallbackRoot : isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
  const _fallbackFormat = !!options.fallbackFormat;
  const _missing = isFunction(options.missing) ? options.missing : null;
  const _postTranslation = isFunction(options.postTranslation) ? options.postTranslation : null;
  const _warnHtmlMessage = isLocale ? root.warnHtmlMessage : isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
  const _escapeParameter = !!options.escapeParameter;
  const _modifiers = isLocale ? root.modifiers : isPlainObject(options.modifiers) ? options.modifiers : {};
  const _pluralRules = options.pluralRules || isLocale && root.pluralRules;
  function trackReactivityValues() {
    return [
      _locale.value,
      _fallbackLocale.value,
      _messages.value,
      _datetimeFormats.value,
      _numberFormats.value
    ];
  }
  const locale = computed({
    get: () => {
      return _composer.value ? _composer.value.locale.value : _locale.value;
    },
    set: (val) => {
      if (_composer.value) {
        _composer.value.locale.value = val;
      }
      _locale.value = val;
    }
  });
  const fallbackLocale = computed({
    get: () => {
      return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
    },
    set: (val) => {
      if (_composer.value) {
        _composer.value.fallbackLocale.value = val;
      }
      _fallbackLocale.value = val;
    }
  });
  const messages = computed(() => {
    if (_composer.value) {
      return _composer.value.messages.value;
    } else {
      return _messages.value;
    }
  });
  const datetimeFormats = computed(() => _datetimeFormats.value);
  const numberFormats = computed(() => _numberFormats.value);
  function getPostTranslationHandler() {
    return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
  }
  function setPostTranslationHandler(handler) {
    if (_composer.value) {
      _composer.value.setPostTranslationHandler(handler);
    }
  }
  function getMissingHandler() {
    return _composer.value ? _composer.value.getMissingHandler() : _missing;
  }
  function setMissingHandler(handler) {
    if (_composer.value) {
      _composer.value.setMissingHandler(handler);
    }
  }
  function warpWithDeps(fn) {
    trackReactivityValues();
    return fn();
  }
  function t2(...args) {
    return _composer.value ? warpWithDeps(() => Reflect.apply(_composer.value.t, null, [...args])) : warpWithDeps(() => "");
  }
  function rt(...args) {
    return _composer.value ? Reflect.apply(_composer.value.rt, null, [...args]) : "";
  }
  function d(...args) {
    return _composer.value ? warpWithDeps(() => Reflect.apply(_composer.value.d, null, [...args])) : warpWithDeps(() => "");
  }
  function n2(...args) {
    return _composer.value ? warpWithDeps(() => Reflect.apply(_composer.value.n, null, [...args])) : warpWithDeps(() => "");
  }
  function tm(key) {
    return _composer.value ? _composer.value.tm(key) : {};
  }
  function te(key, locale2) {
    return _composer.value ? _composer.value.te(key, locale2) : false;
  }
  function getLocaleMessage(locale2) {
    return _composer.value ? _composer.value.getLocaleMessage(locale2) : {};
  }
  function setLocaleMessage(locale2, message2) {
    if (_composer.value) {
      _composer.value.setLocaleMessage(locale2, message2);
      _messages.value[locale2] = message2;
    }
  }
  function mergeLocaleMessage(locale2, message2) {
    if (_composer.value) {
      _composer.value.mergeLocaleMessage(locale2, message2);
    }
  }
  function getDateTimeFormat(locale2) {
    return _composer.value ? _composer.value.getDateTimeFormat(locale2) : {};
  }
  function setDateTimeFormat(locale2, format) {
    if (_composer.value) {
      _composer.value.setDateTimeFormat(locale2, format);
      _datetimeFormats.value[locale2] = format;
    }
  }
  function mergeDateTimeFormat(locale2, format) {
    if (_composer.value) {
      _composer.value.mergeDateTimeFormat(locale2, format);
    }
  }
  function getNumberFormat(locale2) {
    return _composer.value ? _composer.value.getNumberFormat(locale2) : {};
  }
  function setNumberFormat(locale2, format) {
    if (_composer.value) {
      _composer.value.setNumberFormat(locale2, format);
      _numberFormats.value[locale2] = format;
    }
  }
  function mergeNumberFormat(locale2, format) {
    if (_composer.value) {
      _composer.value.mergeNumberFormat(locale2, format);
    }
  }
  const wrapper = {
    get id() {
      return _composer.value ? _composer.value.id : -1;
    },
    locale,
    fallbackLocale,
    messages,
    datetimeFormats,
    numberFormats,
    get inheritLocale() {
      return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
    },
    set inheritLocale(val) {
      if (_composer.value) {
        _composer.value.inheritLocale = val;
      }
    },
    get availableLocales() {
      return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
    },
    get modifiers() {
      return _composer.value ? _composer.value.modifiers : _modifiers;
    },
    get pluralRules() {
      return _composer.value ? _composer.value.pluralRules : _pluralRules;
    },
    get isGlobal() {
      return _composer.value ? _composer.value.isGlobal : false;
    },
    get missingWarn() {
      return _composer.value ? _composer.value.missingWarn : _missingWarn;
    },
    set missingWarn(val) {
      if (_composer.value) {
        _composer.value.missingWarn = val;
      }
    },
    get fallbackWarn() {
      return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
    },
    set fallbackWarn(val) {
      if (_composer.value) {
        _composer.value.missingWarn = val;
      }
    },
    get fallbackRoot() {
      return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
    },
    set fallbackRoot(val) {
      if (_composer.value) {
        _composer.value.fallbackRoot = val;
      }
    },
    get fallbackFormat() {
      return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
    },
    set fallbackFormat(val) {
      if (_composer.value) {
        _composer.value.fallbackFormat = val;
      }
    },
    get warnHtmlMessage() {
      return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
    },
    set warnHtmlMessage(val) {
      if (_composer.value) {
        _composer.value.warnHtmlMessage = val;
      }
    },
    get escapeParameter() {
      return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
    },
    set escapeParameter(val) {
      if (_composer.value) {
        _composer.value.escapeParameter = val;
      }
    },
    t: t2,
    getPostTranslationHandler,
    setPostTranslationHandler,
    getMissingHandler,
    setMissingHandler,
    rt,
    d,
    n: n2,
    tm,
    te,
    getLocaleMessage,
    setLocaleMessage,
    mergeLocaleMessage,
    getDateTimeFormat,
    setDateTimeFormat,
    mergeDateTimeFormat,
    getNumberFormat,
    setNumberFormat,
    mergeNumberFormat
  };
  function sync(composer) {
    composer.locale.value = _locale.value;
    composer.fallbackLocale.value = _fallbackLocale.value;
    Object.keys(_messages.value).forEach((locale2) => {
      composer.mergeLocaleMessage(locale2, _messages.value[locale2]);
    });
    Object.keys(_datetimeFormats.value).forEach((locale2) => {
      composer.mergeDateTimeFormat(locale2, _datetimeFormats.value[locale2]);
    });
    Object.keys(_numberFormats.value).forEach((locale2) => {
      composer.mergeNumberFormat(locale2, _numberFormats.value[locale2]);
    });
    composer.escapeParameter = _escapeParameter;
    composer.fallbackFormat = _fallbackFormat;
    composer.fallbackRoot = _fallbackRoot;
    composer.fallbackWarn = _fallbackWarn;
    composer.missingWarn = _missingWarn;
    composer.warnHtmlMessage = _warnHtmlMessage;
  }
  onBeforeMount(() => {
    if (instance.proxy == null || instance.proxy.$i18n == null) {
      throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    }
    const composer = _composer.value = instance.proxy.$i18n.__composer;
    if (scope === "global") {
      _locale.value = composer.locale.value;
      _fallbackLocale.value = composer.fallbackLocale.value;
      _messages.value = composer.messages.value;
      _datetimeFormats.value = composer.datetimeFormats.value;
      _numberFormats.value = composer.numberFormats.value;
    } else if (isLocale) {
      sync(composer);
    }
  });
  return wrapper;
}
const globalExportProps = [
  "locale",
  "fallbackLocale",
  "availableLocales"
];
const globalExportMethods = ["t", "rt", "d", "n", "tm"];
function injectGlobalFields(app, composer) {
  const i18n2 = /* @__PURE__ */ Object.create(null);
  globalExportProps.forEach((prop) => {
    const desc = Object.getOwnPropertyDescriptor(composer, prop);
    if (!desc) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    const wrap = isRef(desc.value) ? {
      get() {
        return desc.value.value;
      },
      set(val) {
        desc.value.value = val;
      }
    } : {
      get() {
        return desc.get && desc.get();
      }
    };
    Object.defineProperty(i18n2, prop, wrap);
  });
  app.config.globalProperties.$i18n = i18n2;
  globalExportMethods.forEach((method) => {
    const desc = Object.getOwnPropertyDescriptor(composer, method);
    if (!desc || !desc.value) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
  });
}
registerMessageCompiler(compileToFunction);
registerMessageResolver(resolveValue);
registerLocaleFallbacker(fallbackWithLocaleChain);
{
  initFeatureFlags();
}
if (__INTLIFY_PROD_DEVTOOLS__) {
  const target = getGlobalThis();
  target.__INTLIFY__ = true;
  setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
const required$2 = "Required";
const success$2 = "Success!";
const registration$2 = "registration";
const login$2 = "login";
const email$3 = "email";
const message$2 = "Message";
const phone$3 = "phone";
const name$2 = "Name";
const cancel$2 = "Cancel";
const save$2 = "Save";
const edit$2 = "Edit";
const skip$2 = "Skip";
const ok$2 = "OK";
var en = {
  "enter-schema-friendly_name": "Enter {0}...",
  "invalid-date": "Invalid date",
  required: required$2,
  "invalid-email": "Invalid email",
  "64-letters-max": "64 letters max",
  "no-decimals": "No decimals",
  "invalid-phone": "Invalid phone",
  "failed-to-add-this-device": "Failed to add this device.",
  "verify-your-identity": "Verify your identity",
  "something-went-wrong": "Something went wrong.",
  success: success$2,
  "login-with-device": "Login with Device",
  "redirect-now": "Redirect Now",
  "try-again": "Try again",
  "request-new-link": "Request New Link",
  "log-in-to-proceed": "Log in to proceed.",
  "verification-failed-please-try-again": "Verification failed. Please try again.",
  "device-failure": "Device failure",
  "magic-link-failure": "Magic link failure",
  "magic-link-success": "Magic link success",
  "device-success": "Device success",
  "add-your-claimed-app-like-this": "Add your claimed app like this:",
  "click-here": "click here",
  "email-address": "email address",
  "email-or-phone-number": "email or phone number",
  "phone-number": "phone number",
  "where-is-the-password-field": "Where is the password field?",
  "we-dont-recognize-this-device": "We don't recognize this device.",
  "weve-sent-messagetype": `We've sent {0} to <span class="content wrap-text"><b>{1}</b></span> with a one-time link. {2}`,
  "messagetype-sms": "an SMS",
  "messagetype-email": "an email",
  registration: registration$2,
  login: login$2,
  "change-isemail-email-phone": "Change {0}",
  "resend-isemail-email-message": "Resend {0}",
  email: email$3,
  message: message$2,
  phone: phone$3,
  "verify-identifier": "Verify {0}",
  "check-identifier": "Check {0}",
  "not-recognized": "{0} not recognized",
  "toggle-register": "Register at link below.",
  "account-no-longer-active": "This account is no longer active. Contact support.",
  "public-registration-not-allowed": "Public Registration is not Allowed",
  "account-already-exists": "An account with this {0} already exists.",
  "toggle-login": "Login with the link below.",
  "unexpected-error": "An unexpected error occurred.",
  "register-without-a-password": "Register without a password",
  "something-went-wrong-0": "Something went wrong",
  "change-isemail-email-phone-0": "Change {0}",
  "sms-text": "text",
  "register-with-device": "Register with Device",
  "enter-a-valid-email-or-phone-number": "Enter a valid email or phone number.",
  "enter-a-valid-phone-number": "Enter a valid phone number.",
  "enter-a-valid-email-address": "Enter a valid email address.",
  "enter-an-email-or-phone-number": "Enter an email or phone number.",
  "enter-an-email-address": "Enter an email address.",
  "enter-a-phone-number": "Enter a phone number.",
  "continue": "Continue",
  "change-isemail-email-phone-1": "Change {0}",
  "biometrics-scan-failed": "Biometrics scan failed",
  "login-here": "Login here.",
  "already-have-an-account": "Already have an account?",
  "register-here": "Register here.",
  "dont-have-an-account": "Don't have an account?",
  "invalid-app-id": "Invalid App ID",
  "revoke-device": "Revoke Device",
  "add-new-device": "Add New Device",
  "current-device": "Current Device",
  "edit-device": "Edit Device",
  "add-device": "Add Device",
  "my-devices": "My Devices",
  "there-are-no-devices-registered": "There are no devices registered.",
  "no-devices-found": "No devices found.",
  "added-time": "Added",
  name: name$2,
  "last-login": "Last Login",
  cancel: cancel$2,
  save: save$2,
  edit: edit$2,
  "device-name-is-required": "Device name is required.",
  "name-this-device": "Name This Device",
  "rename-device": "Rename Device",
  "give-this-device-a-name": "Give this device a name.",
  "rename-this-device": "Rename this device.",
  "new-device-name": "New device name",
  "email-is-required": "Email is required.",
  "email-address-already-in-use": "Email address already in use.",
  "not-applicable": "N/A",
  "metadata-section": "Metadata Section",
  "there-is-no-currently-logged-in-user": "There is no currently logged in user.",
  "no-user-found": "No user found.",
  "personal-info": "Personal Info",
  "phone-number-is-required": "Phone number is required.",
  "phone-number-already-in-use": "Phone number already in use.",
  "placeholder-phone-number": "(555) 555-5555",
  "are-you-sure-you-want-to-continue": "Are you sure you want to continue?",
  "login-info": "Login Info",
  "failed-to-rename-this-device": "Failed to rename this device.",
  "failed-to-revoke-this-device": "Failed to revoke this device.",
  "failed-to-update-metadata": "Failed to update metadata.",
  "failed-to-update-phone": "Failed to update phone.",
  "your-account-must-have-either-a-phone-or-an-email": "Your account must have either a phone or an email.",
  "failed-to-update-email": "Failed to update email.",
  "your-account-must-have-either-an-email-or-a-phone": "Your account must have either an email or a phone.",
  "welcome-back": "Welcome back",
  "login-title": "Login",
  "register-title": "Register",
  "unexpected-error-contact-support": "An unexpected error occurred. Please contact support.",
  "helper-footer-line-1": "{0} uses passwordless authentication to increase security for our users. Here\u2019s what you need to know:",
  "helper-footer-bullet-0": "Use your device\u2019s built-in authentication method (i.e. Apple Face ID or Windows Hello) to verify your identity.",
  "helper-footer-bullet-1": "Your personal information NEVER leaves your device to maintain privacy and improve security.",
  "helper-footer-bullet-2": "When these options aren\u2019t available on a device, a secure login link will be sent to your {0}.",
  "device-login-failed": "Device login failed. Please try again or login with a different method.",
  "device-name-maximum": "Device name can only be a maximum of 64 characters.",
  "device-registration-failed": "Device registration failed. Please try again or register with a different method.",
  "enable-this-device": "Enable this device to log in to your account.",
  "login-with-link": "Login with {0} link",
  "log-into-your-account-extended": "Log into your account with the method you already use to unlock your device. Accessing your account is just a look or touch away.",
  "log-into-your-account": "Log into your account with the method you already use to unlock your device.",
  "unable-to-create-test-app": "Passage was unable to create a temporary test app for you.",
  "confirm-remove-device": "Please confirm that you want to remove this device from your account.",
  "please-verify-identifier": "Please verify your {0} to complete your {1}.",
  "register-your-account": "Register your account with the method you already use to unlock your device.",
  "register-with-link": "Register with {0} link",
  "link-invalid": "The link is invalid or has expired.",
  "magic-link-invalid": "The magic link is invalid or has expired.",
  "remove-current-device-warning": "The selected device is your current device and you will need to re-enroll it to login again.",
  "does-not-give-app-personal-info": "This does not give the app access to your personal information. It only confirms that you are the owner of your device.",
  "verify-your-identity-with-device": "Verify your identity with your device to proceed.",
  "weve-sent-confirmation-text": "We've sent you a text message to confirm your new number. Click the link to confirm this change.",
  "weve-sent-confirmation-email": "We've sent you an email to confirm your new email address. Click the link to confirm this change.",
  "currently-using-test-app": "You are currently using a temporary test app generated for you by Passage. To claim this app",
  "successfully-changed-email": "You have successfully changed your email address. You will be redirected in a few seconds...",
  "successfully-logged-in-redirect": "You have successfully logged in. You will be redirected in a few seconds...",
  "you-will-be-automatically-signed-in": "You will be automatically signed in here once you click that link.",
  "helper-footer-line-2": "Simply enter your {0} to continue your login.",
  "welcome-back-sign-in-as": "Welcome back! Sign in as",
  "switch-account": "Switch account.",
  "save-device": "Save this device",
  "trust-device": "Trust this device? Log in even faster next time with the method you already use to unlock your device.",
  skip: skip$2,
  "device-name": "Device name",
  ok: ok$2,
  "verify-email-to-register": "Verify email to register",
  "verify-email-to-login": "Verify email to login",
  "verify-phone-to-register": "Verify phone to register",
  "verify-phone-to-login": "Verify phone to login",
  "check-email-to-register": "Check email to register",
  "check-email-to-login": "Check email to login",
  "check-phone-to-register": "Check phone to register",
  "check-phone-to-login": "Check phone to login",
  "login-with-link-error-message-email": "Unable to login with device. Please login with an email link or try again.",
  "login-with-link-error-message-phone": "Unable to login with device. Please login with a text link or try again.",
  "send-email-or-text-link": "Send {0} link",
  "invalid-link": "Invalid Link",
  "login-link-invalid": "The login link is invalid or has expired.",
  "registration-with-link-error-message-email": "We couldn\u2019t register you through your device. Please login with an email link or try again.",
  "registration-with-link-error-message-phone": "We couldn\u2019t register you through your device. Please login with a text link or try again.",
  "device-login-failed-title": "Device login failed"
};
const required$1 = "erforderlich";
const success$1 = "Anmeldung erfolgreich!";
const registration$1 = "Registrierung";
const login$1 = "Anmeldung";
const email$2 = "E-mail";
const message$1 = "Nachricht";
const phone$2 = "Telefon";
const name$1 = "Name";
const cancel$1 = "Abbrechen";
const save$1 = "Speichern";
const edit$1 = "Bearbeiten";
const skip$1 = "\xDCberspringen";
const ok$1 = "OK";
var de = {
  "enter-schema-friendly_name": "{0} eingeben...",
  "invalid-date": "Ung\xFCltiges Datum",
  required: required$1,
  "invalid-email": "Ung\xFCltige E-Mail-Adresse",
  "64-letters-max": "maximal 64 Zeichen",
  "no-decimals": "Nur ganze Zahlen",
  "invalid-phone": "Ung\xFCltige Telefonnummer",
  "failed-to-add-this-device": "Dieses Ger\xE4t konnte nicht hinzugef\xFCgt werden.",
  "verify-your-identity": "Best\xE4tigen Sie Ihre Identit\xE4t",
  "something-went-wrong": "Etwas ist schief gelaufen.",
  success: success$1,
  "login-with-device": "Melden Sie sich mit dem Ger\xE4t an",
  "redirect-now": "Jetzt weiterleiten",
  "try-again": "Erneut versuchen",
  "request-new-link": "Link erneut senden",
  "log-in-to-proceed": "Melden Sie sich an, um fortzufahren.",
  "verification-failed-please-try-again": "\xDCberpr\xFCfung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "device-failure": "Ger\xE4tefehler",
  "magic-link-failure": "Magic-Link Fehler",
  "magic-link-success": "Magic Link aktiviert",
  "device-success": "Ger\xE4t erfolgreich aktiviert",
  "add-your-claimed-app-like-this": "Add your claimed app like this:",
  "click-here": "Klicken Sie hier",
  "email-address": "E-Mail Addresse",
  "email-or-phone-number": "E-Mail oder Telefonnummer",
  "phone-number": "Telefonnummer",
  "where-is-the-password-field": "Wo ist das Passwortfeld?",
  "we-dont-recognize-this-device": "Wir erkennen dieses Ger\xE4t nicht.",
  "weve-sent-messagetype": 'Wir haben {0} an <span class="content wrap-text"><b>{1}</b></span> mit einem einmal-Link. {2}',
  "messagetype-sms": "eine SMS",
  "messagetype-email": "eine E-Mail",
  registration: registration$1,
  login: login$1,
  "change-isemail-email-phone": "{0} \xE4ndern",
  "resend-isemail-email-message": "{0} erneut senden",
  email: email$2,
  message: message$1,
  phone: phone$2,
  "verify-identifier": "Verifica {0}",
  "check-identifier": "\xDCberpr\xFCfen Sie {0}",
  "not-recognized": "{0} nicht erkannt",
  "toggle-register": "Registrieren Sie sich unter dem nachstehenden Link.",
  "account-no-longer-active": "Dieses Konto ist deaktiviert. Bitte Kontaktieren Sie den Support.",
  "public-registration-not-allowed": "Eine \xF6ffentliche Registrierung ist nicht zul\xE4ssig",
  "account-already-exists": "Ein Konto mit dieser {0} existiert bereits.",
  "toggle-login": "Melden Sie sich mit dem unten stehenden Link an.",
  "unexpected-error": "Ein unerwarteter Fehler ist aufgetreten.",
  "register-without-a-password": "Registrieren Sie sich ohne Passwort",
  "something-went-wrong-0": "Etwas ist schief gelaufen",
  "change-isemail-email-phone-0": "{0} \xE4ndern",
  "sms-text": "text",
  "register-with-device": "Mit meinem Ger\xE4t registrieren",
  "enter-a-valid-email-or-phone-number": "Geben Sie eine g\xFCltige E-Mail-Adresse oder Telefonnummer ein.",
  "enter-a-valid-phone-number": "Geben Sie eine g\xFCltige Telefonnummer ein.",
  "enter-a-valid-email-address": "Geben sie eine g\xFCltige E-Mail-Adresse an.",
  "enter-an-email-or-phone-number": "Geben Sie eine E-Mail oder Telefonnummer ein.",
  "enter-an-email-address": "Geben Sie eine E-mail Adresse ein.",
  "enter-a-phone-number": "Geben Sie eine Telefonnummer ein.",
  "continue": "Weiter",
  "change-isemail-email-phone-1": "{0} \xE4ndern",
  "biometrics-scan-failed": "Biometrie-Scan fehlgeschlagen",
  "login-here": "Hier anmelden.",
  "already-have-an-account": "Sie haben bereits ein Konto?",
  "register-here": "Hier registrieren.",
  "dont-have-an-account": "Sie haben kein Konto?",
  "invalid-app-id": "Ung\xFCltige App-ID",
  "revoke-device": "Ger\xE4t entfernen",
  "add-new-device": "Neues Ger\xE4t hinzuf\xFCgen",
  "current-device": "Aktuelles Ger\xE4t",
  "edit-device": "Ger\xE4t bearbeiten",
  "add-device": "Ger\xE4t hinzuf\xFCgen",
  "my-devices": "Meine Ger\xE4te",
  "there-are-no-devices-registered": "Es sind keine Ger\xE4te registriert.",
  "no-devices-found": "Keine Ger\xE4te gefunden.",
  "added-time": "Hinzugef\xFCgt",
  name: name$1,
  "last-login": "Letzte Anmeldung",
  cancel: cancel$1,
  save: save$1,
  edit: edit$1,
  "device-name-is-required": "Ger\xE4tename ist erforderlich.",
  "name-this-device": "Benennen Sie dieses Ger\xE4t",
  "rename-device": "Ger\xE4t umbenennen",
  "give-this-device-a-name": "Geben Sie diesem Ger\xE4t einen Namen.",
  "rename-this-device": "Benennen Sie dieses Ger\xE4t um.",
  "new-device-name": "Neuer Ger\xE4tename",
  "email-is-required": "E-Mail ist erforderlich.",
  "email-address-already-in-use": "E-Mail-Adresse wird bereits verwendet.",
  "not-applicable": "N/A",
  "metadata-section": "Metadaten-Abschnitt",
  "there-is-no-currently-logged-in-user": "Derzeit ist kein Benutzer angemeldet.",
  "no-user-found": "Kein Benutzer gefunden.",
  "personal-info": "Pers\xF6nliche Informationen",
  "phone-number-is-required": "Telefonnummer ist erforderlich.",
  "phone-number-already-in-use": "Telefonnummer bereits verwendet.",
  "placeholder-phone-number": "+43 555 5555555",
  "are-you-sure-you-want-to-continue": "Bist du dir sicher, dass du weitermachen willst?",
  "login-info": "Anmeldeinformationen",
  "failed-to-rename-this-device": "Fehler beim Umbenennen dieses Ger\xE4ts.",
  "failed-to-revoke-this-device": "Dieses Ger\xE4t konnte nicht widerrufen werden.",
  "failed-to-update-metadata": "Metadaten konnten nicht aktualisiert werden.",
  "failed-to-update-phone": "Telefon konnte nicht aktualisiert werden.",
  "your-account-must-have-either-a-phone-or-an-email": "Ihr Konto muss entweder ein Telefon oder eine E-Mail haben.",
  "failed-to-update-email": "E-Mail konnte nicht aktualisiert werden.",
  "your-account-must-have-either-an-email-or-a-phone": "Ihr Konto muss entweder eine E-Mail oder ein Telefon haben.",
  "welcome-back": "Willkommen zur\xFCck",
  "login-title": "Anmeldung",
  "register-title": "Registrieren",
  "unexpected-error-contact-support": "Ein unerwarteter Fehler ist aufgetreten.",
  "helper-footer-line-1": "{0} verwendet eine passwortlose Authentifizierung, um die Sicherheit f\xFCr unsere Nutzer zu erh\xF6hen. Folgendes m\xFCssen Sie wissen:",
  "helper-footer-bullet-0": "Verwenden Sie die integrierte Authentifizierungsmethode Ihres Ger\xE4ts (z. B. Apple Face ID oder Windows Hello), um Ihre Identit\xE4t zu best\xE4tigen.",
  "helper-footer-bullet-1": "Ihre pers\xF6nlichen Daten verlassen NIE Ihr Ger\xE4t, um die Privatsph\xE4re zu wahren und die Sicherheit zu verbessern.",
  "helper-footer-bullet-2": "Wenn diese Optionen auf einem Ger\xE4t nicht verf\xFCgbar sind, wird ein sicherer Anmeldelink an Ihre {0} gesendet.",
  "device-login-failed": "Ger\xE4teanmeldung fehlgeschlagen. Bitte versuchen Sie es erneut oder melden Sie sich mit einer anderen Methode an.",
  "device-name-maximum": "Der Ger\xE4tename darf maximal 64 Zeichen lang sein.",
  "device-registration-failed": "Ger\xE4teregistrierung fehlgeschlagen. Bitte versuchen Sie es erneut oder registrieren Sie sich mit einer anderen Methode.",
  "enable-this-device": "Aktivieren Sie dieses Ger\xE4t, um sich bei Ihrem Konto anzumelden.",
  "login-with-link": "Melden Sie sich mit dem {0}-Link an",
  "log-into-your-account-extended": "Melden Sie sich mit der Methode, die Sie bereits zum Entsperren Ihres Ger\xE4ts verwenden, bei Ihrem Konto an. Der Zugriff auf Ihr Konto ist nur einen Blick oder eine Ber\xFChrung entfernt.",
  "log-into-your-account": "Melden Sie sich mit der Methode, die Sie bereits zum Entsperren Ihres Ger\xE4ts verwenden, bei Ihrem Konto an.",
  "unable-to-create-test-app": "Passage konnte keine tempor\xE4re Test-App f\xFCr Sie erstellen.",
  "confirm-remove-device": "Bitte best\xE4tigen Sie, dass Sie dieses Ger\xE4t aus Ihrem Konto entfernen m\xF6chten.",
  "please-verify-identifier": "Bitte best\xE4tigen Sie Ihre {0}, um Ihre {1} abzuschlie\xDFen.",
  "register-your-account": "Registrieren Sie Ihr Konto mit der Methode, die Sie bereits zum Entsperren Ihres Ger\xE4ts verwenden.",
  "register-with-link": "Registrieren Sie sich mit dem {0}-Link",
  "link-invalid": "Der Link ist ung\xFCltig oder abgelaufen.",
  "magic-link-invalid": "Der Link ist ung\xFCltig oder abgelaufen.",
  "remove-current-device-warning": "Das ausgew\xE4hlte Ger\xE4t ist Ihr aktuelles Ger\xE4t und Sie m\xFCssen es erneut registrieren, um sich erneut anzumelden.",
  "does-not-give-app-personal-info": "Dadurch erh\xE4lt die App keinen Zugriff auf Ihre pers\xF6nlichen Daten. Es best\xE4tigt nur, dass Sie der Eigent\xFCmer Ihres Ger\xE4ts sind.",
  "verify-your-identity-with-device": "Best\xE4tigen Sie Ihre Identit\xE4t mit Ihrem Ger\xE4t, um fortzufahren.",
  "weve-sent-confirmation-text": "Wir haben Ihnen eine SMS gesendet, um Ihre neue Nummer zu best\xE4tigen. Klicken Sie auf den Link, um diese \xC4nderung zu best\xE4tigen.",
  "weve-sent-confirmation-email": "Wir haben Ihnen eine E-Mail gesendet, um Ihre neue E-Mail-Adresse zu best\xE4tigen. Klicken Sie auf den Link, um diese \xC4nderung zu best\xE4tigen.",
  "currently-using-test-app": "Sie verwenden derzeit eine von Passage f\xFCr Sie generierte tempor\xE4re Test-App. Um diese App zu verwenden",
  "successfully-changed-email": "Sie haben ihre E-Mail Adresse erfolgreich ge\xE4ndert. Sie werden in wenigen Sekunden weitergeleitet...",
  "successfully-logged-in-redirect": "Sie haben sich erfolgreich angemeldet. Sie werden in wenigen Sekunden weitergeleitet...",
  "you-will-be-automatically-signed-in": "Sie werden automatisch hier angemeldet, sobald Sie auf diesen Link klicken.",
  "helper-footer-line-2": "Geben Sie einfach Ihre {0} ein, um mit der Anmeldung fortzufahren.",
  "welcome-back-sign-in-as": "Willkommen zur\xFCck! Einloggen als",
  "switch-account": "Account wechseln",
  "save-device": "Dieses Ger\xE4t speichern",
  "trust-device": "Vertrauen Sie diesem Ger\xE4t? Melden Sie sich beim n\xE4chsten Mal noch schneller mit der Methode an, die Sie bereits zum Entsperren Ihres Ger\xE4ts verwenden.",
  skip: skip$1,
  "device-name": "Ger\xE4tename",
  ok: ok$1,
  "verify-email-to-register": "E-Mail f\xFCr die Registrierung best\xE4tigen",
  "verify-email-to-login": "E-Mail zum Anmelden best\xE4tigen",
  "verify-phone-to-register": "Ger\xE4t f\xFCr die Registrierung best\xE4tigen",
  "verify-phone-to-login": "Ger\xE4t zur Anmeldung best\xE4tigen",
  "check-email-to-register": "E-Mail f\xFCr die Registrierung pr\xFCfen",
  "check-email-to-login": "E-Mail zur Anmeldung pr\xFCfen",
  "check-phone-to-register": "Telefon f\xFCr die Registrierung pr\xFCfen",
  "check-phone-to-login": "Telefon zum Anmelden pr\xFCfen",
  "login-with-link-error-message-email": "Sie k\xF6nnen sich nicht mit Ihrem Ger\xE4t anmelden. Bitte melden Sie sich mit einem email-Link an oder versuchen Sie es erneut",
  "login-with-link-error-message-phone": "Sie k\xF6nnen sich nicht mit Ihrem Ger\xE4t anmelden. Bitte melden Sie sich mit einem text-Link an oder versuchen Sie es erneut",
  "send-email-or-text-link": "{0}-Link senden",
  "invalid-link": "Ung\xFCltiger Link",
  "login-link-invalid": "Der Link ist ung\xFCltig oder abgelaufen.",
  "registration-with-link-error-message-email": "Kann nicht am Ger\xE4t registriert werden. Bitte melden Sie sich mit einem email-Link an oder versuchen Sie es erneut.",
  "registration-with-link-error-message-phone": "Kann nicht am Ger\xE4t registriert werden. Bitte melden Sie sich mit einem text-Link an oder versuchen Sie es erneut.",
  "device-login-failed-title": "Ger\xE4teanmeldung fehlgeschlagen"
};
const required = "richiesto";
const success = "Successo!";
const registration = "iscrizione";
const login = "Accedi";
const email$1 = "E-mail";
const message = "Messagio";
const phone$1 = "Telefono";
const name = "Nome";
const cancel = "Annulla";
const save = "Salva";
const edit = "modificare";
const skip = "Saltare";
const ok = "OK";
var it = {
  "enter-schema-friendly_name": "Inserisci {0}...",
  "invalid-date": "Data non valida",
  required,
  "invalid-email": "E-mail non valido",
  "64-letters-max": "massimo 64 caratteri",
  "no-decimals": "Senza decimali",
  "invalid-phone": "Telefono non valido",
  "failed-to-add-this-device": "Impossibile aggiungere questo dispositivo.",
  "verify-your-identity": "Verifica la tua identit\xE0",
  "something-went-wrong": "Qualcosa non ha funzionato.",
  success,
  "login-with-device": "Accedi con il dispositivo",
  "redirect-now": "Avanti ora",
  "try-again": "Riprova",
  "request-new-link": "Invia nuovamente il link",
  "log-in-to-proceed": "Accedi per procedere.",
  "verification-failed-please-try-again": "Verifica non riuscita. Per favore riprova.",
  "device-failure": "Errore del dispositivo",
  "magic-link-failure": "Guasto del link magico",
  "magic-link-success": "Magic Link attivato",
  "device-success": "Dispositivo attivato correttamente",
  "add-your-claimed-app-like-this": "Add your claimed app like this:",
  "click-here": "fare clic qui",
  "email-address": "Indirizzo e-mail",
  "email-or-phone-number": "e-mail o numero di telefono",
  "phone-number": "numero di telefono",
  "where-is-the-password-field": "Dov'\xE8 il campo della password?",
  "we-dont-recognize-this-device": "Non riconosciamo questo dispositivo.",
  "weve-sent-messagetype": 'Abbiamo inviato {0} a <span class="content wrap-text"><b>{1}</b></span> con un link una tantum. {2}',
  "messagetype-sms": "un SMS",
  "messagetype-email": "un'email",
  registration,
  login,
  "change-isemail-email-phone": "Cambia {0}",
  "resend-isemail-email-message": "Invia nuovamente {0}",
  email: email$1,
  message,
  phone: phone$1,
  "verify-identifier": "Best\xE4tigen Sie {0}",
  "check-identifier": "Controlla {0}",
  "not-recognized": "{0} non riconosciuto",
  "toggle-register": "Registrati usando il link qui sotto.",
  "account-no-longer-active": "Questo account \xE8 disabilitato. Si prega di contattare l'assistenza.",
  "public-registration-not-allowed": "Non \xE8 consentita la registrazione pubblica",
  "account-already-exists": "Esiste gi\xE0 un account con questa {0}.",
  "toggle-login": "Accedi con il link sottostante.",
  "unexpected-error": "Si \xE8 verificato un errore imprevisto.",
  "register-without-a-password": "Registrati senza password",
  "something-went-wrong-0": "Qualcosa \xE8 andato storto",
  "change-isemail-email-phone-0": "Cambia {0}",
  "sms-text": "text",
  "register-with-device": "Registrati con il dispositivo",
  "enter-a-valid-email-or-phone-number": "Inserire un'e-mail o un numero di telefono valido.",
  "enter-a-valid-phone-number": "Inserire un numero di telefono valido.",
  "enter-a-valid-email-address": "Inserire un indirizzo email valido.",
  "enter-an-email-or-phone-number": "Inserire un'e-mail o un numero di telefono.",
  "enter-an-email-address": "Inserire un indirizzo email.",
  "enter-a-phone-number": "Inserire un numero telefonico.",
  "continue": "Continua",
  "change-isemail-email-phone-1": "Cambia {0}",
  "biometrics-scan-failed": "Scansione biometrica non riuscita",
  "login-here": "Accedi qui.",
  "already-have-an-account": "Hai gi\xE0 un account?",
  "register-here": "Registrati qui.",
  "dont-have-an-account": "Non hai un account?",
  "invalid-app-id": "ID app non valido",
  "revoke-device": "Revoca dispositivo",
  "add-new-device": "Aggiungi nuovo dispositivo",
  "current-device": "Dispositivo attuale",
  "edit-device": "Modifica dispositivo",
  "add-device": "Aggiungi dispositivo",
  "my-devices": "I miei dispositivi",
  "there-are-no-devices-registered": "Non ci sono dispositivi registrati.",
  "no-devices-found": "Nessun dispositivo trovato.",
  "added-time": "Aggiunto",
  name,
  "last-login": "Ultimo accesso",
  cancel,
  save,
  edit,
  "device-name-is-required": "Il nome del dispositivo \xE8 obbligatorio.",
  "name-this-device": "Assegna un nome a questo dispositivo",
  "rename-device": "Rinomina dispositivo",
  "give-this-device-a-name": "Assegna un nome a questo dispositivo.",
  "rename-this-device": "Rinomina questo dispositivo.",
  "new-device-name": "Nuovo nome dispositivo",
  "email-is-required": "L'e-mail \xE8 richiesta.",
  "email-address-already-in-use": "Indirizzo email gi\xE0 in uso.",
  "not-applicable": "N/A",
  "metadata-section": "Sezione Metadati",
  "there-is-no-currently-logged-in-user": "Non c'\xE8 nessun utente attualmente connesso.",
  "no-user-found": "Nessun utente trovato.",
  "personal-info": "Informazioni personali",
  "phone-number-is-required": "Il numero di telefono \xE8 richiesto.",
  "phone-number-already-in-use": "Numero di telefono gi\xE0 in uso.",
  "placeholder-phone-number": "+39 555 5555555",
  "are-you-sure-you-want-to-continue": "Sei sicuro di voler continuare?",
  "login-info": "Informazioni di accesso",
  "failed-to-rename-this-device": "Impossibile rinominare questo dispositivo.",
  "failed-to-revoke-this-device": "Impossibile revocare questo dispositivo.",
  "failed-to-update-metadata": "Impossibile aggiornare i metadati.",
  "failed-to-update-phone": "Impossibile aggiornare il telefono.",
  "your-account-must-have-either-a-phone-or-an-email": "Il tuo account deve avere un telefono o un'e-mail.",
  "failed-to-update-email": "Impossibile aggiornare l'e-mail.",
  "your-account-must-have-either-an-email-or-a-phone": "Il tuo account deve avere un'e-mail o un telefono.",
  "welcome-back": "Ben tornato",
  "login-title": "Accedi",
  "register-title": "Registrati",
  "unexpected-error-contact-support": "Si \xE8 verificato un errore imprevisto.",
  "helper-footer-line-1": "{0} utilizza l'autenticazione senza password per aumentare la sicurezza per i nostri utenti. Ecco cosa devi sapere:",
  "helper-footer-bullet-0": "Utilizza il metodo di autenticazione integrato del tuo dispositivo (ad esempio Apple Face ID o Windows Hello) per verificare la tua identit\xE0.",
  "helper-footer-bullet-1": "Le tue informazioni personali non lasciano MAI il tuo dispositivo per mantenere la privacy e migliorare la sicurezza.",
  "helper-footer-bullet-2": "Se queste opzioni non sono disponibili su un dispositivo, verr\xE0 inviato un collegamento di registrazione sicuro al tuo {0}.",
  "device-login-failed": "Accesso al dispositivo non riuscito. Riprova o accedi con un metodo diverso.",
  "device-name-maximum": "Il nome del dispositivo pu\xF2 contenere solo un massimo di 64 caratteri.",
  "device-registration-failed": "Registrazione del dispositivo non riuscita. Riprova o registrati con un metodo diverso.",
  "enable-this-device": "Abilita questo dispositivo per accedere al tuo account.",
  "login-with-link": "Accedi con il link {0}",
  "log-into-your-account-extended": "Accedi al tuo account con il metodo che gi\xE0 utilizzi per sbloccare il tuo dispositivo. L'accesso al tuo account \xE8 solo uno sguardo o un tocco.",
  "log-into-your-account": "Accedi al tuo account con il metodo che gi\xE0 utilizzi per sbloccare il tuo dispositivo.",
  "unable-to-create-test-app": "Passage non \xE8 stato in grado di creare un'app di prova temporanea per te.",
  "confirm-remove-device": "Conferma di voler rimuovere questo dispositivo dal tuo account.",
  "please-verify-identifier": "Verifica il tuo {0} per completare il tuo {1}.",
  "register-your-account": "Registra il tuo account con il metodo che gi\xE0 utilizzi per sbloccare il tuo dispositivo.",
  "register-with-link": "Registrati con il link {0}",
  "link-invalid": "Il link non \xE8 valido oppure \xE8 scaduto.",
  "magic-link-invalid": "Il link magico non \xE8 valido oppure \xE8 scaduto.",
  "remove-current-device-warning": "Il dispositivo selezionato \xE8 il tuo attuale dispositivo e dovrai registrarlo nuovamente per accedere nuovamente.",
  "does-not-give-app-personal-info": "Ci\xF2 non consente all'app di accedere alle tue informazioni personali. Conferma solo che sei il proprietario del tuo dispositivo.",
  "verify-your-identity-with-device": "Verifica la tua identit\xE0 con il tuo dispositivo per procedere.",
  "weve-sent-confirmation-text": "Ti abbiamo inviato un SMS per confermare il tuo nuovo numero. Fare clic sul collegamento per confermare questa modifica.",
  "weve-sent-confirmation-email": "Ti abbiamo inviato un'e-mail per confermare il tuo nuovo indirizzo e-mail. Fare clic sul collegamento per confermare questa modifica.",
  "currently-using-test-app": "Stai attualmente utilizzando un'app di prova temporanea generata per te da Passage. Per usare questa app",
  "successfully-changed-email": "Hai modificato con successo il tuo indirizzo email. Verrai reindirizzato in pochi secondi...",
  "successfully-logged-in-redirect": "Hai effettuato l'accesso con successo. Verrai reindirizzato in pochi secondi...",
  "you-will-be-automatically-signed-in": "Verrai automaticamente registrato qui dopo aver fatto clic su quel link.",
  "helper-footer-line-2": "Inserisci semplicemente il tuo {0} per continuare il tuo accesso.",
  "welcome-back-sign-in-as": "Bentornati! Accedi come",
  "switch-account": "Cambiare account.",
  "save-device": "Salva questo dispositivo",
  "trust-device": "Vi fidate di questo dispositivo? La prossima volta accedete ancora pi\xF9 velocemente con il metodo che gi\xE0 utilizzate per sbloccare il dispositivo.",
  skip,
  "device-name": "Nome dispositivo",
  ok,
  "verify-email-to-register": "Verificare l'e-mail per registrarsi",
  "verify-email-to-login": "Verifica dell'e-mail per l'accesso",
  "verify-phone-to-register": "Verificare il telefono per la registrazione",
  "verify-phone-to-login": "Verifica del telefono per l'accesso",
  "check-email-to-register": "Controllare l'e-mail per registrarsi",
  "check-email-to-login": "Controllare l'e-mail per effettuare il login",
  "check-phone-to-register": "Controllare il telefono per registrarsi",
  "check-phone-to-login": "Controllare il telefono per accedere",
  "login-with-link-error-message-email": "Impossibile effettuare il login con il dispositivo. Effettuare il login con un link email o riprovare",
  "login-with-link-error-message-phone": "Impossibile effettuare il login con il dispositivo. Effettuare il login con un link text o riprovare",
  "send-email-or-text-link": "Invia link {0}",
  "invalid-link": "Link non valido",
  "login-link-invalid": "Il link magico non \xE8 valido oppure \xE8 scaduto.",
  "registration-with-link-error-message-email": "Impossibile registrare il dispositivo. Effettuare il login con un link email o riprovare",
  "registration-with-link-error-message-phone": "Impossibile registrare il dispositivo. Effettuare il login con un link text o riprovare",
  "device-login-failed-title": "Accesso al dispositivo non riuscito"
};
const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en,
    de,
    it
  }
});
function setLocale(locale) {
  if (locale === void 0 || locale === null) {
    i18n.global.locale.value = navigator.language;
    return;
  }
  i18n.global.locale.value = locale;
}
function useLocale() {
  return i18n.global;
}
function useAddDevice() {
  const addPending = ref(false);
  const errorMessage = ref("");
  function addDevice() {
    return __async(this, null, function* () {
      errorMessage.value = "";
      addPending.value = true;
      try {
        const passageUser = new q("").getCurrentUser();
        return yield passageUser.addDevice();
      } catch (e2) {
        errorMessage.value = useLocale().t("failed-to-add-this-device");
        return void 0;
      } finally {
        addPending.value = false;
      }
    });
  }
  return {
    addDevice,
    addPending,
    errorMessage
  };
}
var appleBiometric = "data:image/svg+xml;base64,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";
var windowsHello = "data:image/svg+xml;base64,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";
var genericBiometrics = "data:image/svg+xml;base64,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";
var emailFailed = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA2MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyLjI5OTMgMzcuNjI3OEg2LjY0NDZWMTAuNzUwOEwyOS4yMjMgMjQuMTg5M0w1MS44MDE0IDEwLjc1MDhWMjQuNDMxMkM1My44MzM0IDI0Ljc1MzcgNTUuNzI0NCAyNS40MjU3IDU3LjQ0NiAyNi4zNjY0VjUuMzc1NEM1Ny40NDYgMi40MTg5MyA1NC45MDU5IDAgNTEuODAxNCAwSDYuNjQ0NkMzLjU0MDA3IDAgMSAyLjQxODkzIDEgNS4zNzU0VjM3LjYyNzhDMSA0MC41ODQzIDMuNTQwMDcgNDMuMDAzMiA2LjY0NDYgNDMuMDAzMkgzMi4yOTkzQzMyLjE1ODIgNDIuMTE2MyAzMi4wNDUzIDQxLjIyOTQgMzIuMDQ1MyA0MC4zMTU1QzMyLjA0NTMgMzkuNDAxNyAzMi4xNTgyIDM4LjUxNDggMzIuMjk5MyAzNy42Mjc4Wk01MS44MDE0IDUuMzc1NEwyOS4yMjMgMTguODEzOUw2LjY0NDYgNS4zNzU0SDUxLjgwMTRaTTUyLjk1ODUgNDAuMzE1NUw1OC45NyA0Ni4wMTM1TDU0Ljk2MjMgNDkuODNMNDguOTc5MSA0NC4xMDUyTDQyLjk5NTggNDkuODNMMzkuMDE2NCA0Ni4wMTM1TDQ0Ljk5OTYgNDAuMzE1NUwzOS4wMTY0IDM0LjYxNzZMNDIuOTk1OCAzMC44Mjc5TDQ4Ljk3OTEgMzYuNTI1OUw1NC45NjIzIDMwLjgyNzlMNTguOTcgMzQuNjE3Nkw1Mi45NTg1IDQwLjMxNTVaIiBmaWxsPSIjRkYwMDAwIi8+Cjwvc3ZnPgo=";
var emailSuccess = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA2MCA1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzUzMF8xNDQzKSI+CjxwYXRoIGQ9Ik01MS43MTkxIDQuMDY3NzVINy41NTQ0NkM0LjUxODE0IDQuMDY3NzUgMi4wNjE0OCA2LjU1OTI3IDIuMDYxNDggOS42MDQ0N0wyLjAzMzg3IDQyLjgyNDhDMi4wMzM4NyA0NS44NyA0LjUxODE0IDQ4LjM2MTUgNy41NTQ0NiA0OC4zNjE1SDI5LjYzNjhWNDIuODI0OEg3LjU1NDQ2VjE1LjE0MTJMMjkuNjM2OCAyOC45ODNMNTEuNzE5MSAxNS4xNDEyVjI4Ljk4M0g1Ny4yMzk3VjkuNjA0NDdDNTcuMjM5NyA2LjU1OTI3IDU0Ljc1NTQgNC4wNjc3NSA1MS43MTkxIDQuMDY3NzVaTTI5LjYzNjggMjMuNDQ2M0w3LjU1NDQ2IDkuNjA0NDdINTEuNzE5MUwyOS42MzY4IDIzLjQ0NjNaTTQ0LjM3NjcgNTMuODk4M0wzNC42MDUzIDQ0LjA5ODNMMzguNDk3MyA0MC4xOTQ5TDQ0LjM0OTEgNDYuMDYzOEw1Ni4wNTI4IDM0LjMyNTlMNjAgMzguMjI5M0w0NC4zNzY3IDUzLjg5ODNaIiBmaWxsPSIjMDRENzhCIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNTMwXzE0NDMiPgo8cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNTMuODk4MyIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
var email = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCA0NCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5Ljg0MjUgMTAuNjc0NEwyMy4wNDMyIDIuMjQ3NzNDMjIuNzE4MSAyLjA4NDc2IDIyLjM2MDUgMiAyMS45OTgxIDJDMjEuNjM1NiAyIDIxLjI3OCAyLjA4NDc2IDIwLjk1MyAyLjI0NzczTDQuMTUzNjQgMTAuNjc0NEMzLjUwOTYxIDEwLjk5NTEgMi45NjY2NCAxMS40OTI1IDIuNTg2MDggMTIuMTEwMkMyLjIwNTUxIDEyLjcyOCAyLjAwMjUxIDEzLjQ0MTcgMiAxNC4xNzA2VjMyLjIwOTJDMiAzNC4zNjc2IDMuNzQ0MDYgMzYuMTE3NiA1Ljg5NTc4IDM2LjExNzZIMzguMTA0MkM0MC4yNTU5IDM2LjExNzYgNDIgMzQuMzY3NiA0MiAzMi4yMDkyVjE0LjE3MDZDNDEuOTk3MSAxMy40NDEzIDQxLjc5MzYgMTIuNzI3MyA0MS40MTIzIDEyLjEwOTVDNDEuMDMxIDExLjQ5MTcgNDAuNDg3MyAxMC45OTQ2IDM5Ljg0MjUgMTAuNjc0NFYxMC42NzQ0WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zNC45NDEgMzAuMjM1NEwyMi43OTY1IDIwLjE1NDFDMjIuNDAwNyAxOS44MjU2IDIxLjkxMzUgMTkuNjQ3MiAyMS40MTIxIDE5LjY0NzJDMjAuOTEwNiAxOS42NDcyIDIwLjQyMzUgMTkuODI1NiAyMC4wMjc3IDIwLjE1NDFMNy44ODIyIDMwLjIzNTQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjYuNzA1NyAyMy4xNzY2TDM5LjY0NjkgMTIuNTg4MyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zLjE3NjM5IDEyLjU4ODNMMTYuMTE3NiAyMy4xNzY2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
var fingerprintFailed = "data:image/svg+xml;base64,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";
var fingerprintSuccess = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNzgiIHZpZXdCb3g9IjAgMCA0NCA3OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNjE1MTUgMTguNjE1MkMxLjMyOTczIDE4LjYxNzQgMS4wNDg3MSAxOC41NTQ0IDAuODAwNjIzIDE4LjQzMjZDMC42MTg2NTggMTguMzQ0MyAwLjQ1ODkxOSAxOC4yMjU2IDAuMzMwNzUyIDE4LjA4MzRDMC4yMDI1ODYgMTcuOTQxMiAwLjEwODU2NSAxNy43NzgzIDAuMDU0MTkyIDE3LjYwNDRDLTAuMDAwMTgxMDAyIDE3LjQzMDUgLTAuMDEzODE0NiAxNy4yNDg5IDAuMDE0MDg5MSAxNy4wNzA0QzAuMDQxOTkyOCAxNi44OTE4IDAuMTEwODc0IDE2LjcxOTkgMC4yMTY3MDEgMTYuNTY0NkMyLjI1NjIgMTMuNjI2NyA4LjQ2MTQzIDYuNzY5MjkgMjIuMDAxNyA2Ljc2OTI5QzI3Ljg2OTUgNi43NjkyOSAzMy4wMTU4IDguMDk5NDkgMzcuMjkwNSAxMC43MjE2QzQwLjgwODggMTIuODczNCA0Mi43ODA2IDE1LjMwOTMgNDMuNzIgMTYuNDgyNEM0My44MzkxIDE2LjYzMDMgNDMuOTIyOCAxNi43OTczIDQzLjk2NiAxNi45NzM1QzQ0LjAwOTMgMTcuMTQ5NyA0NC4wMTEyIDE3LjMzMTYgNDMuOTcxOCAxNy41MDg0QzQzLjkzMjQgMTcuNjg1MyA0My44NTI0IDE3Ljg1MzYgNDMuNzM2NCAxOC4wMDMzQzQzLjYyMDUgMTguMTUzMSA0My40NzExIDE4LjI4MTQgNDMuMjk2OSAxOC4zODA1QzQyLjk0MDggMTguNTgzNyA0Mi41MDcxIDE4LjY1OTEgNDIuMDg3NyAxOC41OTFDNDEuNjY4MiAxOC41MjI4IDQxLjI5NjEgMTguMzE2MyA0MS4wNSAxOC4wMTUzQzM5LjM1MDEgMTUuOTA1NCAzNC4xNjY3IDkuNDg1MzkgMjIuMDAxNyA5LjQ4NTM5QzEwLjEyNzUgOS40ODUzOSA0Ljc1OTAzIDE1LjM5MzMgMy4wMTA0MyAxNy45MjY4QzIuODY5OTMgMTguMTM4MyAyLjY2NjUzIDE4LjMxMzcgMi40MjEyNCAxOC40MzQ3QzIuMTc1OTUgMTguNTU1NyAxLjg5NzY3IDE4LjYxOCAxLjYxNTE1IDE4LjYxNTJaIiBmaWxsPSIjMDRENzhCIi8+CjxwYXRoIGQ9Ik0yOC42NDU4IDUwLjc2OUMyOC41MTExIDUwLjc3MDYgMjguMzc2OCA1MC43NTU0IDI4LjI0NTkgNTAuNzIzNUMxOC40NDY1IDQ4LjI5MDEgMTQuNzg3NCAzOC40Njk3IDE0LjYzODYgMzguMDYxM0wxNC42MTU0IDM3Ljk3MTRDMTQuNTM1MSAzNy42ODc5IDEyLjU2ODkgMzAuOTUzNiAxNS41ODc0IDI3LjAwOTRDMTYuOTcxIDI1LjIxMDggMTkuMDc1NSAyNC4yODgyIDIxLjg1NDMgMjQuMjg4MkMyNC40MzggMjQuMjg4MiAyNi4zMDE4IDI1LjA5MzQgMjcuNTgzMSAyNi43NTk3QzI4LjYzODUgMjguMTIwMyAyOS4wNjA2IDI5Ljc5ODMgMjkuNDY5MSAzMS40MTQ5QzMwLjMyNzEgMzQuNzgxNSAzMC45NDY2IDM2LjU0OTQgMzQuNTEyOCAzNi43MzE0QzM2LjA3OSAzNi44MTA4IDM3LjEwOCAzNS44OTI0IDM3LjY5MTcgMzUuMTEwNkMzOS4yNjk1IDMyLjk3ODcgMzkuNTQzOSAyOS41MDMxIDM4LjM1NDUgMjYuNDM0OUMzNi44MjYzIDIyLjQ3NDggMzEuNDAyNiAxNS4wMDg0IDIxLjgzOTYgMTUuMDA4NEMxNy43NTczIDE1LjAwODQgMTQuMDA2NCAxNi4zMjM1IDEwLjk5ODUgMTguNzk1QzguNTA4ODEgMjAuODQyMyA2LjUzNjI3IDIzLjczMjggNS41ODY0MSAyNi43MDM2QzMuODI0OTQgMzIuMjM0OSA2LjEzNTIxIDQwLjkyOTYgNi4xNTczOCA0MS4wMDg5QzYuMjExMzIgNDEuMjExMyA2LjIyNDMgNDEuNDIyNCA2LjE5NTU1IDQxLjYyOTlDNi4xNjY4IDQxLjgzNzQgNi4wOTY5IDQyLjAzNyA1Ljk4OTk4IDQyLjIxNjlDNS44ODMwNiA0Mi4zOTY5IDUuNzQxMjggNDIuNTUzNSA1LjU3MyA0Mi42Nzc3QzUuNDA0NzIgNDIuODAxOCA1LjIxMzM0IDQyLjg5MSA1LjAxMDE2IDQyLjkzOThDNC41OTk2NyA0My4wNDkyIDQuMTYyNzYgNDIuOTkzMSAzLjc5MzA2IDQyLjc4MzVDMy40MjMzNSA0Mi41NzM4IDMuMTUwMjcgNDIuMjI3NCAzLjAzMjM0IDQxLjgxODNDMi45MjY4IDQxLjQyMTYgMC40NTkyNyAzMi4xNDgxIDIuNDk0MDggMjUuNzU1N0M0LjcxMDQyIDE4LjgyODkgMTEuNTUwNSAxMS44NDYxIDIxLjg0MjcgMTEuODQ2MUMyNi41OTk0IDExLjg0NjEgMzEuMDkzMyAxMy40NjY5IDM0Ljg0NDIgMTYuNTI3N0MzNy43NDg3IDE4LjkwODMgNDAuMTIxMiAyMi4xMDU1IDQxLjM2MjQgMjUuMzAxOEM0Mi45NDAyIDI5LjM4MjUgNDIuNTE3IDMzLjk2MjYgNDAuMjg2OSAzNi45NTQ3QzM4LjgwMDkgMzguOTUwMSAzNi42ODQ4IDM5Ljk5MzIgMzQuMzQwOCAzOS44OEMyOC4yMzQyIDM5LjU3MzIgMjcuMTM2NiAzNS4yOTk5IDI2LjMzNjYgMzIuMTgzQzI1LjUxMzQgMjguOTg1OCAyNC45ODY4IDI3LjQ0NDIgMjEuODQyNyAyNy40NDQyQzIwLjExNjEgMjcuNDQ0MiAxOC45MDM0IDI3LjkyMDMgMTguMTQ4OCAyOC45MDY0QzE3LjExOTggMzAuMjU1NCAxNy4wMzk2IDMyLjM2NCAxNy4xNTM2IDMzLjg5MzhDMTcuMjI4NCAzNC45NTk3IDE3LjQwODcgMzYuMDE1NSAxNy42OTE4IDM3LjA0NTZDMTcuOTQzIDM3LjY4MDQgMjEuMjEzNyA0NS43MjEzIDI5LjA0NjkgNDcuNjY3QzI5LjI0OTQgNDcuNzE1IDI5LjQ0MDMgNDcuODAzIDI5LjYwODUgNDcuOTI1N0MyOS43NzY4IDQ4LjA0ODMgMjkuOTE5MSA0OC4yMDMzIDMwLjAyNzEgNDguMzgxNkMzMC4xMzUxIDQ4LjU1OTkgMzAuMjA2NyA0OC43NTc5IDMwLjIzNzcgNDguOTY0MUMzMC4yNjg4IDQ5LjE3MDQgMzAuMjU4NiA0OS4zODA3IDMwLjIwNzggNDkuNTgzQzMwLjExMjMgNDkuOTI0NSAyOS45MDc5IDUwLjIyNTIgMjkuNjI1OCA1MC40Mzk0QzI5LjM0MzggNTAuNjUzNSAyOC45OTk2IDUwLjc2OTMgMjguNjQ1OCA1MC43NjlaIiBmaWxsPSIjMDRENzhCIi8+CjxwYXRoIGQ9Ik0xNS4yNiA0OS4wNzY5QzE1LjAzNDkgNDkuMDc3MyAxNC44MTIgNDkuMDM1NyAxNC42MDQ2IDQ4Ljk1NDVDMTQuMzk3MiA0OC44NzMzIDE0LjIwOTYgNDguNzU0MiAxNC4wNTI5IDQ4LjYwNDNDMTAuMDMzNiA0NC42OTEzIDcuNzYwMDcgNDAuMzE1NyA2LjkwNDUyIDM0Ljg0NDRWMzQuODE1NEM2LjQyNDI4IDMxLjE5MzMgNy4xMjczMyAyNi4wNjUyIDEwLjU3MjMgMjIuNTM5NEMxMy4xMTUxIDE5LjkzNzggMTYuNjg5OSAxOC42MTU0IDIxLjE3ODYgMTguNjE1NEMyNi40ODcxIDE4LjYxNTQgMzAuNjU4OSAyMC45MDUgMzMuMjYwMiAyNS4yMjY0QzM1LjE0NzYgMjguMzY1OSAzNS41MjE4IDMxLjQ5NDMgMzUuNTMxNiAzMS42MjI3QzM1LjU1MTMgMzEuODIwNyAzNS41Mjg4IDMyLjAyMDQgMzUuNDY1MyAzMi4yMTA0QzM1LjQwMTggMzIuNDAwMyAzNS4yOTg1IDMyLjU3NjcgMzUuMTYxMyAzMi43Mjk2QzM1LjAyNDIgMzIuODgyNCAzNC44NTU5IDMzLjAwODcgMzQuNjY2MSAzMy4xMDExQzM0LjQ3NjMgMzMuMTkzNSAzNC4yNjg3IDMzLjI1MDMgMzQuMDU1MiAzMy4yNjgyQzMzLjYyNDQgMzMuMzExNiAzMy4xOTI1IDMzLjE5NiAzMi44NTI3IDMyLjk0NjZDMzIuNTEyOSAzMi42OTcxIDMyLjI5MjUgMzIuMzMzNyAzMi4yMzkxIDMxLjkzNDhDMzEuOTU0MiAzMC4wNTc2IDMxLjI5OTQgMjguMjQ1MiAzMC4zMDc0IDI2LjU4NzlDMjguMjkxMiAyMy4yODc5IDI1LjIyMzggMjEuNjEwMyAyMS4xNjY3IDIxLjYxMDNDMTcuNjYyMiAyMS42MTAzIDE0LjkyMDMgMjIuNTg4NiAxMy4wMzQgMjQuNTJDMTAuMzE0OCAyNy4zMDQzIDkuNzg5MTggMzEuNTkzNiAxMC4xNjIzIDM0LjQzMTFDMTAuOTExOSAzOS4yNjkyIDEyLjkxNjEgNDMuMTE4IDE2LjQ1NTIgNDYuNTU3NUMxNi42MDI5IDQ2LjcgMTYuNzE4MiA0Ni44Njg3IDE2Ljc5NDIgNDcuMDUzNEMxNi44NzAzIDQ3LjIzODEgMTYuOTA1NSA0Ny40MzUxIDE2Ljg5NzggNDcuNjMyN0MxNi44OTAyIDQ3LjgzMDMgMTYuODM5NyA0OC4wMjQ0IDE2Ljc0OTYgNDguMjAzNkMxNi42NTk0IDQ4LjM4MjcgMTYuNTMxMyA0OC41NDMyIDE2LjM3MyA0OC42NzU2QzE2LjA2OCA0OC45MzIgMTUuNjcxNiA0OS4wNzQ5IDE1LjI2IDQ5LjA3NjlaIiBmaWxsPSIjMDRENzhCIi8+CjxwYXRoIGQ9Ik0zNS4wMTE0IDQ1LjY5MjRDMzEuMzg4NiA0NS42OTI0IDI4LjMwODYgNDQuNzEyNSAyNS44NDQgNDIuNzY0NUMyMC44OTI0IDM4Ljg2NzYgMjAuMzM3MyAzMi41MjA3IDIwLjMxMjggMzIuMjUyOUMyMC4yNzc5IDMxLjgxMzIgMjAuNDIzMiAzMS4zNzggMjAuNzE2OCAzMS4wNDNDMjEuMDEwNSAzMC43MDgxIDIxLjQyODMgMzAuNTAwNyAyMS44Nzg0IDMwLjQ2NjZDMjIuMzI4NSAzMC40MzI2IDIyLjc3NCAzMC41NzQ1IDIzLjExNyAzMC44NjEzQzIzLjQ1OTkgMzEuMTQ4MSAyMy42NzIyIDMxLjU1NjMgMjMuNzA3MSAzMS45OTU5QzIzLjcxOTMgMzIuMDg5NiAyNC4yMTQzIDM3LjI4MTIgMjguMDMxMSA0MC4yNzExQzMwLjI4OTUgNDIuMDMyOCAzMy4zMDgxIDQyLjczMTkgMzcuMDI3OSA0Mi4zMjM2QzM3LjQ3MjUgNDIuMjcwOSAzNy45MjA0IDQyLjM5MjMgMzguMjczNiA0Mi42NjEyQzM4LjYyNjggNDIuOTMwMSAzOC44NTY3IDQzLjMyNDcgMzguOTEyOSA0My43NTg3QzM4LjkzNzMgNDMuOTczIDM4LjkxNzcgNDQuMTkgMzguODU1MyA0NC4zOTY5QzM4Ljc5MjggNDQuNjAzOCAzOC42ODg5IDQ0Ljc5NjUgMzguNTQ5NCA0NC45NjM3QzM4LjQxIDQ1LjEzMSAzOC4yMzc4IDQ1LjI2OTQgMzguMDQzIDQ1LjM3MUMzNy44NDgyIDQ1LjQ3MjUgMzcuNjM0NiA0NS41MzUyIDM3LjQxNDcgNDUuNTU1MkMzNi42MTcgNDUuNjQ2MiAzNS44MTQ2IDQ1LjY5MiAzNS4wMTE0IDQ1LjY5MjRaIiBmaWxsPSIjMDRENzhCIi8+CjxwYXRoIGQ9Ik0zNy45MzIyIDMuNjA5MDNDMzYuNTg0MSAyLjcwMSAzMS44MDQxIDAgMjIuODE1OSAwQzEzLjM4MTIgMCA4LjU4OTQ2IDIuOTgzODYgNy41Mjk0NiAzLjc0MjIxQzcuNDU5NDYgMy43ODY3IDcuMzkzOTIgMy44MzgzMiA3LjMzMzg0IDMuODk2M0M3LjMyNzUgMy45MDI2NSA3LjMxOTI0IDMuOTA2NTQgNy4zMTA0NSAzLjkwNzMxQzcuMTQxMTggNC4wNjAzIDcuMDA1MzYgNC4yNDg5IDYuOTEyMDUgNC40NjA1MUM2LjgxODczIDQuNjcyMTMgNi43NzAwNiA0LjkwMTkxIDYuNzY5MjkgNS4xMzQ1M0M2Ljc3MjIgNS4zNTI1OSA2LjgxNjY0IDUuNTY3OTEgNi45MDAwNyA1Ljc2ODE2QzYuOTgzNTEgNS45Njg0MSA3LjEwNDI5IDYuMTQ5NjQgNy4yNTU1IDYuMzAxNDdDNy40MDY3MSA2LjQ1MzMxIDcuNTg1MzggNi41NzI3NiA3Ljc4MTI2IDYuNjUyOTlDNy45NzcxNCA2LjczMzIyIDguMTg2MzkgNi43NzI2NCA4LjM5NzAyIDYuNzY5QzguNzM0NjIgNi43Njg3NiA5LjA2NDA2IDYuNjYxNjEgOS4zNDExMyA2LjQ2MTkyQzkuMzg2ODQgNi40MjY3IDEzLjUxMDkgMy4yODk4NCAyMi44MTkxIDMuMjg5ODRDMzIuMTI3MyAzLjI4OTg0IDM2LjI3MzcgNi40MTU2OSAzNi4zMTgzIDYuNDM4OEMzNi42MDE0IDYuNjU2MTEgMzYuOTQ1MSA2Ljc3MjAyIDM3LjI5NzUgNi43NjlDMzcuNTA4MyA2Ljc3MjM1IDM3LjcxNzcgNi43MzI1NiAzNy45MTM2IDYuNjUxOTNDMzguMTA5NSA2LjU3MTMgMzguMjg4MSA2LjQ1MTQgMzguNDM5MiA2LjI5OTEzQzM4LjU5MDIgNi4xNDY4NiAzOC43MTA3IDUuOTY1MiAzOC43OTM4IDUuNzY0NkMzOC44NzY4IDUuNTYzOTkgMzguOTIwOCA1LjM0ODM3IDM4LjkyMzEgNS4xMzAxM0MzOC45MjMyIDQuODAzMjIgMzguODI4OSA0LjQ4Mzc1IDM4LjY1MjQgNC4yMTI3MUMzOC40NzU4IDMuOTQxNjggMzguMjI1IDMuNzMxNDYgMzcuOTMyMiAzLjYwOTAzWiIgZmlsbD0iIzA0RDc4QiIvPgo8cGF0aCBkPSJNMzIuMTUzOCA2NS45OTk5QzMyLjE1MzggNjAuMzk0MSAyNy42MDU3IDU1Ljg0NjEgMjEuOTk5OSA1NS44NDYxQzE2LjM5NDEgNTUuODQ2MSAxMS44NDYxIDYwLjM5NDEgMTEuODQ2MSA2NS45OTk5QzExLjg0NjEgNzEuNjA1NyAxNi4zOTQxIDc2LjE1MzggMjEuOTk5OSA3Ni4xNTM4QzI3LjYwNTcgNzYuMTUzOCAzMi4xNTM4IDcxLjYwNTcgMzIuMTUzOCA2NS45OTk5WiIgc3Ryb2tlPSIjMDRENzhCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNMjcuMDc2OSA2MS43NjkzTDE5Ljk2OTIgNzAuMjMwOEwxNi45MjMgNjYuODQ2MiIgc3Ryb2tlPSIjMDRENzhCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
var phone = "data:image/svg+xml;base64,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";
var help = "data:image/svg+xml;base64,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";
var close = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMS41TDExIDExLjVNMSAxMS41TDExIDEuNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
var loginWithEmail = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA3MiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTY5LjMzMzMgMjhWM0gzNkgyLjY2NjY2VjI4VjUzSDM2IiBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTY5LjMzMzMgNDQuNjY2Nkg0NiIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHN0cm9rZS13aWR0aD0iNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01NC4zMzMzIDM2LjMzMzRMNDYgNDQuNjY2N0w1NC4zMzMzIDUzIiBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuNjY2NjYgM0wzNiAyOEw2OS4zMzMzIDMiIHN0cm9rZT0iY3VycmVudGNvbG9yIiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
var loginWithText = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NyA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjQyOTYgMjguNDA0MUg0Mi4zNzg1TTE0LjQyOTYgMTcuMjI0NUgzMS4xOTg5IiBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMuMjUgNTEuNTczN1Y4LjgzOTc4QzMuMjUgNy4zNTcyOCAzLjgzODkyIDUuOTM1NSA0Ljg4NzIxIDQuODg3MjFDNS45MzU1IDMuODM4OTIgNy4zNTcyOCAzLjI1IDguODM5NzggMy4yNUg0Ny45NjgzQzQ5LjQ1MDggMy4yNSA1MC44NzI2IDMuODM4OTIgNTEuOTIwOCA0Ljg4NzIxQzUyLjk2OTEgNS45MzU1IDUzLjU1OCA3LjM1NzI4IDUzLjU1OCA4LjgzOTc4VjM2Ljc4ODdDNTMuNTU4IDM4LjI3MTIgNTIuOTY5MSAzOS42OTMgNTEuOTIwOCA0MC43NDEzQzUwLjg3MjYgNDEuNzg5NiA0OS40NTA4IDQyLjM3ODUgNDcuOTY4MyA0Mi4zNzg1SDE3LjExNTVDMTYuMjc3NiA0Mi4zNzg2IDE1LjQ1MDYgNDIuNTY3IDE0LjY5NTQgNDIuOTI5OUMxMy45NDAyIDQzLjI5MjcgMTMuMjc2MyA0My44MjA2IDEyLjc1MjYgNDQuNDc0N0w2LjIzNzc0IDUyLjYxOUM2LjAyMDkzIDUyLjg5MDcgNS43MjUwNCA1My4wODgzIDUuMzkxIDUzLjE4NDVDNS4wNTY5NSA1My4yODA3IDQuNzAxMjcgNTMuMjcwNyA0LjM3MzE2IDUzLjE1NTlDNC4wNDUwNCA1My4wNDExIDMuNzYwNzEgNTIuODI3MiAzLjU1OTQ5IDUyLjU0MzdDMy4zNTgyOCA1Mi4yNjAzIDMuMjUwMTMgNTEuOTIxMyAzLjI1IDUxLjU3MzdWNTEuNTczN1oiIHN0cm9rZT0iY3VycmVudGNvbG9yIiBzdHJva2Utd2lkdGg9IjUiLz4KPC9zdmc+Cg==";
const Icons = {
  appleBiometric,
  windowsHello,
  genericBiometrics,
  emailFailed,
  emailSuccess,
  email,
  fingerprintFailed,
  fingerprintSuccess,
  phone,
  help,
  close,
  loginWithEmail,
  loginWithText
};
const cache = {};
function filterAttrs(attrs) {
  return Object.keys(attrs).reduce((result, key) => {
    if (attrs[key] !== false && attrs[key] !== null && attrs[key] !== void 0) {
      result[key] = attrs[key];
    }
    return result;
  }, {});
}
const InlineSvg = {
  name: "InlineSvg",
  inheritAttrs: false,
  render() {
    if (!this.svgElSource) {
      return null;
    }
    return h(
      "svg",
      Object.assign(
        {},
        this.getSvgAttrs(this.svgElSource),
        filterAttrs(this.$attrs),
        { innerHTML: this.getSvgContent(this.svgElSource) }
      )
    );
  },
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    transformSource: {
      type: Function,
      default: (svg) => svg
    },
    keepDuringLoading: {
      type: Boolean,
      default: true
    }
  },
  emits: ["loaded", "unloaded", "error"],
  data() {
    return {
      svgElSource: null
    };
  },
  watch: {
    src(newValue) {
      this.getSource(newValue);
    }
  },
  mounted() {
    this.getSource(this.src);
  },
  methods: {
    getSvgAttrs(svgEl) {
      let svgAttrs = {};
      const attrs = svgEl.attributes;
      if (!attrs) {
        return svgAttrs;
      }
      for (let i = attrs.length - 1; i >= 0; i--) {
        svgAttrs[attrs[i].name] = attrs[i].value;
      }
      return svgAttrs;
    },
    getSvgContent(svgEl) {
      svgEl = svgEl.cloneNode(true);
      svgEl = this.transformSource(svgEl);
      if (this.title) {
        setTitle(svgEl, this.title);
      }
      return svgEl.innerHTML;
    },
    getSource(src) {
      if (!cache[src]) {
        cache[src] = this.download(src);
      }
      if (this.svgElSource && cache[src].isPending() && !this.keepDuringLoading) {
        this.svgElSource = null;
        this.$emit("unloaded");
      }
      cache[src].then((svg) => {
        this.svgElSource = svg;
        this.$nextTick(() => {
          this.$emit("loaded", this.$el);
        });
      }).catch((err) => {
        if (this.svgElSource) {
          this.svgElSource = null;
          this.$emit("unloaded");
        }
        delete cache[src];
        this.$emit("error", err);
      });
    },
    download(url) {
      return makePromiseState(new Promise((resolve2, reject) => {
        const request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.onload = () => {
          if (request.status >= 200 && request.status < 400) {
            try {
              const parser = new DOMParser();
              const result = parser.parseFromString(request.responseText, "text/xml");
              let svgEl = result.getElementsByTagName("svg")[0];
              if (svgEl) {
                resolve2(svgEl);
              } else {
                reject(new Error('Loaded file is not valid SVG"'));
              }
            } catch (e2) {
              reject(e2);
            }
          } else {
            reject(new Error("Error loading SVG"));
          }
        };
        request.onerror = reject;
        request.send();
      }));
    }
  }
};
function setTitle(svg, title) {
  const titleTags = svg.getElementsByTagName("title");
  if (titleTags.length) {
    titleTags[0].textContent = title;
  } else {
    const titleEl = document.createElementNS("http://www.w3.org/2000/svg", "title");
    titleEl.textContent = title;
    svg.appendChild(titleEl);
  }
}
function makePromiseState(promise) {
  if (promise.isPending)
    return promise;
  let isPending = true;
  let result = promise.then(
    (v2) => {
      isPending = false;
      return v2;
    },
    (e2) => {
      isPending = false;
      throw e2;
    }
  );
  result.isPending = function getIsPending() {
    return isPending;
  };
  return result;
}
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  setup(__props) {
    var _a;
    const parser = new UAParser();
    const OS = (_a = parser.getOS().name) != null ? _a : "";
    let icon;
    if (OS.startsWith("Windows")) {
      icon = Icons.windowsHello;
    } else if (OS.startsWith("Mac OS") || OS.startsWith("iOS")) {
      icon = Icons.appleBiometric;
    } else {
      icon = Icons.genericBiometrics;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(InlineSvg), {
        src: unref(icon),
        alt: "Platform device icon"
      }, null, 8, ["src"]);
    };
  }
});
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function passkeyAllowAddDevice(userInfo) {
  return __async(this, null, function* () {
    var _a;
    const { appId: appId2 } = useAppId();
    const passage = new q(appId2.value);
    const browserInfo = yield passage.browserInfo();
    if (!browserInfo.createPassKeySupported) {
      return true;
    }
    let currentInfo = userInfo;
    if (userInfo === void 0) {
      currentInfo = yield passage.getCurrentUser().userInfo();
    }
    if (!currentInfo) {
      return true;
    }
    const hasPasskey = ((_a = currentInfo.webauthn_types) != null ? _a : []).includes(X.Passkey);
    return !hasPasskey;
  });
}
function useAppInfo(appId2) {
  const activeAppId = appId2 === void 0 ? useAppId().appId : ref(appId2);
  const roamingAuthenticatorsAllowed = false;
  const webauthnAllowed = ref(false);
  const invalidAppId = ref(false);
  const loading = ref(true);
  const appInfo = ref();
  function execute() {
    return __async(this, null, function* () {
      invalidAppId.value = false;
      const passage = new q(activeAppId.value);
      try {
        appInfo.value = yield passage.appInfo();
        useLocale().fallbackLocale.value = appInfo.value.default_language;
        if (passage.checkWebauthnConfig(appInfo.value)) {
          webauthnAllowed.value = yield passage.isWebauthnSupported(roamingAuthenticatorsAllowed);
        } else {
          webauthnAllowed.value = false;
        }
        invalidAppId.value = false;
        loading.value = false;
      } catch (err) {
        invalidAppId.value = true;
        loading.value = false;
      }
    });
  }
  onMounted(() => __async(this, null, function* () {
    yield execute();
  }));
  watch(activeAppId, () => {
    execute();
  });
  return {
    appInfo,
    webauthnAllowed,
    invalidAppId,
    loading
  };
}
var intlTelInput$1 = { exports: {} };
(function(module) {
  (function(factory) {
    if (module.exports)
      module.exports = factory();
    else
      window.intlTelInput = factory();
  })(function(undefined$1) {
    return function() {
      var allCountries = [["Afghanistan (\u202B\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646\u202C\u200E)", "af", "93"], ["Albania (Shqip\xEBri)", "al", "355"], ["Algeria (\u202B\u0627\u0644\u062C\u0632\u0627\u0626\u0631\u202C\u200E)", "dz", "213"], ["American Samoa", "as", "1", 5, ["684"]], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1", 6, ["264"]], ["Antigua and Barbuda", "ag", "1", 7, ["268"]], ["Argentina", "ar", "54"], ["Armenia (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)", "am", "374"], ["Aruba", "aw", "297"], ["Ascension Island", "ac", "247"], ["Australia", "au", "61", 0], ["Austria (\xD6sterreich)", "at", "43"], ["Azerbaijan (Az\u0259rbaycan)", "az", "994"], ["Bahamas", "bs", "1", 8, ["242"]], ["Bahrain (\u202B\u0627\u0644\u0628\u062D\u0631\u064A\u0646\u202C\u200E)", "bh", "973"], ["Bangladesh (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)", "bd", "880"], ["Barbados", "bb", "1", 9, ["246"]], ["Belarus (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)", "by", "375"], ["Belgium (Belgi\xEB)", "be", "32"], ["Belize", "bz", "501"], ["Benin (B\xE9nin)", "bj", "229"], ["Bermuda", "bm", "1", 10, ["441"]], ["Bhutan (\u0F60\u0F56\u0FB2\u0F74\u0F42)", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil (Brasil)", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1", 11, ["284"]], ["Brunei", "bn", "673"], ["Bulgaria (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi (Uburundi)", "bi", "257"], ["Cambodia (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)", "kh", "855"], ["Cameroon (Cameroun)", "cm", "237"], ["Canada", "ca", "1", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde (Kabu Verdi)", "cv", "238"], ["Caribbean Netherlands", "bq", "599", 1, ["3", "4", "7"]], ["Cayman Islands", "ky", "1", 12, ["345"]], ["Central African Republic (R\xE9publique centrafricaine)", "cf", "236"], ["Chad (Tchad)", "td", "235"], ["Chile", "cl", "56"], ["China (\u4E2D\u56FD)", "cn", "86"], ["Christmas Island", "cx", "61", 2, ["89164"]], ["Cocos (Keeling) Islands", "cc", "61", 1, ["89162"]], ["Colombia", "co", "57"], ["Comoros (\u202B\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631\u202C\u200E)", "km", "269"], ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"], ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506"], ["C\xF4te d\u2019Ivoire", "ci", "225"], ["Croatia (Hrvatska)", "hr", "385"], ["Cuba", "cu", "53"], ["Cura\xE7ao", "cw", "599", 0], ["Cyprus (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)", "cy", "357"], ["Czech Republic (\u010Cesk\xE1 republika)", "cz", "420"], ["Denmark (Danmark)", "dk", "45"], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1", 13, ["767"]], ["Dominican Republic (Rep\xFAblica Dominicana)", "do", "1", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt (\u202B\u0645\u0635\u0631\u202C\u200E)", "eg", "20"], ["El Salvador", "sv", "503"], ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia (Eesti)", "ee", "372"], ["Eswatini", "sz", "268"], ["Ethiopia", "et", "251"], ["Falkland Islands (Islas Malvinas)", "fk", "500"], ["Faroe Islands (F\xF8royar)", "fo", "298"], ["Fiji", "fj", "679"], ["Finland (Suomi)", "fi", "358", 0], ["France", "fr", "33"], ["French Guiana (Guyane fran\xE7aise)", "gf", "594"], ["French Polynesia (Polyn\xE9sie fran\xE7aise)", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)", "ge", "995"], ["Germany (Deutschland)", "de", "49"], ["Ghana (Gaana)", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)", "gr", "30"], ["Greenland (Kalaallit Nunaat)", "gl", "299"], ["Grenada", "gd", "1", 14, ["473"]], ["Guadeloupe", "gp", "590", 0], ["Guam", "gu", "1", 15, ["671"]], ["Guatemala", "gt", "502"], ["Guernsey", "gg", "44", 1, ["1481", "7781", "7839", "7911"]], ["Guinea (Guin\xE9e)", "gn", "224"], ["Guinea-Bissau (Guin\xE9 Bissau)", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509"], ["Honduras", "hn", "504"], ["Hong Kong (\u9999\u6E2F)", "hk", "852"], ["Hungary (Magyarorsz\xE1g)", "hu", "36"], ["Iceland (\xCDsland)", "is", "354"], ["India (\u092D\u093E\u0930\u0924)", "in", "91"], ["Indonesia", "id", "62"], ["Iran (\u202B\u0627\u06CC\u0631\u0627\u0646\u202C\u200E)", "ir", "98"], ["Iraq (\u202B\u0627\u0644\u0639\u0631\u0627\u0642\u202C\u200E)", "iq", "964"], ["Ireland", "ie", "353"], ["Isle of Man", "im", "44", 2, ["1624", "74576", "7524", "7924", "7624"]], ["Israel (\u202B\u05D9\u05E9\u05E8\u05D0\u05DC\u202C\u200E)", "il", "972"], ["Italy (Italia)", "it", "39", 0], ["Jamaica", "jm", "1", 4, ["876", "658"]], ["Japan (\u65E5\u672C)", "jp", "81"], ["Jersey", "je", "44", 3, ["1534", "7509", "7700", "7797", "7829", "7937"]], ["Jordan (\u202B\u0627\u0644\u0623\u0631\u062F\u0646\u202C\u200E)", "jo", "962"], ["Kazakhstan (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)", "kz", "7", 1, ["33", "7"]], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait (\u202B\u0627\u0644\u0643\u0648\u064A\u062A\u202C\u200E)", "kw", "965"], ["Kyrgyzstan (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)", "kg", "996"], ["Laos (\u0EA5\u0EB2\u0EA7)", "la", "856"], ["Latvia (Latvija)", "lv", "371"], ["Lebanon (\u202B\u0644\u0628\u0646\u0627\u0646\u202C\u200E)", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya (\u202B\u0644\u064A\u0628\u064A\u0627\u202C\u200E)", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania (Lietuva)", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau (\u6FB3\u9580)", "mo", "853"], ["North Macedonia (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)", "mk", "389"], ["Madagascar (Madagasikara)", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60"], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania (\u202B\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627\u202C\u200E)", "mr", "222"], ["Mauritius (Moris)", "mu", "230"], ["Mayotte", "yt", "262", 1, ["269", "639"]], ["Mexico (M\xE9xico)", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova (Republica Moldova)", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia (\u041C\u043E\u043D\u0433\u043E\u043B)", "mn", "976"], ["Montenegro (Crna Gora)", "me", "382"], ["Montserrat", "ms", "1", 16, ["664"]], ["Morocco (\u202B\u0627\u0644\u0645\u063A\u0631\u0628\u202C\u200E)", "ma", "212", 0], ["Mozambique (Mo\xE7ambique)", "mz", "258"], ["Myanmar (Burma) (\u1019\u103C\u1014\u103A\u1019\u102C)", "mm", "95"], ["Namibia (Namibi\xEB)", "na", "264"], ["Nauru", "nr", "674"], ["Nepal (\u0928\u0947\u092A\u093E\u0932)", "np", "977"], ["Netherlands (Nederland)", "nl", "31"], ["New Caledonia (Nouvelle-Cal\xE9donie)", "nc", "687"], ["New Zealand", "nz", "64"], ["Nicaragua", "ni", "505"], ["Niger (Nijar)", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea (\uC870\uC120 \uBBFC\uC8FC\uC8FC\uC758 \uC778\uBBFC \uACF5\uD654\uAD6D)", "kp", "850"], ["Northern Mariana Islands", "mp", "1", 17, ["670"]], ["Norway (Norge)", "no", "47", 0], ["Oman (\u202B\u0639\u064F\u0645\u0627\u0646\u202C\u200E)", "om", "968"], ["Pakistan (\u202B\u067E\u0627\u06A9\u0633\u062A\u0627\u0646\u202C\u200E)", "pk", "92"], ["Palau", "pw", "680"], ["Palestine (\u202B\u0641\u0644\u0633\u0637\u064A\u0646\u202C\u200E)", "ps", "970"], ["Panama (Panam\xE1)", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru (Per\xFA)", "pe", "51"], ["Philippines", "ph", "63"], ["Poland (Polska)", "pl", "48"], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", 3, ["787", "939"]], ["Qatar (\u202B\u0642\u0637\u0631\u202C\u200E)", "qa", "974"], ["R\xE9union (La R\xE9union)", "re", "262", 0], ["Romania (Rom\xE2nia)", "ro", "40"], ["Russia (\u0420\u043E\u0441\u0441\u0438\u044F)", "ru", "7", 0], ["Rwanda", "rw", "250"], ["Saint Barth\xE9lemy", "bl", "590", 1], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1", 18, ["869"]], ["Saint Lucia", "lc", "1", 19, ["758"]], ["Saint Martin (Saint-Martin (partie fran\xE7aise))", "mf", "590", 2], ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1", 20, ["784"]], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["S\xE3o Tom\xE9 and Pr\xEDncipe (S\xE3o Tom\xE9 e Pr\xEDncipe)", "st", "239"], ["Saudi Arabia (\u202B\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629\u202C\u200E)", "sa", "966"], ["Senegal (S\xE9n\xE9gal)", "sn", "221"], ["Serbia (\u0421\u0440\u0431\u0438\u0458\u0430)", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65"], ["Sint Maarten", "sx", "1", 21, ["721"]], ["Slovakia (Slovensko)", "sk", "421"], ["Slovenia (Slovenija)", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia (Soomaaliya)", "so", "252"], ["South Africa", "za", "27"], ["South Korea (\uB300\uD55C\uBBFC\uAD6D)", "kr", "82"], ["South Sudan (\u202B\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)", "ss", "211"], ["Spain (Espa\xF1a)", "es", "34"], ["Sri Lanka (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)", "lk", "94"], ["Sudan (\u202B\u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)", "sd", "249"], ["Suriname", "sr", "597"], ["Svalbard and Jan Mayen", "sj", "47", 1, ["79"]], ["Sweden (Sverige)", "se", "46"], ["Switzerland (Schweiz)", "ch", "41"], ["Syria (\u202B\u0633\u0648\u0631\u064A\u0627\u202C\u200E)", "sy", "963"], ["Taiwan (\u53F0\u7063)", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand (\u0E44\u0E17\u0E22)", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1", 22, ["868"]], ["Tunisia (\u202B\u062A\u0648\u0646\u0633\u202C\u200E)", "tn", "216"], ["Turkey (T\xFCrkiye)", "tr", "90"], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1", 23, ["649"]], ["Tuvalu", "tv", "688"], ["U.S. Virgin Islands", "vi", "1", 24, ["340"]], ["Uganda", "ug", "256"], ["Ukraine (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)", "ua", "380"], ["United Arab Emirates (\u202B\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629\u202C\u200E)", "ae", "971"], ["United Kingdom", "gb", "44", 0], ["United States", "us", "1", 0], ["Uruguay", "uy", "598"], ["Uzbekistan (O\u02BBzbekiston)", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City (Citt\xE0 del Vaticano)", "va", "39", 1, ["06698"]], ["Venezuela", "ve", "58"], ["Vietnam (Vi\u1EC7t Nam)", "vn", "84"], ["Wallis and Futuna (Wallis-et-Futuna)", "wf", "681"], ["Western Sahara (\u202B\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629\u202C\u200E)", "eh", "212", 1, ["5288", "5289"]], ["Yemen (\u202B\u0627\u0644\u064A\u0645\u0646\u202C\u200E)", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"], ["\xC5land Islands", "ax", "358", 1, ["18"]]];
      for (var i = 0; i < allCountries.length; i++) {
        var c = allCountries[i];
        allCountries[i] = {
          name: c[0],
          iso2: c[1],
          dialCode: c[2],
          priority: c[3] || 0,
          areaCodes: c[4] || null
        };
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i2 = 0; i2 < props.length; i2++) {
          var descriptor = props[i2];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor)
            descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          _defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var intlTelInputGlobals = {
        getInstance: function getInstance(input) {
          var id2 = input.getAttribute("data-intl-tel-input-id");
          return window.intlTelInputGlobals.instances[id2];
        },
        instances: {},
        documentReady: function documentReady() {
          return document.readyState === "complete";
        }
      };
      if (typeof window === "object")
        window.intlTelInputGlobals = intlTelInputGlobals;
      var id = 0;
      var defaults = {
        allowDropdown: true,
        autoHideDialCode: true,
        autoPlaceholder: "polite",
        customContainer: "",
        customPlaceholder: null,
        dropdownContainer: null,
        excludeCountries: [],
        formatOnDisplay: true,
        geoIpLookup: null,
        hiddenInput: "",
        initialCountry: "",
        localizedCountries: null,
        nationalMode: true,
        onlyCountries: [],
        placeholderNumberType: "MOBILE",
        preferredCountries: ["us", "gb"],
        separateDialCode: false,
        utilsScript: ""
      };
      var regionlessNanpNumbers = ["800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889"];
      var forEachProp = function forEachProp2(obj, callback) {
        var keys = Object.keys(obj);
        for (var i2 = 0; i2 < keys.length; i2++) {
          callback(keys[i2], obj[keys[i2]]);
        }
      };
      var forEachInstance = function forEachInstance2(method) {
        forEachProp(window.intlTelInputGlobals.instances, function(key) {
          window.intlTelInputGlobals.instances[key][method]();
        });
      };
      var Iti = /* @__PURE__ */ function() {
        function Iti2(input, options) {
          var _this = this;
          _classCallCheck(this, Iti2);
          this.id = id++;
          this.telInput = input;
          this.activeItem = null;
          this.highlightedItem = null;
          var customOptions = options || {};
          this.options = {};
          forEachProp(defaults, function(key, value) {
            _this.options[key] = customOptions.hasOwnProperty(key) ? customOptions[key] : value;
          });
          this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
        }
        _createClass(Iti2, [{
          key: "_init",
          value: function _init() {
            var _this2 = this;
            if (this.options.nationalMode)
              this.options.autoHideDialCode = false;
            if (this.options.separateDialCode) {
              this.options.autoHideDialCode = this.options.nationalMode = false;
            }
            this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (this.isMobile) {
              document.body.classList.add("iti-mobile");
              if (!this.options.dropdownContainer)
                this.options.dropdownContainer = document.body;
            }
            if (typeof Promise !== "undefined") {
              var autoCountryPromise = new Promise(function(resolve2, reject) {
                _this2.resolveAutoCountryPromise = resolve2;
                _this2.rejectAutoCountryPromise = reject;
              });
              var utilsScriptPromise = new Promise(function(resolve2, reject) {
                _this2.resolveUtilsScriptPromise = resolve2;
                _this2.rejectUtilsScriptPromise = reject;
              });
              this.promise = Promise.all([autoCountryPromise, utilsScriptPromise]);
            } else {
              this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {
              };
              this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {
              };
            }
            this.selectedCountryData = {};
            this._processCountryData();
            this._generateMarkup();
            this._setInitialState();
            this._initListeners();
            this._initRequests();
          }
        }, {
          key: "_processCountryData",
          value: function _processCountryData() {
            this._processAllCountries();
            this._processCountryCodes();
            this._processPreferredCountries();
            if (this.options.localizedCountries)
              this._translateCountriesByLocale();
            if (this.options.onlyCountries.length || this.options.localizedCountries) {
              this.countries.sort(this._countryNameSort);
            }
          }
        }, {
          key: "_addCountryCode",
          value: function _addCountryCode(iso2, countryCode, priority) {
            if (countryCode.length > this.countryCodeMaxLen) {
              this.countryCodeMaxLen = countryCode.length;
            }
            if (!this.countryCodes.hasOwnProperty(countryCode)) {
              this.countryCodes[countryCode] = [];
            }
            for (var i2 = 0; i2 < this.countryCodes[countryCode].length; i2++) {
              if (this.countryCodes[countryCode][i2] === iso2)
                return;
            }
            var index = priority !== undefined$1 ? priority : this.countryCodes[countryCode].length;
            this.countryCodes[countryCode][index] = iso2;
          }
        }, {
          key: "_processAllCountries",
          value: function _processAllCountries() {
            if (this.options.onlyCountries.length) {
              var lowerCaseOnlyCountries = this.options.onlyCountries.map(function(country) {
                return country.toLowerCase();
              });
              this.countries = allCountries.filter(function(country) {
                return lowerCaseOnlyCountries.indexOf(country.iso2) > -1;
              });
            } else if (this.options.excludeCountries.length) {
              var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
                return country.toLowerCase();
              });
              this.countries = allCountries.filter(function(country) {
                return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
              });
            } else {
              this.countries = allCountries;
            }
          }
        }, {
          key: "_translateCountriesByLocale",
          value: function _translateCountriesByLocale() {
            for (var i2 = 0; i2 < this.countries.length; i2++) {
              var iso = this.countries[i2].iso2.toLowerCase();
              if (this.options.localizedCountries.hasOwnProperty(iso)) {
                this.countries[i2].name = this.options.localizedCountries[iso];
              }
            }
          }
        }, {
          key: "_countryNameSort",
          value: function _countryNameSort(a2, b2) {
            return a2.name.localeCompare(b2.name);
          }
        }, {
          key: "_processCountryCodes",
          value: function _processCountryCodes() {
            this.countryCodeMaxLen = 0;
            this.dialCodes = {};
            this.countryCodes = {};
            for (var i2 = 0; i2 < this.countries.length; i2++) {
              var c2 = this.countries[i2];
              if (!this.dialCodes[c2.dialCode])
                this.dialCodes[c2.dialCode] = true;
              this._addCountryCode(c2.iso2, c2.dialCode, c2.priority);
            }
            for (var _i = 0; _i < this.countries.length; _i++) {
              var _c = this.countries[_i];
              if (_c.areaCodes) {
                var rootCountryCode = this.countryCodes[_c.dialCode][0];
                for (var j2 = 0; j2 < _c.areaCodes.length; j2++) {
                  var areaCode = _c.areaCodes[j2];
                  for (var k2 = 1; k2 < areaCode.length; k2++) {
                    var partialDialCode = _c.dialCode + areaCode.substr(0, k2);
                    this._addCountryCode(rootCountryCode, partialDialCode);
                    this._addCountryCode(_c.iso2, partialDialCode);
                  }
                  this._addCountryCode(_c.iso2, _c.dialCode + areaCode);
                }
              }
            }
          }
        }, {
          key: "_processPreferredCountries",
          value: function _processPreferredCountries() {
            this.preferredCountries = [];
            for (var i2 = 0; i2 < this.options.preferredCountries.length; i2++) {
              var countryCode = this.options.preferredCountries[i2].toLowerCase();
              var countryData = this._getCountryData(countryCode, false, true);
              if (countryData)
                this.preferredCountries.push(countryData);
            }
          }
        }, {
          key: "_createEl",
          value: function _createEl(name2, attrs, container) {
            var el = document.createElement(name2);
            if (attrs)
              forEachProp(attrs, function(key, value) {
                return el.setAttribute(key, value);
              });
            if (container)
              container.appendChild(el);
            return el;
          }
        }, {
          key: "_generateMarkup",
          value: function _generateMarkup() {
            if (!this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete"))) {
              this.telInput.setAttribute("autocomplete", "off");
            }
            var parentClass = "iti";
            if (this.options.allowDropdown)
              parentClass += " iti--allow-dropdown";
            if (this.options.separateDialCode)
              parentClass += " iti--separate-dial-code";
            if (this.options.customContainer) {
              parentClass += " ";
              parentClass += this.options.customContainer;
            }
            var wrapper = this._createEl("div", {
              "class": parentClass
            });
            this.telInput.parentNode.insertBefore(wrapper, this.telInput);
            this.flagsContainer = this._createEl("div", {
              "class": "iti__flag-container"
            }, wrapper);
            wrapper.appendChild(this.telInput);
            this.selectedFlag = this._createEl("div", {
              "class": "iti__selected-flag",
              role: "combobox",
              "aria-controls": "iti-".concat(this.id, "__country-listbox"),
              "aria-owns": "iti-".concat(this.id, "__country-listbox"),
              "aria-expanded": "false"
            }, this.flagsContainer);
            this.selectedFlagInner = this._createEl("div", {
              "class": "iti__flag"
            }, this.selectedFlag);
            if (this.options.separateDialCode) {
              this.selectedDialCode = this._createEl("div", {
                "class": "iti__selected-dial-code"
              }, this.selectedFlag);
            }
            if (this.options.allowDropdown) {
              this.selectedFlag.setAttribute("tabindex", "0");
              this.dropdownArrow = this._createEl("div", {
                "class": "iti__arrow"
              }, this.selectedFlag);
              this.countryList = this._createEl("ul", {
                "class": "iti__country-list iti__hide",
                id: "iti-".concat(this.id, "__country-listbox"),
                role: "listbox",
                "aria-label": "List of countries"
              });
              if (this.preferredCountries.length) {
                this._appendListItems(this.preferredCountries, "iti__preferred", true);
                this._createEl("li", {
                  "class": "iti__divider",
                  role: "separator",
                  "aria-disabled": "true"
                }, this.countryList);
              }
              this._appendListItems(this.countries, "iti__standard");
              if (this.options.dropdownContainer) {
                this.dropdown = this._createEl("div", {
                  "class": "iti iti--container"
                });
                this.dropdown.appendChild(this.countryList);
              } else {
                this.flagsContainer.appendChild(this.countryList);
              }
            }
            if (this.options.hiddenInput) {
              var hiddenInputName = this.options.hiddenInput;
              var name2 = this.telInput.getAttribute("name");
              if (name2) {
                var i2 = name2.lastIndexOf("[");
                if (i2 !== -1)
                  hiddenInputName = "".concat(name2.substr(0, i2), "[").concat(hiddenInputName, "]");
              }
              this.hiddenInput = this._createEl("input", {
                type: "hidden",
                name: hiddenInputName
              });
              wrapper.appendChild(this.hiddenInput);
            }
          }
        }, {
          key: "_appendListItems",
          value: function _appendListItems(countries, className, preferred) {
            var tmp = "";
            for (var i2 = 0; i2 < countries.length; i2++) {
              var c2 = countries[i2];
              var idSuffix = preferred ? "-preferred" : "";
              tmp += "<li class='iti__country ".concat(className, "' tabIndex='-1' id='iti-").concat(this.id, "__item-").concat(c2.iso2).concat(idSuffix, "' role='option' data-dial-code='").concat(c2.dialCode, "' data-country-code='").concat(c2.iso2, "' aria-selected='false'>");
              tmp += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(c2.iso2, "'></div></div>");
              tmp += "<span class='iti__country-name'>".concat(c2.name, "</span>");
              tmp += "<span class='iti__dial-code'>+".concat(c2.dialCode, "</span>");
              tmp += "</li>";
            }
            this.countryList.insertAdjacentHTML("beforeend", tmp);
          }
        }, {
          key: "_setInitialState",
          value: function _setInitialState() {
            var attributeValue = this.telInput.getAttribute("value");
            var inputValue = this.telInput.value;
            var useAttribute = attributeValue && attributeValue.charAt(0) === "+" && (!inputValue || inputValue.charAt(0) !== "+");
            var val = useAttribute ? attributeValue : inputValue;
            var dialCode = this._getDialCode(val);
            var isRegionlessNanp = this._isRegionlessNanp(val);
            var _this$options = this.options, initialCountry = _this$options.initialCountry, nationalMode = _this$options.nationalMode, autoHideDialCode = _this$options.autoHideDialCode, separateDialCode = _this$options.separateDialCode;
            if (dialCode && !isRegionlessNanp) {
              this._updateFlagFromNumber(val);
            } else if (initialCountry !== "auto") {
              if (initialCountry) {
                this._setFlag(initialCountry.toLowerCase());
              } else {
                if (dialCode && isRegionlessNanp) {
                  this._setFlag("us");
                } else {
                  this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;
                  if (!val) {
                    this._setFlag(this.defaultCountry);
                  }
                }
              }
              if (!val && !nationalMode && !autoHideDialCode && !separateDialCode) {
                this.telInput.value = "+".concat(this.selectedCountryData.dialCode);
              }
            }
            if (val)
              this._updateValFromNumber(val);
          }
        }, {
          key: "_initListeners",
          value: function _initListeners() {
            this._initKeyListeners();
            if (this.options.autoHideDialCode)
              this._initBlurListeners();
            if (this.options.allowDropdown)
              this._initDropdownListeners();
            if (this.hiddenInput)
              this._initHiddenInputListener();
          }
        }, {
          key: "_initHiddenInputListener",
          value: function _initHiddenInputListener() {
            var _this3 = this;
            this._handleHiddenInputSubmit = function() {
              _this3.hiddenInput.value = _this3.getNumber();
            };
            if (this.telInput.form)
              this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
          }
        }, {
          key: "_getClosestLabel",
          value: function _getClosestLabel() {
            var el = this.telInput;
            while (el && el.tagName !== "LABEL") {
              el = el.parentNode;
            }
            return el;
          }
        }, {
          key: "_initDropdownListeners",
          value: function _initDropdownListeners() {
            var _this4 = this;
            this._handleLabelClick = function(e2) {
              if (_this4.countryList.classList.contains("iti__hide"))
                _this4.telInput.focus();
              else
                e2.preventDefault();
            };
            var label = this._getClosestLabel();
            if (label)
              label.addEventListener("click", this._handleLabelClick);
            this._handleClickSelectedFlag = function() {
              if (_this4.countryList.classList.contains("iti__hide") && !_this4.telInput.disabled && !_this4.telInput.readOnly) {
                _this4._showDropdown();
              }
            };
            this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag);
            this._handleFlagsContainerKeydown = function(e2) {
              var isDropdownHidden = _this4.countryList.classList.contains("iti__hide");
              if (isDropdownHidden && ["ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter"].indexOf(e2.key) !== -1) {
                e2.preventDefault();
                e2.stopPropagation();
                _this4._showDropdown();
              }
              if (e2.key === "Tab")
                _this4._closeDropdown();
            };
            this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
          }
        }, {
          key: "_initRequests",
          value: function _initRequests() {
            var _this5 = this;
            if (this.options.utilsScript && !window.intlTelInputUtils) {
              if (window.intlTelInputGlobals.documentReady()) {
                window.intlTelInputGlobals.loadUtils(this.options.utilsScript);
              } else {
                window.addEventListener("load", function() {
                  window.intlTelInputGlobals.loadUtils(_this5.options.utilsScript);
                });
              }
            } else
              this.resolveUtilsScriptPromise();
            if (this.options.initialCountry === "auto")
              this._loadAutoCountry();
            else
              this.resolveAutoCountryPromise();
          }
        }, {
          key: "_loadAutoCountry",
          value: function _loadAutoCountry() {
            if (window.intlTelInputGlobals.autoCountry) {
              this.handleAutoCountry();
            } else if (!window.intlTelInputGlobals.startedLoadingAutoCountry) {
              window.intlTelInputGlobals.startedLoadingAutoCountry = true;
              if (typeof this.options.geoIpLookup === "function") {
                this.options.geoIpLookup(function(countryCode) {
                  window.intlTelInputGlobals.autoCountry = countryCode.toLowerCase();
                  setTimeout(function() {
                    return forEachInstance("handleAutoCountry");
                  });
                }, function() {
                  return forEachInstance("rejectAutoCountryPromise");
                });
              }
            }
          }
        }, {
          key: "_initKeyListeners",
          value: function _initKeyListeners() {
            var _this6 = this;
            this._handleKeyupEvent = function() {
              if (_this6._updateFlagFromNumber(_this6.telInput.value)) {
                _this6._triggerCountryChange();
              }
            };
            this.telInput.addEventListener("keyup", this._handleKeyupEvent);
            this._handleClipboardEvent = function() {
              setTimeout(_this6._handleKeyupEvent);
            };
            this.telInput.addEventListener("cut", this._handleClipboardEvent);
            this.telInput.addEventListener("paste", this._handleClipboardEvent);
          }
        }, {
          key: "_cap",
          value: function _cap(number2) {
            var max = this.telInput.getAttribute("maxlength");
            return max && number2.length > max ? number2.substr(0, max) : number2;
          }
        }, {
          key: "_initBlurListeners",
          value: function _initBlurListeners() {
            var _this7 = this;
            this._handleSubmitOrBlurEvent = function() {
              _this7._removeEmptyDialCode();
            };
            if (this.telInput.form)
              this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent);
            this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
          }
        }, {
          key: "_removeEmptyDialCode",
          value: function _removeEmptyDialCode() {
            if (this.telInput.value.charAt(0) === "+") {
              var numeric = this._getNumeric(this.telInput.value);
              if (!numeric || this.selectedCountryData.dialCode === numeric) {
                this.telInput.value = "";
              }
            }
          }
        }, {
          key: "_getNumeric",
          value: function _getNumeric(s) {
            return s.replace(/\D/g, "");
          }
        }, {
          key: "_trigger",
          value: function _trigger(name2) {
            var e2 = document.createEvent("Event");
            e2.initEvent(name2, true, true);
            this.telInput.dispatchEvent(e2);
          }
        }, {
          key: "_showDropdown",
          value: function _showDropdown() {
            this.countryList.classList.remove("iti__hide");
            this.selectedFlag.setAttribute("aria-expanded", "true");
            this._setDropdownPosition();
            if (this.activeItem) {
              this._highlightListItem(this.activeItem, false);
              this._scrollTo(this.activeItem, true);
            }
            this._bindDropdownListeners();
            this.dropdownArrow.classList.add("iti__arrow--up");
            this._trigger("open:countrydropdown");
          }
        }, {
          key: "_toggleClass",
          value: function _toggleClass(el, className, shouldHaveClass) {
            if (shouldHaveClass && !el.classList.contains(className))
              el.classList.add(className);
            else if (!shouldHaveClass && el.classList.contains(className))
              el.classList.remove(className);
          }
        }, {
          key: "_setDropdownPosition",
          value: function _setDropdownPosition() {
            var _this8 = this;
            if (this.options.dropdownContainer) {
              this.options.dropdownContainer.appendChild(this.dropdown);
            }
            if (!this.isMobile) {
              var pos = this.telInput.getBoundingClientRect();
              var windowTop = window.pageYOffset || document.documentElement.scrollTop;
              var inputTop = pos.top + windowTop;
              var dropdownHeight = this.countryList.offsetHeight;
              var dropdownFitsBelow = inputTop + this.telInput.offsetHeight + dropdownHeight < windowTop + window.innerHeight;
              var dropdownFitsAbove = inputTop - dropdownHeight > windowTop;
              this._toggleClass(this.countryList, "iti__country-list--dropup", !dropdownFitsBelow && dropdownFitsAbove);
              if (this.options.dropdownContainer) {
                var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.offsetHeight;
                this.dropdown.style.top = "".concat(inputTop + extraTop, "px");
                this.dropdown.style.left = "".concat(pos.left + document.body.scrollLeft, "px");
                this._handleWindowScroll = function() {
                  return _this8._closeDropdown();
                };
                window.addEventListener("scroll", this._handleWindowScroll);
              }
            }
          }
        }, {
          key: "_getClosestListItem",
          value: function _getClosestListItem(target) {
            var el = target;
            while (el && el !== this.countryList && !el.classList.contains("iti__country")) {
              el = el.parentNode;
            }
            return el === this.countryList ? null : el;
          }
        }, {
          key: "_bindDropdownListeners",
          value: function _bindDropdownListeners() {
            var _this9 = this;
            this._handleMouseoverCountryList = function(e2) {
              var listItem = _this9._getClosestListItem(e2.target);
              if (listItem)
                _this9._highlightListItem(listItem, false);
            };
            this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList);
            this._handleClickCountryList = function(e2) {
              var listItem = _this9._getClosestListItem(e2.target);
              if (listItem)
                _this9._selectListItem(listItem);
            };
            this.countryList.addEventListener("click", this._handleClickCountryList);
            var isOpening = true;
            this._handleClickOffToClose = function() {
              if (!isOpening)
                _this9._closeDropdown();
              isOpening = false;
            };
            document.documentElement.addEventListener("click", this._handleClickOffToClose);
            var query = "";
            var queryTimer = null;
            this._handleKeydownOnDropdown = function(e2) {
              e2.preventDefault();
              if (e2.key === "ArrowUp" || e2.key === "Up" || e2.key === "ArrowDown" || e2.key === "Down")
                _this9._handleUpDownKey(e2.key);
              else if (e2.key === "Enter")
                _this9._handleEnterKey();
              else if (e2.key === "Escape")
                _this9._closeDropdown();
              else if (/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(e2.key)) {
                if (queryTimer)
                  clearTimeout(queryTimer);
                query += e2.key.toLowerCase();
                _this9._searchForCountry(query);
                queryTimer = setTimeout(function() {
                  query = "";
                }, 1e3);
              }
            };
            document.addEventListener("keydown", this._handleKeydownOnDropdown);
          }
        }, {
          key: "_handleUpDownKey",
          value: function _handleUpDownKey(key) {
            var next = key === "ArrowUp" || key === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
            if (next) {
              if (next.classList.contains("iti__divider")) {
                next = key === "ArrowUp" || key === "Up" ? next.previousElementSibling : next.nextElementSibling;
              }
              this._highlightListItem(next, true);
            }
          }
        }, {
          key: "_handleEnterKey",
          value: function _handleEnterKey() {
            if (this.highlightedItem)
              this._selectListItem(this.highlightedItem);
          }
        }, {
          key: "_searchForCountry",
          value: function _searchForCountry(query) {
            for (var i2 = 0; i2 < this.countries.length; i2++) {
              if (this._startsWith(this.countries[i2].name, query)) {
                var listItem = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(this.countries[i2].iso2));
                this._highlightListItem(listItem, false);
                this._scrollTo(listItem, true);
                break;
              }
            }
          }
        }, {
          key: "_startsWith",
          value: function _startsWith(a2, b2) {
            return a2.substr(0, b2.length).toLowerCase() === b2;
          }
        }, {
          key: "_updateValFromNumber",
          value: function _updateValFromNumber(originalNumber) {
            var number2 = originalNumber;
            if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
              var useNational = !this.options.separateDialCode && (this.options.nationalMode || number2.charAt(0) !== "+");
              var _intlTelInputUtils$nu = intlTelInputUtils.numberFormat, NATIONAL = _intlTelInputUtils$nu.NATIONAL, INTERNATIONAL = _intlTelInputUtils$nu.INTERNATIONAL;
              var format = useNational ? NATIONAL : INTERNATIONAL;
              number2 = intlTelInputUtils.formatNumber(number2, this.selectedCountryData.iso2, format);
            }
            number2 = this._beforeSetNumber(number2);
            this.telInput.value = number2;
          }
        }, {
          key: "_updateFlagFromNumber",
          value: function _updateFlagFromNumber(originalNumber) {
            var number2 = originalNumber;
            var selectedDialCode = this.selectedCountryData.dialCode;
            var isNanp = selectedDialCode === "1";
            if (number2 && this.options.nationalMode && isNanp && number2.charAt(0) !== "+") {
              if (number2.charAt(0) !== "1")
                number2 = "1".concat(number2);
              number2 = "+".concat(number2);
            }
            if (this.options.separateDialCode && selectedDialCode && number2.charAt(0) !== "+") {
              number2 = "+".concat(selectedDialCode).concat(number2);
            }
            var dialCode = this._getDialCode(number2, true);
            var numeric = this._getNumeric(number2);
            var countryCode = null;
            if (dialCode) {
              var countryCodes = this.countryCodes[this._getNumeric(dialCode)];
              var alreadySelected = countryCodes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
              var isRegionlessNanpNumber = selectedDialCode === "1" && this._isRegionlessNanp(numeric);
              if (!isRegionlessNanpNumber && !alreadySelected) {
                for (var j2 = 0; j2 < countryCodes.length; j2++) {
                  if (countryCodes[j2]) {
                    countryCode = countryCodes[j2];
                    break;
                  }
                }
              }
            } else if (number2.charAt(0) === "+" && numeric.length) {
              countryCode = "";
            } else if (!number2 || number2 === "+") {
              countryCode = this.defaultCountry;
            }
            if (countryCode !== null) {
              return this._setFlag(countryCode);
            }
            return false;
          }
        }, {
          key: "_isRegionlessNanp",
          value: function _isRegionlessNanp(number2) {
            var numeric = this._getNumeric(number2);
            if (numeric.charAt(0) === "1") {
              var areaCode = numeric.substr(1, 3);
              return regionlessNanpNumbers.indexOf(areaCode) !== -1;
            }
            return false;
          }
        }, {
          key: "_highlightListItem",
          value: function _highlightListItem(listItem, shouldFocus) {
            var prevItem = this.highlightedItem;
            if (prevItem)
              prevItem.classList.remove("iti__highlight");
            this.highlightedItem = listItem;
            this.highlightedItem.classList.add("iti__highlight");
            if (shouldFocus)
              this.highlightedItem.focus();
          }
        }, {
          key: "_getCountryData",
          value: function _getCountryData(countryCode, ignoreOnlyCountriesOption, allowFail) {
            var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
            for (var i2 = 0; i2 < countryList.length; i2++) {
              if (countryList[i2].iso2 === countryCode) {
                return countryList[i2];
              }
            }
            if (allowFail) {
              return null;
            }
            throw new Error("No country data for '".concat(countryCode, "'"));
          }
        }, {
          key: "_setFlag",
          value: function _setFlag(countryCode) {
            var prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
            this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
            if (this.selectedCountryData.iso2) {
              this.defaultCountry = this.selectedCountryData.iso2;
            }
            this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(countryCode));
            var title = countryCode ? "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : "Unknown";
            this.selectedFlag.setAttribute("title", title);
            if (this.options.separateDialCode) {
              var dialCode = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
              this.selectedDialCode.innerHTML = dialCode;
              var selectedFlagWidth = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
              this.telInput.style.paddingLeft = "".concat(selectedFlagWidth + 6, "px");
            }
            this._updatePlaceholder();
            if (this.options.allowDropdown) {
              var prevItem = this.activeItem;
              if (prevItem) {
                prevItem.classList.remove("iti__active");
                prevItem.setAttribute("aria-selected", "false");
              }
              if (countryCode) {
                var nextItem = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(countryCode, "-preferred")) || this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(countryCode));
                nextItem.setAttribute("aria-selected", "true");
                nextItem.classList.add("iti__active");
                this.activeItem = nextItem;
                this.selectedFlag.setAttribute("aria-activedescendant", nextItem.getAttribute("id"));
              }
            }
            return prevCountry.iso2 !== countryCode;
          }
        }, {
          key: "_getHiddenSelectedFlagWidth",
          value: function _getHiddenSelectedFlagWidth() {
            var containerClone = this.telInput.parentNode.cloneNode();
            containerClone.style.visibility = "hidden";
            document.body.appendChild(containerClone);
            var flagsContainerClone = this.flagsContainer.cloneNode();
            containerClone.appendChild(flagsContainerClone);
            var selectedFlagClone = this.selectedFlag.cloneNode(true);
            flagsContainerClone.appendChild(selectedFlagClone);
            var width = selectedFlagClone.offsetWidth;
            containerClone.parentNode.removeChild(containerClone);
            return width;
          }
        }, {
          key: "_updatePlaceholder",
          value: function _updatePlaceholder() {
            var shouldSetPlaceholder = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
            if (window.intlTelInputUtils && shouldSetPlaceholder) {
              var numberType = intlTelInputUtils.numberType[this.options.placeholderNumberType];
              var placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
              placeholder = this._beforeSetNumber(placeholder);
              if (typeof this.options.customPlaceholder === "function") {
                placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
              }
              this.telInput.setAttribute("placeholder", placeholder);
            }
          }
        }, {
          key: "_selectListItem",
          value: function _selectListItem(listItem) {
            var flagChanged = this._setFlag(listItem.getAttribute("data-country-code"));
            this._closeDropdown();
            this._updateDialCode(listItem.getAttribute("data-dial-code"), true);
            this.telInput.focus();
            var len = this.telInput.value.length;
            this.telInput.setSelectionRange(len, len);
            if (flagChanged) {
              this._triggerCountryChange();
            }
          }
        }, {
          key: "_closeDropdown",
          value: function _closeDropdown() {
            this.countryList.classList.add("iti__hide");
            this.selectedFlag.setAttribute("aria-expanded", "false");
            this.dropdownArrow.classList.remove("iti__arrow--up");
            document.removeEventListener("keydown", this._handleKeydownOnDropdown);
            document.documentElement.removeEventListener("click", this._handleClickOffToClose);
            this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList);
            this.countryList.removeEventListener("click", this._handleClickCountryList);
            if (this.options.dropdownContainer) {
              if (!this.isMobile)
                window.removeEventListener("scroll", this._handleWindowScroll);
              if (this.dropdown.parentNode)
                this.dropdown.parentNode.removeChild(this.dropdown);
            }
            this._trigger("close:countrydropdown");
          }
        }, {
          key: "_scrollTo",
          value: function _scrollTo(element, middle) {
            var container = this.countryList;
            var windowTop = window.pageYOffset || document.documentElement.scrollTop;
            var containerHeight = container.offsetHeight;
            var containerTop = container.getBoundingClientRect().top + windowTop;
            var containerBottom = containerTop + containerHeight;
            var elementHeight = element.offsetHeight;
            var elementTop = element.getBoundingClientRect().top + windowTop;
            var elementBottom = elementTop + elementHeight;
            var newScrollTop = elementTop - containerTop + container.scrollTop;
            var middleOffset = containerHeight / 2 - elementHeight / 2;
            if (elementTop < containerTop) {
              if (middle)
                newScrollTop -= middleOffset;
              container.scrollTop = newScrollTop;
            } else if (elementBottom > containerBottom) {
              if (middle)
                newScrollTop += middleOffset;
              var heightDifference = containerHeight - elementHeight;
              container.scrollTop = newScrollTop - heightDifference;
            }
          }
        }, {
          key: "_updateDialCode",
          value: function _updateDialCode(newDialCodeBare, hasSelectedListItem) {
            var inputVal = this.telInput.value;
            var newDialCode = "+".concat(newDialCodeBare);
            var newNumber;
            if (inputVal.charAt(0) === "+") {
              var prevDialCode = this._getDialCode(inputVal);
              if (prevDialCode) {
                newNumber = inputVal.replace(prevDialCode, newDialCode);
              } else {
                newNumber = newDialCode;
              }
            } else if (this.options.nationalMode || this.options.separateDialCode) {
              return;
            } else {
              if (inputVal) {
                newNumber = newDialCode + inputVal;
              } else if (hasSelectedListItem || !this.options.autoHideDialCode) {
                newNumber = newDialCode;
              } else {
                return;
              }
            }
            this.telInput.value = newNumber;
          }
        }, {
          key: "_getDialCode",
          value: function _getDialCode(number2, includeAreaCode) {
            var dialCode = "";
            if (number2.charAt(0) === "+") {
              var numericChars = "";
              for (var i2 = 0; i2 < number2.length; i2++) {
                var c2 = number2.charAt(i2);
                if (!isNaN(parseInt(c2, 10))) {
                  numericChars += c2;
                  if (includeAreaCode) {
                    if (this.countryCodes[numericChars]) {
                      dialCode = number2.substr(0, i2 + 1);
                    }
                  } else {
                    if (this.dialCodes[numericChars]) {
                      dialCode = number2.substr(0, i2 + 1);
                      break;
                    }
                  }
                  if (numericChars.length === this.countryCodeMaxLen) {
                    break;
                  }
                }
              }
            }
            return dialCode;
          }
        }, {
          key: "_getFullNumber",
          value: function _getFullNumber() {
            var val = this.telInput.value.trim();
            var dialCode = this.selectedCountryData.dialCode;
            var prefix;
            var numericVal = this._getNumeric(val);
            if (this.options.separateDialCode && val.charAt(0) !== "+" && dialCode && numericVal) {
              prefix = "+".concat(dialCode);
            } else {
              prefix = "";
            }
            return prefix + val;
          }
        }, {
          key: "_beforeSetNumber",
          value: function _beforeSetNumber(originalNumber) {
            var number2 = originalNumber;
            if (this.options.separateDialCode) {
              var dialCode = this._getDialCode(number2);
              if (dialCode) {
                dialCode = "+".concat(this.selectedCountryData.dialCode);
                var start = number2[dialCode.length] === " " || number2[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                number2 = number2.substr(start);
              }
            }
            return this._cap(number2);
          }
        }, {
          key: "_triggerCountryChange",
          value: function _triggerCountryChange() {
            this._trigger("countrychange");
          }
        }, {
          key: "handleAutoCountry",
          value: function handleAutoCountry() {
            if (this.options.initialCountry === "auto") {
              this.defaultCountry = window.intlTelInputGlobals.autoCountry;
              if (!this.telInput.value) {
                this.setCountry(this.defaultCountry);
              }
              this.resolveAutoCountryPromise();
            }
          }
        }, {
          key: "handleUtils",
          value: function handleUtils() {
            if (window.intlTelInputUtils) {
              if (this.telInput.value) {
                this._updateValFromNumber(this.telInput.value);
              }
              this._updatePlaceholder();
            }
            this.resolveUtilsScriptPromise();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var form = this.telInput.form;
            if (this.options.allowDropdown) {
              this._closeDropdown();
              this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag);
              this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
              var label = this._getClosestLabel();
              if (label)
                label.removeEventListener("click", this._handleLabelClick);
            }
            if (this.hiddenInput && form)
              form.removeEventListener("submit", this._handleHiddenInputSubmit);
            if (this.options.autoHideDialCode) {
              if (form)
                form.removeEventListener("submit", this._handleSubmitOrBlurEvent);
              this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent);
            }
            this.telInput.removeEventListener("keyup", this._handleKeyupEvent);
            this.telInput.removeEventListener("cut", this._handleClipboardEvent);
            this.telInput.removeEventListener("paste", this._handleClipboardEvent);
            this.telInput.removeAttribute("data-intl-tel-input-id");
            var wrapper = this.telInput.parentNode;
            wrapper.parentNode.insertBefore(this.telInput, wrapper);
            wrapper.parentNode.removeChild(wrapper);
            delete window.intlTelInputGlobals.instances[this.id];
          }
        }, {
          key: "getExtension",
          value: function getExtension() {
            if (window.intlTelInputUtils) {
              return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return "";
          }
        }, {
          key: "getNumber",
          value: function getNumber(format) {
            if (window.intlTelInputUtils) {
              var iso2 = this.selectedCountryData.iso2;
              return intlTelInputUtils.formatNumber(this._getFullNumber(), iso2, format);
            }
            return "";
          }
        }, {
          key: "getNumberType",
          value: function getNumberType() {
            if (window.intlTelInputUtils) {
              return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return -99;
          }
        }, {
          key: "getSelectedCountryData",
          value: function getSelectedCountryData() {
            return this.selectedCountryData;
          }
        }, {
          key: "getValidationError",
          value: function getValidationError() {
            if (window.intlTelInputUtils) {
              var iso2 = this.selectedCountryData.iso2;
              return intlTelInputUtils.getValidationError(this._getFullNumber(), iso2);
            }
            return -99;
          }
        }, {
          key: "isValidNumber",
          value: function isValidNumber() {
            var val = this._getFullNumber().trim();
            var countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
            return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, countryCode) : null;
          }
        }, {
          key: "setCountry",
          value: function setCountry(originalCountryCode) {
            var countryCode = originalCountryCode.toLowerCase();
            if (!this.selectedFlagInner.classList.contains("iti__".concat(countryCode))) {
              this._setFlag(countryCode);
              this._updateDialCode(this.selectedCountryData.dialCode, false);
              this._triggerCountryChange();
            }
          }
        }, {
          key: "setNumber",
          value: function setNumber(number2) {
            var flagChanged = this._updateFlagFromNumber(number2);
            this._updateValFromNumber(number2);
            if (flagChanged) {
              this._triggerCountryChange();
            }
          }
        }, {
          key: "setPlaceholderNumberType",
          value: function setPlaceholderNumberType(type) {
            this.options.placeholderNumberType = type;
            this._updatePlaceholder();
          }
        }]);
        return Iti2;
      }();
      intlTelInputGlobals.getCountryData = function() {
        return allCountries;
      };
      var injectScript = function injectScript2(path, handleSuccess, handleFailure) {
        var script = document.createElement("script");
        script.onload = function() {
          forEachInstance("handleUtils");
          if (handleSuccess)
            handleSuccess();
        };
        script.onerror = function() {
          forEachInstance("rejectUtilsScriptPromise");
          if (handleFailure)
            handleFailure();
        };
        script.className = "iti-load-utils";
        script.async = true;
        script.src = path;
        document.body.appendChild(script);
      };
      intlTelInputGlobals.loadUtils = function(path) {
        if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
          window.intlTelInputGlobals.startedLoadingUtilsScript = true;
          if (typeof Promise !== "undefined") {
            return new Promise(function(resolve2, reject) {
              return injectScript(path, resolve2, reject);
            });
          }
          injectScript(path);
        }
        return null;
      };
      intlTelInputGlobals.defaults = defaults;
      intlTelInputGlobals.version = "17.0.19";
      return function(input, options) {
        var iti = new Iti(input, options);
        iti._init();
        input.setAttribute("data-intl-tel-input-id", iti.id);
        window.intlTelInputGlobals.instances[iti.id] = iti;
        return iti;
      };
    }();
  });
})(intlTelInput$1);
var intlTelInput = intlTelInput$1.exports;
var gridstack = {};
var gridstackEngine = {};
var utils = {};
Object.defineProperty(utils, "__esModule", { value: true });
utils.Utils = utils.obsoleteAttr = utils.obsoleteOptsDel = utils.obsoleteOpts = utils.obsolete = void 0;
function obsolete(self2, f2, oldName, newName, rev) {
  let wrapper = (...args) => {
    console.warn("gridstack.js: Function `" + oldName + "` is deprecated in " + rev + " and has been replaced with `" + newName + "`. It will be **completely** removed in v1.0");
    return f2.apply(self2, args);
  };
  wrapper.prototype = f2.prototype;
  return wrapper;
}
utils.obsolete = obsolete;
function obsoleteOpts(opts, oldName, newName, rev) {
  if (opts[oldName] !== void 0) {
    opts[newName] = opts[oldName];
    console.warn("gridstack.js: Option `" + oldName + "` is deprecated in " + rev + " and has been replaced with `" + newName + "`. It will be **completely** removed in v1.0");
  }
}
utils.obsoleteOpts = obsoleteOpts;
function obsoleteOptsDel(opts, oldName, rev, info) {
  if (opts[oldName] !== void 0) {
    console.warn("gridstack.js: Option `" + oldName + "` is deprecated in " + rev + info);
  }
}
utils.obsoleteOptsDel = obsoleteOptsDel;
function obsoleteAttr(el, oldName, newName, rev) {
  let oldAttr = el.getAttribute(oldName);
  if (oldAttr !== null) {
    el.setAttribute(newName, oldAttr);
    console.warn("gridstack.js: attribute `" + oldName + "`=" + oldAttr + " is deprecated on this object in " + rev + " and has been replaced with `" + newName + "`. It will be **completely** removed in v1.0");
  }
}
utils.obsoleteAttr = obsoleteAttr;
class Utils {
  static getElements(els) {
    if (typeof els === "string") {
      let list = document.querySelectorAll(els);
      if (!list.length && els[0] !== "." && els[0] !== "#") {
        list = document.querySelectorAll("." + els);
        if (!list.length) {
          list = document.querySelectorAll("#" + els);
        }
      }
      return Array.from(list);
    }
    return [els];
  }
  static getElement(els) {
    if (typeof els === "string") {
      if (!els.length)
        return null;
      if (els[0] === "#") {
        return document.getElementById(els.substring(1));
      }
      if (els[0] === "." || els[0] === "[") {
        return document.querySelector(els);
      }
      if (!isNaN(+els[0])) {
        return document.getElementById(els);
      }
      let el = document.querySelector(els);
      if (!el) {
        el = document.getElementById(els);
      }
      if (!el) {
        el = document.querySelector("." + els);
      }
      return el;
    }
    return els;
  }
  static isIntercepted(a2, b2) {
    return !(a2.y >= b2.y + b2.h || a2.y + a2.h <= b2.y || a2.x + a2.w <= b2.x || a2.x >= b2.x + b2.w);
  }
  static isTouching(a2, b2) {
    return Utils.isIntercepted(a2, { x: b2.x - 0.5, y: b2.y - 0.5, w: b2.w + 1, h: b2.h + 1 });
  }
  static sort(nodes, dir, column) {
    column = column || nodes.reduce((col, n2) => Math.max(n2.x + n2.w, col), 0) || 12;
    if (dir === -1)
      return nodes.sort((a2, b2) => b2.x + b2.y * column - (a2.x + a2.y * column));
    else
      return nodes.sort((b2, a2) => b2.x + b2.y * column - (a2.x + a2.y * column));
  }
  static createStylesheet(id, parent) {
    let style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.setAttribute("gs-style-id", id);
    if (style.styleSheet) {
      style.styleSheet.cssText = "";
    } else {
      style.appendChild(document.createTextNode(""));
    }
    if (!parent) {
      parent = document.getElementsByTagName("head")[0];
      parent.appendChild(style);
    } else {
      parent.insertBefore(style, parent.firstChild);
    }
    return style.sheet;
  }
  static removeStylesheet(id) {
    let el = document.querySelector("STYLE[gs-style-id=" + id + "]");
    if (el && el.parentNode)
      el.remove();
  }
  static addCSSRule(sheet, selector, rules) {
    if (typeof sheet.addRule === "function") {
      sheet.addRule(selector, rules);
    } else if (typeof sheet.insertRule === "function") {
      sheet.insertRule(`${selector}{${rules}}`);
    }
  }
  static toBool(v2) {
    if (typeof v2 === "boolean") {
      return v2;
    }
    if (typeof v2 === "string") {
      v2 = v2.toLowerCase();
      return !(v2 === "" || v2 === "no" || v2 === "false" || v2 === "0");
    }
    return Boolean(v2);
  }
  static toNumber(value) {
    return value === null || value.length === 0 ? void 0 : Number(value);
  }
  static parseHeight(val) {
    let h2;
    let unit = "px";
    if (typeof val === "string") {
      let match = val.match(/^(-[0-9]+\.[0-9]+|[0-9]*\.[0-9]+|-[0-9]+|[0-9]+)(px|em|rem|vh|vw|%)?$/);
      if (!match) {
        throw new Error("Invalid height");
      }
      unit = match[2] || "px";
      h2 = parseFloat(match[1]);
    } else {
      h2 = val;
    }
    return { h: h2, unit };
  }
  static defaults(target, ...sources) {
    sources.forEach((source) => {
      for (const key in source) {
        if (!source.hasOwnProperty(key))
          return;
        if (target[key] === null || target[key] === void 0) {
          target[key] = source[key];
        } else if (typeof source[key] === "object" && typeof target[key] === "object") {
          this.defaults(target[key], source[key]);
        }
      }
    });
    return target;
  }
  static same(a2, b2) {
    if (typeof a2 !== "object")
      return a2 == b2;
    if (typeof a2 !== typeof b2)
      return false;
    if (Object.keys(a2).length !== Object.keys(b2).length)
      return false;
    for (const key in a2) {
      if (a2[key] !== b2[key])
        return false;
    }
    return true;
  }
  static copyPos(a2, b2, minMax = false) {
    a2.x = b2.x;
    a2.y = b2.y;
    a2.w = b2.w;
    a2.h = b2.h;
    if (!minMax)
      return a2;
    if (b2.minW)
      a2.minW = b2.minW;
    if (b2.minH)
      a2.minH = b2.minH;
    if (b2.maxW)
      a2.maxW = b2.maxW;
    if (b2.maxH)
      a2.maxH = b2.maxH;
    return a2;
  }
  static samePos(a2, b2) {
    return a2 && b2 && a2.x === b2.x && a2.y === b2.y && a2.w === b2.w && a2.h === b2.h;
  }
  static removeInternalAndSame(a2, b2) {
    if (typeof a2 !== "object" || typeof b2 !== "object")
      return;
    for (let key in a2) {
      let val = a2[key];
      if (key[0] === "_" || val === b2[key]) {
        delete a2[key];
      } else if (val && typeof val === "object" && b2[key] !== void 0) {
        for (let i in val) {
          if (val[i] === b2[key][i] || i[0] === "_") {
            delete val[i];
          }
        }
        if (!Object.keys(val).length) {
          delete a2[key];
        }
      }
    }
  }
  static closestByClass(el, name2) {
    while (el) {
      if (el.classList.contains(name2))
        return el;
      el = el.parentElement;
    }
    return null;
  }
  static throttle(func, delay) {
    let isWaiting = false;
    return (...args) => {
      if (!isWaiting) {
        isWaiting = true;
        setTimeout(() => {
          func(...args);
          isWaiting = false;
        }, delay);
      }
    };
  }
  static removePositioningStyles(el) {
    let style = el.style;
    if (style.position) {
      style.removeProperty("position");
    }
    if (style.left) {
      style.removeProperty("left");
    }
    if (style.top) {
      style.removeProperty("top");
    }
    if (style.width) {
      style.removeProperty("width");
    }
    if (style.height) {
      style.removeProperty("height");
    }
  }
  static getScrollElement(el) {
    if (!el)
      return document.scrollingElement || document.documentElement;
    const style = getComputedStyle(el);
    const overflowRegex = /(auto|scroll)/;
    if (overflowRegex.test(style.overflow + style.overflowY)) {
      return el;
    } else {
      return this.getScrollElement(el.parentElement);
    }
  }
  static updateScrollPosition(el, position, distance) {
    let rect = el.getBoundingClientRect();
    let innerHeightOrClientHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < 0 || rect.bottom > innerHeightOrClientHeight) {
      let offsetDiffDown = rect.bottom - innerHeightOrClientHeight;
      let offsetDiffUp = rect.top;
      let scrollEl = this.getScrollElement(el);
      if (scrollEl !== null) {
        let prevScroll = scrollEl.scrollTop;
        if (rect.top < 0 && distance < 0) {
          if (el.offsetHeight > innerHeightOrClientHeight) {
            scrollEl.scrollTop += distance;
          } else {
            scrollEl.scrollTop += Math.abs(offsetDiffUp) > Math.abs(distance) ? distance : offsetDiffUp;
          }
        } else if (distance > 0) {
          if (el.offsetHeight > innerHeightOrClientHeight) {
            scrollEl.scrollTop += distance;
          } else {
            scrollEl.scrollTop += offsetDiffDown > distance ? distance : offsetDiffDown;
          }
        }
        position.top += scrollEl.scrollTop - prevScroll;
      }
    }
  }
  static updateScrollResize(event, el, distance) {
    const scrollEl = this.getScrollElement(el);
    const height = scrollEl.clientHeight;
    const offsetTop = scrollEl === this.getScrollElement() ? 0 : scrollEl.getBoundingClientRect().top;
    const pointerPosY = event.clientY - offsetTop;
    const top = pointerPosY < distance;
    const bottom = pointerPosY > height - distance;
    if (top) {
      scrollEl.scrollBy({ behavior: "smooth", top: pointerPosY - distance });
    } else if (bottom) {
      scrollEl.scrollBy({ behavior: "smooth", top: distance - (height - pointerPosY) });
    }
  }
  static clone(obj) {
    if (obj === null || obj === void 0 || typeof obj !== "object") {
      return obj;
    }
    if (obj instanceof Array) {
      return [...obj];
    }
    return Object.assign({}, obj);
  }
  static cloneDeep(obj) {
    const ret = Utils.clone(obj);
    for (const key in ret) {
      if (ret.hasOwnProperty(key) && typeof ret[key] === "object" && key.substring(0, 2) !== "__" && !skipFields.find((k2) => k2 === key)) {
        ret[key] = Utils.cloneDeep(obj[key]);
      }
    }
    return ret;
  }
}
utils.Utils = Utils;
const skipFields = ["_isNested", "el", "grid", "subGrid", "engine"];
Object.defineProperty(gridstackEngine, "__esModule", { value: true });
gridstackEngine.GridStackEngine = void 0;
const utils_1 = utils;
class GridStackEngine {
  constructor(opts = {}) {
    this.addedNodes = [];
    this.removedNodes = [];
    this.column = opts.column || 12;
    this.onChange = opts.onChange;
    this._float = opts.float;
    this.maxRow = opts.maxRow;
    this.nodes = opts.nodes || [];
  }
  batchUpdate() {
    if (this.batchMode)
      return this;
    this.batchMode = true;
    this._prevFloat = this._float;
    this._float = true;
    this.saveInitial();
    return this;
  }
  commit() {
    if (!this.batchMode)
      return this;
    this.batchMode = false;
    this._float = this._prevFloat;
    delete this._prevFloat;
    return this._packNodes()._notify();
  }
  _useEntireRowArea(node, nn) {
    return !this.float && !this._hasLocked && (!node._moving || node._skipDown || nn.y <= node.y);
  }
  _fixCollisions(node, nn = node, collide, opt = {}) {
    this._sortNodes(-1);
    collide = collide || this.collide(node, nn);
    if (!collide)
      return false;
    if (node._moving && !opt.nested && !this.float) {
      if (this.swap(node, collide))
        return true;
    }
    let area = nn;
    if (this._useEntireRowArea(node, nn)) {
      area = { x: 0, w: this.column, y: nn.y, h: nn.h };
      collide = this.collide(node, area, opt.skip);
    }
    let didMove = false;
    let newOpt = { nested: true, pack: false };
    while (collide = collide || this.collide(node, area, opt.skip)) {
      let moved;
      if (collide.locked || node._moving && !node._skipDown && nn.y > node.y && !this.float && (!this.collide(collide, Object.assign(Object.assign({}, collide), { y: node.y }), node) || !this.collide(collide, Object.assign(Object.assign({}, collide), { y: nn.y - collide.h }), node))) {
        node._skipDown = node._skipDown || nn.y > node.y;
        moved = this.moveNode(node, Object.assign(Object.assign(Object.assign({}, nn), { y: collide.y + collide.h }), newOpt));
        if (collide.locked && moved) {
          utils_1.Utils.copyPos(nn, node);
        } else if (!collide.locked && moved && opt.pack) {
          this._packNodes();
          nn.y = collide.y + collide.h;
          utils_1.Utils.copyPos(node, nn);
        }
        didMove = didMove || moved;
      } else {
        moved = this.moveNode(collide, Object.assign(Object.assign(Object.assign({}, collide), { y: nn.y + nn.h, skip: node }), newOpt));
      }
      if (!moved) {
        return didMove;
      }
      collide = void 0;
    }
    return didMove;
  }
  collide(skip2, area = skip2, skip22) {
    return this.nodes.find((n2) => n2 !== skip2 && n2 !== skip22 && utils_1.Utils.isIntercepted(n2, area));
  }
  collideAll(skip2, area = skip2, skip22) {
    return this.nodes.filter((n2) => n2 !== skip2 && n2 !== skip22 && utils_1.Utils.isIntercepted(n2, area));
  }
  collideCoverage(node, o2, collides) {
    if (!o2.rect || !node._rect)
      return;
    let r0 = node._rect;
    let r2 = Object.assign({}, o2.rect);
    if (r2.y > r0.y) {
      r2.h += r2.y - r0.y;
      r2.y = r0.y;
    } else {
      r2.h += r0.y - r2.y;
    }
    if (r2.x > r0.x) {
      r2.w += r2.x - r0.x;
      r2.x = r0.x;
    } else {
      r2.w += r0.x - r2.x;
    }
    let collide;
    collides.forEach((n2) => {
      if (n2.locked || !n2._rect)
        return;
      let r22 = n2._rect;
      let yOver = Number.MAX_VALUE, xOver = Number.MAX_VALUE, overMax = 0.5;
      if (r0.y < r22.y) {
        yOver = (r2.y + r2.h - r22.y) / r22.h;
      } else if (r0.y + r0.h > r22.y + r22.h) {
        yOver = (r22.y + r22.h - r2.y) / r22.h;
      }
      if (r0.x < r22.x) {
        xOver = (r2.x + r2.w - r22.x) / r22.w;
      } else if (r0.x + r0.w > r22.x + r22.w) {
        xOver = (r22.x + r22.w - r2.x) / r22.w;
      }
      let over = Math.min(xOver, yOver);
      if (over > overMax) {
        overMax = over;
        collide = n2;
      }
    });
    return collide;
  }
  cacheRects(w2, h2, top, right, bottom, left) {
    this.nodes.forEach((n2) => n2._rect = {
      y: n2.y * h2 + top,
      x: n2.x * w2 + left,
      w: n2.w * w2 - left - right,
      h: n2.h * h2 - top - bottom
    });
    return this;
  }
  swap(a2, b2) {
    if (!b2 || b2.locked || !a2 || a2.locked)
      return false;
    function _doSwap() {
      let x2 = b2.x, y2 = b2.y;
      b2.x = a2.x;
      b2.y = a2.y;
      if (a2.h != b2.h) {
        a2.x = x2;
        a2.y = b2.y + b2.h;
      } else if (a2.w != b2.w) {
        a2.x = b2.x + b2.w;
        a2.y = y2;
      } else {
        a2.x = x2;
        a2.y = y2;
      }
      a2._dirty = b2._dirty = true;
      return true;
    }
    let touching;
    if (a2.w === b2.w && a2.h === b2.h && (a2.x === b2.x || a2.y === b2.y) && (touching = utils_1.Utils.isTouching(a2, b2)))
      return _doSwap();
    if (touching === false)
      return;
    if (a2.w === b2.w && a2.x === b2.x && (touching || (touching = utils_1.Utils.isTouching(a2, b2)))) {
      if (b2.y < a2.y) {
        let t2 = a2;
        a2 = b2;
        b2 = t2;
      }
      return _doSwap();
    }
    if (touching === false)
      return;
    if (a2.h === b2.h && a2.y === b2.y && (touching || (touching = utils_1.Utils.isTouching(a2, b2)))) {
      if (b2.x < a2.x) {
        let t2 = a2;
        a2 = b2;
        b2 = t2;
      }
      return _doSwap();
    }
    return false;
  }
  isAreaEmpty(x2, y2, w2, h2) {
    let nn = { x: x2 || 0, y: y2 || 0, w: w2 || 1, h: h2 || 1 };
    return !this.collide(nn);
  }
  compact() {
    if (this.nodes.length === 0)
      return this;
    this.batchUpdate()._sortNodes();
    let copyNodes = this.nodes;
    this.nodes = [];
    copyNodes.forEach((node) => {
      if (!node.locked) {
        node.autoPosition = true;
      }
      this.addNode(node, false);
      node._dirty = true;
    });
    return this.commit();
  }
  set float(val) {
    if (this._float === val)
      return;
    this._float = val || false;
    if (!val) {
      this._packNodes()._notify();
    }
  }
  get float() {
    return this._float || false;
  }
  _sortNodes(dir) {
    this.nodes = utils_1.Utils.sort(this.nodes, dir, this.column);
    return this;
  }
  _packNodes() {
    if (this.batchMode) {
      return this;
    }
    this._sortNodes();
    if (this.float) {
      this.nodes.forEach((n2) => {
        if (n2._updating || n2._orig === void 0 || n2.y === n2._orig.y)
          return;
        let newY = n2.y;
        while (newY > n2._orig.y) {
          --newY;
          let collide = this.collide(n2, { x: n2.x, y: newY, w: n2.w, h: n2.h });
          if (!collide) {
            n2._dirty = true;
            n2.y = newY;
          }
        }
      });
    } else {
      this.nodes.forEach((n2, i) => {
        if (n2.locked)
          return;
        while (n2.y > 0) {
          let newY = i === 0 ? 0 : n2.y - 1;
          let canBeMoved = i === 0 || !this.collide(n2, { x: n2.x, y: newY, w: n2.w, h: n2.h });
          if (!canBeMoved)
            break;
          n2._dirty = n2.y !== newY;
          n2.y = newY;
        }
      });
    }
    return this;
  }
  prepareNode(node, resizing) {
    node = node || {};
    node._id = node._id || GridStackEngine._idSeq++;
    if (node.x === void 0 || node.y === void 0 || node.x === null || node.y === null) {
      node.autoPosition = true;
    }
    let defaults = { x: 0, y: 0, w: 1, h: 1 };
    utils_1.Utils.defaults(node, defaults);
    if (!node.autoPosition) {
      delete node.autoPosition;
    }
    if (!node.noResize) {
      delete node.noResize;
    }
    if (!node.noMove) {
      delete node.noMove;
    }
    if (typeof node.x == "string") {
      node.x = Number(node.x);
    }
    if (typeof node.y == "string") {
      node.y = Number(node.y);
    }
    if (typeof node.w == "string") {
      node.w = Number(node.w);
    }
    if (typeof node.h == "string") {
      node.h = Number(node.h);
    }
    if (isNaN(node.x)) {
      node.x = defaults.x;
      node.autoPosition = true;
    }
    if (isNaN(node.y)) {
      node.y = defaults.y;
      node.autoPosition = true;
    }
    if (isNaN(node.w)) {
      node.w = defaults.w;
    }
    if (isNaN(node.h)) {
      node.h = defaults.h;
    }
    return this.nodeBoundFix(node, resizing);
  }
  nodeBoundFix(node, resizing) {
    let before = node._orig || utils_1.Utils.copyPos({}, node);
    if (node.maxW) {
      node.w = Math.min(node.w, node.maxW);
    }
    if (node.maxH) {
      node.h = Math.min(node.h, node.maxH);
    }
    if (node.minW && node.minW <= this.column) {
      node.w = Math.max(node.w, node.minW);
    }
    if (node.minH) {
      node.h = Math.max(node.h, node.minH);
    }
    if (node.w > this.column) {
      if (this.column < 12 && !this._inColumnResize) {
        node.w = Math.min(12, node.w);
        this.cacheOneLayout(node, 12);
      }
      node.w = this.column;
    } else if (node.w < 1) {
      node.w = 1;
    }
    if (this.maxRow && node.h > this.maxRow) {
      node.h = this.maxRow;
    } else if (node.h < 1) {
      node.h = 1;
    }
    if (node.x < 0) {
      node.x = 0;
    }
    if (node.y < 0) {
      node.y = 0;
    }
    if (node.x + node.w > this.column) {
      if (resizing) {
        node.w = this.column - node.x;
      } else {
        node.x = this.column - node.w;
      }
    }
    if (this.maxRow && node.y + node.h > this.maxRow) {
      if (resizing) {
        node.h = this.maxRow - node.y;
      } else {
        node.y = this.maxRow - node.h;
      }
    }
    if (!utils_1.Utils.samePos(node, before)) {
      node._dirty = true;
    }
    return node;
  }
  getDirtyNodes(verify) {
    if (verify) {
      return this.nodes.filter((n2) => n2._dirty && !utils_1.Utils.samePos(n2, n2._orig));
    }
    return this.nodes.filter((n2) => n2._dirty);
  }
  _notify(nodes, removeDOM = true) {
    if (this.batchMode)
      return this;
    nodes = nodes === void 0 ? [] : Array.isArray(nodes) ? nodes : [nodes];
    let dirtyNodes = nodes.concat(this.getDirtyNodes());
    this.onChange && this.onChange(dirtyNodes, removeDOM);
    return this;
  }
  cleanNodes() {
    if (this.batchMode)
      return this;
    this.nodes.forEach((n2) => {
      delete n2._dirty;
      delete n2._lastTried;
    });
    return this;
  }
  saveInitial() {
    this.nodes.forEach((n2) => {
      n2._orig = utils_1.Utils.copyPos({}, n2);
      delete n2._dirty;
    });
    this._hasLocked = this.nodes.some((n2) => n2.locked);
    return this;
  }
  restoreInitial() {
    this.nodes.forEach((n2) => {
      if (utils_1.Utils.samePos(n2, n2._orig))
        return;
      utils_1.Utils.copyPos(n2, n2._orig);
      n2._dirty = true;
    });
    this._notify();
    return this;
  }
  addNode(node, triggerAddEvent = false) {
    let dup = this.nodes.find((n2) => n2._id === node._id);
    if (dup)
      return dup;
    node = this._inColumnResize ? this.nodeBoundFix(node) : this.prepareNode(node);
    delete node._temporaryRemoved;
    delete node._removeDOM;
    if (node.autoPosition) {
      this._sortNodes();
      for (let i = 0; ; ++i) {
        let x2 = i % this.column;
        let y2 = Math.floor(i / this.column);
        if (x2 + node.w > this.column) {
          continue;
        }
        let box = { x: x2, y: y2, w: node.w, h: node.h };
        if (!this.nodes.find((n2) => utils_1.Utils.isIntercepted(box, n2))) {
          node.x = x2;
          node.y = y2;
          delete node.autoPosition;
          break;
        }
      }
    }
    this.nodes.push(node);
    if (triggerAddEvent) {
      this.addedNodes.push(node);
    }
    this._fixCollisions(node);
    if (!this.batchMode) {
      this._packNodes()._notify();
    }
    return node;
  }
  removeNode(node, removeDOM = true, triggerEvent = false) {
    if (!this.nodes.find((n2) => n2 === node)) {
      return this;
    }
    if (triggerEvent) {
      this.removedNodes.push(node);
    }
    if (removeDOM)
      node._removeDOM = true;
    this.nodes = this.nodes.filter((n2) => n2 !== node);
    return this._packNodes()._notify(node);
  }
  removeAll(removeDOM = true) {
    delete this._layouts;
    if (this.nodes.length === 0)
      return this;
    removeDOM && this.nodes.forEach((n2) => n2._removeDOM = true);
    this.removedNodes = this.nodes;
    this.nodes = [];
    return this._notify(this.removedNodes);
  }
  moveNodeCheck(node, o2) {
    if (!this.changedPosConstrain(node, o2))
      return false;
    o2.pack = true;
    if (!this.maxRow) {
      return this.moveNode(node, o2);
    }
    let clonedNode;
    let clone = new GridStackEngine({
      column: this.column,
      float: this.float,
      nodes: this.nodes.map((n2) => {
        if (n2 === node) {
          clonedNode = Object.assign({}, n2);
          return clonedNode;
        }
        return Object.assign({}, n2);
      })
    });
    if (!clonedNode)
      return false;
    let canMove = clone.moveNode(clonedNode, o2);
    if (this.maxRow && canMove) {
      canMove = clone.getRow() <= this.maxRow;
      if (!canMove && !o2.resizing) {
        let collide = this.collide(node, o2);
        if (collide && this.swap(node, collide)) {
          this._notify();
          return true;
        }
      }
    }
    if (!canMove)
      return false;
    clone.nodes.filter((n2) => n2._dirty).forEach((c) => {
      let n2 = this.nodes.find((a2) => a2._id === c._id);
      if (!n2)
        return;
      utils_1.Utils.copyPos(n2, c);
      n2._dirty = true;
    });
    this._notify();
    return true;
  }
  willItFit(node) {
    delete node._willFitPos;
    if (!this.maxRow)
      return true;
    let clone = new GridStackEngine({
      column: this.column,
      float: this.float,
      nodes: this.nodes.map((n3) => {
        return Object.assign({}, n3);
      })
    });
    let n2 = Object.assign({}, node);
    this.cleanupNode(n2);
    delete n2.el;
    delete n2._id;
    delete n2.content;
    delete n2.grid;
    clone.addNode(n2);
    if (clone.getRow() <= this.maxRow) {
      node._willFitPos = utils_1.Utils.copyPos({}, n2);
      return true;
    }
    return false;
  }
  changedPosConstrain(node, p2) {
    p2.w = p2.w || node.w;
    p2.h = p2.h || node.h;
    if (node.x !== p2.x || node.y !== p2.y)
      return true;
    if (node.maxW) {
      p2.w = Math.min(p2.w, node.maxW);
    }
    if (node.maxH) {
      p2.h = Math.min(p2.h, node.maxH);
    }
    if (node.minW) {
      p2.w = Math.max(p2.w, node.minW);
    }
    if (node.minH) {
      p2.h = Math.max(p2.h, node.minH);
    }
    return node.w !== p2.w || node.h !== p2.h;
  }
  moveNode(node, o2) {
    if (!node || !o2)
      return false;
    if (o2.pack === void 0)
      o2.pack = true;
    if (typeof o2.x !== "number") {
      o2.x = node.x;
    }
    if (typeof o2.y !== "number") {
      o2.y = node.y;
    }
    if (typeof o2.w !== "number") {
      o2.w = node.w;
    }
    if (typeof o2.h !== "number") {
      o2.h = node.h;
    }
    let resizing = node.w !== o2.w || node.h !== o2.h;
    let nn = utils_1.Utils.copyPos({}, node, true);
    utils_1.Utils.copyPos(nn, o2);
    nn = this.nodeBoundFix(nn, resizing);
    utils_1.Utils.copyPos(o2, nn);
    if (utils_1.Utils.samePos(node, o2))
      return false;
    let prevPos = utils_1.Utils.copyPos({}, node);
    let area = nn;
    let collides = this.collideAll(node, area, o2.skip);
    let needToMove = true;
    if (collides.length) {
      let collide = node._moving && !o2.nested ? this.collideCoverage(node, o2, collides) : collides[0];
      if (collide) {
        needToMove = !this._fixCollisions(node, nn, collide, o2);
      } else {
        needToMove = false;
      }
    }
    if (needToMove) {
      node._dirty = true;
      utils_1.Utils.copyPos(node, nn);
    }
    if (o2.pack) {
      this._packNodes()._notify();
    }
    return !utils_1.Utils.samePos(node, prevPos);
  }
  getRow() {
    return this.nodes.reduce((row, n2) => Math.max(row, n2.y + n2.h), 0);
  }
  beginUpdate(node) {
    if (!node._updating) {
      node._updating = true;
      delete node._skipDown;
      if (!this.batchMode)
        this.saveInitial();
    }
    return this;
  }
  endUpdate() {
    let n2 = this.nodes.find((n3) => n3._updating);
    if (n2) {
      delete n2._updating;
      delete n2._skipDown;
    }
    return this;
  }
  save(saveElement = true) {
    var _a;
    let len = (_a = this._layouts) === null || _a === void 0 ? void 0 : _a.length;
    let layout = len && this.column !== len - 1 ? this._layouts[len - 1] : null;
    let list = [];
    this._sortNodes();
    this.nodes.forEach((n2) => {
      let wl = layout === null || layout === void 0 ? void 0 : layout.find((l) => l._id === n2._id);
      let w2 = Object.assign({}, n2);
      if (wl) {
        w2.x = wl.x;
        w2.y = wl.y;
        w2.w = wl.w;
      }
      for (let key in w2) {
        if (key[0] === "_" || w2[key] === null || w2[key] === void 0)
          delete w2[key];
      }
      delete w2.grid;
      if (!saveElement)
        delete w2.el;
      if (!w2.autoPosition)
        delete w2.autoPosition;
      if (!w2.noResize)
        delete w2.noResize;
      if (!w2.noMove)
        delete w2.noMove;
      if (!w2.locked)
        delete w2.locked;
      list.push(w2);
    });
    return list;
  }
  layoutsNodesChange(nodes) {
    if (!this._layouts || this._inColumnResize)
      return this;
    this._layouts.forEach((layout, column) => {
      if (!layout || column === this.column)
        return this;
      if (column < this.column) {
        this._layouts[column] = void 0;
      } else {
        let ratio = column / this.column;
        nodes.forEach((node) => {
          if (!node._orig)
            return;
          let n2 = layout.find((l) => l._id === node._id);
          if (!n2)
            return;
          if (node.y !== node._orig.y) {
            n2.y += node.y - node._orig.y;
          }
          if (node.x !== node._orig.x) {
            n2.x = Math.round(node.x * ratio);
          }
          if (node.w !== node._orig.w) {
            n2.w = Math.round(node.w * ratio);
          }
        });
      }
    });
    return this;
  }
  updateNodeWidths(prevColumn, column, nodes, layout = "moveScale") {
    var _a;
    if (!this.nodes.length || !column || prevColumn === column)
      return this;
    this.cacheLayout(this.nodes, prevColumn);
    this.batchUpdate();
    let newNodes = [];
    let domOrder = false;
    if (column === 1 && (nodes === null || nodes === void 0 ? void 0 : nodes.length)) {
      domOrder = true;
      let top = 0;
      nodes.forEach((n2) => {
        n2.x = 0;
        n2.w = 1;
        n2.y = Math.max(n2.y, top);
        top = n2.y + n2.h;
      });
      newNodes = nodes;
      nodes = [];
    } else {
      nodes = utils_1.Utils.sort(this.nodes, -1, prevColumn);
    }
    let cacheNodes = [];
    if (column > prevColumn) {
      cacheNodes = this._layouts[column] || [];
      let lastIndex = this._layouts.length - 1;
      if (!cacheNodes.length && prevColumn !== lastIndex && ((_a = this._layouts[lastIndex]) === null || _a === void 0 ? void 0 : _a.length)) {
        prevColumn = lastIndex;
        this._layouts[lastIndex].forEach((cacheNode) => {
          let n2 = nodes.find((n3) => n3._id === cacheNode._id);
          if (n2) {
            n2.x = cacheNode.x;
            n2.y = cacheNode.y;
            n2.w = cacheNode.w;
          }
        });
      }
    }
    cacheNodes.forEach((cacheNode) => {
      let j2 = nodes.findIndex((n2) => n2._id === cacheNode._id);
      if (j2 !== -1) {
        nodes[j2].x = cacheNode.x;
        nodes[j2].y = cacheNode.y;
        nodes[j2].w = cacheNode.w;
        newNodes.push(nodes[j2]);
        nodes.splice(j2, 1);
      }
    });
    if (nodes.length) {
      if (typeof layout === "function") {
        layout(column, prevColumn, newNodes, nodes);
      } else if (!domOrder) {
        let ratio = column / prevColumn;
        let move = layout === "move" || layout === "moveScale";
        let scale = layout === "scale" || layout === "moveScale";
        nodes.forEach((node) => {
          node.x = column === 1 ? 0 : move ? Math.round(node.x * ratio) : Math.min(node.x, column - 1);
          node.w = column === 1 || prevColumn === 1 ? 1 : scale ? Math.round(node.w * ratio) || 1 : Math.min(node.w, column);
          newNodes.push(node);
        });
        nodes = [];
      }
    }
    newNodes = utils_1.Utils.sort(newNodes, -1, column);
    this._inColumnResize = true;
    this.nodes = [];
    newNodes.forEach((node) => {
      this.addNode(node, false);
      delete node._orig;
    });
    this.commit();
    delete this._inColumnResize;
    return this;
  }
  cacheLayout(nodes, column, clear2 = false) {
    let copy = [];
    nodes.forEach((n2, i) => {
      n2._id = n2._id || GridStackEngine._idSeq++;
      copy[i] = { x: n2.x, y: n2.y, w: n2.w, _id: n2._id };
    });
    this._layouts = clear2 ? [] : this._layouts || [];
    this._layouts[column] = copy;
    return this;
  }
  cacheOneLayout(n2, column) {
    n2._id = n2._id || GridStackEngine._idSeq++;
    let layout = { x: n2.x, y: n2.y, w: n2.w, _id: n2._id };
    this._layouts = this._layouts || [];
    this._layouts[column] = this._layouts[column] || [];
    let index = this._layouts[column].findIndex((l) => l._id === n2._id);
    index === -1 ? this._layouts[column].push(layout) : this._layouts[column][index] = layout;
    return this;
  }
  cleanupNode(node) {
    for (let prop in node) {
      if (prop[0] === "_" && prop !== "_id")
        delete node[prop];
    }
    return this;
  }
}
gridstackEngine.GridStackEngine = GridStackEngine;
GridStackEngine._idSeq = 1;
var gridstackDdi = {};
Object.defineProperty(gridstackDdi, "__esModule", { value: true });
gridstackDdi.GridStackDDI = void 0;
class GridStackDDI {
  static registerPlugin(pluginClass) {
    GridStackDDI.ddi = new pluginClass();
    return GridStackDDI.ddi;
  }
  static get() {
    return GridStackDDI.ddi || GridStackDDI.registerPlugin(GridStackDDI);
  }
  remove(el) {
    return this;
  }
}
gridstackDdi.GridStackDDI = GridStackDDI;
var types = {};
Object.defineProperty(types, "__esModule", { value: true });
(function(exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k2, k22) {
    if (k22 === void 0)
      k22 = k2;
    Object.defineProperty(o2, k22, { enumerable: true, get: function() {
      return m2[k2];
    } });
  } : function(o2, m2, k2, k22) {
    if (k22 === void 0)
      k22 = k2;
    o2[k22] = m2[k2];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports2) {
    for (var p2 in m2)
      if (p2 !== "default" && !exports2.hasOwnProperty(p2))
        __createBinding(exports2, m2, p2);
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.GridStack = void 0;
  /*!
   * GridStack 5.0
   * https://gridstackjs.com/
   *
   * Copyright (c) 2021 Alain Dumesny
   * see root license https://github.com/gridstack/gridstack.js/tree/master/LICENSE
   */
  const gridstack_engine_1 = gridstackEngine;
  const utils_12 = utils;
  const gridstack_ddi_1 = gridstackDdi;
  __exportStar(types, exports);
  __exportStar(utils, exports);
  __exportStar(gridstackEngine, exports);
  __exportStar(gridstackDdi, exports);
  const GridDefaults = {
    column: 12,
    minRow: 0,
    maxRow: 0,
    itemClass: "grid-stack-item",
    placeholderClass: "grid-stack-placeholder",
    placeholderText: "",
    handle: ".grid-stack-item-content",
    handleClass: null,
    styleInHead: false,
    cellHeight: "auto",
    cellHeightThrottle: 100,
    margin: 10,
    auto: true,
    minWidth: 768,
    float: false,
    staticGrid: false,
    animate: true,
    alwaysShowResizeHandle: false,
    resizable: {
      autoHide: true,
      handles: "se"
    },
    draggable: {
      handle: ".grid-stack-item-content",
      scroll: false,
      appendTo: "body"
    },
    disableDrag: false,
    disableResize: false,
    rtl: "auto",
    removable: false,
    removableOptions: {
      accept: ".grid-stack-item"
    },
    marginUnit: "px",
    cellHeightUnit: "px",
    disableOneColumnMode: false,
    oneColumnModeDomSort: false
  };
  class GridStack {
    constructor(el, opts = {}) {
      this._gsEventHandler = {};
      this._extraDragRow = 0;
      this.el = el;
      opts = opts || {};
      if (opts.row) {
        opts.minRow = opts.maxRow = opts.row;
        delete opts.row;
      }
      let rowAttr = utils_12.Utils.toNumber(el.getAttribute("gs-row"));
      if (opts.column === "auto") {
        delete opts.column;
      }
      let defaults = Object.assign(Object.assign({}, utils_12.Utils.cloneDeep(GridDefaults)), { column: utils_12.Utils.toNumber(el.getAttribute("gs-column")) || 12, minRow: rowAttr ? rowAttr : utils_12.Utils.toNumber(el.getAttribute("gs-min-row")) || 0, maxRow: rowAttr ? rowAttr : utils_12.Utils.toNumber(el.getAttribute("gs-max-row")) || 0, staticGrid: utils_12.Utils.toBool(el.getAttribute("gs-static")) || false, _styleSheetClass: "grid-stack-instance-" + (Math.random() * 1e4).toFixed(0), alwaysShowResizeHandle: opts.alwaysShowResizeHandle || false, resizable: {
        autoHide: !(opts.alwaysShowResizeHandle || false),
        handles: "se"
      }, draggable: {
        handle: (opts.handleClass ? "." + opts.handleClass : opts.handle ? opts.handle : "") || ".grid-stack-item-content",
        scroll: false,
        appendTo: "body"
      }, removableOptions: {
        accept: "." + (opts.itemClass || "grid-stack-item")
      } });
      if (el.getAttribute("gs-animate")) {
        defaults.animate = utils_12.Utils.toBool(el.getAttribute("gs-animate"));
      }
      this.opts = utils_12.Utils.defaults(opts, defaults);
      opts = null;
      this.initMargin();
      if (this.opts.column !== 1 && !this.opts.disableOneColumnMode && this._widthOrContainer() <= this.opts.minWidth) {
        this._prevColumn = this.getColumn();
        this.opts.column = 1;
      }
      if (this.opts.rtl === "auto") {
        this.opts.rtl = el.style.direction === "rtl";
      }
      if (this.opts.rtl) {
        this.el.classList.add("grid-stack-rtl");
      }
      let parentGridItemEl = utils_12.Utils.closestByClass(this.el, GridDefaults.itemClass);
      if (parentGridItemEl && parentGridItemEl.gridstackNode) {
        this.opts._isNested = parentGridItemEl.gridstackNode;
        this.opts._isNested.subGrid = this;
        parentGridItemEl.classList.add("grid-stack-nested");
        this.el.classList.add("grid-stack-nested");
      }
      this._isAutoCellHeight = this.opts.cellHeight === "auto";
      if (this._isAutoCellHeight || this.opts.cellHeight === "initial") {
        this.cellHeight(void 0, false);
      } else {
        if (typeof this.opts.cellHeight == "number" && this.opts.cellHeightUnit && this.opts.cellHeightUnit !== GridDefaults.cellHeightUnit) {
          this.opts.cellHeight = this.opts.cellHeight + this.opts.cellHeightUnit;
          delete this.opts.cellHeightUnit;
        }
        this.cellHeight(this.opts.cellHeight, false);
      }
      this.el.classList.add(this.opts._styleSheetClass);
      this._setStaticClass();
      this.engine = new gridstack_engine_1.GridStackEngine({
        column: this.getColumn(),
        float: this.opts.float,
        maxRow: this.opts.maxRow,
        onChange: (cbNodes) => {
          let maxH = 0;
          this.engine.nodes.forEach((n2) => {
            maxH = Math.max(maxH, n2.y + n2.h);
          });
          cbNodes.forEach((n2) => {
            let el2 = n2.el;
            if (!el2)
              return;
            if (n2._removeDOM) {
              if (el2)
                el2.remove();
              delete n2._removeDOM;
            } else {
              this._writePosAttr(el2, n2);
            }
          });
          this._updateStyles(false, maxH);
        }
      });
      if (this.opts.auto) {
        this.batchUpdate();
        let elements = [];
        this.getGridItems().forEach((el2) => {
          let x2 = parseInt(el2.getAttribute("gs-x"));
          let y2 = parseInt(el2.getAttribute("gs-y"));
          elements.push({
            el: el2,
            i: (Number.isNaN(x2) ? 1e3 : x2) + (Number.isNaN(y2) ? 1e3 : y2) * this.getColumn()
          });
        });
        elements.sort((a2, b2) => a2.i - b2.i).forEach((e2) => this._prepareElement(e2.el));
        this.commit();
      }
      this.setAnimation(this.opts.animate);
      this._updateStyles();
      if (this.opts.column != 12) {
        this.el.classList.add("grid-stack-" + this.opts.column);
      }
      if (this.opts.dragIn)
        GridStack.setupDragIn(this.opts.dragIn, this.opts.dragInOptions);
      delete this.opts.dragIn;
      delete this.opts.dragInOptions;
      this._setupRemoveDrop();
      this._setupAcceptWidget();
      this._updateWindowResizeEvent();
    }
    static init(options = {}, elOrString = ".grid-stack") {
      let el = GridStack.getGridElement(elOrString);
      if (!el) {
        if (typeof elOrString === "string") {
          console.error('GridStack.initAll() no grid was found with selector "' + elOrString + '" - element missing or wrong selector ?\nNote: ".grid-stack" is required for proper CSS styling and drag/drop, and is the default selector.');
        } else {
          console.error("GridStack.init() no grid element was passed.");
        }
        return null;
      }
      if (!el.gridstack) {
        el.gridstack = new GridStack(el, utils_12.Utils.cloneDeep(options));
      }
      return el.gridstack;
    }
    static initAll(options = {}, selector = ".grid-stack") {
      let grids = [];
      GridStack.getGridElements(selector).forEach((el) => {
        if (!el.gridstack) {
          el.gridstack = new GridStack(el, utils_12.Utils.cloneDeep(options));
          delete options.dragIn;
          delete options.dragInOptions;
        }
        grids.push(el.gridstack);
      });
      if (grids.length === 0) {
        console.error('GridStack.initAll() no grid was found with selector "' + selector + '" - element missing or wrong selector ?\nNote: ".grid-stack" is required for proper CSS styling and drag/drop, and is the default selector.');
      }
      return grids;
    }
    static addGrid(parent, opt = {}) {
      if (!parent)
        return null;
      let el = parent;
      if (!parent.classList.contains("grid-stack")) {
        let doc2 = document.implementation.createHTMLDocument("");
        doc2.body.innerHTML = `<div class="grid-stack ${opt.class || ""}"></div>`;
        el = doc2.body.children[0];
        parent.appendChild(el);
      }
      let grid = GridStack.init(opt, el);
      if (grid.opts.children) {
        let children = grid.opts.children;
        delete grid.opts.children;
        grid.load(children);
      }
      return grid;
    }
    get placeholder() {
      if (!this._placeholder) {
        let placeholderChild = document.createElement("div");
        placeholderChild.className = "placeholder-content";
        if (this.opts.placeholderText) {
          placeholderChild.innerHTML = this.opts.placeholderText;
        }
        this._placeholder = document.createElement("div");
        this._placeholder.classList.add(this.opts.placeholderClass, GridDefaults.itemClass, this.opts.itemClass);
        this.placeholder.appendChild(placeholderChild);
      }
      return this._placeholder;
    }
    addWidget(els, options) {
      if (arguments.length > 2) {
        console.warn("gridstack.ts: `addWidget(el, x, y, width...)` is deprecated. Use `addWidget({x, y, w, content, ...})`. It will be removed soon");
        let a2 = arguments, i = 1, opt = {
          x: a2[i++],
          y: a2[i++],
          w: a2[i++],
          h: a2[i++],
          autoPosition: a2[i++],
          minW: a2[i++],
          maxW: a2[i++],
          minH: a2[i++],
          maxH: a2[i++],
          id: a2[i++]
        };
        return this.addWidget(els, opt);
      }
      function isGridStackWidget(w2) {
        return w2.x !== void 0 || w2.y !== void 0 || w2.w !== void 0 || w2.h !== void 0 || w2.content !== void 0 ? true : false;
      }
      let el;
      if (typeof els === "string") {
        let doc2 = document.implementation.createHTMLDocument("");
        doc2.body.innerHTML = els;
        el = doc2.body.children[0];
      } else if (arguments.length === 0 || arguments.length === 1 && isGridStackWidget(els)) {
        let content = els ? els.content || "" : "";
        options = els;
        let doc2 = document.implementation.createHTMLDocument("");
        doc2.body.innerHTML = `<div class="grid-stack-item ${this.opts.itemClass || ""}"><div class="grid-stack-item-content">${content}</div></div>`;
        el = doc2.body.children[0];
      } else {
        el = els;
      }
      let domAttr = this._readAttr(el);
      options = utils_12.Utils.cloneDeep(options) || {};
      utils_12.Utils.defaults(options, domAttr);
      let node = this.engine.prepareNode(options);
      this._writeAttr(el, options);
      if (this._insertNotAppend) {
        this.el.prepend(el);
      } else {
        this.el.appendChild(el);
      }
      this._prepareElement(el, true, options);
      this._updateContainerHeight();
      if (node.subGrid && !node.subGrid.el) {
        let autoColumn;
        let ops = node.subGrid;
        if (ops.column === "auto") {
          ops.column = node.w;
          ops.disableOneColumnMode = true;
          autoColumn = true;
        }
        let content = node.el.querySelector(".grid-stack-item-content");
        node.subGrid = GridStack.addGrid(content, node.subGrid);
        if (autoColumn) {
          node.subGrid._autoColumn = true;
        }
      }
      this._triggerAddEvent();
      this._triggerChangeEvent();
      return el;
    }
    save(saveContent = true, saveGridOpt = false) {
      let list = this.engine.save(saveContent);
      list.forEach((n2) => {
        if (saveContent && n2.el && !n2.subGrid) {
          let sub = n2.el.querySelector(".grid-stack-item-content");
          n2.content = sub ? sub.innerHTML : void 0;
          if (!n2.content)
            delete n2.content;
        } else {
          if (!saveContent) {
            delete n2.content;
          }
          if (n2.subGrid) {
            n2.subGrid = n2.subGrid.save(saveContent, true);
          }
        }
        delete n2.el;
      });
      if (saveGridOpt) {
        let o2 = utils_12.Utils.cloneDeep(this.opts);
        if (o2.marginBottom === o2.marginTop && o2.marginRight === o2.marginLeft && o2.marginTop === o2.marginRight) {
          o2.margin = o2.marginTop;
          delete o2.marginTop;
          delete o2.marginRight;
          delete o2.marginBottom;
          delete o2.marginLeft;
        }
        if (o2.rtl === (this.el.style.direction === "rtl")) {
          o2.rtl = "auto";
        }
        if (this._isAutoCellHeight) {
          o2.cellHeight = "auto";
        }
        if (this._autoColumn) {
          o2.column = "auto";
          delete o2.disableOneColumnMode;
        }
        utils_12.Utils.removeInternalAndSame(o2, GridDefaults);
        o2.children = list;
        return o2;
      }
      return list;
    }
    load(layout, addAndRemove = true) {
      let items = GridStack.Utils.sort([...layout], -1, this._prevColumn || this.getColumn());
      this._insertNotAppend = true;
      if (this._prevColumn && this._prevColumn !== this.opts.column && items.some((n2) => n2.x + n2.w > this.opts.column)) {
        this._ignoreLayoutsNodeChange = true;
        this.engine.cacheLayout(items, this._prevColumn, true);
      }
      let removed = [];
      this.batchUpdate();
      if (addAndRemove) {
        let copyNodes = [...this.engine.nodes];
        copyNodes.forEach((n2) => {
          let item = items.find((w2) => n2.id === w2.id);
          if (!item) {
            if (typeof addAndRemove === "function") {
              addAndRemove(this, n2, false);
            } else {
              removed.push(n2);
              this.removeWidget(n2.el, true, false);
            }
          }
        });
      }
      items.forEach((w2) => {
        let item = w2.id || w2.id === 0 ? this.engine.nodes.find((n2) => n2.id === w2.id) : void 0;
        if (item) {
          this.update(item.el, w2);
          if (w2.subGrid && w2.subGrid.children) {
            let sub = item.el.querySelector(".grid-stack");
            if (sub && sub.gridstack) {
              sub.gridstack.load(w2.subGrid.children);
              this._insertNotAppend = true;
            }
          }
        } else if (addAndRemove) {
          if (typeof addAndRemove === "function") {
            w2 = addAndRemove(this, w2, true).gridstackNode;
          } else {
            w2 = this.addWidget(w2).gridstackNode;
          }
        }
      });
      this.engine.removedNodes = removed;
      this.commit();
      delete this._ignoreLayoutsNodeChange;
      delete this._insertNotAppend;
      return this;
    }
    batchUpdate() {
      this.engine.batchUpdate();
      return this;
    }
    getCellHeight(forcePixel = false) {
      if (this.opts.cellHeight && this.opts.cellHeight !== "auto" && (!forcePixel || !this.opts.cellHeightUnit || this.opts.cellHeightUnit === "px")) {
        return this.opts.cellHeight;
      }
      let el = this.el.querySelector("." + this.opts.itemClass);
      if (el) {
        let height = utils_12.Utils.toNumber(el.getAttribute("gs-h"));
        return Math.round(el.offsetHeight / height);
      }
      let rows = parseInt(this.el.getAttribute("gs-current-row"));
      return rows ? Math.round(this.el.getBoundingClientRect().height / rows) : this.opts.cellHeight;
    }
    cellHeight(val, update = true) {
      if (update && val !== void 0) {
        if (this._isAutoCellHeight !== (val === "auto")) {
          this._isAutoCellHeight = val === "auto";
          this._updateWindowResizeEvent();
        }
      }
      if (val === "initial" || val === "auto") {
        val = void 0;
      }
      if (val === void 0) {
        let marginDiff = -this.opts.marginRight - this.opts.marginLeft + this.opts.marginTop + this.opts.marginBottom;
        val = this.cellWidth() + marginDiff;
      }
      let data = utils_12.Utils.parseHeight(val);
      if (this.opts.cellHeightUnit === data.unit && this.opts.cellHeight === data.h) {
        return this;
      }
      this.opts.cellHeightUnit = data.unit;
      this.opts.cellHeight = data.h;
      if (update) {
        this._updateStyles(true, this.getRow());
      }
      return this;
    }
    cellWidth() {
      return this._widthOrContainer() / this.getColumn();
    }
    _widthOrContainer() {
      return this.el.clientWidth || this.el.parentElement.clientWidth || window.innerWidth;
    }
    commit() {
      this.engine.commit();
      this._triggerRemoveEvent();
      this._triggerAddEvent();
      this._triggerChangeEvent();
      return this;
    }
    compact() {
      this.engine.compact();
      this._triggerChangeEvent();
      return this;
    }
    column(column, layout = "moveScale") {
      if (column < 1 || this.opts.column === column)
        return this;
      let oldColumn = this.getColumn();
      if (column === 1) {
        this._prevColumn = oldColumn;
      } else {
        delete this._prevColumn;
      }
      this.el.classList.remove("grid-stack-" + oldColumn);
      this.el.classList.add("grid-stack-" + column);
      this.opts.column = this.engine.column = column;
      let domNodes;
      if (column === 1 && this.opts.oneColumnModeDomSort) {
        domNodes = [];
        this.getGridItems().forEach((el) => {
          if (el.gridstackNode) {
            domNodes.push(el.gridstackNode);
          }
        });
        if (!domNodes.length) {
          domNodes = void 0;
        }
      }
      this.engine.updateNodeWidths(oldColumn, column, domNodes, layout);
      if (this._isAutoCellHeight)
        this.cellHeight();
      this._ignoreLayoutsNodeChange = true;
      this._triggerChangeEvent();
      delete this._ignoreLayoutsNodeChange;
      return this;
    }
    getColumn() {
      return this.opts.column;
    }
    getGridItems() {
      return Array.from(this.el.children).filter((el) => el.matches("." + this.opts.itemClass) && !el.matches("." + this.opts.placeholderClass));
    }
    destroy(removeDOM = true) {
      if (!this.el)
        return;
      this._updateWindowResizeEvent(true);
      this.setStatic(true, false);
      this.setAnimation(false);
      if (!removeDOM) {
        this.removeAll(removeDOM);
        this.el.classList.remove(this.opts._styleSheetClass);
      } else {
        this.el.parentNode.removeChild(this.el);
      }
      this._removeStylesheet();
      this.el.removeAttribute("gs-current-row");
      delete this.opts._isNested;
      delete this.opts;
      delete this._placeholder;
      delete this.engine;
      delete this.el.gridstack;
      delete this.el;
      return this;
    }
    float(val) {
      this.engine.float = val;
      this._triggerChangeEvent();
      return this;
    }
    getFloat() {
      return this.engine.float;
    }
    getCellFromPixel(position, useDocRelative = false) {
      let box = this.el.getBoundingClientRect();
      let containerPos;
      if (useDocRelative) {
        containerPos = { top: box.top + document.documentElement.scrollTop, left: box.left };
      } else {
        containerPos = { top: this.el.offsetTop, left: this.el.offsetLeft };
      }
      let relativeLeft = position.left - containerPos.left;
      let relativeTop = position.top - containerPos.top;
      let columnWidth = box.width / this.getColumn();
      let rowHeight = box.height / parseInt(this.el.getAttribute("gs-current-row"));
      return { x: Math.floor(relativeLeft / columnWidth), y: Math.floor(relativeTop / rowHeight) };
    }
    getRow() {
      return Math.max(this.engine.getRow(), this.opts.minRow);
    }
    isAreaEmpty(x2, y2, w2, h2) {
      return this.engine.isAreaEmpty(x2, y2, w2, h2);
    }
    makeWidget(els) {
      let el = GridStack.getElement(els);
      this._prepareElement(el, true);
      this._updateContainerHeight();
      this._triggerAddEvent();
      this._triggerChangeEvent();
      return el;
    }
    on(name2, callback) {
      if (name2.indexOf(" ") !== -1) {
        let names = name2.split(" ");
        names.forEach((name3) => this.on(name3, callback));
        return this;
      }
      if (name2 === "change" || name2 === "added" || name2 === "removed" || name2 === "enable" || name2 === "disable") {
        let noData = name2 === "enable" || name2 === "disable";
        if (noData) {
          this._gsEventHandler[name2] = (event) => callback(event);
        } else {
          this._gsEventHandler[name2] = (event) => callback(event, event.detail);
        }
        this.el.addEventListener(name2, this._gsEventHandler[name2]);
      } else if (name2 === "drag" || name2 === "dragstart" || name2 === "dragstop" || name2 === "resizestart" || name2 === "resize" || name2 === "resizestop" || name2 === "dropped") {
        this._gsEventHandler[name2] = callback;
      } else {
        console.log("GridStack.on(" + name2 + ') event not supported, but you can still use $(".grid-stack").on(...) while jquery-ui is still used internally.');
      }
      return this;
    }
    off(name2) {
      if (name2.indexOf(" ") !== -1) {
        let names = name2.split(" ");
        names.forEach((name3) => this.off(name3));
        return this;
      }
      if (name2 === "change" || name2 === "added" || name2 === "removed" || name2 === "enable" || name2 === "disable") {
        if (this._gsEventHandler[name2]) {
          this.el.removeEventListener(name2, this._gsEventHandler[name2]);
        }
      }
      delete this._gsEventHandler[name2];
      return this;
    }
    removeWidget(els, removeDOM = true, triggerEvent = true) {
      GridStack.getElements(els).forEach((el) => {
        if (el.parentElement !== this.el)
          return;
        let node = el.gridstackNode;
        if (!node) {
          node = this.engine.nodes.find((n2) => el === n2.el);
        }
        if (!node)
          return;
        delete el.gridstackNode;
        gridstack_ddi_1.GridStackDDI.get().remove(el);
        this.engine.removeNode(node, removeDOM, triggerEvent);
        if (removeDOM && el.parentElement) {
          el.remove();
        }
      });
      if (triggerEvent) {
        this._triggerRemoveEvent();
        this._triggerChangeEvent();
      }
      return this;
    }
    removeAll(removeDOM = true) {
      this.engine.nodes.forEach((n2) => {
        delete n2.el.gridstackNode;
        gridstack_ddi_1.GridStackDDI.get().remove(n2.el);
      });
      this.engine.removeAll(removeDOM);
      this._triggerRemoveEvent();
      return this;
    }
    setAnimation(doAnimate) {
      if (doAnimate) {
        this.el.classList.add("grid-stack-animate");
      } else {
        this.el.classList.remove("grid-stack-animate");
      }
      return this;
    }
    setStatic(val, updateClass = true) {
      if (this.opts.staticGrid === val)
        return this;
      this.opts.staticGrid = val;
      this._setupRemoveDrop();
      this._setupAcceptWidget();
      this.engine.nodes.forEach((n2) => this._prepareDragDropByNode(n2));
      if (updateClass) {
        this._setStaticClass();
      }
      return this;
    }
    update(els, opt) {
      if (arguments.length > 2) {
        console.warn("gridstack.ts: `update(el, x, y, w, h)` is deprecated. Use `update(el, {x, w, content, ...})`. It will be removed soon");
        let a2 = arguments, i = 1;
        opt = { x: a2[i++], y: a2[i++], w: a2[i++], h: a2[i++] };
        return this.update(els, opt);
      }
      GridStack.getElements(els).forEach((el) => {
        if (!el || !el.gridstackNode)
          return;
        let n2 = el.gridstackNode;
        let w2 = utils_12.Utils.cloneDeep(opt);
        delete w2.autoPosition;
        let keys = ["x", "y", "w", "h"];
        let m2;
        if (keys.some((k2) => w2[k2] !== void 0 && w2[k2] !== n2[k2])) {
          m2 = {};
          keys.forEach((k2) => {
            m2[k2] = w2[k2] !== void 0 ? w2[k2] : n2[k2];
            delete w2[k2];
          });
        }
        if (!m2 && (w2.minW || w2.minH || w2.maxW || w2.maxH)) {
          m2 = {};
        }
        if (w2.content) {
          let sub = el.querySelector(".grid-stack-item-content");
          if (sub && sub.innerHTML !== w2.content) {
            sub.innerHTML = w2.content;
          }
          delete w2.content;
        }
        let changed = false;
        let ddChanged = false;
        for (const key in w2) {
          if (key[0] !== "_" && n2[key] !== w2[key]) {
            n2[key] = w2[key];
            changed = true;
            ddChanged = ddChanged || !this.opts.staticGrid && (key === "noResize" || key === "noMove" || key === "locked");
          }
        }
        if (m2) {
          this.engine.cleanNodes().beginUpdate(n2).moveNode(n2, m2);
          this._updateContainerHeight();
          this._triggerChangeEvent();
          this.engine.endUpdate();
        }
        if (changed) {
          this._writeAttr(el, n2);
        }
        if (ddChanged) {
          this._prepareDragDropByNode(n2);
        }
      });
      return this;
    }
    margin(value) {
      let isMultiValue = typeof value === "string" && value.split(" ").length > 1;
      if (!isMultiValue) {
        let data = utils_12.Utils.parseHeight(value);
        if (this.opts.marginUnit === data.unit && this.opts.margin === data.h)
          return;
      }
      this.opts.margin = value;
      this.opts.marginTop = this.opts.marginBottom = this.opts.marginLeft = this.opts.marginRight = void 0;
      this.initMargin();
      this._updateStyles(true);
      return this;
    }
    getMargin() {
      return this.opts.margin;
    }
    willItFit(node) {
      if (arguments.length > 1) {
        console.warn("gridstack.ts: `willItFit(x,y,w,h,autoPosition)` is deprecated. Use `willItFit({x, y,...})`. It will be removed soon");
        let a2 = arguments, i = 0, w2 = { x: a2[i++], y: a2[i++], w: a2[i++], h: a2[i++], autoPosition: a2[i++] };
        return this.willItFit(w2);
      }
      return this.engine.willItFit(node);
    }
    _triggerChangeEvent() {
      if (this.engine.batchMode)
        return this;
      let elements = this.engine.getDirtyNodes(true);
      if (elements && elements.length) {
        if (!this._ignoreLayoutsNodeChange) {
          this.engine.layoutsNodesChange(elements);
        }
        this._triggerEvent("change", elements);
      }
      this.engine.saveInitial();
      return this;
    }
    _triggerAddEvent() {
      if (this.engine.batchMode)
        return this;
      if (this.engine.addedNodes && this.engine.addedNodes.length > 0) {
        if (!this._ignoreLayoutsNodeChange) {
          this.engine.layoutsNodesChange(this.engine.addedNodes);
        }
        this.engine.addedNodes.forEach((n2) => {
          delete n2._dirty;
        });
        this._triggerEvent("added", this.engine.addedNodes);
        this.engine.addedNodes = [];
      }
      return this;
    }
    _triggerRemoveEvent() {
      if (this.engine.batchMode)
        return this;
      if (this.engine.removedNodes && this.engine.removedNodes.length > 0) {
        this._triggerEvent("removed", this.engine.removedNodes);
        this.engine.removedNodes = [];
      }
      return this;
    }
    _triggerEvent(name2, data) {
      let event = data ? new CustomEvent(name2, { bubbles: false, detail: data }) : new Event(name2);
      this.el.dispatchEvent(event);
      return this;
    }
    _removeStylesheet() {
      if (this._styles) {
        utils_12.Utils.removeStylesheet(this._styles._id);
        delete this._styles;
      }
      return this;
    }
    _updateStyles(forceUpdate = false, maxH) {
      if (forceUpdate) {
        this._removeStylesheet();
      }
      this._updateContainerHeight();
      if (this.opts.cellHeight === 0) {
        return this;
      }
      let cellHeight = this.opts.cellHeight;
      let cellHeightUnit = this.opts.cellHeightUnit;
      let prefix = `.${this.opts._styleSheetClass} > .${this.opts.itemClass}`;
      if (!this._styles) {
        let id = "gridstack-style-" + (Math.random() * 1e5).toFixed();
        let styleLocation = this.opts.styleInHead ? void 0 : this.el.parentNode;
        this._styles = utils_12.Utils.createStylesheet(id, styleLocation);
        if (!this._styles)
          return this;
        this._styles._id = id;
        this._styles._max = 0;
        utils_12.Utils.addCSSRule(this._styles, prefix, `min-height: ${cellHeight}${cellHeightUnit}`);
        let top = this.opts.marginTop + this.opts.marginUnit;
        let bottom = this.opts.marginBottom + this.opts.marginUnit;
        let right = this.opts.marginRight + this.opts.marginUnit;
        let left = this.opts.marginLeft + this.opts.marginUnit;
        let content = `${prefix} > .grid-stack-item-content`;
        let placeholder = `.${this.opts._styleSheetClass} > .grid-stack-placeholder > .placeholder-content`;
        utils_12.Utils.addCSSRule(this._styles, content, `top: ${top}; right: ${right}; bottom: ${bottom}; left: ${left};`);
        utils_12.Utils.addCSSRule(this._styles, placeholder, `top: ${top}; right: ${right}; bottom: ${bottom}; left: ${left};`);
        utils_12.Utils.addCSSRule(this._styles, `${prefix} > .ui-resizable-ne`, `right: ${right}`);
        utils_12.Utils.addCSSRule(this._styles, `${prefix} > .ui-resizable-e`, `right: ${right}`);
        utils_12.Utils.addCSSRule(this._styles, `${prefix} > .ui-resizable-se`, `right: ${right}; bottom: ${bottom}`);
        utils_12.Utils.addCSSRule(this._styles, `${prefix} > .ui-resizable-nw`, `left: ${left}`);
        utils_12.Utils.addCSSRule(this._styles, `${prefix} > .ui-resizable-w`, `left: ${left}`);
        utils_12.Utils.addCSSRule(this._styles, `${prefix} > .ui-resizable-sw`, `left: ${left}; bottom: ${bottom}`);
      }
      maxH = maxH || this._styles._max;
      if (maxH > this._styles._max) {
        let getHeight = (rows) => cellHeight * rows + cellHeightUnit;
        for (let i = this._styles._max + 1; i <= maxH; i++) {
          let h2 = getHeight(i);
          utils_12.Utils.addCSSRule(this._styles, `${prefix}[gs-y="${i - 1}"]`, `top: ${getHeight(i - 1)}`);
          utils_12.Utils.addCSSRule(this._styles, `${prefix}[gs-h="${i}"]`, `height: ${h2}`);
          utils_12.Utils.addCSSRule(this._styles, `${prefix}[gs-min-h="${i}"]`, `min-height: ${h2}`);
          utils_12.Utils.addCSSRule(this._styles, `${prefix}[gs-max-h="${i}"]`, `max-height: ${h2}`);
        }
        this._styles._max = maxH;
      }
      return this;
    }
    _updateContainerHeight() {
      if (!this.engine || this.engine.batchMode)
        return this;
      let row = this.getRow() + this._extraDragRow;
      this.el.setAttribute("gs-current-row", String(row));
      if (row === 0) {
        this.el.style.removeProperty("height");
        return this;
      }
      let cellHeight = this.opts.cellHeight;
      let unit = this.opts.cellHeightUnit;
      if (!cellHeight)
        return this;
      this.el.style.height = row * cellHeight + unit;
      return this;
    }
    _prepareElement(el, triggerAddEvent = false, node) {
      if (!node) {
        el.classList.add(this.opts.itemClass);
        node = this._readAttr(el);
      }
      el.gridstackNode = node;
      node.el = el;
      node.grid = this;
      let copy = Object.assign({}, node);
      node = this.engine.addNode(node, triggerAddEvent);
      if (!utils_12.Utils.same(node, copy)) {
        this._writeAttr(el, node);
      }
      this._prepareDragDropByNode(node);
      return this;
    }
    _writePosAttr(el, n2) {
      if (n2.x !== void 0 && n2.x !== null) {
        el.setAttribute("gs-x", String(n2.x));
      }
      if (n2.y !== void 0 && n2.y !== null) {
        el.setAttribute("gs-y", String(n2.y));
      }
      if (n2.w) {
        el.setAttribute("gs-w", String(n2.w));
      }
      if (n2.h) {
        el.setAttribute("gs-h", String(n2.h));
      }
      return this;
    }
    _writeAttr(el, node) {
      if (!node)
        return this;
      this._writePosAttr(el, node);
      let attrs = {
        autoPosition: "gs-auto-position",
        minW: "gs-min-w",
        minH: "gs-min-h",
        maxW: "gs-max-w",
        maxH: "gs-max-h",
        noResize: "gs-no-resize",
        noMove: "gs-no-move",
        locked: "gs-locked",
        id: "gs-id",
        resizeHandles: "gs-resize-handles"
      };
      for (const key in attrs) {
        if (node[key]) {
          el.setAttribute(attrs[key], String(node[key]));
        } else {
          el.removeAttribute(attrs[key]);
        }
      }
      return this;
    }
    _readAttr(el) {
      let node = {};
      node.x = utils_12.Utils.toNumber(el.getAttribute("gs-x"));
      node.y = utils_12.Utils.toNumber(el.getAttribute("gs-y"));
      node.w = utils_12.Utils.toNumber(el.getAttribute("gs-w"));
      node.h = utils_12.Utils.toNumber(el.getAttribute("gs-h"));
      node.maxW = utils_12.Utils.toNumber(el.getAttribute("gs-max-w"));
      node.minW = utils_12.Utils.toNumber(el.getAttribute("gs-min-w"));
      node.maxH = utils_12.Utils.toNumber(el.getAttribute("gs-max-h"));
      node.minH = utils_12.Utils.toNumber(el.getAttribute("gs-min-h"));
      node.autoPosition = utils_12.Utils.toBool(el.getAttribute("gs-auto-position"));
      node.noResize = utils_12.Utils.toBool(el.getAttribute("gs-no-resize"));
      node.noMove = utils_12.Utils.toBool(el.getAttribute("gs-no-move"));
      node.locked = utils_12.Utils.toBool(el.getAttribute("gs-locked"));
      node.resizeHandles = el.getAttribute("gs-resize-handles");
      node.id = el.getAttribute("gs-id");
      for (const key in node) {
        if (!node.hasOwnProperty(key))
          return;
        if (!node[key] && node[key] !== 0) {
          delete node[key];
        }
      }
      return node;
    }
    _setStaticClass() {
      let classes = ["grid-stack-static"];
      if (this.opts.staticGrid) {
        this.el.classList.add(...classes);
        this.el.setAttribute("gs-static", "true");
      } else {
        this.el.classList.remove(...classes);
        this.el.removeAttribute("gs-static");
      }
      return this;
    }
    onParentResize() {
      if (!this.el || !this.el.clientWidth)
        return;
      let changedColumn = false;
      if (this._autoColumn && this.opts._isNested) {
        if (this.opts.column !== this.opts._isNested.w) {
          changedColumn = true;
          this.column(this.opts._isNested.w, "none");
        }
      } else {
        let oneColumn = !this.opts.disableOneColumnMode && this.el.clientWidth <= this.opts.minWidth;
        if (this.opts.column === 1 !== oneColumn) {
          changedColumn = true;
          if (this.opts.animate) {
            this.setAnimation(false);
          }
          this.column(oneColumn ? 1 : this._prevColumn);
          if (this.opts.animate) {
            this.setAnimation(true);
          }
        }
      }
      if (this._isAutoCellHeight) {
        if (!changedColumn && this.opts.cellHeightThrottle) {
          if (!this._cellHeightThrottle) {
            this._cellHeightThrottle = utils_12.Utils.throttle(() => this.cellHeight(), this.opts.cellHeightThrottle);
          }
          this._cellHeightThrottle();
        } else {
          this.cellHeight();
        }
      }
      this.engine.nodes.forEach((n2) => {
        if (n2.subGrid) {
          n2.subGrid.onParentResize();
        }
      });
      return this;
    }
    _updateWindowResizeEvent(forceRemove = false) {
      const workTodo = (this._isAutoCellHeight || !this.opts.disableOneColumnMode) && !this.opts._isNested;
      if (!forceRemove && workTodo && !this._windowResizeBind) {
        this._windowResizeBind = this.onParentResize.bind(this);
        window.addEventListener("resize", this._windowResizeBind);
      } else if ((forceRemove || !workTodo) && this._windowResizeBind) {
        window.removeEventListener("resize", this._windowResizeBind);
        delete this._windowResizeBind;
      }
      return this;
    }
    static getElement(els = ".grid-stack-item") {
      return utils_12.Utils.getElement(els);
    }
    static getElements(els = ".grid-stack-item") {
      return utils_12.Utils.getElements(els);
    }
    static getGridElement(els) {
      return GridStack.getElement(els);
    }
    static getGridElements(els) {
      return utils_12.Utils.getElements(els);
    }
    initMargin() {
      let data;
      let margin = 0;
      let margins = [];
      if (typeof this.opts.margin === "string") {
        margins = this.opts.margin.split(" ");
      }
      if (margins.length === 2) {
        this.opts.marginTop = this.opts.marginBottom = margins[0];
        this.opts.marginLeft = this.opts.marginRight = margins[1];
      } else if (margins.length === 4) {
        this.opts.marginTop = margins[0];
        this.opts.marginRight = margins[1];
        this.opts.marginBottom = margins[2];
        this.opts.marginLeft = margins[3];
      } else {
        data = utils_12.Utils.parseHeight(this.opts.margin);
        this.opts.marginUnit = data.unit;
        margin = this.opts.margin = data.h;
      }
      if (this.opts.marginTop === void 0) {
        this.opts.marginTop = margin;
      } else {
        data = utils_12.Utils.parseHeight(this.opts.marginTop);
        this.opts.marginTop = data.h;
        delete this.opts.margin;
      }
      if (this.opts.marginBottom === void 0) {
        this.opts.marginBottom = margin;
      } else {
        data = utils_12.Utils.parseHeight(this.opts.marginBottom);
        this.opts.marginBottom = data.h;
        delete this.opts.margin;
      }
      if (this.opts.marginRight === void 0) {
        this.opts.marginRight = margin;
      } else {
        data = utils_12.Utils.parseHeight(this.opts.marginRight);
        this.opts.marginRight = data.h;
        delete this.opts.margin;
      }
      if (this.opts.marginLeft === void 0) {
        this.opts.marginLeft = margin;
      } else {
        data = utils_12.Utils.parseHeight(this.opts.marginLeft);
        this.opts.marginLeft = data.h;
        delete this.opts.margin;
      }
      this.opts.marginUnit = data.unit;
      if (this.opts.marginTop === this.opts.marginBottom && this.opts.marginLeft === this.opts.marginRight && this.opts.marginTop === this.opts.marginRight) {
        this.opts.margin = this.opts.marginTop;
      }
      return this;
    }
    static setupDragIn(dragIn, dragInOptions) {
    }
    movable(els, val) {
      return this;
    }
    resizable(els, val) {
      return this;
    }
    disable() {
      return this;
    }
    enable() {
      return this;
    }
    enableMove(doEnable) {
      return this;
    }
    enableResize(doEnable) {
      return this;
    }
    _setupAcceptWidget() {
      return this;
    }
    _setupRemoveDrop() {
      return this;
    }
    _prepareDragDropByNode(node) {
      return this;
    }
    _onStartMoving(el, event, ui, node, cellWidth, cellHeight) {
      return;
    }
    _dragOrResize(el, event, ui, node, cellWidth, cellHeight) {
      return;
    }
    _leave(el, helper) {
      return;
    }
  }
  exports.GridStack = GridStack;
  GridStack.Utils = utils_12.Utils;
  GridStack.Engine = gridstack_engine_1.GridStackEngine;
})(gridstack);
const _sfc_main$7 = defineComponent({
  name: "Checkbox",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    toggleSwitch: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, context) {
    const inputRef = ref(null);
    const inputValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        if (props.readonly)
          ;
        context.emit("update:modelValue", newValue);
        claimFocus();
      }
    });
    function claimFocus() {
      if (inputRef.value !== null) {
        inputRef.value.focus();
      }
    }
    function changeEvent(event) {
      if (props.readonly) {
        return;
      }
      const checked = event.target.checked;
      context.emit("change", checked);
    }
    function setValue() {
      if (props.readonly) {
        return;
      }
      inputValue.value = !inputValue.value;
    }
    return {
      inputValue,
      inputRef,
      setValue,
      changeEvent
    };
  }
});
const _hoisted_1$7 = ["readonly"];
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["checkbox-container", { readonly: _ctx.readonly }])
  }, [
    withDirectives(createBaseVNode("input", {
      class: normalizeClass(_ctx.toggleSwitch ? "passage-toggle-switch" : "passage-checkbox"),
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.inputValue = $event),
      ref: "inputRef",
      onChange: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.changeEvent && _ctx.changeEvent(...args), ["prevent"])),
      readonly: _ctx.readonly
    }, null, 42, _hoisted_1$7), [
      [vModelCheckbox, _ctx.inputValue]
    ]),
    createBaseVNode("div", {
      class: normalizeClass(["checkbox-label", { "toggle-switch-label": _ctx.toggleSwitch }]),
      onClick: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.setValue && _ctx.setValue(...args), ["prevent"]))
    }, toDisplayString$1(_ctx.label), 3)
  ], 2);
}
var Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
const _sfc_main$6 = defineComponent({
  name: "Validated String",
  props: {
    modelValue: {
      type: String
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { t: t2 } = useLocale();
    const reactiveValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        context.emit("update:modelValue", newValue);
      }
    });
    const errorMessage = ref("");
    function validate() {
      var _a, _b;
      errorMessage.value = "";
      if (props.required && props.modelValue === void 0) {
        errorMessage.value = t2("required");
        return false;
      }
      const validLength = ((_b = (_a = props.modelValue) == null ? void 0 : _a.length) != null ? _b : 0) < 64;
      if (!validLength) {
        errorMessage.value = t2("64-letters-max");
      }
      return validLength;
    }
    return {
      reactiveValue,
      validate,
      errorMessage
    };
  }
});
const _hoisted_1$6 = { class: "validated-field" };
const _hoisted_2$6 = { class: "label" };
const _hoisted_3$5 = {
  key: 0,
  class: "input short",
  part: "input short",
  style: { "width": "100%" },
  value: "N/A",
  readonly: ""
};
const _hoisted_4$4 = ["placeholder", "readonly"];
const _hoisted_5$4 = { class: "error-message" };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createBaseVNode("div", _hoisted_2$6, toDisplayString$1(_ctx.label), 1),
    _ctx.readonly && !_ctx.modelValue ? (openBlock(), createElementBlock("input", _hoisted_3$5)) : withDirectives((openBlock(), createElementBlock("input", {
      key: 1,
      class: normalizeClass(["input short", { "is-danger": _ctx.errorMessage }]),
      part: "input short",
      style: { "width": "100%" },
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.reactiveValue = $event),
      onInput: _cache[1] || (_cache[1] = ($event) => _ctx.errorMessage = ""),
      readonly: _ctx.readonly
    }, null, 42, _hoisted_4$4)), [
      [vModelText, _ctx.reactiveValue]
    ]),
    createBaseVNode("div", _hoisted_5$4, toDisplayString$1(_ctx.errorMessage), 1)
  ]);
}
var ValidatedString = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t2, e2) {
    module.exports = e2();
  }(commonjsGlobal, function() {
    var t2 = 1e3, e2 = 6e4, n2 = 36e5, r2 = "millisecond", i = "second", s = "minute", u2 = "hour", a2 = "day", o2 = "week", f2 = "month", h2 = "quarter", c = "year", d = "date", l = "Invalid Date", $2 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y2 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M2 = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t3) {
      var e3 = ["th", "st", "nd", "rd"], n3 = t3 % 100;
      return "[" + t3 + (e3[(n3 - 20) % 10] || e3[n3] || e3[0]) + "]";
    } }, m2 = function(t3, e3, n3) {
      var r3 = String(t3);
      return !r3 || r3.length >= e3 ? t3 : "" + Array(e3 + 1 - r3.length).join(n3) + t3;
    }, v2 = { s: m2, z: function(t3) {
      var e3 = -t3.utcOffset(), n3 = Math.abs(e3), r3 = Math.floor(n3 / 60), i2 = n3 % 60;
      return (e3 <= 0 ? "+" : "-") + m2(r3, 2, "0") + ":" + m2(i2, 2, "0");
    }, m: function t3(e3, n3) {
      if (e3.date() < n3.date())
        return -t3(n3, e3);
      var r3 = 12 * (n3.year() - e3.year()) + (n3.month() - e3.month()), i2 = e3.clone().add(r3, f2), s2 = n3 - i2 < 0, u3 = e3.clone().add(r3 + (s2 ? -1 : 1), f2);
      return +(-(r3 + (n3 - i2) / (s2 ? i2 - u3 : u3 - i2)) || 0);
    }, a: function(t3) {
      return t3 < 0 ? Math.ceil(t3) || 0 : Math.floor(t3);
    }, p: function(t3) {
      return { M: f2, y: c, w: o2, d: a2, D: d, h: u2, m: s, s: i, ms: r2, Q: h2 }[t3] || String(t3 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t3) {
      return void 0 === t3;
    } }, g2 = "en", D = {};
    D[g2] = M2;
    var p2 = function(t3) {
      return t3 instanceof _2;
    }, S = function t3(e3, n3, r3) {
      var i2;
      if (!e3)
        return g2;
      if ("string" == typeof e3) {
        var s2 = e3.toLowerCase();
        D[s2] && (i2 = s2), n3 && (D[s2] = n3, i2 = s2);
        var u3 = e3.split("-");
        if (!i2 && u3.length > 1)
          return t3(u3[0]);
      } else {
        var a3 = e3.name;
        D[a3] = e3, i2 = a3;
      }
      return !r3 && i2 && (g2 = i2), i2 || !r3 && g2;
    }, w2 = function(t3, e3) {
      if (p2(t3))
        return t3.clone();
      var n3 = "object" == typeof e3 ? e3 : {};
      return n3.date = t3, n3.args = arguments, new _2(n3);
    }, O2 = v2;
    O2.l = S, O2.i = p2, O2.w = function(t3, e3) {
      return w2(t3, { locale: e3.$L, utc: e3.$u, x: e3.$x, $offset: e3.$offset });
    };
    var _2 = function() {
      function M3(t3) {
        this.$L = S(t3.locale, null, true), this.parse(t3);
      }
      var m3 = M3.prototype;
      return m3.parse = function(t3) {
        this.$d = function(t4) {
          var e3 = t4.date, n3 = t4.utc;
          if (null === e3)
            return new Date(NaN);
          if (O2.u(e3))
            return new Date();
          if (e3 instanceof Date)
            return new Date(e3);
          if ("string" == typeof e3 && !/Z$/i.test(e3)) {
            var r3 = e3.match($2);
            if (r3) {
              var i2 = r3[2] - 1 || 0, s2 = (r3[7] || "0").substring(0, 3);
              return n3 ? new Date(Date.UTC(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2)) : new Date(r3[1], i2, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2);
            }
          }
          return new Date(e3);
        }(t3), this.$x = t3.x || {}, this.init();
      }, m3.init = function() {
        var t3 = this.$d;
        this.$y = t3.getFullYear(), this.$M = t3.getMonth(), this.$D = t3.getDate(), this.$W = t3.getDay(), this.$H = t3.getHours(), this.$m = t3.getMinutes(), this.$s = t3.getSeconds(), this.$ms = t3.getMilliseconds();
      }, m3.$utils = function() {
        return O2;
      }, m3.isValid = function() {
        return !(this.$d.toString() === l);
      }, m3.isSame = function(t3, e3) {
        var n3 = w2(t3);
        return this.startOf(e3) <= n3 && n3 <= this.endOf(e3);
      }, m3.isAfter = function(t3, e3) {
        return w2(t3) < this.startOf(e3);
      }, m3.isBefore = function(t3, e3) {
        return this.endOf(e3) < w2(t3);
      }, m3.$g = function(t3, e3, n3) {
        return O2.u(t3) ? this[e3] : this.set(n3, t3);
      }, m3.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m3.valueOf = function() {
        return this.$d.getTime();
      }, m3.startOf = function(t3, e3) {
        var n3 = this, r3 = !!O2.u(e3) || e3, h3 = O2.p(t3), l2 = function(t4, e4) {
          var i2 = O2.w(n3.$u ? Date.UTC(n3.$y, e4, t4) : new Date(n3.$y, e4, t4), n3);
          return r3 ? i2 : i2.endOf(a2);
        }, $3 = function(t4, e4) {
          return O2.w(n3.toDate()[t4].apply(n3.toDate("s"), (r3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e4)), n3);
        }, y3 = this.$W, M4 = this.$M, m4 = this.$D, v3 = "set" + (this.$u ? "UTC" : "");
        switch (h3) {
          case c:
            return r3 ? l2(1, 0) : l2(31, 11);
          case f2:
            return r3 ? l2(1, M4) : l2(0, M4 + 1);
          case o2:
            var g3 = this.$locale().weekStart || 0, D2 = (y3 < g3 ? y3 + 7 : y3) - g3;
            return l2(r3 ? m4 - D2 : m4 + (6 - D2), M4);
          case a2:
          case d:
            return $3(v3 + "Hours", 0);
          case u2:
            return $3(v3 + "Minutes", 1);
          case s:
            return $3(v3 + "Seconds", 2);
          case i:
            return $3(v3 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m3.endOf = function(t3) {
        return this.startOf(t3, false);
      }, m3.$set = function(t3, e3) {
        var n3, o3 = O2.p(t3), h3 = "set" + (this.$u ? "UTC" : ""), l2 = (n3 = {}, n3[a2] = h3 + "Date", n3[d] = h3 + "Date", n3[f2] = h3 + "Month", n3[c] = h3 + "FullYear", n3[u2] = h3 + "Hours", n3[s] = h3 + "Minutes", n3[i] = h3 + "Seconds", n3[r2] = h3 + "Milliseconds", n3)[o3], $3 = o3 === a2 ? this.$D + (e3 - this.$W) : e3;
        if (o3 === f2 || o3 === c) {
          var y3 = this.clone().set(d, 1);
          y3.$d[l2]($3), y3.init(), this.$d = y3.set(d, Math.min(this.$D, y3.daysInMonth())).$d;
        } else
          l2 && this.$d[l2]($3);
        return this.init(), this;
      }, m3.set = function(t3, e3) {
        return this.clone().$set(t3, e3);
      }, m3.get = function(t3) {
        return this[O2.p(t3)]();
      }, m3.add = function(r3, h3) {
        var d2, l2 = this;
        r3 = Number(r3);
        var $3 = O2.p(h3), y3 = function(t3) {
          var e3 = w2(l2);
          return O2.w(e3.date(e3.date() + Math.round(t3 * r3)), l2);
        };
        if ($3 === f2)
          return this.set(f2, this.$M + r3);
        if ($3 === c)
          return this.set(c, this.$y + r3);
        if ($3 === a2)
          return y3(1);
        if ($3 === o2)
          return y3(7);
        var M4 = (d2 = {}, d2[s] = e2, d2[u2] = n2, d2[i] = t2, d2)[$3] || 1, m4 = this.$d.getTime() + r3 * M4;
        return O2.w(m4, this);
      }, m3.subtract = function(t3, e3) {
        return this.add(-1 * t3, e3);
      }, m3.format = function(t3) {
        var e3 = this, n3 = this.$locale();
        if (!this.isValid())
          return n3.invalidDate || l;
        var r3 = t3 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O2.z(this), s2 = this.$H, u3 = this.$m, a3 = this.$M, o3 = n3.weekdays, f3 = n3.months, h3 = function(t4, n4, i3, s3) {
          return t4 && (t4[n4] || t4(e3, r3)) || i3[n4].slice(0, s3);
        }, c2 = function(t4) {
          return O2.s(s2 % 12 || 12, t4, "0");
        }, d2 = n3.meridiem || function(t4, e4, n4) {
          var r4 = t4 < 12 ? "AM" : "PM";
          return n4 ? r4.toLowerCase() : r4;
        }, $3 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a3 + 1, MM: O2.s(a3 + 1, 2, "0"), MMM: h3(n3.monthsShort, a3, f3, 3), MMMM: h3(f3, a3), D: this.$D, DD: O2.s(this.$D, 2, "0"), d: String(this.$W), dd: h3(n3.weekdaysMin, this.$W, o3, 2), ddd: h3(n3.weekdaysShort, this.$W, o3, 3), dddd: o3[this.$W], H: String(s2), HH: O2.s(s2, 2, "0"), h: c2(1), hh: c2(2), a: d2(s2, u3, true), A: d2(s2, u3, false), m: String(u3), mm: O2.s(u3, 2, "0"), s: String(this.$s), ss: O2.s(this.$s, 2, "0"), SSS: O2.s(this.$ms, 3, "0"), Z: i2 };
        return r3.replace(y2, function(t4, e4) {
          return e4 || $3[t4] || i2.replace(":", "");
        });
      }, m3.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m3.diff = function(r3, d2, l2) {
        var $3, y3 = O2.p(d2), M4 = w2(r3), m4 = (M4.utcOffset() - this.utcOffset()) * e2, v3 = this - M4, g3 = O2.m(this, M4);
        return g3 = ($3 = {}, $3[c] = g3 / 12, $3[f2] = g3, $3[h2] = g3 / 3, $3[o2] = (v3 - m4) / 6048e5, $3[a2] = (v3 - m4) / 864e5, $3[u2] = v3 / n2, $3[s] = v3 / e2, $3[i] = v3 / t2, $3)[y3] || v3, l2 ? g3 : O2.a(g3);
      }, m3.daysInMonth = function() {
        return this.endOf(f2).$D;
      }, m3.$locale = function() {
        return D[this.$L];
      }, m3.locale = function(t3, e3) {
        if (!t3)
          return this.$L;
        var n3 = this.clone(), r3 = S(t3, e3, true);
        return r3 && (n3.$L = r3), n3;
      }, m3.clone = function() {
        return O2.w(this.$d, this);
      }, m3.toDate = function() {
        return new Date(this.valueOf());
      }, m3.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m3.toISOString = function() {
        return this.$d.toISOString();
      }, m3.toString = function() {
        return this.$d.toUTCString();
      }, M3;
    }(), T2 = _2.prototype;
    return w2.prototype = T2, [["$ms", r2], ["$s", i], ["$m", s], ["$H", u2], ["$W", a2], ["$M", f2], ["$y", c], ["$D", d]].forEach(function(t3) {
      T2[t3[1]] = function(e3) {
        return this.$g(e3, t3[0], t3[1]);
      };
    }), w2.extend = function(t3, e3) {
      return t3.$i || (t3(e3, _2, w2), t3.$i = true), w2;
    }, w2.locale = S, w2.isDayjs = p2, w2.unix = function(t3) {
      return w2(1e3 * t3);
    }, w2.en = D[g2], w2.Ls = D, w2.p = {}, w2;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
const _sfc_main$5 = defineComponent({
  name: "Validated String",
  props: {
    modelValue: {
      type: String
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { t: t2 } = useLocale();
    const reactiveValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        context.emit("update:modelValue", newValue);
      }
    });
    const errorMessage = ref("");
    function validate() {
      var _a;
      errorMessage.value = "";
      if (props.required && props.modelValue === void 0) {
        errorMessage.value = t2("required");
        return false;
      }
      const validDate = !props.modelValue || dayjs((_a = props.modelValue) != null ? _a : "", "YYYY-DD-MM").isValid();
      if (!validDate) {
        errorMessage.value = t2("invalid-date");
      }
      return validDate;
    }
    return {
      reactiveValue,
      validate,
      errorMessage
    };
  }
});
const _hoisted_1$5 = { class: "validated-field" };
const _hoisted_2$5 = { class: "label" };
const _hoisted_3$4 = {
  key: 0,
  class: "input short",
  part: "input short",
  style: { "width": "100%" },
  value: "N/A",
  readonly: ""
};
const _hoisted_4$3 = ["placeholder", "readonly"];
const _hoisted_5$3 = { class: "error-message" };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    createBaseVNode("div", _hoisted_2$5, toDisplayString$1(_ctx.label), 1),
    _ctx.readonly && !_ctx.modelValue ? (openBlock(), createElementBlock("input", _hoisted_3$4)) : withDirectives((openBlock(), createElementBlock("input", {
      key: 1,
      class: normalizeClass(["input short", { "is-danger": _ctx.errorMessage }]),
      part: "input short",
      style: { "width": "100%" },
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.reactiveValue = $event),
      onInput: _cache[1] || (_cache[1] = ($event) => _ctx.errorMessage = ""),
      readonly: _ctx.readonly
    }, null, 42, _hoisted_4$3)), [
      [vModelText, _ctx.reactiveValue]
    ]),
    createBaseVNode("div", _hoisted_5$3, toDisplayString$1(_ctx.errorMessage), 1)
  ]);
}
var ValidatedDate = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
const _sfc_main$4 = defineComponent({
  name: "Validated String",
  components: {
    Checkbox
  },
  props: {
    modelValue: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const reactiveValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        context.emit("update:modelValue", newValue);
      }
    });
    function validate() {
      return true;
    }
    return {
      reactiveValue,
      validate
    };
  }
});
const _hoisted_1$4 = { class: "validated-field" };
const _hoisted_2$4 = { class: "label" };
const _hoisted_3$3 = /* @__PURE__ */ createBaseVNode("div", { class: "error-message" }, null, -1);
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox = resolveComponent("checkbox");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createBaseVNode("div", _hoisted_2$4, toDisplayString$1(_ctx.label), 1),
    createVNode(_component_checkbox, {
      modelValue: _ctx.reactiveValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.reactiveValue = $event),
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _hoisted_3$3
  ]);
}
var ValidatedBoolean = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
function isEmail(email2) {
  const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegEx.test(email2);
}
const _sfc_main$3 = defineComponent({
  name: "Validated String",
  props: {
    modelValue: {
      type: String
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { t: t2 } = useLocale();
    const reactiveValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        context.emit("update:modelValue", newValue);
      }
    });
    const errorMessage = ref("");
    function validate() {
      var _a, _b, _c;
      errorMessage.value = "";
      if (props.required && props.modelValue === void 0) {
        errorMessage.value = t2("required");
        return false;
      }
      const validLength = ((_b = (_a = props.modelValue) == null ? void 0 : _a.length) != null ? _b : 0) < 64;
      if (!validLength) {
        errorMessage.value = t2("64-letters-max");
        return false;
      }
      const validEmail = !props.modelValue || isEmail((_c = props.modelValue) != null ? _c : "");
      if (!validEmail) {
        errorMessage.value = t2("invalid-email");
      }
      return validEmail;
    }
    return {
      reactiveValue,
      validate,
      errorMessage
    };
  }
});
const _hoisted_1$3 = { class: "validated-field" };
const _hoisted_2$3 = { class: "label" };
const _hoisted_3$2 = {
  key: 0,
  class: "input short",
  part: "input short",
  style: { "width": "100%" },
  value: "N/A",
  readonly: ""
};
const _hoisted_4$2 = ["placeholder", "readonly"];
const _hoisted_5$2 = { class: "error-message" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    createBaseVNode("div", _hoisted_2$3, toDisplayString$1(_ctx.label), 1),
    _ctx.readonly && !_ctx.modelValue ? (openBlock(), createElementBlock("input", _hoisted_3$2)) : withDirectives((openBlock(), createElementBlock("input", {
      key: 1,
      class: normalizeClass(["input short", { "is-danger": _ctx.errorMessage }]),
      part: "input short",
      style: { "width": "100%" },
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.reactiveValue = $event),
      onInput: _cache[1] || (_cache[1] = ($event) => _ctx.errorMessage = ""),
      readonly: _ctx.readonly,
      autocomplete: "email",
      inputmode: "email"
    }, null, 42, _hoisted_4$2)), [
      [vModelText, _ctx.reactiveValue]
    ]),
    createBaseVNode("div", _hoisted_5$2, toDisplayString$1(_ctx.errorMessage), 1)
  ]);
}
var ValidatedEmail = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const _sfc_main$2 = defineComponent({
  name: "Validated Integer",
  props: {
    modelValue: {
      type: Number
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { t: t2 } = useLocale();
    const reactiveValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        if (typeof newValue !== "number") {
          context.emit("update:modelValue", 0);
          return;
        }
        context.emit("update:modelValue", newValue);
      }
    });
    const errorMessage = ref("");
    function validate() {
      errorMessage.value = "";
      if (props.required && props.modelValue === void 0) {
        errorMessage.value = t2("required");
        return false;
      }
      const validInt = !props.modelValue || Number.isInteger(props.modelValue);
      if (!validInt) {
        errorMessage.value = t2("no-decimals");
      }
      return validInt;
    }
    function isInteger(event) {
      if (!/\d/.test(event.key) && event.key !== "-") {
        return event.preventDefault();
      }
    }
    return {
      reactiveValue,
      validate,
      errorMessage,
      isInteger
    };
  }
});
const _hoisted_1$2 = { class: "validated-field" };
const _hoisted_2$2 = { class: "label" };
const _hoisted_3$1 = {
  key: 0,
  class: "input short",
  part: "input short",
  style: { "width": "100%" },
  value: "N/A",
  readonly: ""
};
const _hoisted_4$1 = ["placeholder", "readonly"];
const _hoisted_5$1 = { class: "error-message" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createBaseVNode("div", _hoisted_2$2, toDisplayString$1(_ctx.label), 1),
    _ctx.readonly && !_ctx.modelValue ? (openBlock(), createElementBlock("input", _hoisted_3$1)) : withDirectives((openBlock(), createElementBlock("input", {
      key: 1,
      class: normalizeClass(["input short", { "is-danger": _ctx.errorMessage }]),
      part: "input short",
      style: { "width": "100%" },
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.reactiveValue = $event),
      onInput: _cache[1] || (_cache[1] = ($event) => _ctx.errorMessage = ""),
      readonly: _ctx.readonly,
      type: "number",
      inputmode: "decimal",
      autocomplete: "decimal",
      step: "1",
      pattern: "^[-/d]/d*$",
      onKeypress: _cache[2] || (_cache[2] = ($event) => _ctx.isInteger($event))
    }, null, 42, _hoisted_4$1)), [
      [
        vModelText,
        _ctx.reactiveValue,
        void 0,
        { number: true }
      ]
    ]),
    createBaseVNode("div", _hoisted_5$1, toDisplayString$1(_ctx.errorMessage), 1)
  ]);
}
var ValidatedInteger = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const _sfc_main$1 = defineComponent({
  name: "Validated String",
  props: {
    modelValue: {
      type: String
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { t: t2 } = useLocale();
    const reactiveValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        context.emit("update:modelValue", newValue);
      }
    });
    const errorMessage = ref("");
    function validate() {
      var _a;
      errorMessage.value = "";
      if (props.required && props.modelValue === void 0) {
        errorMessage.value = t2("required");
        return false;
      }
      const isValidPhone = !props.modelValue || ((_a = phoneInput == null ? void 0 : phoneInput.isValidNumber()) != null ? _a : false);
      if (!isValidPhone) {
        errorMessage.value = t2("invalid-phone");
      } else {
        const number2 = phoneInput == null ? void 0 : phoneInput.getNumber();
        if (number2) {
          context.emit("update:modelValue", phoneInput == null ? void 0 : phoneInput.getNumber());
        }
      }
      return isValidPhone;
    }
    const phoneInputBox = ref();
    const controlContainer = ref();
    const { defaultCountryCode: defaultCountryCode2 } = useDefaultCountryCode();
    let phoneInput;
    function showCountryCode() {
      var _a;
      phoneInput = intlTelInput(phoneInputBox.value, {
        initialCountry: (_a = phoneInput == null ? void 0 : phoneInput.getSelectedCountryData().iso2) != null ? _a : defaultCountryCode2.value,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        dropdownContainer: controlContainer.value
      });
    }
    function hideCountryCode() {
      if (phoneInput === void 0) {
        return;
      }
      phoneInput.destroy();
      phoneInput = void 0;
    }
    onMounted(() => {
      if (!props.readonly) {
        showCountryCode();
      }
    });
    watch(
      () => props.readonly,
      () => {
        if (!props.readonly) {
          showCountryCode();
        } else {
          hideCountryCode();
        }
      }
    );
    return {
      reactiveValue,
      validate,
      errorMessage,
      phoneInputBox,
      controlContainer
    };
  }
});
const _hoisted_1$1 = { class: "validated-field" };
const _hoisted_2$1 = { class: "label" };
const _hoisted_3 = {
  class: "input short",
  part: "input short",
  style: { "width": "100%" },
  value: "N/A",
  readonly: ""
};
const _hoisted_4 = ["placeholder", "readonly"];
const _hoisted_5 = {
  ref: "controlContainer",
  style: { "width": "100%" }
};
const _hoisted_6 = { class: "error-message" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    createBaseVNode("div", _hoisted_2$1, toDisplayString$1(_ctx.label), 1),
    withDirectives(createBaseVNode("input", _hoisted_3, null, 512), [
      [vShow, _ctx.readonly && !_ctx.modelValue]
    ]),
    withDirectives(createBaseVNode("input", {
      class: normalizeClass(["input short", { "is-danger": _ctx.errorMessage }]),
      part: "input short",
      style: { "width": "100%" },
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.reactiveValue = $event),
      onInput: _cache[1] || (_cache[1] = ($event) => _ctx.errorMessage = ""),
      readonly: _ctx.readonly,
      autocomplete: "tel",
      inputmode: "tel",
      ref: "phoneInputBox"
    }, null, 42, _hoisted_4), [
      [vShow, !_ctx.readonly || _ctx.modelValue],
      [vModelText, _ctx.reactiveValue]
    ]),
    withDirectives(createBaseVNode("div", _hoisted_5, null, 512), [
      [vShow, !_ctx.readonly || _ctx.modelValue]
    ]),
    createBaseVNode("div", _hoisted_6, toDisplayString$1(_ctx.errorMessage), 1)
  ]);
}
var ValidatedPhone = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
var LayoutType = /* @__PURE__ */ ((LayoutType2) => {
  LayoutType2["Registration"] = "registration";
  LayoutType2["Profile"] = "profile";
  return LayoutType2;
})(LayoutType || {});
const _sfc_main = defineComponent({
  name: "User Metadata",
  components: {
    Checkbox,
    ValidatedString,
    ValidatedDate,
    ValidatedBoolean,
    ValidatedEmail,
    ValidatedInteger,
    ValidatedPhone
  },
  props: {
    appInfo: {
      type: Object,
      required: true
    },
    layoutType: {
      type: String,
      required: true
    },
    userMetadata: {
      type: Object,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { t: t2 } = useLocale();
    const layout = computed(() => {
      return props.layoutType === "registration" ? props.appInfo.layouts.registration : props.appInfo.layouts.profile;
    });
    const schema = computed(() => {
      return props.appInfo.user_metadata_schema;
    });
    const items = computed(() => {
      return layout.value.map((layout2) => {
        const foundSchema = schema.value.find((schema2) => schema2.id === layout2.id);
        return __spreadProps(__spreadValues(__spreadValues({}, layout2), foundSchema), {
          placeholder: getPlaceholder(foundSchema),
          component: getComponent(foundSchema)
        });
      });
    });
    function getPlaceholder(schema2) {
      if (schema2 === void 0) {
        return "";
      }
      switch (schema2.type) {
        case Y.STRING:
          return t2("enter-schema-friendly_name", [schema2.friendly_name.toLowerCase()]);
        case Y.BOOLEAN:
          return "";
        case Y.INTEGER:
          return "0";
        case Y.DATE:
          return "MM/DD/YYYY";
        case Y.PHONE:
          return t2("placeholder-phone-number");
        case Y.EMAIL:
          return "example@email.com";
      }
    }
    function getComponent(schema2) {
      if (schema2 === void 0) {
        return "ValidatedString";
      }
      switch (schema2.type) {
        case Y.STRING:
          return "ValidatedString";
        case Y.BOOLEAN:
          return "ValidatedBoolean";
        case Y.INTEGER:
          return "ValidatedInteger";
        case Y.DATE:
          return "ValidatedDate";
        case Y.PHONE:
          return "ValidatedPhone";
        case Y.EMAIL:
          return "ValidatedEmail";
      }
    }
    const resizeObserver = new ResizeObserver(() => {
      grid.onParentResize();
    });
    let grid;
    const gridContainer = ref();
    onMounted(() => {
      if (!gridContainer.value) {
        return;
      }
      grid = gridstack.GridStack.init(
        {
          acceptWidgets: true,
          minRow: 1,
          cellHeight: "75px",
          minWidth: 400,
          column: 6,
          margin: "0px 10px",
          resizable: {
            handles: "e,w"
          },
          staticGrid: true
        },
        gridContainer.value
      );
      resizeObserver.observe(gridContainer.value);
    });
    const inputComponents = [];
    function setRef2(component) {
      if (component) {
        inputComponents.push(component);
      }
    }
    function validate() {
      let allValid = true;
      inputComponents.forEach((component) => {
        const isValid = component.validate();
        if (!isValid) {
          allValid = false;
        }
      });
      return allValid;
    }
    return {
      layout,
      schema,
      items,
      gridContainer,
      setRef: setRef2,
      validate,
      LayoutType
    };
  }
});
const _hoisted_1 = ["id", "gs-id", "gs-x", "gs-y", "gs-w", "gs-h"];
const _hoisted_2 = { class: "grid-stack-item-content" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["grid-stack", { profile: _ctx.layoutType === _ctx.LayoutType.Profile, register: _ctx.layoutType === _ctx.LayoutType.Registration }]),
    ref: "gridContainer"
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
      return openBlock(), createElementBlock("div", {
        id: item.id,
        class: "grid-stack-item",
        key: item.id,
        "gs-id": item.id,
        "gs-x": item.x,
        "gs-y": item.y,
        "gs-w": item.w,
        "gs-h": item.h
      }, [
        createBaseVNode("div", _hoisted_2, [
          (openBlock(), createBlock(resolveDynamicComponent(item.component), {
            label: item.friendly_name,
            placeholder: item.placeholder,
            required: _ctx.layoutType === _ctx.LayoutType.Registration,
            modelValue: _ctx.userMetadata[item.field_name],
            "onUpdate:modelValue": ($event) => _ctx.userMetadata[item.field_name] = $event,
            ref_for: true,
            ref: _ctx.setRef,
            readonly: !_ctx.isEditing
          }, null, 8, ["label", "placeholder", "required", "modelValue", "onUpdate:modelValue", "readonly"]))
        ])
      ], 8, _hoisted_1);
    }), 128))
  ], 2);
}
var UserMetadata = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
function transformMetadata(metadata, schema, defaultBooleans = false) {
  const transformedMetadata = __spreadValues({}, metadata);
  schema.forEach((schema2) => {
    const metadataValue = transformedMetadata[schema2.field_name];
    if (schema2.type === Y.DATE && metadataValue) {
      transformedMetadata[schema2.field_name] = dayjs(metadataValue).format("YYYY-MM-DD");
    }
    if (defaultBooleans && schema2.type === Y.BOOLEAN && metadataValue === void 0) {
      transformedMetadata[schema2.field_name] = false;
    }
  });
  return transformedMetadata;
}
function useUpdateUser(appID) {
  const { t: t2 } = useLocale();
  const passage = new q(appID);
  const passageUser = passage.getCurrentUser();
  const updateInfoMessage = ref("");
  const updateEmailError = ref("");
  const updatePhoneError = ref("");
  const updateMetadataError = ref("");
  const updatePending = ref(false);
  const identifierExists = (identifier) => __async(this, null, function* () {
    updatePending.value = true;
    const existingUser = yield passage.identifierExists(identifier);
    updatePending.value = false;
    if (existingUser) {
      return false;
    }
    return true;
  });
  const changeEmailRequest = (newEmail) => __async(this, null, function* () {
    updatePending.value = true;
    try {
      yield passageUser.changeEmail(newEmail);
      if (newEmail) {
        updateInfoMessage.value = updateInfoMessage.value = t2("weve-sent-confirmation-email");
      }
    } catch (e2) {
      updateEmailError.value = newEmail === "" ? t2("your-account-must-have-either-an-email-or-a-phone") : t2("failed-to-update-email");
    } finally {
      updatePending.value = false;
    }
  });
  const changePhoneRequest = (newPhone) => __async(this, null, function* () {
    updatePending.value = true;
    try {
      yield passageUser.changePhone(newPhone);
      if (newPhone) {
        updateInfoMessage.value = t2("weve-sent-confirmation-text");
      }
    } catch (e2) {
      updatePhoneError.value = newPhone === "" ? t2("your-account-must-have-either-an-email-or-a-phone") : t2("failed-to-update-phone");
    } finally {
      updatePending.value = false;
    }
  });
  const updateMetadata = (newMetadata, schema) => __async(this, null, function* () {
    updatePending.value = true;
    try {
      const transformedMetadata = transformMetadata(newMetadata, schema);
      yield passageUser.updateMetadata(transformedMetadata);
      return true;
    } catch (e2) {
      updateMetadataError.value = t2("failed-to-update-metadata");
      return false;
    } finally {
      updatePending.value = false;
    }
  });
  return {
    changeEmailRequest,
    updateEmailError,
    changePhoneRequest,
    updatePhoneError,
    updatePending,
    updateInfoMessage,
    identifierExists,
    updateMetadata,
    updateMetadataError
  };
}
var appStyles = ':root .grid-stack-item>.ui-resizable-handle{filter:none}.grid-stack{position:relative}.grid-stack.grid-stack-rtl{direction:ltr}.grid-stack.grid-stack-rtl>.grid-stack-item{direction:rtl}.grid-stack .grid-stack-placeholder>.placeholder-content{border:1px dashed #d3d3d3;margin:0;position:absolute;width:auto;z-index:0!important;text-align:center}.grid-stack>.grid-stack-item{min-width:8.3333333333%;position:absolute;padding:0}.grid-stack>.grid-stack-item>.grid-stack-item-content{margin:0;position:absolute;width:auto;overflow-x:hidden;overflow-y:auto}.grid-stack>.grid-stack-item>.ui-resizable-handle{position:absolute;font-size:.1px;display:block;-ms-touch-action:none;touch-action:none}.grid-stack>.grid-stack-item.ui-resizable-autohide>.ui-resizable-handle,.grid-stack>.grid-stack-item.ui-resizable-disabled>.ui-resizable-handle{display:none}.grid-stack>.grid-stack-item.ui-draggable-dragging,.grid-stack>.grid-stack-item.ui-resizable-resizing{z-index:100}.grid-stack>.grid-stack-item.ui-draggable-dragging>.grid-stack-item-content,.grid-stack>.grid-stack-item.ui-resizable-resizing>.grid-stack-item-content{box-shadow:1px 4px 6px #0003;opacity:.8}.grid-stack>.grid-stack-item>.ui-resizable-se,.grid-stack>.grid-stack-item>.ui-resizable-sw{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDUxMS42MjYgNTExLjYyNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTExLjYyNiA1MTEuNjI3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTMyOC45MDYsNDAxLjk5NGgtMzYuNTUzVjEwOS42MzZoMzYuNTUzYzQuOTQ4LDAsOS4yMzYtMS44MDksMTIuODQ3LTUuNDI2YzMuNjEzLTMuNjE1LDUuNDIxLTcuODk4LDUuNDIxLTEyLjg0NSAgIGMwLTQuOTQ5LTEuODAxLTkuMjMxLTUuNDI4LTEyLjg1MWwtNzMuMDg3LTczLjA5QzI2NS4wNDQsMS44MDksMjYwLjc2LDAsMjU1LjgxMywwYy00Ljk0OCwwLTkuMjI5LDEuODA5LTEyLjg0Nyw1LjQyNCAgIGwtNzMuMDg4LDczLjA5Yy0zLjYxOCwzLjYxOS01LjQyNCw3LjkwMi01LjQyNCwxMi44NTFjMCw0Ljk0NiwxLjgwNyw5LjIyOSw1LjQyNCwxMi44NDVjMy42MTksMy42MTcsNy45MDEsNS40MjYsMTIuODUsNS40MjYgICBoMzYuNTQ1djI5Mi4zNThoLTM2LjU0MmMtNC45NTIsMC05LjIzNSwxLjgwOC0xMi44NSw1LjQyMWMtMy42MTcsMy42MjEtNS40MjQsNy45MDUtNS40MjQsMTIuODU0ICAgYzAsNC45NDUsMS44MDcsOS4yMjcsNS40MjQsMTIuODQ3bDczLjA4OSw3My4wODhjMy42MTcsMy42MTcsNy44OTgsNS40MjQsMTIuODQ3LDUuNDI0YzQuOTUsMCw5LjIzNC0xLjgwNywxMi44NDktNS40MjQgICBsNzMuMDg3LTczLjA4OGMzLjYxMy0zLjYyLDUuNDIxLTcuOTAxLDUuNDIxLTEyLjg0N2MwLTQuOTQ4LTEuODA4LTkuMjMyLTUuNDIxLTEyLjg1NCAgIEMzMzguMTQyLDQwMy44MDIsMzMzLjg1Nyw0MDEuOTk0LDMyOC45MDYsNDAxLjk5NHoiIGZpbGw9IiM2NjY2NjYiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K);background-repeat:no-repeat;background-position:center;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg)}.grid-stack>.grid-stack-item>.ui-resizable-se{-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-ms-transform:rotate(-45deg);-o-transform:rotate(-45deg);transform:rotate(-45deg)}.grid-stack>.grid-stack-item>.ui-resizable-nw{cursor:nw-resize;width:20px;height:20px;top:0}.grid-stack>.grid-stack-item>.ui-resizable-n{cursor:n-resize;height:10px;top:0;left:25px;right:25px}.grid-stack>.grid-stack-item>.ui-resizable-ne{cursor:ne-resize;width:20px;height:20px;top:0}.grid-stack>.grid-stack-item>.ui-resizable-e{cursor:e-resize;width:10px;top:15px;bottom:15px}.grid-stack>.grid-stack-item>.ui-resizable-se{cursor:se-resize;width:20px;height:20px}.grid-stack>.grid-stack-item>.ui-resizable-s{cursor:s-resize;height:10px;left:25px;bottom:0;right:25px}.grid-stack>.grid-stack-item>.ui-resizable-sw{cursor:sw-resize;width:20px;height:20px}.grid-stack>.grid-stack-item>.ui-resizable-w{cursor:w-resize;width:10px;top:15px;bottom:15px}.grid-stack>.grid-stack-item.ui-draggable-dragging>.ui-resizable-handle{display:none!important}.grid-stack>.grid-stack-item[gs-w="0"]{width:0%}.grid-stack>.grid-stack-item[gs-x="0"]{left:0}.grid-stack>.grid-stack-item[gs-min-w="0"]{min-width:0}.grid-stack>.grid-stack-item[gs-max-w="0"]{max-width:0%}.grid-stack>.grid-stack-item[gs-w="1"]{width:8.3333333333%}.grid-stack>.grid-stack-item[gs-x="1"]{left:8.3333333333%}.grid-stack>.grid-stack-item[gs-min-w="1"]{min-width:8.3333333333%}.grid-stack>.grid-stack-item[gs-max-w="1"]{max-width:8.3333333333%}.grid-stack>.grid-stack-item[gs-w="2"]{width:16.6666666667%}.grid-stack>.grid-stack-item[gs-x="2"]{left:16.6666666667%}.grid-stack>.grid-stack-item[gs-min-w="2"]{min-width:16.6666666667%}.grid-stack>.grid-stack-item[gs-max-w="2"]{max-width:16.6666666667%}.grid-stack>.grid-stack-item[gs-w="3"]{width:25%}.grid-stack>.grid-stack-item[gs-x="3"]{left:25%}.grid-stack>.grid-stack-item[gs-min-w="3"]{min-width:25%}.grid-stack>.grid-stack-item[gs-max-w="3"]{max-width:25%}.grid-stack>.grid-stack-item[gs-w="4"]{width:33.3333333333%}.grid-stack>.grid-stack-item[gs-x="4"]{left:33.3333333333%}.grid-stack>.grid-stack-item[gs-min-w="4"]{min-width:33.3333333333%}.grid-stack>.grid-stack-item[gs-max-w="4"]{max-width:33.3333333333%}.grid-stack>.grid-stack-item[gs-w="5"]{width:41.6666666667%}.grid-stack>.grid-stack-item[gs-x="5"]{left:41.6666666667%}.grid-stack>.grid-stack-item[gs-min-w="5"]{min-width:41.6666666667%}.grid-stack>.grid-stack-item[gs-max-w="5"]{max-width:41.6666666667%}.grid-stack>.grid-stack-item[gs-w="6"]{width:50%}.grid-stack>.grid-stack-item[gs-x="6"]{left:50%}.grid-stack>.grid-stack-item[gs-min-w="6"]{min-width:50%}.grid-stack>.grid-stack-item[gs-max-w="6"]{max-width:50%}.grid-stack>.grid-stack-item[gs-w="7"]{width:58.3333333333%}.grid-stack>.grid-stack-item[gs-x="7"]{left:58.3333333333%}.grid-stack>.grid-stack-item[gs-min-w="7"]{min-width:58.3333333333%}.grid-stack>.grid-stack-item[gs-max-w="7"]{max-width:58.3333333333%}.grid-stack>.grid-stack-item[gs-w="8"]{width:66.6666666667%}.grid-stack>.grid-stack-item[gs-x="8"]{left:66.6666666667%}.grid-stack>.grid-stack-item[gs-min-w="8"]{min-width:66.6666666667%}.grid-stack>.grid-stack-item[gs-max-w="8"]{max-width:66.6666666667%}.grid-stack>.grid-stack-item[gs-w="9"]{width:75%}.grid-stack>.grid-stack-item[gs-x="9"]{left:75%}.grid-stack>.grid-stack-item[gs-min-w="9"]{min-width:75%}.grid-stack>.grid-stack-item[gs-max-w="9"]{max-width:75%}.grid-stack>.grid-stack-item[gs-w="10"]{width:83.3333333333%}.grid-stack>.grid-stack-item[gs-x="10"]{left:83.3333333333%}.grid-stack>.grid-stack-item[gs-min-w="10"]{min-width:83.3333333333%}.grid-stack>.grid-stack-item[gs-max-w="10"]{max-width:83.3333333333%}.grid-stack>.grid-stack-item[gs-w="11"]{width:91.6666666667%}.grid-stack>.grid-stack-item[gs-x="11"]{left:91.6666666667%}.grid-stack>.grid-stack-item[gs-min-w="11"]{min-width:91.6666666667%}.grid-stack>.grid-stack-item[gs-max-w="11"]{max-width:91.6666666667%}.grid-stack>.grid-stack-item[gs-w="12"]{width:100%}.grid-stack>.grid-stack-item[gs-x="12"]{left:100%}.grid-stack>.grid-stack-item[gs-min-w="12"]{min-width:100%}.grid-stack>.grid-stack-item[gs-max-w="12"]{max-width:100%}.grid-stack.grid-stack-1>.grid-stack-item{min-width:100%}.grid-stack.grid-stack-1>.grid-stack-item[gs-w="1"]{width:100%}.grid-stack.grid-stack-1>.grid-stack-item[gs-x="1"]{left:100%}.grid-stack.grid-stack-1>.grid-stack-item[gs-min-w="1"]{min-width:100%}.grid-stack.grid-stack-1>.grid-stack-item[gs-max-w="1"]{max-width:100%}.grid-stack.grid-stack-animate,.grid-stack.grid-stack-animate .grid-stack-item{-webkit-transition:left .3s,top .3s,height .3s,width .3s;-moz-transition:left .3s,top .3s,height .3s,width .3s;-ms-transition:left .3s,top .3s,height .3s,width .3s;-o-transition:left .3s,top .3s,height .3s,width .3s;transition:left .3s,top .3s,height .3s,width .3s}.grid-stack.grid-stack-animate .grid-stack-item.grid-stack-placeholder,.grid-stack.grid-stack-animate .grid-stack-item.ui-draggable-dragging,.grid-stack.grid-stack-animate .grid-stack-item.ui-resizable-resizing{-webkit-transition:left 0s,top 0s,height 0s,width 0s;-moz-transition:left 0s,top 0s,height 0s,width 0s;-ms-transition:left 0s,top 0s,height 0s,width 0s;-o-transition:left 0s,top 0s,height 0s,width 0s;transition:left 0s,top 0s,height 0s,width 0s}.grid-stack.grid-stack-2>.grid-stack-item{min-width:50%}.grid-stack.grid-stack-2>.grid-stack-item[gs-w="1"]{width:50%}.grid-stack.grid-stack-2>.grid-stack-item[gs-x="1"]{left:50%}.grid-stack.grid-stack-2>.grid-stack-item[gs-min-w="1"]{min-width:50%}.grid-stack.grid-stack-2>.grid-stack-item[gs-max-w="1"]{max-width:50%}.grid-stack.grid-stack-2>.grid-stack-item[gs-w="2"]{width:100%}.grid-stack.grid-stack-2>.grid-stack-item[gs-x="2"]{left:100%}.grid-stack.grid-stack-2>.grid-stack-item[gs-min-w="2"]{min-width:100%}.grid-stack.grid-stack-2>.grid-stack-item[gs-max-w="2"]{max-width:100%}.grid-stack.grid-stack-3>.grid-stack-item{min-width:33.3333333333%}.grid-stack.grid-stack-3>.grid-stack-item[gs-w="1"]{width:33.3333333333%}.grid-stack.grid-stack-3>.grid-stack-item[gs-x="1"]{left:33.3333333333%}.grid-stack.grid-stack-3>.grid-stack-item[gs-min-w="1"]{min-width:33.3333333333%}.grid-stack.grid-stack-3>.grid-stack-item[gs-max-w="1"]{max-width:33.3333333333%}.grid-stack.grid-stack-3>.grid-stack-item[gs-w="2"]{width:66.6666666667%}.grid-stack.grid-stack-3>.grid-stack-item[gs-x="2"]{left:66.6666666667%}.grid-stack.grid-stack-3>.grid-stack-item[gs-min-w="2"]{min-width:66.6666666667%}.grid-stack.grid-stack-3>.grid-stack-item[gs-max-w="2"]{max-width:66.6666666667%}.grid-stack.grid-stack-3>.grid-stack-item[gs-w="3"]{width:100%}.grid-stack.grid-stack-3>.grid-stack-item[gs-x="3"]{left:100%}.grid-stack.grid-stack-3>.grid-stack-item[gs-min-w="3"]{min-width:100%}.grid-stack.grid-stack-3>.grid-stack-item[gs-max-w="3"]{max-width:100%}.grid-stack.grid-stack-4>.grid-stack-item{min-width:25%}.grid-stack.grid-stack-4>.grid-stack-item[gs-w="1"]{width:25%}.grid-stack.grid-stack-4>.grid-stack-item[gs-x="1"]{left:25%}.grid-stack.grid-stack-4>.grid-stack-item[gs-min-w="1"]{min-width:25%}.grid-stack.grid-stack-4>.grid-stack-item[gs-max-w="1"]{max-width:25%}.grid-stack.grid-stack-4>.grid-stack-item[gs-w="2"]{width:50%}.grid-stack.grid-stack-4>.grid-stack-item[gs-x="2"]{left:50%}.grid-stack.grid-stack-4>.grid-stack-item[gs-min-w="2"]{min-width:50%}.grid-stack.grid-stack-4>.grid-stack-item[gs-max-w="2"]{max-width:50%}.grid-stack.grid-stack-4>.grid-stack-item[gs-w="3"]{width:75%}.grid-stack.grid-stack-4>.grid-stack-item[gs-x="3"]{left:75%}.grid-stack.grid-stack-4>.grid-stack-item[gs-min-w="3"]{min-width:75%}.grid-stack.grid-stack-4>.grid-stack-item[gs-max-w="3"]{max-width:75%}.grid-stack.grid-stack-4>.grid-stack-item[gs-w="4"]{width:100%}.grid-stack.grid-stack-4>.grid-stack-item[gs-x="4"]{left:100%}.grid-stack.grid-stack-4>.grid-stack-item[gs-min-w="4"]{min-width:100%}.grid-stack.grid-stack-4>.grid-stack-item[gs-max-w="4"]{max-width:100%}.grid-stack.grid-stack-5>.grid-stack-item{min-width:20%}.grid-stack.grid-stack-5>.grid-stack-item[gs-w="1"]{width:20%}.grid-stack.grid-stack-5>.grid-stack-item[gs-x="1"]{left:20%}.grid-stack.grid-stack-5>.grid-stack-item[gs-min-w="1"]{min-width:20%}.grid-stack.grid-stack-5>.grid-stack-item[gs-max-w="1"]{max-width:20%}.grid-stack.grid-stack-5>.grid-stack-item[gs-w="2"]{width:40%}.grid-stack.grid-stack-5>.grid-stack-item[gs-x="2"]{left:40%}.grid-stack.grid-stack-5>.grid-stack-item[gs-min-w="2"]{min-width:40%}.grid-stack.grid-stack-5>.grid-stack-item[gs-max-w="2"]{max-width:40%}.grid-stack.grid-stack-5>.grid-stack-item[gs-w="3"]{width:60%}.grid-stack.grid-stack-5>.grid-stack-item[gs-x="3"]{left:60%}.grid-stack.grid-stack-5>.grid-stack-item[gs-min-w="3"]{min-width:60%}.grid-stack.grid-stack-5>.grid-stack-item[gs-max-w="3"]{max-width:60%}.grid-stack.grid-stack-5>.grid-stack-item[gs-w="4"]{width:80%}.grid-stack.grid-stack-5>.grid-stack-item[gs-x="4"]{left:80%}.grid-stack.grid-stack-5>.grid-stack-item[gs-min-w="4"]{min-width:80%}.grid-stack.grid-stack-5>.grid-stack-item[gs-max-w="4"]{max-width:80%}.grid-stack.grid-stack-5>.grid-stack-item[gs-w="5"]{width:100%}.grid-stack.grid-stack-5>.grid-stack-item[gs-x="5"]{left:100%}.grid-stack.grid-stack-5>.grid-stack-item[gs-min-w="5"]{min-width:100%}.grid-stack.grid-stack-5>.grid-stack-item[gs-max-w="5"]{max-width:100%}.grid-stack.grid-stack-6>.grid-stack-item{min-width:16.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-w="1"]{width:16.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-x="1"]{left:16.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-min-w="1"]{min-width:16.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-max-w="1"]{max-width:16.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-w="2"]{width:33.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-x="2"]{left:33.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-min-w="2"]{min-width:33.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-max-w="2"]{max-width:33.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-w="3"]{width:50%}.grid-stack.grid-stack-6>.grid-stack-item[gs-x="3"]{left:50%}.grid-stack.grid-stack-6>.grid-stack-item[gs-min-w="3"]{min-width:50%}.grid-stack.grid-stack-6>.grid-stack-item[gs-max-w="3"]{max-width:50%}.grid-stack.grid-stack-6>.grid-stack-item[gs-w="4"]{width:66.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-x="4"]{left:66.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-min-w="4"]{min-width:66.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-max-w="4"]{max-width:66.6666666667%}.grid-stack.grid-stack-6>.grid-stack-item[gs-w="5"]{width:83.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-x="5"]{left:83.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-min-w="5"]{min-width:83.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-max-w="5"]{max-width:83.3333333333%}.grid-stack.grid-stack-6>.grid-stack-item[gs-w="6"]{width:100%}.grid-stack.grid-stack-6>.grid-stack-item[gs-x="6"]{left:100%}.grid-stack.grid-stack-6>.grid-stack-item[gs-min-w="6"]{min-width:100%}.grid-stack.grid-stack-6>.grid-stack-item[gs-max-w="6"]{max-width:100%}.grid-stack.grid-stack-7>.grid-stack-item{min-width:14.2857142857%}.grid-stack.grid-stack-7>.grid-stack-item[gs-w="1"]{width:14.2857142857%}.grid-stack.grid-stack-7>.grid-stack-item[gs-x="1"]{left:14.2857142857%}.grid-stack.grid-stack-7>.grid-stack-item[gs-min-w="1"]{min-width:14.2857142857%}.grid-stack.grid-stack-7>.grid-stack-item[gs-max-w="1"]{max-width:14.2857142857%}.grid-stack.grid-stack-7>.grid-stack-item[gs-w="2"]{width:28.5714285714%}.grid-stack.grid-stack-7>.grid-stack-item[gs-x="2"]{left:28.5714285714%}.grid-stack.grid-stack-7>.grid-stack-item[gs-min-w="2"]{min-width:28.5714285714%}.grid-stack.grid-stack-7>.grid-stack-item[gs-max-w="2"]{max-width:28.5714285714%}.grid-stack.grid-stack-7>.grid-stack-item[gs-w="3"]{width:42.8571428571%}.grid-stack.grid-stack-7>.grid-stack-item[gs-x="3"]{left:42.8571428571%}.grid-stack.grid-stack-7>.grid-stack-item[gs-min-w="3"]{min-width:42.8571428571%}.grid-stack.grid-stack-7>.grid-stack-item[gs-max-w="3"]{max-width:42.8571428571%}.grid-stack.grid-stack-7>.grid-stack-item[gs-w="4"]{width:57.1428571429%}.grid-stack.grid-stack-7>.grid-stack-item[gs-x="4"]{left:57.1428571429%}.grid-stack.grid-stack-7>.grid-stack-item[gs-min-w="4"]{min-width:57.1428571429%}.grid-stack.grid-stack-7>.grid-stack-item[gs-max-w="4"]{max-width:57.1428571429%}.grid-stack.grid-stack-7>.grid-stack-item[gs-w="5"]{width:71.4285714286%}.grid-stack.grid-stack-7>.grid-stack-item[gs-x="5"]{left:71.4285714286%}.grid-stack.grid-stack-7>.grid-stack-item[gs-min-w="5"]{min-width:71.4285714286%}.grid-stack.grid-stack-7>.grid-stack-item[gs-max-w="5"]{max-width:71.4285714286%}.grid-stack.grid-stack-7>.grid-stack-item[gs-w="6"]{width:85.7142857143%}.grid-stack.grid-stack-7>.grid-stack-item[gs-x="6"]{left:85.7142857143%}.grid-stack.grid-stack-7>.grid-stack-item[gs-min-w="6"]{min-width:85.7142857143%}.grid-stack.grid-stack-7>.grid-stack-item[gs-max-w="6"]{max-width:85.7142857143%}.grid-stack.grid-stack-7>.grid-stack-item[gs-w="7"]{width:100%}.grid-stack.grid-stack-7>.grid-stack-item[gs-x="7"]{left:100%}.grid-stack.grid-stack-7>.grid-stack-item[gs-min-w="7"]{min-width:100%}.grid-stack.grid-stack-7>.grid-stack-item[gs-max-w="7"]{max-width:100%}.grid-stack.grid-stack-8>.grid-stack-item{min-width:12.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="1"]{width:12.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="1"]{left:12.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="1"]{min-width:12.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="1"]{max-width:12.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="2"]{width:25%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="2"]{left:25%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="2"]{min-width:25%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="2"]{max-width:25%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="3"]{width:37.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="3"]{left:37.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="3"]{min-width:37.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="3"]{max-width:37.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="4"]{width:50%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="4"]{left:50%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="4"]{min-width:50%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="4"]{max-width:50%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="5"]{width:62.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="5"]{left:62.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="5"]{min-width:62.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="5"]{max-width:62.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="6"]{width:75%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="6"]{left:75%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="6"]{min-width:75%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="6"]{max-width:75%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="7"]{width:87.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="7"]{left:87.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="7"]{min-width:87.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="7"]{max-width:87.5%}.grid-stack.grid-stack-8>.grid-stack-item[gs-w="8"]{width:100%}.grid-stack.grid-stack-8>.grid-stack-item[gs-x="8"]{left:100%}.grid-stack.grid-stack-8>.grid-stack-item[gs-min-w="8"]{min-width:100%}.grid-stack.grid-stack-8>.grid-stack-item[gs-max-w="8"]{max-width:100%}.grid-stack.grid-stack-9>.grid-stack-item{min-width:11.1111111111%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="1"]{width:11.1111111111%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="1"]{left:11.1111111111%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="1"]{min-width:11.1111111111%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="1"]{max-width:11.1111111111%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="2"]{width:22.2222222222%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="2"]{left:22.2222222222%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="2"]{min-width:22.2222222222%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="2"]{max-width:22.2222222222%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="3"]{width:33.3333333333%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="3"]{left:33.3333333333%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="3"]{min-width:33.3333333333%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="3"]{max-width:33.3333333333%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="4"]{width:44.4444444444%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="4"]{left:44.4444444444%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="4"]{min-width:44.4444444444%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="4"]{max-width:44.4444444444%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="5"]{width:55.5555555556%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="5"]{left:55.5555555556%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="5"]{min-width:55.5555555556%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="5"]{max-width:55.5555555556%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="6"]{width:66.6666666667%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="6"]{left:66.6666666667%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="6"]{min-width:66.6666666667%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="6"]{max-width:66.6666666667%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="7"]{width:77.7777777778%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="7"]{left:77.7777777778%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="7"]{min-width:77.7777777778%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="7"]{max-width:77.7777777778%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="8"]{width:88.8888888889%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="8"]{left:88.8888888889%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="8"]{min-width:88.8888888889%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="8"]{max-width:88.8888888889%}.grid-stack.grid-stack-9>.grid-stack-item[gs-w="9"]{width:100%}.grid-stack.grid-stack-9>.grid-stack-item[gs-x="9"]{left:100%}.grid-stack.grid-stack-9>.grid-stack-item[gs-min-w="9"]{min-width:100%}.grid-stack.grid-stack-9>.grid-stack-item[gs-max-w="9"]{max-width:100%}.grid-stack.grid-stack-10>.grid-stack-item{min-width:10%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="1"]{width:10%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="1"]{left:10%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="1"]{min-width:10%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="1"]{max-width:10%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="2"]{width:20%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="2"]{left:20%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="2"]{min-width:20%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="2"]{max-width:20%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="3"]{width:30%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="3"]{left:30%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="3"]{min-width:30%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="3"]{max-width:30%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="4"]{width:40%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="4"]{left:40%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="4"]{min-width:40%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="4"]{max-width:40%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="5"]{width:50%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="5"]{left:50%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="5"]{min-width:50%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="5"]{max-width:50%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="6"]{width:60%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="6"]{left:60%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="6"]{min-width:60%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="6"]{max-width:60%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="7"]{width:70%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="7"]{left:70%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="7"]{min-width:70%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="7"]{max-width:70%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="8"]{width:80%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="8"]{left:80%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="8"]{min-width:80%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="8"]{max-width:80%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="9"]{width:90%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="9"]{left:90%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="9"]{min-width:90%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="9"]{max-width:90%}.grid-stack.grid-stack-10>.grid-stack-item[gs-w="10"]{width:100%}.grid-stack.grid-stack-10>.grid-stack-item[gs-x="10"]{left:100%}.grid-stack.grid-stack-10>.grid-stack-item[gs-min-w="10"]{min-width:100%}.grid-stack.grid-stack-10>.grid-stack-item[gs-max-w="10"]{max-width:100%}.grid-stack.grid-stack-11>.grid-stack-item{min-width:9.0909090909%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="1"]{width:9.0909090909%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="1"]{left:9.0909090909%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="1"]{min-width:9.0909090909%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="1"]{max-width:9.0909090909%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="2"]{width:18.1818181818%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="2"]{left:18.1818181818%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="2"]{min-width:18.1818181818%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="2"]{max-width:18.1818181818%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="3"]{width:27.2727272727%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="3"]{left:27.2727272727%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="3"]{min-width:27.2727272727%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="3"]{max-width:27.2727272727%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="4"]{width:36.3636363636%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="4"]{left:36.3636363636%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="4"]{min-width:36.3636363636%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="4"]{max-width:36.3636363636%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="5"]{width:45.4545454545%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="5"]{left:45.4545454545%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="5"]{min-width:45.4545454545%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="5"]{max-width:45.4545454545%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="6"]{width:54.5454545455%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="6"]{left:54.5454545455%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="6"]{min-width:54.5454545455%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="6"]{max-width:54.5454545455%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="7"]{width:63.6363636364%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="7"]{left:63.6363636364%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="7"]{min-width:63.6363636364%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="7"]{max-width:63.6363636364%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="8"]{width:72.7272727273%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="8"]{left:72.7272727273%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="8"]{min-width:72.7272727273%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="8"]{max-width:72.7272727273%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="9"]{width:81.8181818182%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="9"]{left:81.8181818182%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="9"]{min-width:81.8181818182%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="9"]{max-width:81.8181818182%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="10"]{width:90.9090909091%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="10"]{left:90.9090909091%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="10"]{min-width:90.9090909091%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="10"]{max-width:90.9090909091%}.grid-stack.grid-stack-11>.grid-stack-item[gs-w="11"]{width:100%}.grid-stack.grid-stack-11>.grid-stack-item[gs-x="11"]{left:100%}.grid-stack.grid-stack-11>.grid-stack-item[gs-min-w="11"]{min-width:100%}.grid-stack.grid-stack-11>.grid-stack-item[gs-max-w="11"]{max-width:100%}.p-datatable{position:relative}.p-datatable table{border-collapse:collapse;min-width:100%;table-layout:fixed}.p-datatable .p-sortable-column{cursor:pointer;user-select:none}.p-datatable .p-sortable-column .p-column-title,.p-datatable .p-sortable-column .p-sortable-column-icon,.p-datatable .p-sortable-column .p-sortable-column-badge{vertical-align:middle}.p-datatable .p-sortable-column .p-sortable-column-badge{display:inline-flex;align-items:center;justify-content:center}.p-datatable-responsive-scroll>.p-datatable-wrapper{overflow-x:auto}.p-datatable-responsive-scroll>.p-datatable-wrapper>table,.p-datatable-auto-layout>.p-datatable-wrapper>table{table-layout:auto}.p-datatable-hoverable-rows .p-selectable-row{cursor:pointer}.p-datatable-scrollable .p-datatable-wrapper{position:relative;overflow:auto}.p-datatable-scrollable .p-datatable-thead,.p-datatable-scrollable .p-datatable-tbody,.p-datatable-scrollable .p-datatable-tfoot{display:block}.p-datatable-scrollable .p-datatable-thead>tr,.p-datatable-scrollable .p-datatable-tbody>tr,.p-datatable-scrollable .p-datatable-tfoot>tr{display:flex;flex-wrap:nowrap;width:100%}.p-datatable-scrollable .p-datatable-thead>tr>th,.p-datatable-scrollable .p-datatable-tbody>tr>td,.p-datatable-scrollable .p-datatable-tfoot>tr>td{display:flex;flex:1 1 0;align-items:center}.p-datatable-scrollable .p-datatable-thead{position:sticky;top:0;z-index:1}.p-datatable-scrollable .p-datatable-frozen-tbody{position:sticky;z-index:1}.p-datatable-scrollable .p-datatable-tfoot{position:sticky;bottom:0;z-index:1}.p-datatable-scrollable .p-frozen-column{position:sticky;background:inherit}.p-datatable-scrollable th.p-frozen-column{z-index:1}.p-datatable-scrollable-both .p-datatable-thead>tr>th,.p-datatable-scrollable-both .p-datatable-tbody>tr>td,.p-datatable-scrollable-both .p-datatable-tfoot>tr>td,.p-datatable-scrollable-horizontal .p-datatable-thead>tr>th .p-datatable-scrollable-horizontal .p-datatable-tbody>tr>td,.p-datatable-scrollable-horizontal .p-datatable-tfoot>tr>td{flex:0 0 auto}.p-datatable-flex-scrollable{display:flex;flex-direction:column;height:100%}.p-datatable-flex-scrollable .p-datatable-wrapper{display:flex;flex-direction:column;flex:1;height:100%}.p-datatable-scrollable .p-rowgroup-header{position:sticky;z-index:1}.p-datatable-scrollable.p-datatable-grouped-header .p-datatable-thead,.p-datatable-scrollable.p-datatable-grouped-footer .p-datatable-tfoot{display:table;border-collapse:collapse;width:100%;table-layout:fixed}.p-datatable-scrollable.p-datatable-grouped-header .p-datatable-thead>tr,.p-datatable-scrollable.p-datatable-grouped-footer .p-datatable-tfoot>tr{display:table-row}.p-datatable-scrollable.p-datatable-grouped-header .p-datatable-thead>tr>th,.p-datatable-scrollable.p-datatable-grouped-footer .p-datatable-tfoot>tr>td{display:table-cell}.p-datatable-resizable>.p-datatable-wrapper{overflow-x:auto}.p-datatable-resizable .p-datatable-thead>tr>th,.p-datatable-resizable .p-datatable-tfoot>tr>td,.p-datatable-resizable .p-datatable-tbody>tr>td{overflow:hidden;white-space:nowrap}.p-datatable-resizable .p-resizable-column:not(.p-frozen-column){background-clip:padding-box;position:relative}.p-datatable-resizable-fit .p-resizable-column:last-child .p-column-resizer{display:none}.p-datatable .p-column-resizer{display:block;position:absolute!important;top:0;right:0;margin:0;width:.5rem;height:100%;padding:0;cursor:col-resize;border:1px solid transparent}.p-datatable .p-column-header-content{display:flex;align-items:center}.p-datatable .p-column-resizer-helper{width:1px;position:absolute;z-index:10;display:none}.p-datatable .p-row-editor-init,.p-datatable .p-row-editor-save,.p-datatable .p-row-editor-cancel,.p-datatable .p-row-toggler{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-datatable-reorder-indicator-up,.p-datatable-reorder-indicator-down{position:absolute;display:none}.p-datatable .p-datatable-loading-overlay{position:absolute;display:flex;align-items:center;justify-content:center;z-index:2}.p-column-filter-row{display:flex;align-items:center;width:100%}.p-column-filter-menu{display:inline-flex;margin-left:auto}.p-column-filter-row .p-column-filter-element{flex:1 1 auto;width:1%}.p-column-filter-menu-button,.p-column-filter-clear-button{display:inline-flex;justify-content:center;align-items:center;cursor:pointer;text-decoration:none;overflow:hidden;position:relative}.p-column-filter-overlay{position:absolute;top:0;left:0}.p-column-filter-row-items{margin:0;padding:0;list-style:none}.p-column-filter-row-item{cursor:pointer}.p-column-filter-add-button,.p-column-filter-remove-button{justify-content:center}.p-column-filter-add-button .p-button-label,.p-column-filter-remove-button .p-button-label{flex-grow:0}.p-column-filter-buttonbar{display:flex;align-items:center;justify-content:space-between}.p-column-filter-buttonbar .p-button:not(.p-button-icon-only){width:auto}.p-datatable .p-datatable-tbody>tr>td>.p-column-title{display:none}.p-datatable .p-virtualscroller-loading{transform:none!important;min-height:0;position:sticky;top:0;left:0}.p-paginator{display:flex;align-items:center;justify-content:center;flex-wrap:wrap}.p-paginator-left-content{margin-right:auto}.p-paginator-right-content{margin-left:auto}.p-paginator-page,.p-paginator-next,.p-paginator-last,.p-paginator-first,.p-paginator-prev,.p-paginator-current{cursor:pointer;display:inline-flex;align-items:center;justify-content:center;line-height:1;user-select:none;overflow:hidden;position:relative;background-color:transparent;border:0 none;min-width:2.357rem;height:2.357rem;margin:.143rem;border-radius:2px}.p-paginator-page:hover,.p-paginator-next:hover,.p-paginator-last:hover,.p-paginator-first:hover,.p-paginator-prev:hover,.p-paginator-current:hover{background:rgba(215,215,215,.3137254902)}.p-paginator-page{background-color:transparent;border:0 none;min-width:2.357rem;height:2.357rem;margin:.143rem;border-radius:2px}.p-paginator-page.p-highlight{background:rgba(215,215,215,.5647058824)}.p-paginator-page:not(.p-highlight):hover{background:rgba(215,215,215,.3137254902)}.p-paginator-element:focus{z-index:1;position:relative}.pi-sort-amount-down{display:grid;place-content:center}.pi-sort-amount-down:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9InNvcnQtYW1vdW50LWRvd24iPjxwYXRoIGQ9Ik02LjUsMTkuNzVBLjc0Ljc0LDAsMCwxLDYsMTkuNTNMMy40NywxN0EuNzUuNzUsMCwxLDEsNC41MywxNmwyLDIsMi0yQS43NS43NSwwLDEsMSw5LjUzLDE3TDcsMTkuNTNBLjc0Ljc0LDAsMCwxLDYuNSwxOS43NVoiLz48cGF0aCBkPSJNNi41LDE5Ljc1QS43Ni43NiwwLDAsMSw1Ljc1LDE5VjVhLjc1Ljc1LDAsMCwxLDEuNSwwVjE5QS43Ni43NiwwLDAsMSw2LjUsMTkuNzVaIi8+PHBhdGggZD0iTTIwLDguMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDhhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjxwYXRoIGQ9Ik0xNiwxNC4yNUgxMmEuNzUuNzUsMCwwLDEsMC0xLjVoNGEuNzUuNzUsMCwwLDEsMCwxLjVaIi8+PHBhdGggZD0iTTE0LDE3LjI1SDEyYS43NS43NSwwLDAsMSwwLTEuNWgyYS43NS43NSwwLDAsMSwwLDEuNVoiLz48cGF0aCBkPSJNMTgsMTEuMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDZhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjwvZz48L3N2Zz4=);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9InNvcnQtYW1vdW50LWRvd24iPjxwYXRoIGQ9Ik02LjUsMTkuNzVBLjc0Ljc0LDAsMCwxLDYsMTkuNTNMMy40NywxN0EuNzUuNzUsMCwxLDEsNC41MywxNmwyLDIsMi0yQS43NS43NSwwLDEsMSw5LjUzLDE3TDcsMTkuNTNBLjc0Ljc0LDAsMCwxLDYuNSwxOS43NVoiLz48cGF0aCBkPSJNNi41LDE5Ljc1QS43Ni43NiwwLDAsMSw1Ljc1LDE5VjVhLjc1Ljc1LDAsMCwxLDEuNSwwVjE5QS43Ni43NiwwLDAsMSw2LjUsMTkuNzVaIi8+PHBhdGggZD0iTTIwLDguMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDhhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjxwYXRoIGQ9Ik0xNiwxNC4yNUgxMmEuNzUuNzUsMCwwLDEsMC0xLjVoNGEuNzUuNzUsMCwwLDEsMCwxLjVaIi8+PHBhdGggZD0iTTE0LDE3LjI1SDEyYS43NS43NSwwLDAsMSwwLTEuNWgyYS43NS43NSwwLDAsMSwwLDEuNVoiLz48cGF0aCBkPSJNMTgsMTEuMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDZhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjwvZz48L3N2Zz4=);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-sort-amount-up-alt{display:grid;place-content:center}.pi-sort-amount-up-alt:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9InNvcnQtYW1vdW50LXVwLWFsdCI+PHBhdGggZD0iTTksOC4yNUEuNzQuNzQsMCwwLDEsOC40Nyw4bC0yLTItMiwyQS43NS43NSwwLDEsMSwzLjQ3LDdMNiw0LjQ3QS43NS43NSwwLDAsMSw3LDQuNDdMOS41Myw3QS43NS43NSwwLDAsMSw5LjUzLDgsLjc0Ljc0LDAsMCwxLDksOC4yNVoiLz48cGF0aCBkPSJNNi41LDE5Ljc1QS43Ni43NiwwLDAsMSw1Ljc1LDE5VjVhLjc1Ljc1LDAsMCwxLDEuNSwwVjE5QS43Ni43NiwwLDAsMSw2LjUsMTkuNzVaIi8+PHBhdGggZD0iTTIwLDE3LjI1SDEyYS43NS43NSwwLDAsMSwwLTEuNWg4YS43NS43NSwwLDAsMSwwLDEuNVoiLz48cGF0aCBkPSJNMTYsMTEuMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDRhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjxwYXRoIGQ9Ik0xNCw4LjI1SDEyYS43NS43NSwwLDAsMSwwLTEuNWgyYS43NS43NSwwLDAsMSwwLDEuNVoiLz48cGF0aCBkPSJNMTgsMTQuMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDZhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjwvZz48L3N2Zz4=);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9InNvcnQtYW1vdW50LXVwLWFsdCI+PHBhdGggZD0iTTksOC4yNUEuNzQuNzQsMCwwLDEsOC40Nyw4bC0yLTItMiwyQS43NS43NSwwLDEsMSwzLjQ3LDdMNiw0LjQ3QS43NS43NSwwLDAsMSw3LDQuNDdMOS41Myw3QS43NS43NSwwLDAsMSw5LjUzLDgsLjc0Ljc0LDAsMCwxLDksOC4yNVoiLz48cGF0aCBkPSJNNi41LDE5Ljc1QS43Ni43NiwwLDAsMSw1Ljc1LDE5VjVhLjc1Ljc1LDAsMCwxLDEuNSwwVjE5QS43Ni43NiwwLDAsMSw2LjUsMTkuNzVaIi8+PHBhdGggZD0iTTIwLDE3LjI1SDEyYS43NS43NSwwLDAsMSwwLTEuNWg4YS43NS43NSwwLDAsMSwwLDEuNVoiLz48cGF0aCBkPSJNMTYsMTEuMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDRhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjxwYXRoIGQ9Ik0xNCw4LjI1SDEyYS43NS43NSwwLDAsMSwwLTEuNWgyYS43NS43NSwwLDAsMSwwLDEuNVoiLz48cGF0aCBkPSJNMTgsMTQuMjVIMTJhLjc1Ljc1LDAsMCwxLDAtMS41aDZhLjc1Ljc1LDAsMCwxLDAsMS41WiIvPjwvZz48L3N2Zz4=);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-sort-alt{display:grid;place-content:center}.pi-sort-alt:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9InNvcnQtYWx0Ij48cGF0aCBkPSJNMTAuNSw4LjI1QS43NC43NCwwLDAsMSwxMCw4bC0yLTJMNiw4QS43NS43NSwwLDEsMSw1LDdsMi41LTIuNWEuNzUuNzUsMCwwLDEsMS4wNiwwTDExLDdBLjc1Ljc1LDAsMCwxLDExLDgsLjc0Ljc0LDAsMCwxLDEwLjUsOC4yNVoiLz48cGF0aCBkPSJNOCwxOS43NUEuNzYuNzYsMCwwLDEsNy4yNSwxOVY1YS43NS43NSwwLDAsMSwxLjUsMFYxOUEuNzYuNzYsMCwwLDEsOCwxOS43NVoiLz48cGF0aCBkPSJNMTYsMTkuNzVhLjc0Ljc0LDAsMCwxLS41My0uMjJMMTMsMTdBLjc1Ljc1LDAsMSwxLDE0LDE2bDIsMiwyLTJBLjc1Ljc1LDAsMSwxLDE5LDE3bC0yLjUsMi41QS43NC43NCwwLDAsMSwxNiwxOS43NVoiLz48cGF0aCBkPSJNMTYsMTkuNzVhLjc2Ljc2LDAsMCwxLS43NS0uNzVWNWEuNzUuNzUsMCwwLDEsMS41LDBWMTlBLjc2Ljc2LDAsMCwxLDE2LDE5Ljc1WiIvPjwvZz48L3N2Zz4=);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9InNvcnQtYWx0Ij48cGF0aCBkPSJNMTAuNSw4LjI1QS43NC43NCwwLDAsMSwxMCw4bC0yLTJMNiw4QS43NS43NSwwLDEsMSw1LDdsMi41LTIuNWEuNzUuNzUsMCwwLDEsMS4wNiwwTDExLDdBLjc1Ljc1LDAsMCwxLDExLDgsLjc0Ljc0LDAsMCwxLDEwLjUsOC4yNVoiLz48cGF0aCBkPSJNOCwxOS43NUEuNzYuNzYsMCwwLDEsNy4yNSwxOVY1YS43NS43NSwwLDAsMSwxLjUsMFYxOUEuNzYuNzYsMCwwLDEsOCwxOS43NVoiLz48cGF0aCBkPSJNMTYsMTkuNzVhLjc0Ljc0LDAsMCwxLS41My0uMjJMMTMsMTdBLjc1Ljc1LDAsMSwxLDE0LDE2bDIsMiwyLTJBLjc1Ljc1LDAsMSwxLDE5LDE3bC0yLjUsMi41QS43NC43NCwwLDAsMSwxNiwxOS43NVoiLz48cGF0aCBkPSJNMTYsMTkuNzVhLjc2Ljc2LDAsMCwxLS43NS0uNzVWNWEuNzUuNzUsMCwwLDEsMS41LDBWMTlBLjc2Ljc2LDAsMCwxLDE2LDE5Ljc1WiIvPjwvZz48L3N2Zz4=);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-angle-double-left{display:grid;place-content:center}.pi-angle-double-left:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLWRvdWJsZS1sZWZ0Ij48cGF0aCBkPSJNMTEsMTYuMjVhLjc0Ljc0LDAsMCwxLS41My0uMjJMNywxMi41M2EuNzUuNzUsMCwwLDEsMC0xLjA2TDEwLjQ3LDhBLjc1Ljc1LDAsMCwxLDExLjUzLDlsLTMsMywzLDNhLjc1Ljc1LDAsMCwxLDAsMS4wNkEuNzQuNzQsMCwwLDEsMTEsMTYuMjVaIi8+PHBhdGggZD0iTTE2LjUsMTYuMjVBLjc0Ljc0LDAsMCwxLDE2LDE2bC0zLjUtMy41YS43NS43NSwwLDAsMSwwLTEuMDZMMTYsOEEuNzUuNzUsMCwwLDEsMTcsOWwtMywzLDMsM0EuNzUuNzUsMCwwLDEsMTcsMTYsLjc0Ljc0LDAsMCwxLDE2LjUsMTYuMjVaIi8+PC9nPjwvc3ZnPg==);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLWRvdWJsZS1sZWZ0Ij48cGF0aCBkPSJNMTEsMTYuMjVhLjc0Ljc0LDAsMCwxLS41My0uMjJMNywxMi41M2EuNzUuNzUsMCwwLDEsMC0xLjA2TDEwLjQ3LDhBLjc1Ljc1LDAsMCwxLDExLjUzLDlsLTMsMywzLDNhLjc1Ljc1LDAsMCwxLDAsMS4wNkEuNzQuNzQsMCwwLDEsMTEsMTYuMjVaIi8+PHBhdGggZD0iTTE2LjUsMTYuMjVBLjc0Ljc0LDAsMCwxLDE2LDE2bC0zLjUtMy41YS43NS43NSwwLDAsMSwwLTEuMDZMMTYsOEEuNzUuNzUsMCwwLDEsMTcsOWwtMywzLDMsM0EuNzUuNzUsMCwwLDEsMTcsMTYsLjc0Ljc0LDAsMCwxLDE2LjUsMTYuMjVaIi8+PC9nPjwvc3ZnPg==);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-angle-double-left:before{min-width:28px;min-height:28px}.pi-angle-double-right{display:grid;place-content:center}.pi-angle-double-right:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLWRvdWJsZS1yaWdodCI+PHBhdGggZD0iTTEzLDE2LjI1YS43NC43NCwwLDAsMS0uNTMtLjIyLjc1Ljc1LDAsMCwxLDAtMS4wNmwzLTMtMy0zQS43NS43NSwwLDAsMSwxMy41Myw4bDMuNSwzLjVhLjc1Ljc1LDAsMCwxLDAsMS4wNkwxMy41MywxNkEuNzQuNzQsMCwwLDEsMTMsMTYuMjVaIi8+PHBhdGggZD0iTTcuNSwxNi4yNUEuNzQuNzQsMCwwLDEsNywxNiwuNzUuNzUsMCwwLDEsNywxNWwzLTNMNyw5QS43NS43NSwwLDAsMSw4LDhsMy41LDMuNWEuNzUuNzUsMCwwLDEsMCwxLjA2TDgsMTZBLjc0Ljc0LDAsMCwxLDcuNSwxNi4yNVoiLz48L2c+PC9zdmc+);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLWRvdWJsZS1yaWdodCI+PHBhdGggZD0iTTEzLDE2LjI1YS43NC43NCwwLDAsMS0uNTMtLjIyLjc1Ljc1LDAsMCwxLDAtMS4wNmwzLTMtMy0zQS43NS43NSwwLDAsMSwxMy41Myw4bDMuNSwzLjVhLjc1Ljc1LDAsMCwxLDAsMS4wNkwxMy41MywxNkEuNzQuNzQsMCwwLDEsMTMsMTYuMjVaIi8+PHBhdGggZD0iTTcuNSwxNi4yNUEuNzQuNzQsMCwwLDEsNywxNiwuNzUuNzUsMCwwLDEsNywxNWwzLTNMNyw5QS43NS43NSwwLDAsMSw4LDhsMy41LDMuNWEuNzUuNzUsMCwwLDEsMCwxLjA2TDgsMTZBLjc0Ljc0LDAsMCwxLDcuNSwxNi4yNVoiLz48L2c+PC9zdmc+);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-angle-double-right:before{min-width:28px;min-height:28px}.pi-angle-left{display:grid;place-content:center}.pi-angle-left:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLWxlZnQiPjxwYXRoIGQ9Ik0xMy43NSwxNi4yNWEuNzQuNzQsMCwwLDEtLjUzLS4yMmwtMy41LTMuNWEuNzUuNzUsMCwwLDEsMC0xLjA2TDEzLjIyLDhBLjc1Ljc1LDAsMCwxLDE0LjI4LDlsLTMsMywzLDNhLjc1Ljc1LDAsMCwxLDAsMS4wNkEuNzQuNzQsMCwwLDEsMTMuNzUsMTYuMjVaIi8+PC9nPjwvc3ZnPg==);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLWxlZnQiPjxwYXRoIGQ9Ik0xMy43NSwxNi4yNWEuNzQuNzQsMCwwLDEtLjUzLS4yMmwtMy41LTMuNWEuNzUuNzUsMCwwLDEsMC0xLjA2TDEzLjIyLDhBLjc1Ljc1LDAsMCwxLDE0LjI4LDlsLTMsMywzLDNhLjc1Ljc1LDAsMCwxLDAsMS4wNkEuNzQuNzQsMCwwLDEsMTMuNzUsMTYuMjVaIi8+PC9nPjwvc3ZnPg==);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-angle-left:before{min-width:28px;min-height:28px}.pi-angle-right{display:grid;place-content:center}.pi-angle-right:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLXJpZ2h0Ij48cGF0aCBkPSJNMTAuMjUsMTYuMjVBLjc0Ljc0LDAsMCwxLDkuNzIsMTZhLjc1Ljc1LDAsMCwxLDAtMS4wNmwzLTMtMy0zQS43NS43NSwwLDAsMSwxMC43OCw4bDMuNSwzLjVhLjc1Ljc1LDAsMCwxLDAsMS4wNkwxMC43OCwxNkEuNzQuNzQsMCwwLDEsMTAuMjUsMTYuMjVaIi8+PC9nPjwvc3ZnPg==);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZ2xlLXJpZ2h0Ij48cGF0aCBkPSJNMTAuMjUsMTYuMjVBLjc0Ljc0LDAsMCwxLDkuNzIsMTZhLjc1Ljc1LDAsMCwxLDAtMS4wNmwzLTMtMy0zQS43NS43NSwwLDAsMSwxMC43OCw4bDMuNSwzLjVhLjc1Ljc1LDAsMCwxLDAsMS4wNkwxMC43OCwxNkEuNzQuNzQsMCwwLDEsMTAuMjUsMTYuMjVaIi8+PC9nPjwvc3ZnPg==);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-angle-right:before{min-width:28px;min-height:28px}.pi-filter{display:grid;place-content:center}.pi-filter:before{content:"";min-width:20px;min-height:20px;background-color:var(--passage-body-text-color, #000000)!important;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImZpbHRlciI+PHBhdGggZD0iTTE0LDIwLjVIMTBhLjc2Ljc2LDAsMCwxLS43NS0uNzVWMTJMMy45LDQuNjlhLjczLjczLDAsMCwxLS4wNy0uNzhBLjc2Ljc2LDAsMCwxLDQuNSwzLjVoMTVhLjc2Ljc2LDAsMCwxLC42Ny40MS43My43MywwLDAsMS0uMDcuNzhMMTQuNzUsMTJ2Ny43NUEuNzYuNzYsMCwwLDEsMTQsMjAuNVpNMTAuNzUsMTloMi41VjExLjc1YS43MS43MSwwLDAsMSwuMTUtLjQ0TDE4LDVINmw0LjYyLDYuMzFhLjcxLjcxLDAsMCwxLC4xNS40NFoiLz48L2c+PC9zdmc+);mask:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImZpbHRlciI+PHBhdGggZD0iTTE0LDIwLjVIMTBhLjc2Ljc2LDAsMCwxLS43NS0uNzVWMTJMMy45LDQuNjlhLjczLjczLDAsMCwxLS4wNy0uNzhBLjc2Ljc2LDAsMCwxLDQuNSwzLjVoMTVhLjc2Ljc2LDAsMCwxLC42Ny40MS43My43MywwLDAsMS0uMDcuNzhMMTQuNzUsMTJ2Ny43NUEuNzYuNzYsMCwwLDEsMTQsMjAuNVpNMTAuNzUsMTloMi41VjExLjc1YS43MS43MSwwLDAsMSwuMTUtLjQ0TDE4LDVINmw0LjYyLDYuMzFhLjcxLjcxLDAsMCwxLC4xNS40NFoiLz48L2c+PC9zdmc+);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.pi-filter:before{min-width:28px;min-height:28px}.p-datatable{font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif)}.p-datatable-header{background-color:var(--passage-container-background, transparent)!important;border-width:0px!important;color:var(--passage-header-text-color, #000000)!important;padding:0!important;display:flex;flex-direction:row;flex-wrap:wrap;align-items:flex-end;justify-content:flex-end}.p-datatable-header>*{margin-bottom:15px!important}.p-datatable-header .buttons>*{margin:0 0 0 10px}.p-datatable-thead>tr{filter:drop-shadow(0px 2px 4px rgba(0,0,0,.25))}.p-datatable-thead>tr>th{border-width:0px!important;background-color:var(--passage-table-header-background, #f1f4fa)!important;color:var(--passage-body-text-color, #000000)!important;font-size:calc(var(--passage-body-font-size, 14px) + 10%);font-weight:600;padding:10px}.p-datatable .p-sortable-column .p-sortable-column-icon{margin-left:3px}.p-column-header-content{height:100%}.p-sortable-column:focus{box-shadow:unset!important}.p-datatable-tbody{font-size:var(--passage-body-font-size, 14px)!important}.p-datatable-tbody>tr>td{padding:.75rem;border-width:0px!important;word-break:break-word}.p-datatable-tbody>tr>td .checkbox-container{justify-content:center}.p-datatable-tbody>tr>td .checkbox-container .checkbox-label{margin:0}.p-datatable-tbody>tr{background-color:var(--passage-container-background, transparent)!important;color:var(--passage-body-text-color, #000000)!important}.p-datatable-tbody>tr:hover,.p-datatable-tbody>tr:hover+.p-datatable-row-expansion{background-color:var(--passage-table-background-hover, #f1f4fa)!important}.p-datatable-tbody>tr.p-highlight{background-color:var(--passage-table-background-hover, #f1f4fa)!important}.p-datatable-tbody>tr:not(:first-of-type){border-top:1px solid #d7d7d7}.p-datatable-tbody>tr:last-of-type{border-bottom:1px solid #d7d7d7}.p-datatable-tbody>.p-datatable-row-expansion{border-top:0px!important}.p-datatable-tbody>.p-datatable-row-expansion:hover{background-color:var(--passage-table-background-hover, #f1f4fa)!important}.p-datatable-tbody>.p-datatable-row-expansion>td{padding:0!important}.p-datatable-tbody>.p-datatable-row-expansion>td>:first-child{padding:0px 30px .75rem;padding-top:0}.p-datatable-row-hover-background{background-color:var(--passage-table-background-hover, #f1f4fa)!important}.p-column-filter-menu{margin-left:0!important}.p-sortable-column-icon,.p-column-filter-menu-button,.p-row-toggler{color:var(--passage-body-text-color, #000000)!important;background-color:transparent!important}.p-sortable-column-icon:focus,.p-column-filter-menu-button:focus,.p-row-toggler:focus{box-shadow:unset!important}.p-datatable-emptymessage>td{text-align:center!important;padding:20px!important}.p-paginator-bottom{background-color:var(--passage-container-background, transparent)!important;border-width:0px!important}.p-paginator>*,.p-paginator-page{font-size:var(--passage-body-font-size, 14px)!important;color:var(--passage-body-text-color, #000000)!important}.p-column-filter-overlay{background-color:#fff!important;color:var(--passage-body-text-color, #000000)!important;border-radius:10px!important}.p-column-filter-constraint{padding:10px!important;display:flex;flex-direction:column;align-items:center}.p-column-filter-constraint button{margin-top:15px!important}.p-column-filter-constraint .input-container{width:100%}.p-column-filter-constraint .dropdown-container{min-width:180px}.p-column-filter-buttonbar{padding:0 10px 10px!important}.p-column-filter-add-rule{padding:10px!important;display:flex;justify-content:center}.table-link{cursor:pointer}[v-cloak]{display:none;visibility:hidden}strong,b{font-weight:600}a{cursor:pointer}a:not(.button){font-weight:600;transition:color .2s ease-in-out}img{height:none!important;margin:10px 0}.has-text-centered{text-align:center}select:focus,select:active{outline:none;box-shadow:none!important}.select select{height:40px}.section,.container,.box,.card,.column,.tile{position:relative}.container{z-index:1}.auth-flex-container{display:flex;flex-direction:column;min-height:315px}.flex-row{display:flex;flex-direction:row}.flex-column{display:flex;flex-direction:column}.flex-center{justify-content:center;align-items:center}.flex-wrap{flex-wrap:wrap}.flex-between{justify-content:space-between}.spacer{display:flex;align-items:center;flex-grow:1;min-height:15px}.box,.card,canvas{max-width:100%}.help{margin-top:8px}.help a:not(.button){text-decoration:underline}.help.is-danger{margin-top:0;min-height:29px}.button{transition:all .2s ease-in-out;cursor:pointer}.button.icon-only{background:transparent;border:0;color:inherit}.button.icon-only:focus,.button.icon-only:active{outline:none;border:0;box-shadow:none}.notification{border-radius:5px;padding:5px;margin:5px}.notification.is-danger{background-color:#fef2f5;color:#dd0031}.notification.ephemeral-box{font-size:10px;background:#d7d7d7}.notification.ephemeral-box a{text-decoration:underline}.edit-save-container{display:flex;flex-direction:row;justify-content:flex-end;margin-left:15px}.edit-save-container .edit-save-text{font-size:14px;font-weight:400;color:#6b6b6b;text-decoration:underline;user-select:none;cursor:pointer}.edit-save-container :not(:last-child){margin-right:10px}.login-info-row{display:grid;align-items:center;max-width:600px;grid-template-columns:30% minmax(auto,275px) 100px;grid-template-areas:"title  control editsave" "marginleft message marginright"}.login-info-row .user-info-label{grid-area:title}.login-info-row .login-info-control{grid-area:control}.login-info-row .edit-save-container{grid-area:editsave}.login-info-row .message{grid-area:message}.login-info-row.isCompact{grid-template-columns:auto 100px;grid-template-areas:"title editsave" "control control" "message message"}.login-info-row .user-info-label,.login-info-row .edit-save-container{margin-bottom:5px}.profile-divider{border-top:1px solid #d7d7d7;margin-bottom:30px;margin-top:11px}.table-container .title{min-height:25px}.metadata-header{display:flex}.component-loading{cursor:wait}.component-loading.loading-overlay{inset:0;position:absolute;display:flex;align-items:center;justify-content:center;overflow:hidden;z-index:10}.component-loading.loading-overlay .loading-background{inset:0;position:absolute;background-color:#ffffff80}.component-loading.loading-overlay .loading-icon{position:relative;opacity:.8}.component-loading.loading-overlay .loading-icon:after{content:"";display:block;animation:spin .5s infinite linear;border:2px solid #d7d7d7;border-radius:9999px;position:absolute;top:calc(50% - 1.5em);left:calc(50% - 1.5em);width:3em;height:3em;border-width:.25em;border-color:transparent;border-left-color:#d7d7d7;border-bottom-color:#d7d7d7}.spinner-box{width:80px;height:80px;max-width:22em;margin:5px auto 10px;position:relative;box-sizing:border-box;background:var(--passage-container-background, #ffffff);background-clip:padding-box;border:solid 10px transparent;border-radius:50%}.spinner-box:after{content:"";position:absolute;inset:0;z-index:-1;margin:-10px;border-radius:inherit;background:conic-gradient(from 180deg at 50% 50%,#3d53f6 0deg,rgba(196,196,196,0) 360deg);animation:spin 1.9s linear infinite}.spinner-content{position:absolute;width:60px;height:60px;display:flex;align-items:center;justify-content:center}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.checkbox-container{display:flex;cursor:pointer}.checkbox-container .checkbox-label{user-select:none;color:var(--passage-body-text-color, #000000);font-size:var(--passage-body-font-size, 14px);line-height:20px;margin-left:5px}.checkbox-container .toggle-switch-label{line-height:18px}.checkbox-container.readonly{cursor:default;pointer-events:none}.passage-checkbox[type=checkbox]{-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;width:20px;height:20px;margin:0;background-color:transparent;border-style:solid;border-color:var(--passage-control-border-color, #d7d7d7);border-width:1px;border-radius:var(--passage-control-border-radius, 5px);display:grid;place-content:center}.passage-checkbox[type=checkbox]:checked{background-color:var(--passage-primary-color, #000000);border-color:var(--passage-primary-color, #000000);transition:.1s ease-in-out}.passage-checkbox[type=checkbox]:before{content:"";width:20px;height:20px;background-color:var(--passage-onprimary-color, #ffffff);mask:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDExIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjE2MzQ2IDAuMjA3MDExQzkuMjI3NyAwLjE0MTQ2OSA5LjMwNDM2IDAuMDg5NDAwNiA5LjM4ODk3IDAuMDUzODU0N0M5LjQ3MzU4IDAuMDE4MzA4OSA5LjU2NDQzIDAgOS42NTYyIDBDOS43NDc5NyAwIDkuODM4ODIgMC4wMTgzMDg5IDkuOTIzNDMgMC4wNTM4NTQ3QzEwLjAwOCAwLjA4OTQwMDYgMTAuMDg0NyAwLjE0MTQ2OSAxMC4xNDg5IDAuMjA3MDExQzEwLjQxODEgMC40NzkwMyAxMC40MjE5IDAuOTE4NTkxIDEwLjE1ODQgMS4xOTUzMkw0LjU5Mjc5IDcuNzc0NkM0LjUyOTYgNy44NDM5OSA0LjQ1MjkxIDcuODk5NzYgNC4zNjc0MyA3LjkzODQ5QzQuMjgxOTUgNy45NzcyMyA0LjE4OTQ2IDcuOTk4MTIgNC4wOTU2MyA3Ljk5OTg4QzQuMDAxNzkgOC4wMDE2NCAzLjkwODU5IDcuOTg0MjQgMy44MjE3MSA3Ljk0ODc0QzMuNzM0ODMgNy45MTMyNCAzLjY1NjExIDcuODYwMzkgMy41OTAzNiA3Ljc5MzQzTDAuMjAzNzcxIDQuMzYxNjZDMC4wNzMxNjE5IDQuMjI4NDYgMCA0LjA0OTM1IDAgMy44NjI4QzAgMy42NzYyNSAwLjA3MzE2MTkgMy40OTcxNCAwLjIwMzc3MSAzLjM2Mzk0QzAuMjY4MDA3IDMuMjk4NCAwLjM0NDY3NCAzLjI0NjMzIDAuNDI5MjgyIDMuMjEwNzhDMC41MTM4OTEgMy4xNzUyNCAwLjYwNDc0IDMuMTU2OTMgMC42OTY1MTIgMy4xNTY5M0MwLjc4ODI4NCAzLjE1NjkzIDAuODc5MTMzIDMuMTc1MjQgMC45NjM3NDIgMy4yMTA3OEMxLjA0ODM1IDMuMjQ2MzMgMS4xMjUwMiAzLjI5ODQgMS4xODkyNSAzLjM2Mzk0TDQuMDYxOTIgNi4yNzUyTDkuMTQ0NjMgMC4yMjc3MTlDOS4xNTA0OSAwLjIyMDQ0NCA5LjE1Njc3IDAuMjEzNTI5IDkuMTYzNDYgMC4yMDcwMTFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==);mask-position:center;mask-repeat:no-repeat;-webkit-mask:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDExIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjE2MzQ2IDAuMjA3MDExQzkuMjI3NyAwLjE0MTQ2OSA5LjMwNDM2IDAuMDg5NDAwNiA5LjM4ODk3IDAuMDUzODU0N0M5LjQ3MzU4IDAuMDE4MzA4OSA5LjU2NDQzIDAgOS42NTYyIDBDOS43NDc5NyAwIDkuODM4ODIgMC4wMTgzMDg5IDkuOTIzNDMgMC4wNTM4NTQ3QzEwLjAwOCAwLjA4OTQwMDYgMTAuMDg0NyAwLjE0MTQ2OSAxMC4xNDg5IDAuMjA3MDExQzEwLjQxODEgMC40NzkwMyAxMC40MjE5IDAuOTE4NTkxIDEwLjE1ODQgMS4xOTUzMkw0LjU5Mjc5IDcuNzc0NkM0LjUyOTYgNy44NDM5OSA0LjQ1MjkxIDcuODk5NzYgNC4zNjc0MyA3LjkzODQ5QzQuMjgxOTUgNy45NzcyMyA0LjE4OTQ2IDcuOTk4MTIgNC4wOTU2MyA3Ljk5OTg4QzQuMDAxNzkgOC4wMDE2NCAzLjkwODU5IDcuOTg0MjQgMy44MjE3MSA3Ljk0ODc0QzMuNzM0ODMgNy45MTMyNCAzLjY1NjExIDcuODYwMzkgMy41OTAzNiA3Ljc5MzQzTDAuMjAzNzcxIDQuMzYxNjZDMC4wNzMxNjE5IDQuMjI4NDYgMCA0LjA0OTM1IDAgMy44NjI4QzAgMy42NzYyNSAwLjA3MzE2MTkgMy40OTcxNCAwLjIwMzc3MSAzLjM2Mzk0QzAuMjY4MDA3IDMuMjk4NCAwLjM0NDY3NCAzLjI0NjMzIDAuNDI5MjgyIDMuMjEwNzhDMC41MTM4OTEgMy4xNzUyNCAwLjYwNDc0IDMuMTU2OTMgMC42OTY1MTIgMy4xNTY5M0MwLjc4ODI4NCAzLjE1NjkzIDAuODc5MTMzIDMuMTc1MjQgMC45NjM3NDIgMy4yMTA3OEMxLjA0ODM1IDMuMjQ2MzMgMS4xMjUwMiAzLjI5ODQgMS4xODkyNSAzLjM2Mzk0TDQuMDYxOTIgNi4yNzUyTDkuMTQ0NjMgMC4yMjc3MTlDOS4xNTA0OSAwLjIyMDQ0NCA5LjE1Njc3IDAuMjEzNTI5IDkuMTYzNDYgMC4yMDcwMTFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==);-webkit-mask-position:center;-webkit-mask-repeat:no-repeat;transform:scale(0);transition:.2s transform ease-in-out}.passage-checkbox[type=checkbox]:checked:before{transform:scale(1)}.passage-checkbox[type=checkbox]:focus,.passage-toggle-switch[type=checkbox]:focus{box-shadow:0 0 0 1px #000!important;outline:none}.passage-modal{align-items:center;display:none;flex-direction:column;justify-content:center;overflow:hidden;z-index:40;inset:0;position:absolute;font-family:DM Sans,BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}.passage-modal.is-active{display:flex}.passage-modal .passage-modal-background{inset:0;position:absolute}.passage-modal .passage-modal-card{box-shadow:0 2px 8px 2px #ccc;background-color:var(--passage-container-background, #ffffff);color:var(--passage-body-text-color, #000000);font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-size:var(--passage-body-font-size, 14px);font-weight:var(--passage-body-font-weight, 400);margin:0 auto;padding:40px;display:flex;flex-direction:column;max-height:90%;max-width:420px;width:90%;border-radius:20px;overflow:hidden;position:relative}.passage-modal .passage-modal-card .danger-header{color:var(--passage-error-color, #dd0031)}.passage-modal .passage-modal-card .input-box-title{margin-top:15px}.passage-modal .passage-modal-card .passage-modal-body{padding:20px 0 0}.passage-modal .passage-modal-card .passage-modal-footer{display:flex;justify-content:center;padding-top:20px}.passage-modal .passage-modal-card .passage-modal-footer .cancel-button{margin-left:10px}.passage-modal .passage-modal-card .passage-modal-footer .cancel-only{margin-left:0}.passage-tooltip{position:relative;--tooltip-opacity: 0}.passage-tooltip.is-top:before{transition:.2s opacity;opacity:var(--tooltip-opacity);content:"";position:absolute;z-index:4;border-top:5px solid #000;border-top:5px solid var(--passage-container-background, #ffffff);border-right:5px solid transparent;border-left:5px solid transparent;bottom:calc(100% + 2px);left:50%;transform:translate(-50%)}.passage-tooltip.is-bottom:before{transition:.2s opacity;opacity:var(--tooltip-opacity);content:"";position:absolute;z-index:4;border-right:5px solid transparent;border-bottom:5px solid #000;border-bottom:5px solid var(--passage-container-background, #ffffff);border-left:5px solid transparent;top:calc(100% + 2px);left:50%;transform:translate(-50%)}.passage-tooltip.is-left:before{transition:.2s opacity;opacity:var(--tooltip-opacity);content:"";position:absolute;z-index:4;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid #000;border-left:5px solid var(--passage-container-background, #ffffff);right:calc(100% + 3px);top:50%;transform:translate(-50%)}.passage-tooltip.is-right:before{transition:.2s opacity;opacity:var(--tooltip-opacity);content:"";position:absolute;z-index:4;border-top:5px solid transparent;border-right:5px solid #000;border-right:5px solid var(--passage-container-background, #ffffff);border-bottom:5px solid transparent;left:calc(100% + 3px);top:50%;transform:translate(-50%)}.passage-tooltip.show-tooltip{--tooltip-opacity: 1;--tooltip-display: inline-block}.passage-tooltip-body{position:absolute;opacity:var(--tooltip-opacity);z-index:3;width:max-content;overflow:hidden;transition:.2s opacity;background-color:var(--passage-container-background, #ffffff);border-radius:5px;border:15px solid transparent;color:var(--passage-body-text-color, #000000);font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-size:calc(var(--passage-body-font-size, 14px) - 15%);font-weight:var(--passage-body-font-weight, 400);box-shadow:0 2px 8px 2px #ccc;display:grid}.passage-tooltip-body.is-top{top:auto;right:auto;bottom:calc(100% + 7px);left:50%;transform:translate(-50%)}.passage-tooltip-body.is-right{top:50%;right:auto;bottom:auto;left:calc(100% + 7px);transform:translateY(-50%)}.passage-tooltip-body.is-bottom{top:calc(100% + 7px);right:auto;bottom:auto;left:50%;transform:translate(-50%)}.passage-tooltip-body.is-left{top:50%;right:calc(100% + 7px);bottom:auto;left:auto;transform:translateY(-50%)}.passage-tooltip-body ul{margin:0;padding-inline-start:20px}.passage-tooltip-body .tooltip-header{display:grid;grid-template-columns:auto 12px;align-items:center;margin-bottom:10px;font-size:calc(var(--passage-body-font-size, 14px) + 15%);font-weight:var(--passage-header-font-weight, 700);text-align:left}.passage-tooltip-body .tooltip-content{overflow:scroll}#passage-auth-container .iti,#passage-profile-container .iti{width:100%}#passage-auth-container .iti .input,#passage-profile-container .iti .input{padding-left:calc(.75em + 39px)}#passage-auth-container .iti .iti__country-list,#passage-profile-container .iti .iti__country-list{border-radius:6px}#passage-auth-container .iti .iti__country,#passage-profile-container .iti .iti__country{padding:5px 10px}#passage-auth-container .iti .iti__selected-flag,#passage-profile-container .iti .iti__selected-flag{border-top-left-radius:var(--passage-control-border-radius, 6px);border-bottom-left-radius:var(--passage-control-border-radius, 6px)}#passage-auth-container .iti--container,#passage-profile-container .iti--container{top:unset!important;left:unset!important}.grid-stack{margin:0 -10px}.grid-stack-item>*{overflow:visible!important}.grid-stack-item.editable{cursor:grab}.grid-stack-item .grid-stack-item-content>.checkbox-container{margin-top:4px;margin-left:1px}.grid-stack-item .grid-stack-item-content .label{font-size:14px!important;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;user-select:none}.grid-stack-item .grid-stack-item-content .input{font-size:14px!important}.grid-stack-item .grid-stack-item-content .error-message{font-size:11px!important;word-break:break-word}.grid-stack.profile .label{font-weight:600!important}#passage-auth-container,#passage-profile-container{position:relative;box-sizing:content-box;max-width:var(--passage-container-max-width, 300px);margin:var(--passage-container-margin, auto);padding:var(--passage-container-padding, 30px 30px 20px);background:var(--passage-container-background, transparent);color:var(--passage-body-text-color, #000000);font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-size:var(--passage-body-font-size, 14px);font-weight:var(--passage-body-font-weight, 400)}#passage-auth-container .title,#passage-profile-container .title{color:var(--passage-header-text-color, #000000);font-family:var(--passage-header-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-weight:var(--passage-header-font-weight, 700);font-size:var(--passage-header-font-size, 18px);margin-bottom:0}#passage-auth-container .title.main-title,#passage-profile-container .title.main-title{font-size:var(--passage-header-font-size, 24px);line-height:var(--passage-header-font-size, 31px)}#passage-auth-container .title.secondary-title,#passage-profile-container .title.secondary-title{line-height:var(--passage-header-font-size, 20px)}#passage-auth-container .link,#passage-profile-container .link{font-size:calc(var(--passage-body-font-size, 14px) - 15%)}#passage-auth-container .link a:not(.button),#passage-profile-container .link a:not(.button){text-decoration:underline}#passage-auth-container a,#passage-profile-container a{color:var(--passage-body-text-color, #000000)}#passage-auth-container a:hover,#passage-profile-container a:hover{color:var(--passage-hover-color, var(--passage-primary-color, #4d4d4d))}#passage-auth-container a:active,#passage-profile-container a:active{color:var(--passage-active-color, var(--passage-hover-color, var(--passage-primary-color, #6b6b6b)))}#passage-auth-container .label,#passage-profile-container .label{color:var(--passage-body-text-color, #000000);font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-size:var(--passage-body-font-size, 14px);font-weight:var(--passage-body-font-weight, 400);margin-bottom:3px!important;width:100%;text-align:left}#passage-auth-container .content,#passage-profile-container .content{font-size:calc(var(--passage-body-font-size, 14px) - 15%)}#passage-auth-container .input,#passage-profile-container .input{-webkit-appearance:none;-moz-appearance:none;box-sizing:border-box;color:var(--passage-body-text-color, #000000);font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-size:var(--passage-body-font-size, 14px);font-weight:var(--passage-body-font-weight, 400);min-height:40px;width:100%;padding-left:10px;padding-right:10px;margin:0;background-color:var(--passage-container-background-color, #ffffff);border-style:solid;border-color:var(--passage-control-border-color, #d7d7d7);border-width:1px;border-radius:var(--passage-control-border-radius, 5px);transition:all .3s;text-overflow:ellipsis}#passage-auth-container .input:focus,#passage-auth-container .input:active,#passage-profile-container .input:focus,#passage-profile-container .input:active{outline:none;box-shadow:none!important;border-color:var(--passage-body-text-color, #000000)}#passage-auth-container .input.short,#passage-profile-container .input.short{min-height:30px}#passage-auth-container .input.has-error,#passage-auth-container .input.is-danger,#passage-profile-container .input.has-error,#passage-profile-container .input.is-danger{border-color:var(--passage-error-color, #dd0031)}#passage-auth-container .input:read-only,#passage-profile-container .input:read-only{border-color:transparent!important;pointer-events:none}#passage-auth-container .input:read-only::-webkit-outer-spin-button,#passage-auth-container .input:read-only::-webkit-inner-spin-button,#passage-profile-container .input:read-only::-webkit-outer-spin-button,#passage-profile-container .input:read-only::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}#passage-auth-container .input:read-only[type=number],#passage-profile-container .input:read-only[type=number]{-moz-appearance:textfield}#passage-auth-container ::slotted(.input),#passage-profile-container ::slotted(.input){-webkit-appearance:none;-moz-appearance:none;box-sizing:border-box;color:var(--passage-body-text-color, #000000);font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-size:var(--passage-body-font-size, 14px);font-weight:var(--passage-body-font-weight, 400);min-height:40px;width:100%;padding-left:10px;padding-right:10px;margin:0;color:var(--app-text);background-color:var(--passage-container-background-color, #ffffff);border-style:solid;border-color:var(--passage-control-border-color, #d7d7d7);border-width:1px;border-radius:var(--passage-control-border-radius, 5px);transition:all .3s;text-overflow:ellipsis}#passage-auth-container ::slotted(.input:focus),#passage-auth-container ::slotted(.input:active),#passage-profile-container ::slotted(.input:focus),#passage-profile-container ::slotted(.input:active){outline:none;box-shadow:none!important;border-color:var(--passage-body-text-color, #000000)}#passage-auth-container ::slotted(.input.has-error),#passage-auth-container ::slotted(.input.is-danger),#passage-profile-container ::slotted(.input.has-error),#passage-profile-container ::slotted(.input.is-danger){border-color:var(--passage-error-color, #dd0031)}#passage-auth-container .error-message,#passage-profile-container .error-message{font-size:calc(var(--passage-body-font-size, 14px) - 20%);color:var(--passage-error-color, #dd0031);text-align:left}#passage-auth-container .text.is-danger,#passage-profile-container .text.is-danger{color:var(--passage-error-color, #dd0031)}#passage-auth-container .button,#passage-profile-container .button{color:var(--passage-onprimary-color, #ffffff);background-color:var(--passage-primary-color, #000000);font-family:var(--passage-body-font-family, "DM Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif);font-weight:var(--passage-button-font-weight, 400);font-size:var(--passage-button-font-size, 16px);min-height:40px;border:none;border-radius:var(--passage-button-border-radius, 75px);width:var(--passage-button-width, 40%);white-space:normal;min-width:fit-content;padding:9px 10px}#passage-auth-container .button.small,#passage-profile-container .button.small{min-height:25px;padding:4px 10px 5px;font-size:var(--passage-body-font-size, 14px);line-height:var(--passage-body-font-size, 14px);width:fit-content}#passage-auth-container .button:hover,#passage-profile-container .button:hover{color:var(--passage-onhover-color, var(--passage-onprimary-color, #ffffff));background-color:var(--passage-hover-color, var(--passage-primary-color, #4d4d4d))}#passage-auth-container .button:active,#passage-auth-container .button.is-active,#passage-profile-container .button:active,#passage-profile-container .button.is-active{box-shadow:none!important;color:var(--passage-onactive-color, var(--passage-onhover-color, var(--passage-onprimary-color, #ffffff)));background-color:var(--passage-active-color, var(--passage-hover-color, var(--passage-primary-color, #6b6b6b)))}#passage-auth-container .button:focus,#passage-profile-container .button:focus{color:var(--passage-onprimary-color, #ffffff);outline:none}#passage-auth-container .button:focus-visible,#passage-profile-container .button:focus-visible{outline:none}#passage-auth-container .button.is-secondary,#passage-profile-container .button.is-secondary{color:var(--passage-primary-color, #000000);background-color:var(--passage-onprimary-color, #ffffff);border:1px solid var(--passage-primary-color, #000000)}#passage-auth-container .button.is-secondary:hover,#passage-profile-container .button.is-secondary:hover{color:var(--passage-hover-color, var(--passage-primary-color, #4d4d4d));border-color:var(--passage-hover-color, var(--passage-primary-color, #4d4d4d));background-color:var(--passage-onhover-color, var(--passage-onprimary-color, #ffffff))}#passage-auth-container .button.is-secondary:active,#passage-profile-container .button.is-secondary:active{color:var(--passage-active-color, var(--passage-hover-color, var(--passage-primary-color, #6b6b6b)));border-color:var(--passage-active-color, var(--passage-hover-color, var(--passage-primary-color, #6b6b6b)));background-color:var(--passage-onactive-color, var(--passage-onhover-color, var(--passage-onprimary-color, #ffffff)))}#passage-auth-container .button.is-modal,#passage-profile-container .button.is-modal{min-height:30px;padding:0 10px;width:fit-content}#passage-auth-container .button.is-disabled,#passage-auth-container .button[disabled],fieldset[disabled] #passage-auth-container .button,#passage-profile-container .button.is-disabled,#passage-profile-container .button[disabled],fieldset[disabled] #passage-profile-container .button{pointer-events:none;opacity:.5;color:var(--passage-onprimary-color, #ffffff);background-color:var(--passage-primary-color, #000000);border-color:transparent;box-shadow:none}#passage-profile-container{max-width:var(--passage-container-max-width, 600px);min-height:70px}#passage-profile-container .user-info-label{font-size:calc(var(--passage-body-font-size, 14px) + 10%);font-weight:600;margin-right:15px}#passage-profile-container .message{font-size:calc(var(--passage-body-font-size, 14px) - 20%);text-align:left;min-height:14px;margin-bottom:5px}#passage-profile-container .message.is-danger{color:var(--passage-error-color, #dd0031)}#passage-profile-container .message.is-info{color:#3758a1;padding-left:10px}#passage-profile-container .current-device{font-size:calc(var(--passage-body-font-size, 14px) - 20%);color:gray}#passage-profile-container .feedback{min-height:20px;line-height:20px;font-size:12px;padding:0 5px;margin-top:1px;margin-bottom:2px;border-radius:5px;text-align:center}#passage-profile-container .feedback.feedback-danger{background-color:#fef2f5;color:var(--passage-error-color, #dd0031)}#passage-profile-container .feedback.feedback-info{background-color:#f1f4fa;color:var(--passage-body-text-color, #000000)}\n';
function useIntlTelInput(containerRef) {
  onMounted(() => {
    if (containerRef.value === null) {
      return;
    }
    const shadowDOM = containerRef.value.parentNode;
    if (shadowDOM === null) {
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/css/intlTelInput.css";
    shadowDOM.appendChild(link);
  });
}
function safelyRegisterElement(vueComponent, elementName) {
  try {
    if (!window.customElements.get(`passage-${elementName}`)) {
      window.customElements.define(`passage-${elementName}`, vueComponent);
    }
  } catch (e2) {
    throw new Error(
      `Cannot register custom element <passage-${elementName}>. Ensure the import is happening while code is running client-side in the browser. If doing server-side rendering consider moving the import to a lifecycle event. See https://docs.passage.id/ for more information.`
    );
  }
}
export { computed$1 as $, withModifiers as A, createCommentVNode as B, q as C, passkeyAllowAddDevice as D, _ as E, Fragment as F, onMounted as G, withDirectives as H, InlineSvg as I, vShow as J, normalizeStyle as K, createVNode as L, C as M, isStringNullish as N, intlTelInput as O, createTextVNode as P, Q, vModelText as R, renderSlot as S, LayoutType as T, UserMetadata as U, transformMetadata as V, o as W, X, withCtx as Y, onBeforeMount as Z, _export_sfc as _, appStyles as a, unref as a0, useAppInfo as a1, isRef as a2, normalizeProps as a3, guardReactiveProps as a4, resolveDynamicComponent as a5, onBeforeUnmount as a6, withKeys as a7, useUpdateUser as a8, isEmail as a9, V as aa, Teleport as ab, renderList as ac, resolveDirective as ad, mergeProps as ae, Transition as af, createSlots as ag, toHandlers as ah, watchEffect as ai, onUnmounted as aj, onUpdated as ak, h as al, Checkbox as am, dayjs as an, Y as ao, useIntlTelInput as b, useAppId as c, defineComponent as d, resolveComponent as e, createElementBlock as f, createBaseVNode as g, createBlock as h, useDefaultCountryCode as i, openBlock as j, defineCustomElement as k, safelyRegisterElement as l, readonly as m, reactive as n, onBeforeUpdate as o, computed as p, _sfc_main$8 as q, ref as r, setLocale as s, useLocale as t, useWebFonts as u, useAddDevice as v, watch as w, Icons as x, toDisplayString$1 as y, normalizeClass as z };
